{
  "_meta": {
    "locale": "ru",
    "status": "complete",
    "note": "Complete translation of every en.json key (same key order). Terms follow the Russian pages of avrastro.com: взнос, полис, выгодоприобретатель, заявка, обзор, GESY. Native review welcome."
  },
  "app": {
    "name": "AVRASTRO",
    "tagline": "Advisor OS",
    "workspace": "Рабочее пространство",
    "update_ready": "Готова новая версия AVRASTRO. Нажмите «Обновить», чтобы перейти на неё.",
    "update_reload": "Обновить"
  },
  "nav": {
    "today": "Сейчас",
    "people": "Люди",
    "cases": "Заявки",
    "agenda": "Ежедневник",
    "reviews": "Обзоры",
    "prospects": "Привлечение",
    "insights": "Аналитика",
    "data": "Данные и безопасность",
    "settings": "Настройки",
    "lens": "Лупа",
    "comparator": "Сравнение",
    "service": "Обслуживание и страховые случаи",
    "pipeline": "Воронка",
    "decisions": "Решения",
    "referrals": "Рекомендации",
    "needs": "Анализ потребностей",
    "quotes": "Котировки",
    "proposals": "Предложения",
    "business": "Бизнес-центр",
    "quality": "Качество данных",
    "compliance": "Комплаенс",
    "templates": "Шаблоны",
    "day": "Мой день",
    "renewals": "Продления",
    "retention": "Удержание",
    "vault": "Документы",
    "campaigns": "Кампании",
    "protection": "Защита",
    "tax": "Налоговый центр",
    "production": "Продажи",
    "assistant": "Спросить AVRASTRO",
    "automations": "Автоматизация",
    "fields": "Пользовательские поля",
    "sync": "Синхронизация",
    "security": "Безопасность",
    "account": "Учётная запись",
    "team": "Команда",
    "branding": "Фирменный стиль",
    "radar": "Возможности",
    "analytics": "Аналитика роста",
    "inbox": "Входящие с сайта",
    "portal": "Портал клиента",
    "groups": "Групповые программы",
    "drafts": "Черновики ИИ",
    "register": "Список клиентов",
    "setup": "Мастер настройки",
    "help": "Справка",
    "lessons": "Уроки",
    "salefiles": "Файлы продаж",
    "calls": "Звонки потенциальным клиентам",
    "callstats": "Мой прогресс",
    "gaps": "Карта пробелов в защите",
    "auditpack": "Пакет для проверки",
    "performance": "Результаты за месяц",
    "studio": "AI-студия",
    "taxfolder": "Моя налоговая папка"
  },
  "common": {
    "save": "Сохранить",
    "cancel": "Отмена",
    "close": "Закрыть",
    "delete": "Удалить",
    "edit": "Изменить",
    "add": "Добавить",
    "new": "Новый",
    "back": "Назад",
    "open": "Открыть",
    "confirm": "Подтвердить",
    "search": "Поиск",
    "filter": "Фильтр",
    "all": "Все",
    "none": "Нет",
    "yes": "Да",
    "no": "Нет",
    "today": "Сегодня",
    "tomorrow": "Завтра",
    "yesterday": "Вчера",
    "loading": "Загрузка…",
    "saved": "Сохранено",
    "error": "Что-то пошло не так",
    "optional": "необязательно",
    "more": "Ещё",
    "less": "Меньше",
    "details": "Подробности",
    "done": "Готово",
    "reopen": "Открыть снова",
    "export": "Экспорт",
    "import": "Импорт",
    "print": "Печать",
    "download": "Скачать",
    "copy": "Копировать",
    "copied": "Скопировано",
    "call": "Позвонить",
    "email": "E-mail",
    "whatsapp": "WhatsApp",
    "sms": "SMS",
    "not_set": "Не указано",
    "unknown": "Неизвестно",
    "empty": "Здесь пока ничего нет",
    "name": "Имя",
    "phone": "Телефон",
    "notes": "Примечания",
    "date": "Дата",
    "time": "Время",
    "status": "Статус",
    "priority": "Приоритет",
    "type": "Тип",
    "person": "Человек",
    "all_people": "Все люди",
    "select_person": "Выберите человека…",
    "required": "Обязательно",
    "continue": "Продолжить",
    "undo": "Отменить",
    "view_all": "Показать все",
    "items": "{count, plural, one {# элемент} few {# элемента} many {# элементов} other {# элемента}}",
    "days": "{count, plural, one {# день} few {# дня} many {# дней} other {# дня}}",
    "unsaved": "Несохранённые изменения",
    "keyboard_hint": "Нажмите {key}",
    "nothing_to_undo": "Нечего отменять",
    "active": "Активно",
    "inactive": "неактивно",
    "next": "Далее",
    "deleted": "Удалено",
    "remove": "Убрать"
  },
  "enum": {
    "stage": {
      "lead": "Контакт",
      "prospect": "Потенциальный клиент",
      "client": "Клиент",
      "former": "Бывший клиент",
      "dependent": "Иждивенец"
    },
    "branch": {
      "life": "Жизнь и здоровье",
      "general": "Общее страхование"
    },
    "policyStatus": {
      "offer": "Предложение",
      "pending": "На рассмотрении",
      "active": "Действует",
      "renewed": "Продлён",
      "lapsed": "Прекращён",
      "cancelled": "Аннулирован",
      "matured": "Срок истёк"
    },
    "frequency": {
      "monthly": "Ежемесячно",
      "quarterly": "Ежеквартально",
      "semiannual": "Раз в полгода",
      "annual": "Ежегодно",
      "single": "Единовременный взнос"
    },
    "caseStage": {
      "draft": "Черновик",
      "submitted": "Подана",
      "documents": "Документы",
      "underwriting": "Андеррайтинг",
      "decision": "Решение",
      "issued": "Полис выдан",
      "declined": "Отклонена",
      "postponed": "Отложена",
      "withdrawn": "Отозвана"
    },
    "requirement": {
      "identity": "Удостоверение личности / паспорт",
      "address": "Подтверждение адреса",
      "bank": "Банковские данные / мандат SEPA",
      "questionnaire": "Анкета",
      "financial": "Финансовые документы",
      "medical": "Медицинские данные / обследования",
      "signature": "Подписи",
      "other": "Дополнительные документы"
    },
    "taskKind": {
      "task": "Задача",
      "call": "Звонок",
      "followup": "Напоминание",
      "appointment": "Встреча",
      "review": "Обзор",
      "document": "Напоминание о документе",
      "renewal": "Продление",
      "application": "Заявка",
      "other": "Другое"
    },
    "taskStatus": {
      "open": "Открыта",
      "done": "Выполнена",
      "cancelled": "Отменена"
    },
    "priority": {
      "low": "Низкий",
      "normal": "Обычный",
      "high": "Высокий",
      "urgent": "Срочно"
    },
    "location": {
      "office": "В офисе",
      "client": "У клиента",
      "online": "Онлайн",
      "phone": "По телефону",
      "custom": "Другое место"
    },
    "reviewOutcome": {
      "completed": "Завершён",
      "open": "Открыт",
      "needs_followup": "Нужен повторный контакт",
      "no_change": "Изменения не нужны",
      "declined": "Клиент отказался"
    },
    "prospectStatus": {
      "new": "Новый",
      "called": "Был звонок",
      "no_answer": "Не ответил",
      "callback": "Перезвонить",
      "interested": "Заинтересован",
      "appointment": "Встреча",
      "not_interested": "Не заинтересован",
      "wrong_number": "Неверный номер",
      "converted": "Стал клиентом"
    },
    "outcome": {
      "positive": "Положительный",
      "neutral": "Нейтральный",
      "negative": "Отрицательный"
    },
    "occupationRisk": {
      "low": "Профессия низкого риска",
      "medium": "Профессия среднего риска",
      "high": "Профессия высокого риска"
    },
    "severity": {
      "critical": "Критично",
      "high": "Высокая",
      "medium": "Средняя",
      "low": "Низкая"
    },
    "reviewState": {
      "not_applicable": "Нет действующих полисов",
      "never": "Обзора ещё не было",
      "overdue": "Обзор просрочен",
      "due_soon": "Скоро обзор",
      "ok": "Обзор проведён"
    },
    "serviceStatus": {
      "open": "Открыт",
      "in_progress": "В работе",
      "waiting": "Ожидание",
      "closed": "Закрыт"
    },
    "householdRole": {
      "primary": "Основной член семьи",
      "spouse": "Супруг(а) / партнёр",
      "child": "Ребёнок",
      "dependent": "Иждивенец",
      "other": "Другое"
    },
    "timeline": {
      "created": "Создание",
      "note": "Заметка",
      "call": "Звонок",
      "message": "Сообщение",
      "email": "E-mail",
      "meeting": "Встреча",
      "appointment": "Встреча",
      "task": "Задача",
      "policy": "Полис",
      "case": "Заявка",
      "review": "Обзор",
      "document": "Документ",
      "service": "Обслуживание",
      "proposal": "Предложение",
      "comparison": "Сравнение",
      "import": "Импорт",
      "system": "Система",
      "legacy": "Архивная запись"
    },
    "riskAttitude": {
      "conservative": "Консервативный",
      "balanced": "Сбалансированный",
      "growth": "Ориентированный на рост",
      "unknown": "Не оценивался"
    },
    "quoteStatus": {
      "draft": "Черновик",
      "sent": "Отправлена",
      "accepted": "Принята",
      "declined": "Отклонена",
      "expired": "Истекла"
    },
    "opportunityStage": {
      "lead": "Контакт",
      "qualified": "Квалифицирована",
      "proposal": "Предложение",
      "decision": "Решение",
      "won": "Выиграна",
      "lost": "Проиграна",
      "deferred": "Отложена"
    },
    "referralStatus": {
      "new": "Новая",
      "contacted": "Связались",
      "meeting": "Встреча",
      "converted": "Стал клиентом",
      "declined": "Отказ"
    },
    "commChannel": {
      "phone": "Телефон",
      "email": "E-mail",
      "sms": "SMS",
      "whatsapp": "WhatsApp",
      "meeting": "Встреча",
      "letter": "Письмо",
      "social": "Соцсети",
      "other": "Другое"
    },
    "commDirection": {
      "out": "Исходящее",
      "in": "Входящее"
    },
    "claimStatus": {
      "open": "Открыт",
      "submitted": "Подан",
      "pending_documents": "Ожидаются документы",
      "approved": "Одобрен",
      "paid": "Выплачен",
      "declined": "Отклонён",
      "closed": "Закрыт"
    },
    "policyCategory": {
      "life": "Жизнь",
      "medical": "Медицинское",
      "savings": "Накопительное",
      "pension": "Пенсионное",
      "education": "Образовательное",
      "accident": "От несчастных случаев",
      "critical_illness": "Критические заболевания",
      "disability": "Инвалидность",
      "credit_life": "Кредитное страхование жизни",
      "motor": "Авто",
      "home": "Жильё",
      "travel": "Путешествия",
      "liability": "Гражданская ответственность",
      "business": "Бизнес",
      "group": "Групповое",
      "other": "Другое"
    },
    "partyRole": {
      "owner": "Страхователь",
      "insured": "Застрахованный",
      "beneficiary": "Выгодоприобретатель",
      "payer": "Плательщик",
      "advisor": "Консультант"
    },
    "benefit": {
      "death": "Смерть",
      "critical_illness": "Критические заболевания",
      "disability": "Инвалидность",
      "waiver": "Освобождение от уплаты взносов",
      "income": "Выплата дохода",
      "medical": "Медицинская",
      "hospital": "Госпитализация",
      "accident": "Несчастный случай",
      "savings": "Накопления",
      "maturity": "Дожитие",
      "mortgage": "Ипотека",
      "other": "Другое"
    },
    "lifeEvent": {
      "marriage": "Брак",
      "new_child": "Рождение ребёнка",
      "new_job": "Новая работа",
      "salary_increase": "Повышение зарплаты",
      "home_purchase": "Покупка жилья",
      "mortgage": "Новая ипотека",
      "new_loan": "Новый кредит",
      "business_start": "Открытие бизнеса",
      "retirement_planning": "Планирование пенсии",
      "divorce": "Развод",
      "new_property": "Новая недвижимость",
      "other": "Другое жизненное событие"
    },
    "docCategory": {
      "identity": "Удостоверение личности",
      "policies": "Полисы",
      "applications": "Заявки",
      "tax": "Налоги",
      "income": "Доход",
      "medical": "Медицинские",
      "loans": "Кредиты",
      "claims": "Страховые случаи",
      "quotations": "Котировки",
      "signed": "Подписанные",
      "other": "Другое"
    }
  },
  "today": {
    "greeting": "{part, select, morning {Доброе утро} afternoon {Добрый день} other {Добрый вечер}}{name, select, none {} other {, {name}}}",
    "summary": "{attention, plural, =0 {Срочных дел нет.} one {# клиент требует вашего внимания.} few {# клиента требуют вашего внимания.} many {# клиентов требуют вашего внимания.} other {# клиента требуют вашего внимания.}} {agenda, plural, =0 {В ежедневнике на сегодня пусто.} one {В ежедневнике на сегодня # пункт.} few {В ежедневнике на сегодня # пункта.} many {В ежедневнике на сегодня # пунктов.} other {В ежедневнике на сегодня # пункта.}}",
    "attention_title": "Поле внимания",
    "attention_hint": "По срочности, с причиной и следующим шагом.",
    "attention_empty": "В вашем портфеле всё в порядке. Используйте время, чтобы позвонить тому, с кем давно не говорили.",
    "agenda_title": "Сегодня",
    "agenda_empty": "На сегодня нет встреч и задач.",
    "overdue_title": "Просрочено",
    "cases_title": "Заявки в работе",
    "cases_empty": "Нет активных заявок.",
    "moments_title": "Поводы",
    "moments_empty": "В ближайшие дни нет дней рождения и именин.",
    "stat_people": "Люди",
    "stat_clients": "Клиенты",
    "stat_portfolio": "Годовой портфель",
    "stat_open_cases": "Активные заявки",
    "stat_reviews_due": "Ожидают обзора",
    "stat_overdue": "Просроченные действия",
    "show_more": "Показать ещё {count}",
    "focus_mode": "Фокус",
    "waiting_title": "Решения и ожидание",
    "waiting_client": "Ждём: {name}"
  },
  "attention": {
    "reason": {
      "task_overdue": "Срок «{title}» истёк {days, plural, one {# день назад} few {# дня назад} many {# дней назад} other {# дня назад}}",
      "task_today": "«{title}» — срок сегодня{time, select, none {} other { в {time}}}",
      "appointment_today": "Встреча сегодня в {time}: {title}",
      "appointment_tomorrow": "Встреча завтра в {time} — подготовьте материалы",
      "case_stalled": "{product} без движения уже {days} дн. ({stage})",
      "case_missing": "{product}: {count, plural, one {не хватает # документа} few {не хватает # документов} many {не хватает # документов} other {не хватает # документа}}",
      "case_no_next": "{product} ({stage}): следующий шаг не запланирован",
      "case_target": "{product}: плановая дата выдачи — {date}",
      "review_overdue": "Ежегодный обзор просрочен на {days} дн.",
      "review_never": "{policies, plural, one {# действующий полис} few {# действующих полиса} many {# действующих полисов} other {# действующего полиса}}, обзора ещё не было",
      "review_due_soon": "Ежегодный обзор {date}",
      "renewal_soon": "{product}: продление {date}",
      "birthday": "{when, select, today {День рождения сегодня} tomorrow {День рождения завтра} other {День рождения {date}}} — исполняется {age}",
      "nameday": "{when, select, today {Именины сегодня} tomorrow {Именины завтра} other {Именины {date}}} ({feast})",
      "child_milestone": "{child} исполняется {age} {date} — обзор образования / защиты",
      "protection_gap": "{children, plural, one {# ребёнок на иждивении} few {# ребёнка на иждивении} many {# детей на иждивении} other {# ребёнка на иждивении}}, но нет действующей защиты жизни",
      "no_next_step": "{kind, select, offer {Открытое предложение} case {Открытая заявка} other {Открытая возможность}} без запланированного следующего шага",
      "silence": "Нет контакта с активным клиентом уже {days} дн.",
      "prospect_followup": "Повторный контакт с потенциальным клиентом {name} ({list}) был запланирован на {date}",
      "data_quality": "Нет телефона и e-mail — связаться невозможно",
      "hot": "Тёплый: {signal}{more, plural, =0 {} one { + ещё # сигнал} few { + ещё # сигнала} many { + ещё # сигналов} other { + ещё # сигнала}}",
      "promise_overdue": "Вы обещали «{title}» — опоздание {days, plural, one {# день} few {# дня} many {# дней} other {# дня}}",
      "waiting_client": "Ждём клиента: «{title}» — {days, plural, one {# день} few {# дня} many {# дней} other {# дня}} после срока",
      "quote_expiring": "Котировка {product} {when, select, past {истекла {date}} other {истекает {date}}}",
      "decision_pending": "Решение по «{title}» ожидается уже {days} дн. — повторный контакт не запланирован",
      "needs_missing": "{children, plural, one {# ребёнок зависит} few {# ребёнка зависят} many {# детей зависят} other {# ребёнка зависят}} от этого клиента — анализа потребностей ещё нет",
      "claim_followup": "Страховой случай «{type}» ({status}) требует внимания — {days, plural, =0 {обновлён сегодня} one {последнее обновление # день назад} few {последнее обновление # дня назад} many {последнее обновление # дней назад} other {последнее обновление # дня назад}}",
      "service_open": "Запрос на обслуживание «{title}» открыт уже {days} дн.",
      "referral_thanks": "Порекомендовал(а) {name} — поблагодарите",
      "policy_lapsed": "{product} прекратил действие {days, plural, =0 {сегодня} one {# день назад} few {# дня назад} many {# дней назад} other {# дня назад}} — звонок часто помогает его восстановить",
      "payment_late_verified": "{product}: страховщик подтверждает просрочку платежа",
      "payment_late_note": "{product}: вы отметили возможную просрочку платежа (страховщик не подтвердил)",
      "life_event": "Жизненное событие: {event} ({date}) — возможно, нужен обзор защиты",
      "loan_maturity": "{label}: окончание {date}",
      "mortgage_gap": "Остаток ипотеки {balance, number, currency}, но к ней привязано лишь {cover, number, currency} страхования жизни",
      "education_milestone": "{child} исполняется {age} {date} — хороший повод обсудить планы на образование",
      "extraction_review": "{count, plural, one {# значение из документа ожидает} few {# значения из документа ожидают} many {# значений из документа ожидают} other {# значения из документа ожидают}} вашей проверки",
      "sync_conflict": "Запись «{table}» изменена на двух устройствах — выберите, какую версию сохранить",
      "insured_due": "{what}: {label} — {date}",
      "premium_overdue": "{product}: взнос со сроком {date} ещё не получен ({days, plural, one {# день} few {# дня} many {# дней} other {# дня}})",
      "premium_lapse_risk": "{product}: взнос просрочен на {days, plural, one {# день} few {# дня} many {# дней} other {# дня}} — риск прекращения полиса",
      "kyc_due": "Пересмотр KYC/AML {date}",
      "kyc_overdue": "Пересмотр KYC/AML был назначен на {date} — обновите файл"
    },
    "action": {
      "complete_task": "Выполнить",
      "call": "Позвонить",
      "open_case": "Открыть заявку",
      "schedule_next": "Запланировать шаг",
      "request_documents": "Запросить документы",
      "start_review": "Начать обзор",
      "schedule_review": "Назначить обзор",
      "send_wishes": "Поздравить",
      "prepare_meeting": "Подготовить встречу",
      "discuss_protection": "Обсудить защиту",
      "reconnect": "Возобновить связь",
      "call_prospect": "Позвонить",
      "complete_profile": "Заполнить профиль",
      "open": "Открыть",
      "keep_promise": "Выполнить обещание",
      "chase_client": "Напомнить клиенту",
      "follow_quote": "Уточнить по котировке",
      "start_needs": "Анализ потребностей",
      "open_service": "Открыть обслуживание",
      "thank": "Поблагодарить",
      "resolve_conflict": "Разрешить",
      "review_extraction": "Проверить значения",
      "open_insured": "Открыть объекты",
      "open_kyc": "Открыть KYC"
    },
    "why": "Почему",
    "evidence": "Основание",
    "dismiss": "Отложить до завтра",
    "snoozed": "Отложено до завтра"
  },
  "brief": {
    "title": "Сводка по клиенту",
    "who": "Кто",
    "why": "Почему сейчас",
    "done": "Что сделано",
    "missing": "Чего не хватает",
    "next": "Следующее лучшее действие",
    "last_contact": "Последний контакт {date} · {what}",
    "never_contacted": "Контактов пока не зафиксировано",
    "nothing_missing": "Всё на месте — отношения в хорошем состоянии",
    "no_reason": "Срочных причин нет — поддерживайте отношения",
    "since": "Отношения с {date}",
    "age": "{age} лет",
    "children": "{count, plural, one {# ребёнок} few {# ребёнка} many {# детей} other {# ребёнка}}",
    "open_items": "{count, plural, =0 {нет открытых действий} one {# открытое действие} few {# открытых действия} many {# открытых действий} other {# открытого действия}}"
  },
  "people": {
    "title": "Люди",
    "subtitle": "Клиенты, потенциальные клиенты и их семьи",
    "search": "Имя, телефон, e-mail, профессия…",
    "new": "Новый человек",
    "count": "{count, plural, one {# человек} few {# человека} many {# человек} other {# человека}}",
    "empty": "Под эти фильтры никто не подходит.",
    "filter_stage": "Этап",
    "filter_attention": "Требуют внимания",
    "filter_review": "Ожидают обзора",
    "filter_hot": "Горячие",
    "filter_policies": "С полисами",
    "sort_attention": "По срочности",
    "sort_name": "По имени",
    "sort_recent": "Недавно изменённые",
    "archived": "В архиве",
    "register": "Список клиентов",
    "register_hint": "Распечатайте или выгрузите всех клиентов с датой начала отношений и источником",
    "filter_source": "Источник"
  },
  "person": {
    "display_name": "Имя и фамилия",
    "first_name": "Имя",
    "last_name": "Фамилия",
    "stage": "Этап",
    "phone": "Мобильный телефон",
    "email": "E-mail",
    "birth_date": "Дата рождения",
    "name_day": "Именины (ММ-ДД, если нужно указать вручную)",
    "occupation": "Профессия",
    "employer": "Работодатель",
    "address": "Адрес",
    "city": "Город",
    "region": "Регион / район",
    "source": "Источник",
    "referred_by": "По рекомендации",
    "gender": "Пол",
    "marital_status": "Семейное положение",
    "notes": "Важные примечания",
    "hot": "Горячая возможность",
    "new_title": "Новый человек",
    "edit_title": "Изменить данные",
    "archive": "В архив",
    "archive_confirm": "Переместить {name} в архив? История сохранится, запись можно восстановить.",
    "created": "Добавлено: {name}",
    "updated": "Изменения сохранены",
    "duplicate_warning": "Возможный дубликат: у {name} тот же телефон или e-mail.",
    "client_since": "Клиент с",
    "client_since_hint": "День, когда человек стал вашим клиентом.",
    "client_since_hint_derived": "Если пусто, используется {date} ({basis}).",
    "source_other": "Другой источник…",
    "source_own": "Ваш источник",
    "source_own_ph": "напр. спортзал, родительский комитет",
    "referred_by_hint": "Выберите существующего человека или введите имя",
    "since_basis": {
      "recorded": "указано вручную",
      "first_policy": "первый полис",
      "added": "добавлен в AVRASTRO"
    },
    "client_since_label": "Клиент с {date}",
    "source_label": "Источник: {source}",
    "referred_by_label": "по рекомендации: {name}"
  },
  "focus": {
    "tabs": {
      "overview": "Обзор",
      "policies": "Полисы",
      "cases": "Заявки",
      "actions": "Действия",
      "notes": "Заметки",
      "reviews": "Обзоры",
      "household": "Семья",
      "documents": "Документы и обслуживание",
      "records": "Записи",
      "comparisons": "Сравнения",
      "advisory": "Консультирование",
      "conversations": "Общение",
      "service": "Обслуживание",
      "growth": "Рост",
      "protection": "Защита",
      "insured": "Застрахованные объекты",
      "kyc": "KYC / AML",
      "risk": "Профиль риска"
    },
    "more": {
      "contact": "Контакт",
      "advice": "Консультации и продажи",
      "service": "Обслуживание",
      "docs": "Документы и налоги"
    },
    "quick": {
      "note": "Заметка",
      "followup": "Напоминание",
      "appointment": "Встреча",
      "case": "Заявка",
      "policy": "Полис",
      "review": "Обзор"
    },
    "timeline": "История",
    "timeline_empty": "Истории пока нет.",
    "attention": "Требует внимания",
    "contact": "Связаться"
  },
  "pulse": {
    "policies": "Действующие полисы",
    "portfolio": "Годовой портфель",
    "open_actions": "Открытые действия",
    "review": "Обзор",
    "cases": "Активные заявки",
    "next_move": "Следующий шаг",
    "none": "—"
  },
  "policy": {
    "title": "Полисы",
    "new": "Новый полис",
    "edit": "Изменить полис",
    "product": "Продукт / программа",
    "carrier": "Страховщик",
    "number": "Номер полиса",
    "branch": "Вид страхования",
    "status": "Статус",
    "start": "Дата начала",
    "renewal": "Продление / годовщина",
    "end": "Окончание / срок дожития",
    "premium_annual": "Годовой взнос",
    "premium_monthly": "В пересчёте на месяц",
    "frequency": "Периодичность оплаты",
    "method": "Способ оплаты",
    "sum_assured": "Страховая сумма / выплата",
    "insured": "Застрахованное лицо",
    "beneficiaries": "Выгодоприобретатели",
    "current_premium": "Текущий взнос",
    "adjustments": "{count, plural, one {# изменение взноса} few {# изменения взноса} many {# изменений взноса} other {# изменения взноса}}",
    "empty": "Полисов нет.",
    "premium_suspicious": "Проверьте этот взнос — возможна ошибка с десятичной запятой из старой CRM",
    "next_anniversary": "Следующая годовщина {date}",
    "total": "Итого годовых взносов",
    "owner": "Страхователь",
    "service_health": "Обслуживание",
    "health_ok": "Всё в порядке",
    "health_open": "Открытые вопросы",
    "open_items": "{count, plural, =0 {открытых вопросов нет} one {# открытый вопрос} few {# открытых вопроса} many {# открытых вопросов} other {# открытого вопроса}}",
    "in_days": "{days, plural, =0 {сегодня} one {через # день} few {через # дня} many {через # дней} other {через # дня}}",
    "premium_history": "История взносов",
    "initial": "Начальный взнос",
    "premium": "Взнос",
    "instalment": "Платёж",
    "instalment_for": "Платёж ({freq})",
    "single_premium": "Единовременный взнос",
    "single_hint": "Оплачивается один раз — не пересчитывается в годовой и не учитывается как регулярный взнос.",
    "annual_eq_hint": "= {annual} в год · {monthly} в месяц",
    "eq_annual": "в год",
    "eq_monthly": "в месяц",
    "equivalent_hint": "Эквиваленты рассчитываются из суммы платежа и периодичности; платёж — это то, что клиент фактически платит.",
    "quoted": "по котировке",
    "premium_locked": "Используйте «Изменить взнос», чтобы каждое изменение было датировано и сохранялось в истории.",
    "change_premium": "Изменить взнос",
    "change_status": "Изменить статус",
    "status_from": "Новый статус (сейчас: {status})",
    "status_saved": "Статус обновлён",
    "cancel_reverses": "Аннулирован в течение {days, plural, one {# дня} few {# дней} many {# дней} other {# дня}} после выдачи: зачёт за новый бизнес будет сторнирован в продажах.",
    "reactivation_note": "При восстановлении взнос снова засчитывается — как восстановление, а не как новый бизнес.",
    "adjust_mode": "Как вы хотите ввести изменение?",
    "adjust_new": "Новая сумма",
    "adjust_delta": "Изменение (+ или −)",
    "adjust_current": "сейчас {amount}",
    "effective_date": "Действует с",
    "adjust_future": "Вступает в силу {date}. До этого действует текущий взнос.",
    "adjust_backdated": "Задним числом: продажи засчитываются по вашим настройкам с пометкой «задним числом».",
    "adjust_production": "Продажи: {amount} (засчитывается только разница)",
    "adjust_reason": "Причина",
    "adjust_reason_ph": "напр. индексация, дополнительное покрытие, просьба клиента",
    "increase_saved": "Повышение взноса записано",
    "decrease_saved": "Снижение взноса записано",
    "pending_change": "с {date}: {amount}",
    "future": "предстоит",
    "original": "первоначальный взнос",
    "reverse": "Сторнировать",
    "reverse_hint": "Сторно отменяет это изменение и его зачёт в продажах. Ничего не удаляется — обе записи остаются в истории.",
    "reversed": "Изменение сторнировано",
    "timeline": "История полиса",
    "remaining": "Осталось",
    "months": "{count, plural, one {# месяц} few {# месяца} many {# месяцев} other {# месяца}}",
    "months_left": "{count, plural, one {остался # месяц} few {осталось # месяца} many {осталось # месяцев} other {осталось # месяца}}",
    "category": "Категория",
    "category_auto": "Автоматически ({category})",
    "currency": "Валюта",
    "more_details": "Подробнее",
    "parties": "Лица по полису",
    "party_add": "Добавить лицо",
    "party_other": "Другое лицо (только имя)",
    "benefits": "Выплаты",
    "benefit_add": "Добавить выплату",
    "benefits_count": "{count, plural, one {# выплата} few {# выплаты} many {# выплат} other {# выплаты}}",
    "no_benefits": "выплаты не указаны",
    "all_insured": "все застрахованные",
    "amount": "Сумма",
    "guaranteed": "гарантировано",
    "projected": "прогноз",
    "tags": "Покрываемые потребности",
    "tags_hint": "предложения выделены",
    "tags_apply": "Применить предложения",
    "color": "Цвет",
    "color_hint": "заменяет цвет категории или страховщика",
    "color_auto": "Автоматически",
    "replaces": "Заменяет полис",
    "payment_note": "Статус оплаты",
    "payment_hint": "напр. банк вернул прямое дебетование",
    "payment_verified": "Подтверждено страховщиком",
    "payment": {
      "late": "Просрочка",
      "ok": "Оплачено"
    },
    "payment_late_verified": "Просрочка платежа (подтверждена)",
    "payment_late_note": "Возможная просрочка платежа (ваша заметка)",
    "color_source": {
      "manual": "выбранный цвет",
      "category": "цвет категории",
      "insurer": "цвет страховщика"
    },
    "from_pdf": "Полис из PDF"
  },
  "case": {
    "title": "Заявки",
    "subtitle": "Путь заявки от черновика до выдачи полиса",
    "new": "Новая заявка",
    "product": "Продукт / программа",
    "insurer": "Страховщик",
    "number": "Номер заявки",
    "stage": "Этап",
    "premium": "Годовой взнос",
    "sum_assured": "Страховая сумма",
    "target": "Плановая дата выдачи",
    "next_action": "Следующий шаг",
    "next_action_date": "Дата следующего шага",
    "next_action_time": "Время",
    "requirements": "Документы",
    "missing": "{count, plural, =0 {Все документы на месте} one {не хватает #} few {не хватает #} many {не хватает #} other {не хватает #}}",
    "age": "{days} дн.",
    "stalled": "Без движения",
    "history": "История заявки",
    "move_to": "Перевести: {stage}",
    "advance": "Следующий этап",
    "terminal": "Закрыть как…",
    "issued_policy": "Полис создан по этой заявке",
    "empty": "Заявок пока нет.",
    "add_requirement": "Добавить документ",
    "journey": "Путь",
    "all_stages": "Все этапы",
    "active": "Активные",
    "closed": "Закрытые",
    "event": {
      "created": "Заявка создана"
    },
    "created": "Заявка создана",
    "stage_changed": "Переведена на этап: {stage}",
    "category": "Категория продукта",
    "category_ph": "напр. жизнь, здоровье, накопления",
    "reopened": "Заявка открыта снова",
    "reopened_on": "Открыта снова {date}"
  },
  "task": {
    "new_followup": "Новое напоминание",
    "new_appointment": "Новая встреча",
    "new_task": "Новая задача",
    "edit": "Изменить",
    "title": "Название",
    "kind": "Тип",
    "due_date": "Дата",
    "due_time": "Время",
    "duration": "Длительность (мин)",
    "location_type": "Место",
    "location": "Адрес / ссылка",
    "complete": "Выполнить",
    "complete_title": "Выполнить: {title}",
    "outcome": "Результат",
    "result_note": "Что произошло?",
    "overdue": "Просрочено",
    "no_date": "Без даты",
    "reopen": "Открыть снова",
    "office_autofill": "Адрес офиса из вашего профиля подставляется автоматически.",
    "created": "Добавлено в ежедневник",
    "completed": "Выполнено",
    "delete_confirm": "Удалить эту задачу?",
    "prospect": "Потенциальный клиент: {name}",
    "edit_appointment": "Изменить встречу",
    "edit_task": "Изменить задачу",
    "updated": "Изменения сохранены",
    "video_moved": "Видеозвонок перенесён на новое время — ссылка клиента не меняется. Отправьте ему новое сообщение.",
    "video_keeps_link": "Видеозвонок AVRASTRO · при смене даты или времени комната переносится вместе с ним (ссылка клиента не меняется)."
  },
  "appointment": {
    "calendar_file": "Файл календаря (.ics)",
    "google": "Добавить в Google Календарь",
    "drafts": "Черновики сообщений",
    "draft_note": "Черновики открываются в вашем приложении — ничего не отправляется автоматически.",
    "maps": "Открыть карту"
  },
  "note": {
    "new": "Новая заметка / следующий шаг",
    "title": "Заголовок",
    "body": "Заметка",
    "placeholder": "Запишите, что нужно помнить, что вы обещали и что будет дальше…",
    "remind": "Добавить в ежедневник на",
    "saved": "Заметка сохранена",
    "empty": "Заметок пока нет.",
    "pinned": "Закреплена",
    "action_type": "Тип действия",
    "action": {
      "note": "Заметка",
      "call": "Звонок",
      "followup": "Напоминание",
      "appointment": "Встреча",
      "waiting": "Ожидание ответа",
      "document": "Документы",
      "review": "Обзор",
      "service": "Обслуживание",
      "application": "Заявка"
    }
  },
  "review": {
    "title": "Центр обзоров",
    "subtitle": "Ежегодные обзоры для всех активных клиентов",
    "due_now": "Просрочено",
    "never": "Обзора не было",
    "due_soon": "В ближайшие 30 дней",
    "ok": "Актуально",
    "complete": "Записать обзор",
    "date": "Дата обзора",
    "outcome": "Результат",
    "next_date": "Следующий обзор",
    "notes": "Что изменилось? Семья, доход, здоровье, цели…",
    "followup": "Дата повторного контакта (необязательно)",
    "saved": "Обзор записан",
    "last": "Последний обзор {date}",
    "due": "Срок {date}",
    "followup_title": "Повторный контакт после обзора",
    "empty": "В этой группе нет обзоров.",
    "history": "История обзоров",
    "since_last": "Изменения с последнего обзора ({date})",
    "no_changes": "С последнего обзора изменений не зафиксировано.",
    "change": {
      "life_event": "Жизненное событие",
      "policy_new": "Новый полис",
      "premium_change": "Изменение взноса",
      "income": "Доход",
      "liability": "Кредит",
      "child": "Новый ребёнок",
      "needs_revision": "Пересмотр анализа потребностей",
      "claim": "Страховой случай"
    },
    "questions": "Вопросы обзора",
    "questions_note": "Ответы сохраняются вместе с обзором как подтверждение; изменения в жизни клиента или ответ «нет» на проверку создают задачу.",
    "answer_note": "Примечание (необязательно)",
    "a": {
      "yes": "Да",
      "no": "Нет",
      "na": "н/п"
    },
    "q": {
      "life_changes": "Есть изменения в семье, жилье или работе?",
      "income_change": "Заметно ли изменился доход?",
      "new_debts": "Новые кредиты или ипотека?",
      "health_changes": "Изменения в здоровье, которые могут повлиять на покрытие?",
      "dependants_changed": "Новые иждивенцы (дети, родители)?",
      "goals_changed": "Изменились цели (накопления, образование, пенсия)?",
      "beneficiaries_ok": "Выгодоприобретатели по-прежнему указаны верно?",
      "cover_adequate": "Покрытие по-прежнему достаточно?",
      "satisfied": "Довольны ли обслуживанием?",
      "referral_asked": "Спросили о друзьях или родственниках, которым это может быть полезно?"
    },
    "action": {
      "life_changes": "Пересмотреть защиту после изменений в жизни",
      "income_change": "Перепроверить защиту дохода и накопления",
      "new_debts": "Проверить страхование кредита / ипотеки",
      "health_changes": "Проверить медицинское покрытие и раскрытие сведений",
      "dependants_changed": "Обновить данные о семье и потребности в защите",
      "goals_changed": "Обновить анализ потребностей под новые цели",
      "beneficiaries_ok": "Обновить выгодоприобретателей у страховщика",
      "cover_adequate": "Подготовить предложение, чтобы закрыть пробел в покрытии",
      "satisfied": "Перезвонить по поводу удовлетворённости обслуживанием"
    },
    "evidence": "Подтверждение: отвечено {answered} из {total} вопросов",
    "portfolio_then": "портфель тогда {amount}",
    "actions_count": "к действию: {count}"
  },
  "household": {
    "title": "Семья",
    "children": "Дети и иждивенцы",
    "add_child": "Добавить ребёнка",
    "child_name": "Имя ребёнка",
    "age": "{age} л.",
    "empty": "Члены семьи не указаны.",
    "linked": "Связанные люди",
    "coverage": "Покрытие семьи"
  },
  "documents": {
    "title": "Документы",
    "service": "Обслуживание и страховые случаи",
    "empty": "Документов нет.",
    "service_empty": "Обращений по обслуживанию нет.",
    "note": "Файлы остаются в вашем хранилище документов; AVRASTRO хранит метаданные и ссылки.",
    "new": "Новый документ",
    "name": "Документ",
    "reference": "Номер",
    "link": "Ссылка",
    "link_hint": "Где хранится файл (диск, e-mail, портал страховщика)",
    "delete_confirm": "Убрать «{title}» из реестра?",
    "type": {
      "identity": "Удостоверение личности / паспорт",
      "address": "Подтверждение адреса",
      "bank": "Банк / SEPA",
      "medical": "Медицинские",
      "financial": "Финансовые документы",
      "policy": "Полис",
      "application": "Заявление",
      "claim": "Документ по страховому случаю",
      "proposal": "Предложение",
      "quotation": "Котировка",
      "other": "Другое"
    },
    "title_label": "Название"
  },
  "records": {
    "title": "Сохранённые записи",
    "subtitle": "Данные из прежних модулей AVRASTRO, сохраняемые без изменений до выхода нового модуля.",
    "empty": "Сохранённых записей нет.",
    "kind": {
      "meeting": "Встреча",
      "needs_analysis": "Анализ потребностей",
      "tax_profile": "Налоговый профиль",
      "risk_profile": "Профиль риска",
      "quote": "Котировка",
      "proposal": "Предложение",
      "comparison": "Сравнение полисов",
      "communication": "Коммуникация",
      "feedback": "Отзыв",
      "outcome": "Результат",
      "opportunity": "Возможность",
      "referral": "Рекомендация",
      "consent": "Согласие",
      "weekly_fund": "Еженедельная сводка по фондам",
      "pending_decision": "Ожидающее решение",
      "promise": "Обязательство",
      "sync_inbox": "Элемент синхронизации с планшета",
      "group_plan": "Групповая программа",
      "profile_brief": "Краткий профиль",
      "other": "Другое"
    }
  },
  "prospects": {
    "title": "Привлечение",
    "subtitle": "Списки, сеансы обзвона и конверсия",
    "lists": "Списки",
    "new_list": "Новый список",
    "list_name": "Название списка",
    "import": "Импорт контактов",
    "import_hint": "Вставьте строки из Excel или CSV. Столбцы: имя, телефон, e-mail, профессия, компания, район, источник, примечания (строка заголовков необязательна).",
    "preview": "{unique} новых · {dupes} дубликатов · {clients} уже клиенты",
    "legend_unique": "Новый",
    "legend_dupe": "Дубликат",
    "legend_client": "Уже клиент",
    "add_rows": "Добавить контакты: {count}",
    "call_sheet": "Печать листа обзвона",
    "convert": "Создать карточку человека",
    "converted": "Переведён",
    "empty_list": "Список пуст.",
    "no_lists": "Создайте первый список, чтобы начать обзвон.",
    "calling": "Сеанс обзвона",
    "next": "Следующий контакт",
    "followup_on": "Повторный контакт",
    "stats": "Обзвонено {called} из {total} · заинтересованы: {interested}",
    "density": "Плотность",
    "compact": "Компактно",
    "normal": "Обычно",
    "detailed": "Подробно",
    "handwritten": "Заметки",
    "import_file": "Выберите файл CSV или Excel",
    "first_row_header": "Первая строка — заголовки",
    "ignore": "— не импортировать —",
    "map_column": "Столбец {n}",
    "field": {
      "name": "Имя",
      "phone": "Телефон",
      "email": "E-mail",
      "profession": "Профессия",
      "company": "Компания",
      "area": "Район",
      "source": "Источник",
      "notes": "Примечания"
    }
  },
  "agenda": {
    "day_sheet": "Лист дня",
    "day_sheet_hint": "Две страницы A4 дневного плана, заполненные встречами, звонками и напоминаниями на день из CRM",
    "title": "Ежедневник",
    "subtitle": "Встречи, напоминания и задачи",
    "week": "Неделя",
    "list": "Список",
    "prev": "Назад",
    "next": "Вперёд",
    "this_week": "Эта неделя",
    "overdue": "Просрочено",
    "no_items": "Свободно",
    "unscheduled": "Без даты",
    "print": "Печать ежедневника",
    "mode": {
      "day": "День",
      "week": "Неделя",
      "month": "Месяц"
    },
    "day_summary": "День одним взглядом",
    "markers": "Поводы и даты"
  },
  "goals": {
    "title": "Цели на сегодня",
    "subtitle": "Рассчитываются на этом устройстве по рабочим часам, расписанию, задачам, спискам звонков и записанным действиям — без ИИ, ничего не выдумывается.",
    "recompute": "Пересчитать",
    "recompute_hint": "Рассчитать заново по текущему расписанию — ваши числа и пропуски сохраняются",
    "recomputed": "Цели пересчитаны — ваши числа сохранены",
    "prefs": "Настройки целей",
    "plan_day": "План дня",
    "not_computed": "Целей на этот день пока нет.",
    "compute": "Рассчитать цели",
    "free_line": "Свободно {free} из {work} рабочих часов ({from}–{to})",
    "none": "На этот день предложить нечего: нет свободного времени, номеров для звонков и просроченных дел.",
    "counted": "Прогресс учитывает только записанное — звонки, выполненные задачи, сообщения, назначенные встречи — каждое один раз.",
    "none_day_off": "{date} — нерабочий день в Настройках → Часы работы, поэтому целей нет.",
    "compute_anyway": "Всё равно задать цели",
    "skipped": "Пропущено сегодня",
    "progress": "{done} из {target}",
    "adjusted": "Ваше число (предложено: {n})",
    "decrease": "Уменьшить цель",
    "increase": "Увеличить цель",
    "target_for": "Цель «{goal}»",
    "resume": "Вернуть",
    "skip": "Не сегодня",
    "market": "Заметка о рынке",
    "market_remove": "Удалить",
    "market_add": "Добавить заметку о рынке (с источником)",
    "market_hint": "Только то, что добавляете вы сами, с источником — CRM никогда не пишет рыночные новости.",
    "market_text": "Что произошло",
    "market_source": "Источник (например, пресс-релиз ЕЦБ)",
    "market_url": "Ссылка (необязательно)",
    "saved": "Сохранено",
    "prefs_saved": "Настройки целей сохранены — действуют со следующего расчёта",
    "pref_goal": "Цель",
    "pref_on": "Предлагать",
    "pref_min": "Минимум",
    "pref_max": "Максимум",
    "pref_util": "Доля свободного времени для целей",
    "prefs_note": "Отключённые цели не предлагаются вовсе. Минимум и максимум действуют для предложения; число на день всегда можно изменить.",
    "type": {
      "prospecting_calls": "Звонки потенциальным клиентам",
      "customer_contacts": "Контакты с текущими клиентами",
      "appointments": "Назначить встречи",
      "overdue_followups": "Закрыть просроченные follow-up",
      "renewals": "Связаться по продлениям"
    },
    "why": {
      "overdue": "Просроченные follow-up: {count}",
      "time_limited": "Сегодня свободно только {hours} ч, поэтому не все",
      "renewals": "Клиенты с продлением в ближайшие {days} дней, без контакта последние 2 недели: {count}",
      "contacts_due": "Звонки и follow-up клиентам на сегодня: {count}",
      "contacts_time": "Около {minutes} минут свободного времени для клиентов",
      "light_day": "Лёгкий день: свободно {hours} ч",
      "full_day": "Загруженный день: свободно только {hours} ч",
      "performance_low": "За последние 4 недели вы достигли {rate}% этой цели — чуть ниже",
      "performance_high": "За последние 4 недели вы достигли {rate}% этой цели — чуть выше",
      "calls_time": "{hours} ч на звонки → {count} звонков в вашем обычном темпе ({pace} в час)",
      "calls_time_default": "{hours} ч на звонки → {count} звонков по {pace} в час (начальный темп, пока звонков записано мало)",
      "queue": "Номера в ваших списках, готовые к звонку: {count} (ни разу не звонили: {fresh})",
      "queue_limited": "Не больше {count} номеров в ваших списках",
      "week_meetings": "Цель недели: {goal} встречи, назначено {booked} → ещё {need} за {days} рабочих дн.",
      "expected_from_calls": "При вашей доле ({rate}% звонков) сегодняшние звонки дадут около {count}",
      "pref_min": "Ваш минимум: {value}",
      "pref_max": "Ваш максимум: {value}"
    },
    "relationship": "Встречи для отношений (кофе / рекомендация): запланировано {planned} · проведено {done}",
    "relationship_hint": "считаются отдельно — не как встречи",
    "title_for": "Цели · {date}"
  },
  "planner": {
    "title": "План дня",
    "hint": "Быстрое добавление: тип → время → длительность → Enter (клавиша «n» — перейти туда) · щелчок по свободному времени — блок · перетащите блок, чтобы перенести, нижний край — чтобы изменить длительность · клавиатура: ↑ ↓ перенос, Shift + ↑ ↓ длительность, Enter открыть, Delete отменить, Ctrl + Enter выполнено. Встречи отсюда не переносятся.",
    "conflicts": "Пересечения: {count} — показаны, не изменены",
    "outside": "Вне показанных часов: {count}",
    "add": "Блок",
    "add_at": "Добавить блок в {time}",
    "free": "свободно",
    "suggestion": "предложение",
    "committed": "Встреча — изменяется в своей форме",
    "overlap": "Пересекается с другим",
    "accept": "Принять",
    "dismiss": "Не сегодня",
    "complete": "Готово",
    "edit": "Изменить",
    "open": "Открыть",
    "cancel": "Отменить блок",
    "unplanned": "Без времени",
    "plan_task": "В план",
    "legend_own": "Ваши блоки и задачи",
    "hours_from": "План начинается в",
    "hours_to": "План заканчивается в",
    "minutes": "{n} мин",
    "form_title": "Блок в вашем плане",
    "form_new": "Новый блок в плане",
    "field": {
      "title": "Что",
      "kind": "Тип",
      "start": "С",
      "end": "До",
      "notes": "Заметки",
      "person": "С кем (необязательно)"
    },
    "goal_block": "{goal} · {count}",
    "source": {
      "appointment": "Встреча"
    },
    "kind": {
      "focus": "Время для сосредоточения",
      "personal": "Личное время",
      "task": "Задача",
      "goal": "Цель",
      "admin": "Офисные дела",
      "travel": "Дорога",
      "break": "Перерыв"
    },
    "moved": "Перенесено",
    "done": "Отмечено как выполненное",
    "cancelled": "Блок отменён",
    "accepted": "Добавлено в план",
    "dismissed": "Скрыто на сегодня",
    "planned": "Добавлено в план",
    "no_free": "В рабочих часах не осталось свободных 30 минут",
    "saved": "Сохранено в плане",
    "confirm_conflict": "Это пересекается со встречей. Встреча остаётся на своём месте. Оставить оба в одно время?",
    "type": {
      "client_appointment": "Встреча с клиентом (страхование)",
      "coffee": "Кофе / знакомство",
      "referral_meeting": "Встреча по рекомендации",
      "calls": "Звонки (поиск клиентов)",
      "followup": "Follow-up / повторный контакт",
      "admin": "Почта и офисные дела",
      "prep": "Подготовка к встрече",
      "learning": "Обучение / изучение",
      "team": "Команда / совещание",
      "travel": "Дорога",
      "break": "Перерыв",
      "personal": "Личное",
      "other": "Другое",
      "focus": "Сосредоточенная работа",
      "task": "Задача",
      "goal": "Цель"
    },
    "planning_for": "Вы планируете",
    "rel": {
      "today": "Сегодня",
      "tomorrow": "Завтра",
      "after": "Послезавтра",
      "past": "Прошедший день"
    },
    "pick_date": "Выбрать дату",
    "templates": "Шаблоны дня",
    "copy_from": "Копировать из…",
    "move": "Перенести на другую дату",
    "move_none": "Нет ваших блоков для переноса",
    "print": "Печать",
    "accept_all": "Все предложения в план ({count})",
    "accepted_all": "Предложения добавлены в план",
    "done_social": "Выполнено — записано в историю человека (не как встреча)",
    "duration": "Длительность",
    "qa_add": "Добавить",
    "qa_appointment": "Новая встреча…",
    "social_hint": "Знакомство или рекомендация без продажи: учитывается отдельно от страховых встреч. Если выбрать человека, после выполнения это попадёт в его историю как последний контакт.",
    "appointment_hint": "Страховая встреча становится настоящей встречей в CRM (клиент, место, напоминания) и учитывается как встреча.",
    "move_intro": "Все ваши блоки и принятые предложения за {date} переносятся на то же время.",
    "move_what": "Переносится блоков: {count} → {date}",
    "move_go": "Перенести ({count})",
    "move_staying": "Остаются на месте ({count}) — встречи и задачи CRM отсюда не переносятся:",
    "move_over": "В новую дату блоков на встречах: {count}. Перед сохранением будет вопрос (встречи не меняются).",
    "move_overlap": "Пересечений с другими блоками нового дня: {count} — они будут показаны.",
    "move_undo": "После переноса «Отменить» в сообщении вернёт всё сразу.",
    "moved_day": "Перенесено блоков: {count} на {date}",
    "copy": {
      "yesterday": "Со вчерашнего дня",
      "lastWeek": "С того же дня прошлой недели"
    },
    "copy_counts": "Добавится: {add} · пропущено: {skipped} (пересекаются)",
    "copy_go": "Копировать",
    "copied": "Скопировано блоков: {count}",
    "copy_intro": "Ваши блоки (не задачи) копируются на {date}; пересекающиеся с уже запланированным пропускаются.",
    "templates_intro": "Шаблон заполняет {date} готовыми блоками (встроенные следуют началу рабочего дня); ничего не ставится поверх встреч или других блоков.",
    "template_own": "мой",
    "template_apply": "Применить",
    "template_applied": "«{name}»: блоков в плане: {count}",
    "template_delete": "Удалить шаблон",
    "template_delete_confirm": "Удалить шаблон «{name}»? Планы, созданные по нему, останутся.",
    "template_deleted": "Шаблон удалён",
    "template_save_label": "Сохранить этот день как шаблон (блоков: {count})",
    "template_name_ph": "напр. Мой вторник",
    "template_save": "Сохранить",
    "template_saved": "Шаблон сохранён",
    "tpl": {
      "office": "Офисный день",
      "appointments": "День встреч",
      "calls": "День звонков"
    },
    "print_kind": {
      "plan": "План",
      "blank": "Пустой лист",
      "sheet": "Дневной лист (2 страницы)"
    },
    "print_hint": {
      "plan": "Заполненный план списком: время, тип, что, заметки — без наложений; со звонками / follow-up из CRM и местом для заметок.",
      "blank": "Пустые часы для записи от руки, с датой, именем и полями целей.",
      "sheet": "Бумажный дневной лист: встречи по часам, звонки, follow-up, новые контакты."
    },
    "print_go": "Печать",
    "print_due": "Со звонками / follow-up из CRM",
    "print_notes": "Место для заметок",
    "print_goals": "Поля целей"
  },
  "insights": {
    "title": "Аналитика",
    "subtitle": "Портфель, продажи и воронка — рассчитано по вашим данным",
    "mix": "Портфель по видам страхования",
    "carriers": "Ведущие страховщики",
    "pipeline": "Воронка по этапам",
    "activity": "Последние 30 дней",
    "calls": "Звонки",
    "meetings": "Встречи",
    "cases_issued": "Выданные полисы",
    "new_clients": "Новые клиенты"
  },
  "data": {
    "title": "Данные и безопасность",
    "subtitle": "Импорт, резервное копирование, восстановление и диагностика — каждое изменение можно просмотреть и отменить",
    "import_title": "Импорт из VÉRO CRM (v1–v910)",
    "import_desc": "Перенесите клиентов, полисы, задачи, заметки, заявки, обзоры, потенциальных клиентов и документы из прежней HTML-версии VÉRO CRM. Ничего не записывается до вашего подтверждения.",
    "choose_file": "Выбрать файл копии",
    "or_paste": "…или вставьте JSON",
    "password": "Пароль резервной копии (для файлов .ICRM)",
    "analyze": "Анализировать",
    "analyzing": "Анализ…",
    "detected": "Обнаружено: {source}",
    "preview": "Предпросмотр импорта",
    "warnings": "{count, plural, =0 {Предупреждений нет} one {# предупреждение} few {# предупреждения} many {# предупреждений} other {# предупреждения}}",
    "mode": "Режим импорта",
    "mode_merge": "Объединить с этим рабочим пространством (повторный импорт безопасен)",
    "mode_replace": "Заменить это рабочее пространство",
    "commit": "Импортировать",
    "committing": "Импорт…",
    "done": "Импорт завершён и проверен",
    "safety": "Сначала создан защитный снимок: {label}",
    "verify_ok": "Проверка пройдена: записей — {count}",
    "verify_fail": "Проверка не пройдена — изменения откатены",
    "backup_title": "Резервная копия",
    "backup_desc": "Резервная копия содержит все записи, манифест и контрольные суммы SHA-256.",
    "export_plain": "Экспорт резервной копии (.vero.json)",
    "export_secure": "Экспорт зашифрованной копии",
    "secure_password": "Пароль шифрования (не менее 10 символов)",
    "restore_title": "Восстановление",
    "restore_desc": "Восстановление проверяется, показывается в предпросмотре и применяется одной транзакцией. Перед этим создаётся снимок.",
    "diff": "Изменения",
    "added": "Добавлено",
    "removed": "Удалено",
    "changed": "Изменено",
    "unchanged": "Без изменений",
    "table": "Данные",
    "snapshots": "Защитные снимки",
    "snapshots_empty": "Снимков пока нет.",
    "rollback": "Восстановить этот снимок",
    "rollback_confirm": "Заменить текущее рабочее пространство снимком «{label}»? Сначала будет создан снимок текущего состояния.",
    "diagnostics": "Диагностика",
    "schema": "Версия схемы {version}",
    "integrity": "Проверка целостности",
    "integrity_ok": "Проблем не найдено",
    "integrity_issues": "{count, plural, one {# проблема} few {# проблемы} many {# проблем} other {# проблемы}}",
    "storage": "Хранилище: {engine}",
    "translations": "Переводы",
    "exporter_title": "Данные старого браузера",
    "exporter_desc": "Если ваши данные хранятся только в браузере старой CRM, сначала откройте VÉRO Legacy Exporter в том же браузере и сохраните их в файл. Он только читает данные и ничего не меняет.",
    "stats": {
      "persons": "Люди",
      "policies": "Полисы",
      "tasks": "Задачи и встречи",
      "notes": "Заметки",
      "cases": "Заявки",
      "reviews": "Обзоры",
      "prospects": "Потенциальные клиенты",
      "prospect_lists": "Списки привлечения",
      "documents": "Документы",
      "timeline": "События истории",
      "legacy_records": "Сохранённые записи",
      "service_cases": "Обращения по обслуживанию",
      "households": "Семьи"
    },
    "files_corrupt": "{count, plural, one {# файл документа не прошёл проверку контрольной суммы и не был восстановлен} few {# файла документов не прошли проверку контрольной суммы и не были восстановлены} many {# файлов документов не прошли проверку контрольной суммы и не были восстановлены} other {# файла документов не прошли проверку контрольной суммы и не были восстановлены}}"
  },
  "settings": {
    "title": "Настройки",
    "language": "Язык",
    "language_hint": "Язык интерфейса. Ваши данные никогда не переводятся.",
    "region": "Рынок / регион",
    "region_hint": "Определяет валюту, именины и стандартные списки документов — независимо от языка.",
    "theme": "Оформление",
    "theme_dark": "Ночь",
    "theme_light": "День",
    "theme_auto": "Системная",
    "advisor": "Профиль консультанта",
    "advisor_name": "Ваше имя",
    "company": "Компания / агентство",
    "phone": "Телефон",
    "email": "E-mail",
    "website": "Сайт",
    "office_address": "Адрес офиса",
    "office_maps": "Ссылка на Google Maps (необязательно)",
    "signature": "Подпись в сообщениях",
    "partial_translation": "Частичный перевод — непереведённый текст показывается на английском.",
    "saved": "Настройки сохранены",
    "about": "Об AVRASTRO OS",
    "license": "№ лицензии",
    "accessibility": "Специальные возможности",
    "ui": {
      "contrast": "Высокая контрастность",
      "motion": "Меньше анимации",
      "compact": "Компактный вид"
    },
    "rules": "Умные оповещения",
    "rules_hint": "Отключите правило или задайте его важность. Значения по умолчанию объяснены на каждой карточке.",
    "rule_now": "{count} сейчас",
    "rule_auto": "Автоматически",
    "rule_off": "Выкл.",
    "business_rules": "Бизнес-правила",
    "business_rules_note": "Изменения применяются только к новым записям; прошлые продажи не пересчитываются. Окно аннулирования: {days} дн.",
    "fiscal_start": "Начало финансового года",
    "cancel_window": "Окно аннулирования (дни)",
    "cancel_window_hint": "аннулирование в этот период сторнирует новый бизнес",
    "backdated_label": "Изменения задним числом",
    "backdated": {
      "credit_today": "Засчитывать в день записи",
      "credit_effective": "Засчитывать на дату вступления в силу"
    },
    "commission_enabled": "Учитывать комиссию",
    "no_contact_days": "«Нет контакта» через (дней)",
    "emergency_months": "Резервный фонд (месяцев расходов)",
    "attribution_days": "Окно атрибуции кампаний (дни)",
    "require_consent": "Для кампаний требуется согласие на маркетинг",
    "color_precedence": "Цвет полиса берётся из",
    "insurer_colors": "Цвета страховщиков",
    "rebuild_cost": "Ориентировочная стоимость восстановления за м²",
    "rebuild_cost_hint": "Используется только для ориентировочной проверки недвижимости (по умолчанию 1500 EUR)",
    "gi_days": "Напоминания о продлении общего страхования (дней до окончания)",
    "gi_days_hint": "Через запятую, напр. 45, 30, 15",
    "lapse_risk_days": "Риск прекращения после (дней просрочки)",
    "lapse_risk_days_hint": "Просроченный взнос, открытый дольше этого срока, отмечается как «риск прекращения» (по умолчанию 15)"
  },
  "region": {
    "CY": "Кипр",
    "GR": "Греция",
    "GB": "Великобритания",
    "DE": "Германия",
    "RO": "Румыния",
    "AE": "Объединённые Арабские Эмираты",
    "IL": "Израиль",
    "INTL": "Международный"
  },
  "lens": {
    "placeholder": "Поиск людей, клиентов, заявок — или команда",
    "people": "Люди",
    "prospects": "Потенциальные клиенты",
    "cases": "Заявки",
    "commands": "Действия",
    "go": "Перейти",
    "no_results": "Ничего не найдено по запросу «{q}»",
    "hint": "↑↓ — перемещение · Enter — открыть · Esc — закрыть",
    "cmd": {
      "new_person": "Новый человек",
      "new_note": "Новая заметка",
      "new_followup": "Новое напоминание",
      "new_appointment": "Новая встреча",
      "new_case": "Новая заявка",
      "import": "Импорт данных",
      "backup": "Экспорт резервной копии",
      "toggle_theme": "Переключить день/ночь",
      "new_comparison": "Новое сравнение полисов",
      "start_flow": "Запустить Flow — разобрать портфель",
      "new_needs": "Новый анализ потребностей",
      "new_quote": "Новая котировка",
      "log_contact": "Записать разговор",
      "new_service": "Новый запрос на обслуживание",
      "new_claim": "Новый страховой случай",
      "new_opportunity": "Новая возможность",
      "new_proposal": "Новое предложение",
      "data_quality": "Проверить качество данных",
      "start_my_day": "Начать день",
      "add_policy": "Добавить полис",
      "add_lead": "Добавить контакт",
      "new_campaign": "Новая кампания",
      "upload_document": "Загрузить документ",
      "ask": "Спросить AVRASTRO",
      "sync": "Синхронизировать",
      "tax_center": "Налоговый центр"
    },
    "ai_hint": "поиск или действие",
    "policies": "Полисы",
    "quotes": "Котировки",
    "documents": "Документы",
    "children": "Дети",
    "companies": "Компании",
    "tasks": "Задачи",
    "notes": "Заметки"
  },
  "timeline": {
    "person_created": "Начало отношений",
    "person_archived": "В архиве",
    "note_added": "Добавлена заметка",
    "review_completed": "Записан ежегодный обзор",
    "policy_issued_from_case": "Выдан по заявке",
    "imported": "Импортировано из VÉRO {version}",
    "needs_finalized": "Анализ потребностей завершён",
    "quote_added": "Добавлена котировка",
    "opportunity_opened": "Открыта возможность",
    "referral_given": "Дал(а) рекомендацию",
    "referral_thanked": "Поблагодарили за рекомендацию",
    "referral_converted": "Рекомендация стала клиентом",
    "meeting_held": "Встреча проведена",
    "claim_opened": "Открыт страховой случай",
    "consent_granted": "Согласие дано",
    "consent_withdrawn": "Согласие отозвано",
    "merged": "Дубликат объединён",
    "proposal_issued": "Предложение выдано",
    "search": "Поиск по истории",
    "premium_increase": "Взнос повышен",
    "premium_decrease": "Взнос снижен",
    "premium_reversal": "Изменение взноса сторнировано",
    "payment_late": "Отмечена просрочка платежа",
    "payment_ok": "Платежи в порядке",
    "tax_snapshot": "Налоговый расчёт сохранён",
    "extraction_applied": "Применены значения из документа",
    "policy_offer": "Полис переведён в предложение",
    "policy_pending": "Полис на рассмотрении",
    "policy_active": "Полис действует",
    "policy_renewed": "Полис продлён",
    "policy_lapsed": "Полис прекращён",
    "policy_cancelled": "Полис аннулирован",
    "policy_matured": "Срок полиса истёк",
    "renewal_renewed": "Продление записано",
    "renewal_lapsed": "Не продлён",
    "renewal_declined": "Клиент отказался от продления",
    "referral_attempt": "Связались с рекомендованным человеком",
    "payslip_analysed": "Расчётный лист проанализирован (оценка налога)",
    "insured_item_added": "Добавлен застрахованный объект",
    "insured_item_sold": "Застрахованный объект продан",
    "insured_item_archived": "Застрахованный объект в архиве",
    "gi_renewal_requested_quotes": "Продление: запрошены условия",
    "gi_renewal_compared": "Продление: условия сравнены",
    "gi_renewal_sent_to_client": "Продление: отправлено клиенту",
    "gi_renewal_approved": "Продление: одобрено клиентом",
    "gi_renewal_renewed": "Продление: продлён",
    "gi_renewal_lost": "Продление: потерян",
    "premium_overdue": "Записан просроченный взнос",
    "premium_paid": "Просроченный взнос оплачен",
    "premium_lapsed": "Просроченный взнос не оплачен — полис прекращён",
    "nps_prepared": "Подготовлен опрос об удовлетворённости",
    "nps_answered": "Получен отзыв",
    "kyc_created": "Открыт файл KYC/AML",
    "kyc_updated": "Файл KYC/AML проверен",
    "client_report": "Сообщено клиентом через портал",
    "esign_signed": "Документ подписан электронно",
    "sale_file_created": "Открыт файл продажи (IDD)",
    "sale_file_complete": "Файл продажи (IDD) заполнен",
    "sale_file_reopened": "Файл продажи (IDD) снова требует заполнения",
    "do_not_call_on": "Отмечено «Больше не звонить»",
    "do_not_call_off": "Снята отметка «Больше не звонить»",
    "risk_profile_imported": "Профиль риска с avrastro.com",
    "risk_profile_saved": "Новый профиль риска",
    "family_added": "Добавлен родственник",
    "summary_meeting": "Персональная сводка встречи",
    "summary_transparency": "Сводка прозрачности",
    "summary_shared": "Сводка в портале клиента",
    "policy_deleted": "Полис удалён (ошибочная запись)",
    "policy_restored": "Удалённый полис восстановлен",
    "policy_entered_in_error": "Полис отмечен как ошибочная запись"
  },
  "template": {
    "appointment_confirm": "Здравствуйте, {first}! Подтверждаю нашу встречу {date} в {time}{location, select, none {} other {, {location}}}. {signature}",
    "appointment_subject": "Наша встреча {date}",
    "birthday": "С днём рождения, {first}! Желаю здоровья и прекрасного года. {signature}",
    "nameday": "С именинами, {first}! Всего самого доброго. {signature}",
    "review_invite": "Здравствуйте, {first}! Пора провести ежегодный обзор вашей страховой защиты — найдётся ли у вас 30 минут на этой неделе? {signature}"
  },
  "errors": {
    "person": {
      "not_found": "Человек не найден",
      "name_required": "Введите имя",
      "client_since_invalid": "Дата «клиент с» указана неверно",
      "client_since_future": "Дата «клиент с» не может быть в будущем"
    },
    "task": {
      "title_required": "Введите название",
      "appointment_needs_datetime": "Для встречи нужны дата и время",
      "not_found": "Задача не найдена",
      "not_open": "Эта задача уже не открыта.",
      "same_date": "Выберите другую дату."
    },
    "case": {
      "product_required": "Укажите продукт",
      "not_found": "Заявка не найдена",
      "not_closed": "Заявка ещё открыта.",
      "reopen_issued": "Заявку с выданным полисом нельзя открыть снова — работайте с полисом."
    },
    "policy": {
      "product_required": "Укажите название продукта",
      "invalid_transition": "Из текущего статуса такое изменение недопустимо.",
      "negative_premium": "Взнос не может быть отрицательным.",
      "not_found": "Полис не найден.",
      "same_status": "У полиса уже этот статус.",
      "deleted": "Этот полис удалён. Сначала восстановите его, чтобы изменить.",
      "already_deleted": "Этот полис уже удалён.",
      "not_deleted": "Этот полис не удалён.",
      "delete_reason_required": "Укажите причину (не менее 3 символов).",
      "stepup_required": "Сначала подтвердите паролем и кодом приложения.",
      "restore_window_passed": "Срок восстановления истёк."
    },
    "note": {
      "empty": "Заметка пуста",
      "not_found": "Заметка не найдена"
    },
    "prospect": {
      "not_found": "Потенциальный клиент не найден",
      "already_converted": "Уже переведён"
    },
    "prospect_list": {
      "name_required": "Назовите список",
      "not_found": "Список не найден"
    },
    "requirement": {
      "not_found": "Документ не найден",
      "status_invalid": "Неизвестный статус документа.",
      "waiting_invalid": "Неизвестная сторона."
    },
    "import": {
      "invalid_json": "Этот файл не является корректным JSON или резервной копией AVRASTRO.",
      "password_required": "Эта резервная копия зашифрована — введите пароль.",
      "bad_password": "Неверный пароль или повреждённый файл.",
      "unsupported": "Неподдерживаемый файл: данные AVRASTRO не найдены.",
      "checksum": "Контрольная сумма не совпадает — файл изменён или повреждён."
    },
    "storage": {
      "failed": "Не удалось сохранить. Изменение не применено.",
      "quota": "Хранилище заполнено. Экспортируйте резервную копию и освободите место.",
      "blocked": "Другое окно AVRASTRO обновляет базу данных. Закройте его и попробуйте снова.",
      "newer_schema": "Эти данные сохранены более новой версией AVRASTRO. Обновите приложение.",
      "verify_failed": "Не удалось проверить данные, поэтому ничего не изменено."
    },
    "comparison": {
      "not_found": "Сравнение не найдено",
      "locked": "По этому сравнению принято решение, оно заблокировано",
      "no_plans": "Добавьте хотя бы одну программу"
    },
    "undo": {
      "conflict": "Отменить нельзя — запись с тех пор изменилась"
    },
    "screen": {
      "title": "На этом экране возникла проблема",
      "body": "Ваши данные в безопасности. Ошибка записана в диагностику («Данные и безопасность»).",
      "retry": "Повторить"
    },
    "needs": {
      "locked": "Этот анализ потребностей завершён. Чтобы изменить его, откройте новую редакцию.",
      "not_found": "Анализ потребностей не найден"
    },
    "quote": {
      "product_required": "Укажите продукт",
      "not_found": "Котировка не найдена"
    },
    "opportunity": {
      "title_required": "Дайте возможности название",
      "not_found": "Возможность не найдена"
    },
    "referral": {
      "name_required": "Введите имя рекомендованного человека",
      "not_found": "Рекомендация не найдена",
      "already_converted": "Уже переведена",
      "outcome_invalid": "Неизвестный результат."
    },
    "communication": {
      "no_party": "Выберите, с кем был разговор"
    },
    "meeting": {
      "not_found": "Встреча не найдена"
    },
    "claim": {
      "type_required": "Укажите тип страхового случая"
    },
    "service": {
      "title_required": "Опишите запрос"
    },
    "document": {
      "title_required": "Назовите документ",
      "not_found": "Документ не найден"
    },
    "consent": {
      "purpose_required": "Выберите цель"
    },
    "template": {
      "invalid": "В шаблоне должен быть текст"
    },
    "merge": {
      "same": "Выберите двух разных людей"
    },
    "adjustment": {
      "already_reversed": "Это изменение уже сторнировано.",
      "amount_invalid": "Введите корректную сумму.",
      "date_required": "Выберите дату вступления изменения в силу.",
      "is_reversal": "Сторно нельзя сторнировать — запишите новое изменение.",
      "negative": "Взнос не может стать отрицательным.",
      "no_change": "Новый взнос равен текущему.",
      "not_found": "Этого изменения взноса больше нет.",
      "reason_required": "Укажите причину.",
      "single_premium_instalment": "У полиса с единовременным взносом нет регулярных платежей — измените разовую сумму."
    },
    "automation": {
      "action_not_allowed": "Автоматизация может только создавать задачи.",
      "due_invalid": "Срок в днях должен быть от 0 до 365.",
      "name_required": "Назовите правило.",
      "not_found": "Этого правила больше нет."
    },
    "campaign": {
      "already_launched": "Эта кампания уже запущена.",
      "closed": "Кампания закрыта, изменить её нельзя.",
      "not_found": "Кампания не найдена.",
      "not_prepared": "Сначала проверьте и зафиксируйте аудиторию.",
      "segment_required": "Выберите сегмент для аудитории.",
      "title_required": "Назовите кампанию.",
      "objective_invalid": "Неизвестная цель кампании."
    },
    "commission": {
      "not_found": "Строка комиссии не найдена.",
      "rate_invalid": "Ставка должна быть от 0 до 100%.",
      "mapping": "Выберите столбцы номера полиса, суммы и периода.",
      "nothing_to_accept": "В выписке нет данных для принятия по этой строке.",
      "already_accepted": "Эта строка выписки уже принята.",
      "already_paid": "Ожидаемая комиссия уже отмечена как выплаченная."
    },
    "crypto": {
      "already_enabled": "Шифрование уже включено.",
      "not_enabled": "Шифрование не включено.",
      "passphrase_too_short": "Используйте не менее 10 символов.",
      "wrong_passphrase": "Неверная парольная фраза или ключ восстановления."
    },
    "custom": {
      "entity_invalid": "Для этого типа записей пользовательские поля недоступны.",
      "in_use": "В поле уже есть значения, поэтому его ключ и тип изменить нельзя.",
      "key_exists": "Поле с таким ключом уже существует.",
      "key_invalid": "Используйте только строчные латинские буквы, цифры и _, начиная с буквы.",
      "label_required": "Задайте название поля.",
      "not_date": "Введите корректную дату.",
      "not_number": "Введите число.",
      "not_option": "Выберите один из вариантов списка.",
      "options_required": "Для поля выбора нужен хотя бы один вариант.",
      "required": "Это поле обязательно.",
      "unknown_field": "Неизвестное пользовательское поле."
    },
    "extraction": {
      "closed": "Эта проверка уже закрыта.",
      "invalid_amount": "Одна из принятых сумм не является корректным числом.",
      "invalid_rate": "Процентная ставка должна быть от 0 до 100%.",
      "no_person": "Сначала привяжите документ к человеку.",
      "not_found": "Проверка не найдена.",
      "nothing_accepted": "Сначала примите или исправьте хотя бы одно значение.",
      "policy_required": "Выберите полис, к которому относятся эти значения."
    },
    "financial": {
      "not_found": "Этого элемента больше нет.",
      "rate_invalid": "Ставка должна быть от 0 до 100%.",
      "type_required": "Выберите тип."
    },
    "production": {
      "duplicate_key": "В журнале продаж есть повторяющаяся запись."
    },
    "record": {
      "not_found": "Запись не найдена."
    },
    "renewal": {
      "negative": "Взнос при продлении не может быть отрицательным.",
      "not_found": "Продление не найдено."
    },
    "tax": {
      "already_approved": "Эти правила уже утверждены.",
      "band_rate_invalid": "Ставка каждой ступени должна быть от 0% до 100%.",
      "bands_required": "Добавьте хотя бы одну налоговую ступень.",
      "ruleset_not_found": "Налоговые правила не найдены.",
      "snapshot_not_found": "Сохранённый расчёт не найден.",
      "source_required": "Укажите официальный источник этих правил.",
      "year_invalid": "Введите корректный налоговый год."
    },
    "workspace": {
      "read_only": "Это устройство доступно только для чтения, пока вы снова не войдёте для синхронизации.",
      "read_only_licence": "Подписка закончилась, поэтому AVRASTRO работает только в режиме чтения. Ваши данные в безопасности — продлите подписку в разделе «Учётная запись», чтобы вносить изменения.",
      "read_only_plan": "Этот раздел AVRASTRO не входит в ваш текущий тариф, поэтому его записи доступны только для чтения. Ничего не удалено."
    },
    "branding": {
      "scope_invalid": "Неизвестный профиль фирменного стиля.",
      "not_found": "Этого профиля фирменного стиля больше нет.",
      "image_invalid": "Можно сохранить только изображения PNG, JPEG или WebP размером примерно до 500 КБ.",
      "email_invalid": "Проверьте адрес e-mail.",
      "website_invalid": "Проверьте адрес сайта.",
      "accent_invalid": "Укажите цвет в формате #9A7427.",
      "mode_invalid": "Неизвестный режим фирменного стиля.",
      "signature_not_owner": "Это изображение подписи принадлежит другому пользователю — изменять или использовать его может только он."
    },
    "checklist": {
      "name_required": "Назовите список.",
      "items_required": "Добавьте хотя бы один пункт.",
      "not_found": "Этого списка больше нет."
    },
    "group": {
      "not_found": "Групповая программа не найдена",
      "employer_required": "Укажите работодателя",
      "category": "Неизвестная категория",
      "status": "Неизвестный статус",
      "employer_share": "Доля работодателя должна быть от 0 до 100%",
      "member_name_required": "Введите имя участника",
      "member_not_found": "Участник не найден",
      "class": "Неизвестная категория участника",
      "leave_before_join": "Дата выхода раньше даты вступления",
      "census_empty": "В файле нет строк",
      "renewal_date_required": "Сначала укажите дату продления",
      "renewal_task_exists": "Напоминание об этом продлении уже существует"
    },
    "intake": {
      "revoked": "Клиент отозвал доступ к этим данным",
      "no_contact": "Нет имени, e-mail или телефона, чтобы создать запись",
      "bad_time": "Неверное время встречи",
      "kind": "Неизвестный тип"
    },
    "payslip": {
      "no_gross": "Сначала укажите зарплату брутто."
    },
    "insured": {
      "not_found": "Этого застрахованного объекта больше нет.",
      "person_fixed": "Застрахованный объект остаётся у своего клиента.",
      "kind": "Неизвестный тип объекта.",
      "status": "Неизвестный статус объекта.",
      "year": "Год указан неверно.",
      "year_built": "Год постройки указан неверно.",
      "amount": "Суммы и площади должны быть числами не меньше нуля.",
      "ncd": "Лет безаварийности — целое число от 0 до 60.",
      "employees": "Число сотрудников должно быть целым и не меньше нуля.",
      "date": "Одна из дат указана неверно.",
      "policy": "Связанный полис должен принадлежать тому же клиенту.",
      "label_required": "Укажите название, регистрационный номер, адрес или вид деятельности."
    },
    "gi_renewal": {
      "not_general": "Это не полис общего страхования.",
      "stage": "Неизвестный этап продления.",
      "no_date": "У полиса нет даты продления или начала.",
      "closed": "По этому продлению решение уже принято.",
      "same_stage": "Продление уже на этом этапе."
    },
    "premium": {
      "not_found": "Этого просроченного взноса больше нет.",
      "closed": "Эта запись уже закрыта (оплачена или полис прекращён).",
      "policy_fixed": "Просроченный взнос остаётся привязан к своему полису.",
      "amount": "Сумма должна быть числом больше нуля.",
      "due_date": "Введите корректную дату платежа.",
      "future": "Дата платежа не может быть в будущем.",
      "duplicate": "По этому полису уже записан открытый просроченный взнос с этой датой.",
      "status": "Неизвестный статус.",
      "mapping": "Выберите столбцы номера полиса, суммы и даты платежа."
    },
    "schedule": {
      "product_required": "Укажите продукт или вид страхования.",
      "premium": "Укажите взнос (число не меньше нуля).",
      "sum": "Страховая сумма должна быть числом не меньше нуля.",
      "date": "Одна из дат указана неверно.",
      "dates": "Дата окончания раньше даты начала.",
      "frequency": "Неизвестная периодичность оплаты.",
      "duplicate": "Полис с таким номером уже существует."
    },
    "nps": {
      "archived": "Этот человек в архиве.",
      "ref": "Встреча или страховой случай этого клиента не найдены.",
      "meeting_not_held": "Сначала запишите результат встречи.",
      "claim_not_closed": "Страховой случай ещё не закрыт.",
      "duplicate": "Опрос по этому поводу уже подготовлен.",
      "token": "Ссылка на опрос недействительна.",
      "not_found": "Опрос не найден.",
      "closed": "На этот опрос уже ответили или он отозван.",
      "score": "Оценка должна быть целым числом от 0 до 10.",
      "not_promoter": "Просьба об отзыве отправляется только при оценке 9 или 10."
    },
    "kyc": {
      "document": "Выберите удостоверение личности из документов этого клиента.",
      "pep": "Ответьте на вопрос о политически значимом лице.",
      "risk": "Выберите уровень риска.",
      "share": "Доля выгодоприобретателя должна быть от 0 до 100%.",
      "share_total": "Сумма долей выгодоприобретателей превышает 100%.",
      "id_number": "Номера удостоверения, паспорта, налоговый или банковский номер не вносятся в эти поля — храните их в документе в хранилище.",
      "date": "Неверная дата.",
      "future": "Дата проверки не может быть в будущем."
    },
    "creport": {
      "kind": "Неизвестный тип сообщения.",
      "id": "Неверный номер сообщения.",
      "accepted": "Это сообщение уже принято.",
      "policy": "Этот полис не принадлежит данному клиенту."
    },
    "voice": {
      "consent_required": "Нет согласия клиента на запись этой встречи.",
      "nothing_kept": "Ничего не отмечено для сохранения.",
      "meeting_not_found": "Встреча не найдена.",
      "dictation_confirm": "Подтвердите, что записываете только свой голос."
    },
    "whatsapp": {
      "use": "Неизвестный тип сообщения WhatsApp."
    },
    "setup": {
      "step": "Неизвестный шаг настройки.",
      "lines_required": "Выберите хотя бы один класс: жизнь или общее страхование.",
      "capacity": "Выберите статус из списка.",
      "reg_no": "Регистрационный номер слишком длинный.",
      "time": "Неверное время.",
      "hours_order": "Время окончания должно быть позже времени начала.",
      "https": "Ссылка должна начинаться с https:// — ничего не изменено.",
      "minutes": "Длительность должна быть от 10 до 240 минут."
    },
    "client_import": {
      "stage": "Выберите: клиенты или потенциальные клиенты.",
      "empty": "Нет новых записей для импорта.",
      "too_many": "Не более 5000 строк за раз — разделите файл."
    },
    "sale_file": {
      "not_found": "Файл продажи не найден.",
      "person": "Файл относится к другому человеку.",
      "line": "Выберите тип продажи.",
      "advice": "Укажите, была ли дана рекомендация.",
      "channel": "Выберите способ продажи.",
      "policy": "Полис не принадлежит этому клиенту.",
      "policy_has_file": "У этого полиса уже есть файл продажи.",
      "needs": "Анализ потребностей не относится к этому клиенту.",
      "case": "Заявка не относится к этому клиенту.",
      "date": "Неверная дата продажи.",
      "future": "Дата продажи не может быть в будущем.",
      "check_date": "Дата раскрытия информации неверна или в будущем.",
      "document": "Выберите документ из документов этого клиента.",
      "risk_profile": "Профиль риска не относится к этому клиенту."
    },
    "next_action": {
      "task_exists": "Задача для этого действия уже существует."
    },
    "lesson": {
      "slug": "Неизвестный урок.",
      "quiz": "Неверный результат теста."
    },
    "call": {
      "outcome": "Выберите результат звонка.",
      "no_target": "Звонок ни к кому не привязан.",
      "do_not_call": "Этот номер отмечен «Больше не звонить».",
      "day": "Дата звонка некорректна.",
      "future": "Звонок не может быть в будущем.",
      "hour": "Время звонка некорректно.",
      "callback_date": "Укажите, когда перезвонить.",
      "callback_past": "Дата не может быть раньше звонка.",
      "meeting_time": "Укажите дату и время встречи.",
      "lawful_basis": "Выберите правовое основание из списка."
    },
    "risk": {
      "incomplete": "Ответьте на все вопросы.",
      "override_reason": "Укажите, почему выбран другой профиль, чем ориентировочный.",
      "source": "Неизвестный источник профиля.",
      "date": "Дата некорректна.",
      "future": "Дата не может быть в будущем.",
      "duplicate": "Этот результат уже импортирован.",
      "level": "Профиль риска не найден.",
      "task_exists": "Задача пересмотра уже есть."
    },
    "family": {
      "not_found": "Родственник не найден.",
      "relation": "Выберите родство.",
      "self": "Человек не может быть своим родственником.",
      "name_required": "Укажите имя или выберите человека.",
      "date": "Дата некорректна.",
      "birth_future": "Дата рождения не может быть в будущем.",
      "pays": "Выберите, кто платит.",
      "duplicate": "Этот человек уже есть на семейной карте."
    },
    "summary": {
      "kind": "Неизвестный вид сводки.",
      "lang": "Выберите греческий, английский или русский.",
      "not_found": "Сводка не найдена.",
      "shared": "Сводка уже отправлена; создайте новую.",
      "meeting": "Встреча не относится к этому клиенту.",
      "title": "Укажите заголовок.",
      "empty": "Сводка пуста."
    },
    "radar": {
      "task_exists": "Задача уже есть."
    },
    "recommendation": {
      "approval_required": "Сначала отметьте «Одобряю» — предложенная кампания создаётся только с вашего одобрения.",
      "unknown_theme": "Эта тема кампании больше не существует.",
      "channel": "Выберите канал кампании.",
      "already_running": "Кампания с этой темой уже идёт."
    },
    "market_note": {
      "title_required": "Укажите заголовок заметки.",
      "source_required": "Для заметки о рынке нужен источник (издание, организация или сайт).",
      "date_invalid": "Укажите дату публикации (сегодня или раньше).",
      "url_invalid": "Ссылка должна начинаться с http:// или https://.",
      "theme_required": "Выберите хотя бы одну тему кампании, к которой относится заметка."
    },
    "day_report": {
      "day": "Отчёт сохраняется за сегодня или прошедший день.",
      "rating": "Самооценка — целое число от 1 до 5.",
      "metric": "Неизвестный показатель в отчёте.",
      "value": "Ваши записи — целые числа от 0 до 9999.",
      "goals": "Выполненных целей не может быть больше, чем целей (не более 99)."
    },
    "catalog": {
      "name_required": "Введите название.",
      "name_too_long": "Слишком длинное название (не более 120 символов).",
      "duplicate": "Такое название уже есть в списке.",
      "not_found": "Этой записи каталога больше нет.",
      "mismatch": "Страховщик, категория и программа не соответствуют друг другу.",
      "in_use": "Её используют полисы или вложенные записи — отключите её.",
      "move_insurer": "Запись нельзя перенести к другому страховщику.",
      "category": "Неизвестный тип полиса.",
      "branch": "Неизвестный вид страхования.",
      "dates": "«Продаётся до» раньше, чем «продаётся с»."
    },
    "plan": {
      "time": "Укажите время начала и окончания.",
      "end_before_start": "Окончание должно быть после начала.",
      "too_short": "Блок длится не меньше 5 минут.",
      "too_long": "Блок длится не больше 12 часов.",
      "day": "Недопустимый день.",
      "kind": "Неизвестный тип блока.",
      "title_required": "Дайте блоку название.",
      "overlaps_appointment": "Это время пересекается со встречей — ничего не изменено.",
      "appointment_fixed": "Встречи не переносятся из плана — откройте саму встречу.",
      "not_found": "Блок не найден.",
      "block_closed": "Блок уже выполнен или отменён.",
      "task_planned": "Эта задача уже в плане на этот день.",
      "after_midnight": "Блок закончился бы после полуночи.",
      "same_day": "Выберите другую дату, не ту, что вы планируете.",
      "nothing_to_move": "В этот день нет ваших блоков.",
      "nothing_to_copy": "Нечего копировать (или всё пересекается с уже запланированным).",
      "template_nothing": "Шаблон не помещается: все его блоки пересекаются с запланированным.",
      "template_name": "Дайте шаблону название.",
      "template_empty": "В этом дне нет блоков для шаблона.",
      "template_limit": "Не более 20 своих шаблонов.",
      "template_not_found": "Шаблон не найден.",
      "no_suggestions": "Предложений нет."
    },
    "goals": {
      "day": "Недопустимый день.",
      "not_found": "Целей на этот день пока нет.",
      "type": "Неизвестная цель.",
      "target": "Введите число от 0 до предела этой цели.",
      "market_text": "Напишите заметку о рынке.",
      "market_source": "Укажите источник заметки о рынке.",
      "market_url": "Ссылка должна начинаться с http:// или https://."
    },
    "taxf": {
      "year_invalid": "Неверный налоговый год.",
      "year_not_found": "Папка года не найдена.",
      "email_invalid": "Проверьте адрес e-mail.",
      "category_unknown": "Неизвестная категория.",
      "category_label_required": "Укажите название категории.",
      "date_invalid": "Неверная дата.",
      "amount_invalid": "Неверная сумма.",
      "expected_not_found": "Ожидаемый документ не найден.",
      "document_not_in_folder": "Файл не относится к этой папке.",
      "item_not_found": "Документ не найден.",
      "item_other_year": "Документ относится к другому году.",
      "title_required": "Укажите название."
    }
  },
  "boot": {
    "volatile": "В этом окне хранилище недоступно — изменения сохраняются только до его закрытия. Экспортируйте резервную копию, чтобы их сохранить.",
    "opening": "Открытие рабочего пространства…",
    "failed": "Не удалось открыть рабочее пространство.",
    "recover": "Открыть средства восстановления"
  },
  "demo": {
    "banner": "Демонстрационное пространство с вымышленными людьми. Импортируйте свои данные в разделе «Данные и безопасность».",
    "load": "Загрузить демо-данные",
    "clear": "Начать с нуля"
  },
  "briefing": {
    "title": "Ежедневная сводка",
    "meetings": "{count, plural, one {Сегодня # встреча} few {Сегодня # встречи} many {Сегодня # встреч} other {Сегодня # встречи}} — {count, plural, =1 {в} other {ближайшая в}} {time}: {name} ({title}).",
    "no_meetings": "Сегодня встреч нет{count, plural, =0 {.} one { — хороший день для # важного звонка.} few { — хороший день для # важных звонков.} many { — хороший день для # важных звонков.} other { — хороший день для # важного звонка.}}",
    "overdue": "{count, plural, one {Просрочено # действие} few {Просрочено # действия} many {Просрочено # действий} other {Просрочено # действия}}; самое давнее — «{title}» ({name}).",
    "cases": "{count, plural, one {# заявка застряла} few {# заявки застряли} many {# заявок застряли} other {# заявки застряли}}: {product} ({name}) уже {days} дн. на этапе «{stage}»{missing, plural, =0 {.} one {, не хватает # документа.} few {, не хватает # документов.} many {, не хватает # документов.} other {, не хватает # документа.}}",
    "cases_moving": "{count, plural, =1 {Ваша активная заявка движется.} other {Все активные заявки (#) движутся.}}",
    "birthday": "У {name} сегодня день рождения — исполняется {age}.",
    "nameday": "У {name} сегодня именины ({feast}).",
    "reviews": "{count, plural, one {# клиенту пора на ежегодный обзор} few {# клиентам пора на ежегодный обзор} many {# клиентам пора на ежегодный обзор} other {# клиента ждут ежегодного обзора}}; самый крупный портфель — {name} ({amount, number, currency}).",
    "gaps": "{count, plural, one {В # семье есть дети, но нет страхования жизни} few {В # семьях есть дети, но нет страхования жизни} many {В # семьях есть дети, но нет страхования жизни} other {В # семьи есть дети, но нет страхования жизни}} — начните с {name}.",
    "start_flow": "Запустить Flow",
    "generated": "Составлено AVRASTRO по вашим данным · {time}",
    "promises": "{count, plural, one {Подходит срок # обещания} few {Подходит срок # обещаний} many {Подходит срок # обещаний} other {Подходит срок # обещания}} — «{title}» для {name}.",
    "decisions": "{count, plural, one {# клиент принимает решение} few {# клиента принимают решение} many {# клиентов принимают решение} other {# клиента принимают решение}}; {name} обдумывает «{title}» уже {days} дн.",
    "waiting": "{count, plural, one {Вы ждёте ответа от # клиента.} few {Вы ждёте ответа от # клиентов.} many {Вы ждёте ответа от # клиентов.} other {Вы ждёте ответа от # клиента.}}"
  },
  "flow": {
    "title": "Flow",
    "subtitle": "По одному клиенту за раз. AVRASTRO задаёт порядок, вы звоните.",
    "progress": "Разобрано {done} из {total}",
    "start": "Запустить Flow",
    "resume": "Продолжить Flow",
    "done_title": "Портфель разобран",
    "done_body": "{count, plural, one {Вы разобрали # пункт.} few {Вы разобрали # пункта.} many {Вы разобрали # пунктов.} other {Вы разобрали # пункта.}} Всё остальное запланировано.",
    "skip": "Пропустить",
    "snooze": "Завтра",
    "note": "Записать",
    "exit": "Выйти из Flow",
    "context": "Контекст",
    "last_contact": "Последний контакт",
    "portfolio": "Портфель",
    "open_cases": "Открытые заявки",
    "keys": "Клавиши",
    "logged": "Записано — следующий клиент",
    "empty": "Сейчас ничего не требует вашего внимания.",
    "days_ago": "{days, plural, =0 {сегодня} one {# день назад} few {# дня назад} many {# дней назад} other {# дня назад}}",
    "keys_log": "записать разговор",
    "keys_move": "предлагаемый шаг",
    "outcome": {
      "positive": "Поговорили — положительно",
      "neutral": "Поговорили — нейтрально",
      "negative": "Не ответил / не сейчас"
    },
    "outcome_q": "Как прошло?",
    "outcome_title": {
      "positive": "Звонок — положительно: {reason}",
      "neutral": "Звонок — нейтрально: {reason}",
      "negative": "Звонок — нет ответа: {reason}"
    }
  },
  "capture": {
    "title": "Быстрая запись",
    "placeholder": "Пишите как обычно: «ραντεβού με Άννα αύριο 10:30» или «call George Friday 3pm»",
    "understood": "AVRASTRO понял",
    "create": "Создать: {kind}",
    "no_person": "Человек не привязан",
    "choose_person": "Возможно, вы имели в виду",
    "hint": "Enter — создать · Tab — выбрать человека",
    "kind_note": "Заметка",
    "kind_case": "Заявка",
    "created": "Создано: {kind}",
    "needs_time": "Нужно время — открывается форма"
  },
  "coverage": {
    "title": "Радар покрытия",
    "subtitle": "Имеющаяся защита и то, что нужно на этом этапе жизни",
    "area": {
      "life": "Жизнь",
      "health": "Здоровье",
      "income": "Доход",
      "savings": "Накопления и пенсия",
      "education": "Образование",
      "property": "Имущество"
    },
    "need": {
      "0": "Не нужно",
      "1": "Желательно",
      "2": "Важно",
      "3": "Необходимо"
    },
    "held": {
      "0": "Нет покрытия",
      "1": "Покрыто",
      "0.5": "Предложено"
    },
    "reason": {
      "dependents": "От этого дохода зависят дети",
      "partner": "От этого дохода зависит партнёр",
      "debts": "Покрывает долги и расходы на похороны",
      "none": "Не актуально на этом этапе жизни",
      "health": "Медицинское покрытие нужно всем",
      "income": "Трудоспособный возраст — доход является главным активом",
      "retiring": "Близок выход на пенсию",
      "retirement": "Горизонт пенсионных накоплений",
      "children_education": "Впереди образование детей",
      "property": "Жильё и имущество",
      "needs_analysis": "По анализу потребностей"
    },
    "gaps": "{count, plural, =0 {Пробелов нет} one {# пробел} few {# пробела} many {# пробелов} other {# пробела}}",
    "score": "Покрытие {score}%",
    "opportunities": "Возможности по покрытию",
    "opportunities_hint": "Клиенты с необходимой или важной потребностью без действующего покрытия",
    "held_series": "Есть",
    "need_series": "Нужно"
  },
  "health": {
    "title": "Состояние отношений",
    "book": "Здоровье портфеля",
    "book_hint": "С учётом взносов по {count} клиентам",
    "band": {
      "strong": "Крепкие",
      "steady": "Стабильные",
      "watch": "Под наблюдением",
      "at_risk": "Под угрозой"
    },
    "factor": {
      "coverage": "Покрытие",
      "engagement": "Контакт",
      "review": "Обзор",
      "open_items": "Открытые вопросы",
      "profile": "Профиль"
    },
    "detail": {
      "coverage": "{gaps, plural, =0 {Все нужные области покрыты} one {# пробел в покрытии} few {# пробела в покрытии} many {# пробелов в покрытии} other {# пробела в покрытии}}",
      "engagement": "Последний контакт {days, plural, =0 {сегодня} one {# день назад} few {# дня назад} many {# дней назад} other {# дня назад}}",
      "never": "Контактов не зафиксировано",
      "open": "просрочено: {overdue} · без движения: {stalled} · не хватает документов: {missing}",
      "profile": "Заполнено {filled} из {total} ключевых данных"
    },
    "why": "Как рассчитывается оценка",
    "book_empty": "Состояние портфеля появится, когда у вас будут клиенты с полисами.",
    "column": "Состояние"
  },
  "constellation": {
    "title": "Созвездие",
    "subtitle": "Ваш портфель как живая карта — чем ближе к центру, тем скорее нужно ваше внимание. Размер — объём портфеля.",
    "legend_now": "Нужно сейчас",
    "legend_soon": "Скоро",
    "legend_calm": "Спокойно",
    "hint": "Наведите, чтобы увидеть причину · нажмите, чтобы открыть",
    "size": "Размер = годовой портфель",
    "you": "Вы"
  },
  "prep": {
    "title": "Подготовка к встрече",
    "open": "Подготовка к встрече",
    "talking": "Темы для разговора",
    "family": "Семья",
    "holdings": "Полисы",
    "open_items": "Открытые вопросы",
    "since": "Клиент с {date}",
    "point_gap": "Обсудить «{area}»: {reason}",
    "point_review": "Ежегодный обзор: {state}",
    "point_case": "Новости по {product} ({stage})",
    "point_moment": "Упомянуть: {what}",
    "point_renewal": "{product}: продление {date}",
    "none": "Открытых вопросов нет — используйте время, чтобы укрепить отношения.",
    "point_promise": "Мы обещали: {text}",
    "point_waiting": "Клиент обещал: {text}",
    "point_decision": "Ожидается решение: {title} ({days} дн.)"
  },
  "undo": {
    "action": "Отменить",
    "done": "Отменено",
    "conflict": "Отменить нельзя — запись с тех пор изменилась"
  },
  "comparator": {
    "title": "Сравнение полисов",
    "subtitle": "Сравните до трёх программ рядом — защита, стоимость и прогнозная стоимость, ничего не смешивая",
    "new": "Новое сравнение",
    "for": "Для",
    "plan": "Программа {label}",
    "add_plan": "Добавить программу",
    "remove_plan": "Убрать",
    "insurer": "Страховщик",
    "product": "Продукт",
    "kind": "Тип",
    "kinds": {
      "protection": "Защита",
      "savings": "Накопления",
      "combined": "Защита + накопления"
    },
    "monthly": "Ежемесячный взнос",
    "indexation": "Индексация взноса, %/год",
    "term": "Срок (лет)",
    "cover": "Страховая сумма / выплата",
    "savings_share": "Доля взноса на накопления, %",
    "delay": "Месяцев без инвестирования",
    "y1": "Сбор 1-го года, %",
    "y2": "Сбор 2-го года, %",
    "fee": "Годовая комиссия, %",
    "return": "Предполагаемая доходность, %",
    "guaranteed": "Гарантировано на дату окончания",
    "quotation": "№ котировки",
    "results": "Результаты",
    "total_paid": "Всего взносов",
    "saved": "Сравнение сохранено",
    "projected": "Прогнозная стоимость",
    "guaranteed_value": "Гарантированная стоимость",
    "protection_cost": "Стоимость защиты и сборов",
    "net_cost": "Чистая стоимость за вычетом прогнозной",
    "per1000": "Годовой взнос на 1 000 покрытия",
    "breakeven": "Прогнозная стоимость превысит взносы",
    "breakeven_year": "на {year}-й год",
    "never": "никогда",
    "charges_impact": "Потери на задержках, сборах и комиссиях",
    "best": "Лучшее",
    "chart": "Прогнозная стоимость и уплаченные взносы",
    "chart_paid": "Уплаченные взносы",
    "year": "Год {year}",
    "warn": {
      "no_cover": "Страховая сумма не указана",
      "no_term": "Срок не указан",
      "long_delay": "12+ месяцев без инвестирования",
      "high_charges": "Начальные сборы съедают бо́льшую часть первых двух лет",
      "fees_exceed_return": "Комиссии выше предполагаемой доходности — фонд в реальном выражении уменьшается"
    },
    "decide": "Записать решение",
    "decision": "Решение",
    "decisions": {
      "A": "Программа A",
      "B": "Программа B",
      "C": "Программа C",
      "later": "Решит позже",
      "none": "Ни одна"
    },
    "decided": "Решение {date}: {decision}",
    "locked": "По этому сравнению принято решение, оно заблокировано. Чтобы изменить, откройте копию.",
    "copy": "Открыть как новый черновик",
    "empty": "Сравнений пока нет",
    "history": "Сравнения",
    "legacy": "Импортировано из старой CRM",
    "followup": "Дата повторного контакта",
    "draft": "Черновик",
    "chart_hint": "Сплошная линия: прогнозная стоимость · пунктир: уплаченные взносы. Наведите на любой год.",
    "copied": "Открыт новый черновик на основе решённого сравнения",
    "decided_toast": "Решение записано и заблокировано",
    "disclaimer": "Прогнозы рассчитаны по введённым вами доходности и комиссиям; это иллюстрация, а не гарантия. Всегда прикладывайте официальную котировку страховщика.",
    "followup_hint": "В ежедневник будет добавлено напоминание (по умолчанию через 7 дней).",
    "lock_note": "Запись решения фиксирует программы, результаты и вывод в текущем виде. Вы всегда можете открыть копию.",
    "name": "Название сравнения",
    "need_person": "Выберите клиента, для которого это сравнение",
    "no_term": "Укажите срок, чтобы увидеть прогноз",
    "plans": "программы",
    "section_cost": "Стоимость",
    "section_protection": "Защита",
    "section_savings": "Накопления и стоимость",
    "no_data": "Укажите ежемесячный взнос, чтобы увидеть прогноз"
  },
  "insights_v2": {
    "cohorts": "Портфель по году начала",
    "activity": "Активность — последние 12 недель",
    "funnel": "Воронка",
    "health_dist": "Состояние отношений",
    "opportunities": "Возможности по покрытию",
    "less": "Меньше",
    "more": "Больше",
    "weekday": "Выполнено: {count}",
    "at_risk": "Требуют внимания в первую очередь",
    "funnel_hint": "Заявки, дошедшие до каждого этапа (выдан = конверсия).",
    "policies": "{count, plural, one {# полис} few {# полиса} many {# полисов} other {# полиса}}"
  },
  "space": {
    "label": "Разделы",
    "today": "Сегодня",
    "people": "Люди",
    "growth": "Рост",
    "advisory": "Консультирование",
    "cases": "Заявки",
    "intelligence": "Аналитика",
    "system": "Система"
  },
  "dates": {
    "plus3": "+3 дня",
    "plus7": "+1 неделя",
    "day": "День",
    "month": "Месяц",
    "year": "Год",
    "ph_day": "ДД",
    "ph_month": "ММ",
    "ph_year": "ГГГГ",
    "clear": "Очистить дату",
    "year_hint": "↑ ↓ меняют год · PgUp / PgDn — на 10 лет",
    "err_incomplete": "Введите полную дату: день, месяц и год (4 цифры).",
    "err_day": "День должен быть от 1 до 31.",
    "err_month": "Месяц должен быть от 1 до 12.",
    "err_year": "Введите год от {min} до {max}.",
    "err_no_such_day": "Такой даты нет: в этом месяце {days} дн.",
    "err_feb29": "{year} — не високосный год: в феврале 28 дней.",
    "err_before": "Дата должна быть не раньше {date}.",
    "err_after": "Дата должна быть не позже {date}."
  },
  "rule": {
    "task_overdue": "Просроченные действия",
    "promise_overdue": "Обещания клиентам",
    "waiting_client": "Ожидание клиента",
    "appointment_today": "Встречи сегодня",
    "case_stalled": "Застрявшие заявки",
    "case_missing": "Недостающие документы по заявкам",
    "case_no_next": "Заявки без следующего шага",
    "decision_pending": "Ожидающие решения",
    "quote_expiring": "Истекающие котировки",
    "claim_followup": "Страховые случаи на контроле",
    "service_open": "Открытые запросы на обслуживание",
    "review_overdue": "Просроченные обзоры",
    "review_never": "Обзора не было",
    "review_due_soon": "Скорые обзоры",
    "renewal_soon": "Годовщины полисов",
    "protection_gap": "Пробелы в защите",
    "needs_missing": "Нет анализа потребностей",
    "no_next_step": "Предложения без следующего шага",
    "silence": "Долгое молчание",
    "hot": "Тёплые возможности",
    "prospect_followup": "Повторные контакты с потенциальными клиентами",
    "referral_thanks": "Благодарности за рекомендации",
    "birthday": "Дни рождения",
    "nameday": "Именины",
    "child_milestone": "Важные даты детей",
    "data_quality": "Нет контактных данных",
    "policy_lapsed": "Прекращённые полисы",
    "payment_late": "Просроченные платежи",
    "life_event": "Жизненные события",
    "loan_maturity": "Окончание кредитов",
    "education_milestone": "Этапы образования",
    "mortgage_gap": "Пробелы в страховании ипотеки",
    "extraction_review": "Значения из документов на проверку",
    "sync_conflict": "Конфликты синхронизации",
    "insured_due": "Техосмотр (MOT) и дорожный налог",
    "premium_overdue": "Просроченные взносы",
    "kyc_review": "Пересмотр KYC/AML"
  },
  "hot": {
    "marked": "отмечен вами как горячий",
    "recent_interest": "{count, plural, =1 {недавно обращался} one {недавно обращался # раз} few {недавно обращался # раза} many {недавно обращался # раз} other {недавно обращался # раза}}",
    "many_interactions": "{count} взаимодействий за месяц",
    "active_quote": "есть открытая котировка",
    "pending_comparison": "принимает решение по сравнению",
    "open_opportunity": "есть открытая возможность",
    "application_started": "начал оформление заявки",
    "referrer": "рекомендовал вам клиентов",
    "coverage_gap": "пробел: {area}"
  },
  "journey": {
    "title": "Путь консультирования",
    "profile": "Профиль",
    "needs": "Потребности",
    "proposal": "Предложение",
    "comparison": "Сравнение",
    "decision": "Решение",
    "application": "Заявка",
    "policy": "Полис"
  },
  "needs": {
    "title": "Анализ потребностей",
    "subtitle": "Первичный профиль, потребности, риск и налоги в одной записи с версиями",
    "new": "Новый анализ потребностей",
    "analysis": "Анализ потребностей",
    "start": "Начать",
    "none": "Пока нет",
    "none_person": "Для {name} анализа потребностей пока нет.",
    "last": "Последний",
    "filter": {
      "all": "Все",
      "missing": "Нет анализа",
      "draft": "Черновик",
      "final": "Завершён"
    },
    "status": {
      "draft": "Черновик",
      "final": "Завершён"
    },
    "suggest": "Предложить",
    "suggested": "Предложения заполнены — проверьте их",
    "saved": "Анализ потребностей сохранён",
    "finalize": "Завершить",
    "finalized": "Анализ потребностей завершён",
    "finalized_at": "завершён {date}",
    "revise": "Новая редакция",
    "revised": "Открыта новая редакция",
    "locked": "Завершён и заблокирован — чтобы изменить, откройте новую редакцию.",
    "need_person": "Сначала выберите клиента",
    "profile": "Первичный профиль",
    "risk": "Профиль риска",
    "risk_attitude": "Отношение к риску",
    "vulnerability": "Уязвимость",
    "no_vulnerability": "По профилю признаков уязвимости нет.",
    "level": {
      "high": "Высокая",
      "medium": "Средняя",
      "low": "Низкая"
    },
    "areas": "Потребности",
    "areas_hint": "Приоритет, цель, имеющееся покрытие и пробел — с вашим обоснованием и следующим шагом",
    "area": "Область",
    "priority": "Приоритет",
    "target": "Цель",
    "existing": "Есть",
    "gap": "Пробел",
    "reasoning": "Обоснование",
    "action": "Предлагаемое действие",
    "p": {
      "0": "—",
      "1": "Желательно",
      "2": "Важно",
      "3": "Необходимо"
    },
    "create_actions": "Создать напоминания для важных потребностей с действием",
    "from_household": "из семьи: {count}",
    "health_hint": "Только общие сведения — без медицинских подробностей",
    "area_label": {
      "life": "Защита жизни",
      "income": "Защита дохода (в месяц)",
      "critical_illness": "Критические заболевания",
      "health": "Медицинское страхование",
      "accident": "Несчастный случай",
      "mortgage": "Ипотека / кредиты",
      "retirement": "Пенсия",
      "savings": "Накопления",
      "education": "Образование",
      "property": "Имущество",
      "business": "Бизнес"
    },
    "basis": {
      "life_dependants": "От этого дохода зависят иждивенцы — примерно {years} лет дохода плюс долги, минус накопления",
      "life_debts": "Покрывает долги и расходы на похороны",
      "mortgage": "Остаток ипотеки",
      "income": "Около {pct}% месячного дохода при нетрудоспособности",
      "critical_illness": "Примерно {years} лет дохода",
      "health": "Медицинское покрытие нужно всем",
      "accident": "Примерно годовой доход",
      "retirement": "Выход на пенсию в {age}",
      "savings": "Резерв и цели",
      "education": "{children, plural, =0 {Детей пока нет} =1 {Образование ребёнка} one {Образование # ребёнка} few {Образование # детей} many {Образование # детей} other {Образование # ребёнка}}",
      "property": "Жильё и имущество",
      "business": "Непрерывность бизнеса"
    },
    "f": {
      "annualIncome": "Годовой доход",
      "partnerIncome": "Доход партнёра",
      "monthlyExpenses": "Ежемесячные расходы",
      "mortgage": "Остаток ипотеки",
      "liabilities": "Другие долги",
      "savings": "Накопления",
      "dependants": "Иждивенцы",
      "retirementAge": "Пенсионный возраст",
      "smoker": "Курит",
      "employment": "Занятость",
      "employer": "Работодатель",
      "businessOwner": "Владелец бизнеса",
      "goals": "Цели",
      "concerns": "Опасения",
      "existingCoverNotes": "Имеющееся покрытие (у других компаний)",
      "healthNotes": "Сведения о здоровье"
    }
  },
  "risk": {
    "single_income": "Семья из {dependants} чел. зависит в основном от одного дохода",
    "debt_exposure": "Долги составляют {ratio}× годового дохода",
    "low_buffer": "Накоплений хватит на {months} мес. расходов",
    "smoker": "Курит — влияет на стоимость и риски для здоровья",
    "business_owner": "Владелец бизнеса — доход зависит от бизнеса",
    "title": "Профиль риска и пригодность",
    "level": {
      "conservative": "Консервативный",
      "cautious": "Умеренно-осторожный",
      "balanced": "Сбалансированный",
      "growth": "Ориентированный на рост",
      "dynamic": "Динамичный"
    },
    "explain": {
      "conservative": "Главное — сохранить капитал; низкая терпимость к колебаниям.",
      "cautious": "В основном стабильность, немного места для роста.",
      "balanced": "Баланс между стабильностью и ростом; допускает умеренные колебания.",
      "growth": "Цель — рост в долгосрочной перспективе; допускает значительные колебания.",
      "dynamic": "Максимальный упор на рост; допускает большие колебания на длинном горизонте."
    },
    "source": {
      "website": "с avrastro.com",
      "manual": "анкета консультанта"
    },
    "import": "Импорт с avrastro.com",
    "questionnaire": "Анкета риска",
    "date": "Дата",
    "source_label": "Источник · версия",
    "score": "Баллы",
    "goal": "Цель",
    "goal_ph": "например, пенсия, учёба ребёнка",
    "goal_date": "Когда понадобятся деньги",
    "goal_date_hint": "Используется для предупреждения, когда профиль перестаёт соответствовать оставшемуся сроку.",
    "time_to_goal": "Срок до цели",
    "years": "{count, plural, one {# год} few {# года} many {# лет} other {# года}}",
    "none": "Профиля риска пока нет. Заполните анкету или импортируйте результат, которым клиент поделился с avrastro.com.",
    "none_short": "Без профиля риска",
    "history": "{count, plural, one {# версия} few {# версии} many {# версий} other {# версии}}",
    "answers": "{count, plural, one {# ответ} few {# ответа} many {# ответов} other {# ответа}}",
    "disclaimer": "Вспомогательный инструмент для оценки пригодности консультантом (IDD, статья 30); это не рекомендация, продукт не называется. Пригодность оценивает консультант.",
    "create_task": "Задача пересмотра",
    "task_created": "Задача создана",
    "task_title": "Пересмотр профиля риска: {name}",
    "new_version": "Новая версия",
    "mismatch": {
      "horizon_short": "Профиль «{level}» больше не соответствует сроку {years} г. до цели (подходит не выше «{fits}»).",
      "near_retirement": "До пенсии {years} г., а профиль «{level}» (подходит не выше «{fits}»).",
      "goal_passed": "Дата цели прошла — стоит составить новый профиль.",
      "stale": "Профиль устарел — стоит его пересмотреть."
    },
    "questionnaire_intro": "Восемь вопросов: горизонт, цель, реакция на падение, способность нести убытки, знания, опыт, стабильность дохода и резервы. Результат ориентировочный; решение за вами.",
    "q": {
      "horizon": "Когда вам понадобится бо́льшая часть этих денег?",
      "objective": "Какова главная цель?",
      "reaction": "Если бы стоимость упала на 15% за год, что бы вы сделали?",
      "loss_capacity": "Какую часть сбережений вы могли бы потерять, не меняя своих планов?",
      "knowledge": "Как бы вы оценили свои знания об инвестициях?",
      "experience": "Были ли у вас инвестиционные фонды, акции или инвестиционные страховые продукты?",
      "income": "Насколько стабилен ваш доход?",
      "reserves": "Есть ли у вас резерв на 3–6 месяцев расходов?"
    },
    "opt": {
      "horizon": {
        "o1": "Менее чем через 3 года",
        "o2": "Через 3–7 лет",
        "o3": "Через 7–15 лет",
        "o4": "Более чем через 15 лет"
      },
      "objective": {
        "o1": "Не потерять капитал",
        "o2": "Стабильный доход",
        "o3": "Сбалансированный рост",
        "o4": "Рост в долгосрочной перспективе"
      },
      "reaction": {
        "o1": "Забрал бы всё",
        "o2": "Забрал бы часть",
        "o3": "Подождал бы",
        "o4": "Добавил бы денег"
      },
      "loss_capacity": {
        "o1": "Никакую",
        "o2": "До 10%",
        "o3": "10–25%",
        "o4": "Более 25%"
      },
      "knowledge": {
        "o1": "Никаких",
        "o2": "Базовые",
        "o3": "Хорошие",
        "o4": "Профессиональные"
      },
      "experience": {
        "o1": "Никогда",
        "o2": "Один раз",
        "o3": "Несколько лет",
        "o4": "Регулярно"
      },
      "income": {
        "o1": "Нестабильный",
        "o2": "Меняется",
        "o3": "Стабильный",
        "o4": "Очень стабильный, есть резервы"
      },
      "reserves": {
        "o1": "Нет",
        "o2": "Частично",
        "o3": "Да",
        "o4": "Больше"
      }
    },
    "indicative": "Ориентировочный профиль: {level} ({score}/{max})",
    "capped": {
      "horizon": "Ограничен уровнем «Умеренно-осторожный» из-за короткого горизонта.",
      "loss_capacity": "Ограничен уровнем «Умеренно-осторожный»: нет способности нести убытки.",
      "knowledge": "Ограничен уровнем «Сбалансированный»: нет знаний и опыта."
    },
    "override": "Записываемый профиль",
    "override_hint": "Можно выбрать другой профиль, чем ориентировочный; тогда укажите причину.",
    "keep_indicative": "Ориентировочный",
    "override_reason": "Причина",
    "save": "Сохранить новую версию",
    "saved": "Профиль риска сохранён",
    "import_hint": "Когда клиент делится результатом анкеты риска с avrastro.com, он импортируется сам, когда вы принимаете это во «Входящих». Здесь результат (JSON) можно вставить и вручную.",
    "import_save": "Импортировать",
    "import_unreadable": "В этом тексте не найден профиль или баллы.",
    "from_score": "Профиль определён по баллам (в результате он не назван).",
    "in_sale_file": "Профиль риска для оценки пригодности",
    "pick": "Выберите версию",
    "use_latest": "Последний",
    "sale_file_hint": "Заполняется в карточке клиента → «Профиль риска»."
  },
  "tax": {
    "title": "Оценка налога",
    "no_ruleset": "Для региона {region} налоговые правила пока недоступны.",
    "provident": "Накопительный фонд / год",
    "pension": "Пенсионный фонд / год",
    "medical": "Медицинский фонд / год",
    "housing": "Проценты по ипотеке или аренда",
    "household_income": "Доход семьи",
    "si_actual": "Социальное страхование (фактически)",
    "si_hint": "Оставьте пустым для оценки",
    "cap": "Лимит вычетов (1/5 дохода)",
    "used": "Использовано",
    "capacity": "Остаток лимита",
    "life_relief": "Вычет по взносам страхования жизни",
    "saving": "Ориентировочная экономия на налоге",
    "marginal": "Предельная ставка",
    "capacity_hint": "Ещё до {amount} дополнительных взносов на страхование жизни или пенсию подпадают под вычет — примерно на {saving} меньше налога в год.",
    "enter_income": "Укажите годовой доход, чтобы увидеть оценку.",
    "disclaimer": "Оценка по набору правил {id} (проверено {date}). Не налоговая консультация — уточните у налогового консультанта клиента.",
    "note": {
      "si_estimated": "Социальное страхование оценено по стандартной ставке.",
      "life_no_sum_insured": "У полиса страхования жизни не указана страховая сумма — вычет рассчитан по полному взносу.",
      "cap_reached": "Взносы уже превышают лимит вычетов.",
      "household_income_assumed": "Доход семьи не указан — предполагается, что условие для пособия на детей выполнено.",
      "housing_over_threshold": "Доход семьи выше порога — вычета по процентам по ипотеке / аренде нет.",
      "provident_limited": "Взносы в пенсионный и накопительный фонды ограничены 10% зарплаты."
    }
  },
  "quotes": {
    "title": "Котировки",
    "subtitle": "Каждая котировка видна, пока её не примут, не отклонят или пока не истечёт срок",
    "new": "Новая котировка",
    "edit": "Изменить котировку",
    "saved": "Котировка сохранена",
    "empty": "Котировок пока нет.",
    "insurer": "Страховщик",
    "product": "Продукт",
    "number": "№ котировки",
    "premium": "Взнос",
    "expiry": "Действует до",
    "url": "Ссылка на PDF",
    "followup": "Связаться",
    "valid_until": "действует до {date}"
  },
  "proposal": {
    "title": "Предложения",
    "subtitle": "Предложения для клиента на основе потребностей, котировок и сравнений",
    "new": "Новое предложение",
    "studio": "Студия предложений",
    "name": "Название предложения",
    "default_title": "Предложение по защите и накоплениям",
    "empty": "Предложений пока нет.",
    "recommendations": "Рекомендации",
    "no_needs": "Анализа потребностей пока нет — рекомендации появятся, когда вы его проведёте.",
    "close_gap": "Закрыть пробел: {area}",
    "rationale": "Обоснование",
    "rationale_hint": "Почему эта рекомендация подходит клиенту",
    "assumptions": "Допущения",
    "default_assumptions": "Прогнозы основаны на предполагаемой доходности и сборах, указанных в сравнении. Взносы и выплаты соответствуют официальной котировке страховщика.",
    "preview": "Предпросмотр",
    "issue": "Выдать и распечатать",
    "issued": "Предложение выдано",
    "prepared_for": "Подготовлено для: {name} · {date}",
    "signatures": "Подпись клиента · Подпись консультанта",
    "version_note": "При выдаче создаётся пронумерованная версия от {date} в документах и истории клиента.",
    "section": {
      "situation": "Ситуация",
      "needs": "Потребности",
      "recommendations": "Рекомендации",
      "quotes": "Котировки",
      "comparison": "Сравнение",
      "tax": "Налоги",
      "next_steps": "Следующие шаги"
    }
  },
  "print": {
    "pdf_hint": "Для PDF: в окне печати выберите «Сохранить как PDF» (Mac: кнопка «PDF» внизу слева · Windows: принтер «Microsoft Print to PDF»).",
    "notes_space": "Больше места для заметок от руки",
    "paper_letter": "Letter (США)",
    "paper_a4": "A4",
    "paper": "Размер бумаги",
    "orientation_landscape": "Альбомная",
    "orientation_portrait": "Книжная",
    "orientation": "Ориентация",
    "studio": "Студия печати",
    "studio_hint": "Выберите разделы — единая служба печати с вашим фирменным стилем.",
    "sections": "Разделы",
    "section": {
      "identity": "Данные",
      "policies": "Полисы",
      "coverage": "Покрытие",
      "needs": "Потребности",
      "comparisons": "Сравнения",
      "applications": "Заявки",
      "meetings": "Встречи",
      "notes": "Заметки",
      "review": "Обзор",
      "next_actions": "Следующие шаги",
      "protection": "Карта защиты",
      "finances": "Доходы, кредиты и цели",
      "tax": "Налоги",
      "renewals": "Продления",
      "life_events": "Жизненные события",
      "review_changes": "Изменения с последнего обзора"
    },
    "report": {
      "client_review": "Обзор клиента",
      "needs_analysis": "Анализ потребностей",
      "insurance_summary": "Сводка по страхованию",
      "family_protection": "Защита семьи",
      "tax_planning": "Налоговое планирование",
      "renewal_summary": "Сводка по продлениям",
      "meeting_summary": "Итоги встречи",
      "proposal_summary": "Сводка предложения"
    },
    "prepared_for": "Подготовлено для",
    "page": "Страница",
    "of": "из",
    "confidential": "Конфиденциально — подготовлено для указанного выше клиента.",
    "client_report": "Отчёт для клиента",
    "confidential_short": "Конфиденциально",
    "plan_title": "План дня",
    "plan_more": "ещё — см. «План»",
    "plan_in_crm": "в CRM",
    "plan_due": "Звонки и follow-up из CRM (без времени)",
    "plan_notes": "Заметки",
    "blank_title": "План дня"
  },
  "pipeline": {
    "title": "Воронка",
    "subtitle": "{open} открыто · {won} выиграно в этом году · {value}",
    "new": "Новая возможность",
    "opportunity": "Возможность",
    "stage": "Этап",
    "expected": "Ожидаемый годовой взнос",
    "target_close": "Плановое закрытие",
    "next_action_date": "Следующий шаг",
    "advance": "Далее",
    "moved": "Переведена на этап: {stage}",
    "won": "Выиграна 🎉",
    "close_by": "закрыть до {date}",
    "why_hot": "Почему тёплая",
    "no_signals": "Сейчас тёплых сигналов нет.",
    "empty": "Возможностей нет.",
    "show_closed": "Показать закрытые",
    "hide_closed": "Скрыть закрытые"
  },
  "decisions": {
    "title": "Ожидающие решения",
    "subtitle": "Сравнения, котировки и возможности, ожидающие ответа клиента",
    "none": "Решений не ожидается.",
    "kind": {
      "comparison": "Сравнение",
      "quotation": "Котировка",
      "opportunity": "Возможность"
    },
    "waiting_days": "{days, plural, =0 {сегодня} one {# день} few {# дня} many {# дней} other {# дня}}",
    "no_deadline": "Без срока",
    "no_followup": "Без повторного контакта",
    "reason": "Почему ожидается",
    "objections": "Возражения"
  },
  "referrals": {
    "title": "Рекомендации",
    "subtitle": "Рекомендаций: {total} · стали клиентами: {converted}",
    "new": "Новая рекомендация",
    "saved": "Рекомендация сохранена",
    "empty": "Рекомендаций пока нет.",
    "referrer": "Рекомендовал(а)",
    "name": "Рекомендованный человек",
    "by": "от {name}",
    "convert": "Создать карточку",
    "converted": "По рекомендации создана карточка человека",
    "thank": "Поблагодарить",
    "thanked": "поблагодарили",
    "top": "Лучшие рекомендатели",
    "given": "Данные рекомендации",
    "referred_by": "Рекомендовал(а)",
    "relationship": "Кем приходится рекомендателю",
    "rel": {
      "family": "Родственник",
      "friend": "Друг / подруга",
      "colleague": "Коллега",
      "neighbour": "Сосед",
      "business": "Деловой контакт",
      "other": "Другое"
    },
    "log_attempt": "Записать контакт",
    "attempt_saved": "Контакт записан",
    "attempts": "{count, plural, one {# попытка} few {# попытки} many {# попыток} other {# попытки}}",
    "meeting_on": "встреча {date}",
    "next_on": "следующая {date}",
    "channel": "Канал",
    "outcome": "Результат",
    "out": {
      "reached": "Поговорили",
      "no_answer": "Не ответил",
      "callback": "Перезвонить позже",
      "meeting": "Встреча назначена",
      "not_interested": "Не заинтересован"
    },
    "appointment": "Встреча",
    "next_step": "Следующая попытка",
    "next_step_hint": "Если пусто: через два дня при «не ответил» / «перезвонить»",
    "funnel": "{given} получено · {met} встреч · {won} клиентов",
    "to_thank": "поблагодарить: {count}",
    "to_thank_hint": "Рекомендации, за которые ещё не поблагодарили"
  },
  "service": {
    "title": "Центр обслуживания",
    "subtitle": "Запросы и страховые случаи после выдачи полиса — статус, следующий шаг и срок",
    "new": "Новый запрос",
    "request": "Запрос",
    "next": "Следующий шаг",
    "idle": "Открыт",
    "open_only": "Только открытые",
    "placeholder": "напр. смена выгодоприобретателя",
    "tab": {
      "requests": "Запросы",
      "claims": "Страховые случаи"
    },
    "type": {
      "beneficiary": "Смена выгодоприобретателя",
      "payment": "Вопрос по оплате / взносу",
      "address": "Смена адреса",
      "certificate": "Запрос справки",
      "reinstatement": "Восстановление полиса",
      "cancellation": "Расторжение",
      "cover_change": "Изменение покрытия",
      "complaint": "Жалоба"
    }
  },
  "claims": {
    "new": "Новый страховой случай",
    "saved": "Страховой случай сохранён",
    "empty": "Страховых случаев нет.",
    "type": "Тип случая",
    "event_date": "Дата события",
    "reference": "Номер случая",
    "claimed": "Заявлено",
    "paid": "Выплачено",
    "note": "AVRASTRO помогает сопровождать страховой случай; решение принимает страховщик.",
    "kind": {
      "hospital": "Госпитализация",
      "outpatient": "Амбулаторное лечение",
      "accident": "Несчастный случай",
      "critical_illness": "Критическое заболевание",
      "death": "Смерть",
      "disability": "Нетрудоспособность",
      "property": "Имущество",
      "motor": "Авто"
    }
  },
  "comms": {
    "title": "Коммуникации",
    "log": "Записать разговор",
    "logged": "Разговор записан",
    "empty": "Разговоров пока не записано.",
    "channel": "Канал",
    "direction": "Направление",
    "subject": "Тема",
    "summary": "Кратко",
    "followup": "Повторный контакт"
  },
  "meetings": {
    "title": "Встречи",
    "new": "Новая встреча",
    "edit": "Изменить встречу",
    "saved": "Встреча сохранена",
    "empty": "Встреч не записано.",
    "untitled": "Встреча",
    "purpose": "Цель",
    "attendees": "Участники",
    "agenda": "Повестка",
    "held": "Проведена",
    "record_outcome": "Записать итоги",
    "assistant": "Помощник после встречи",
    "notes": "Заметки о встрече",
    "notes_hint": "Пишите свободно, на греческом или английском — лучше по одному пункту в строке",
    "analyse": "Найти обещания и следующие шаги",
    "analyse_hint": "AVRASTRO прочитает ваши заметки и предложит, кто что обещал и к какому сроку. Перед сохранением вы всё проверяете.",
    "commitments": "Обязательства",
    "no_commitments": "Обязательств не найдено — при необходимости добавьте их сами.",
    "add_commitment": "Добавить обязательство",
    "keep": "Оставить",
    "by": {
      "advisor": "Я обещал(а)",
      "client": "Клиент обещал"
    },
    "decisions": "Решения",
    "objections": "Возражения",
    "opportunities": "Возможности",
    "review_note": "Обязательства с датой становятся напоминаниями; обещания клиента отслеживаются как «ждём клиента».",
    "save_outcome": "Сохранить итоги",
    "completed": "Встреча записана — напоминания созданы",
    "promises": "Обещания",
    "no_promises": "Открытых обещаний нет."
  },
  "business": {
    "title": "Бизнес-центр",
    "subtitle": "Цели, продажи, активность и обслуживание — по отдельности",
    "set_targets": "Задать цели",
    "targets_saved": "Цели сохранены",
    "no_target": "Цель не задана",
    "metric": {
      "annualPremium": "Новые годовые взносы",
      "policies": "Новые полисы",
      "newClients": "Новые клиенты",
      "meetings": "Встречи",
      "calls": "Звонки",
      "reviews": "Обзоры",
      "referrals": "Рекомендации"
    },
    "of_target": "из {target} · {pct}%",
    "on_pace": "в графике",
    "behind": "отставание",
    "pace": "Где вы должны быть сегодня",
    "production_by_month": "Продажи по месяцам",
    "monthly_target": "Месячная цель",
    "pipeline": "Воронка",
    "open_value": "Открытый объём",
    "conversion": "Конверсия",
    "won_lost": "Выиграно / проиграно",
    "prospects_called": "Обзвонено потенциальных клиентов",
    "service": "Обслуживание",
    "service_opened": "Открыто запросов",
    "service_closed": "Закрыто запросов",
    "claims_closed": "Закрыто страховых случаев",
    "claims_paid": "Выплачено по страховым случаям",
    "def": {
      "production": "Продажи = годовой взнос полисов, начавшихся в этом году (без предложений).",
      "activity": "Активность = проведённые звонки и встречи, записанные обзоры и полученные рекомендации за этот год.",
      "production_ledger": "Продажи берутся из журнала: новый бизнес, повышения и снижения взносов, продления и сторно — каждое засчитывается один раз."
    },
    "open_ledger": "Открыть журнал продаж",
    "other_currencies": "другие валюты: {list}"
  },
  "quality": {
    "title": "Качество данных",
    "subtitle": "{count, plural, =0 {Проблем не найдено} one {Найдена # проблема} few {Найдено # проблемы} many {Найдено # проблем} other {Найдено # проблемы}} — для каждой указаны причина и предлагаемое исправление",
    "clean": "Ваши данные в порядке.",
    "never_deletes": "Проверка качества данных ничего не удаляет. Перед объединением создаётся защитный снимок, объединение можно отменить.",
    "kind": {
      "duplicate_person": "Дубликаты",
      "duplicate_prospect": "Дубликаты потенциальных клиентов",
      "prospect_is_client": "Потенциальный клиент уже клиент",
      "missing_contact": "Нет контактных данных",
      "invalid_email": "Неверный e-mail",
      "invalid_phone": "Неверный телефон",
      "missing_birthdate": "Нет даты рождения",
      "broken_reference": "Битые связи",
      "client_without_policy": "Клиент без полиса",
      "needs_outdated": "Устаревший анализ потребностей",
      "shared_contact": "Общие контактные данные"
    },
    "issue": {
      "duplicate_person": "{a} и {b} похожи на одного человека",
      "duplicate_prospect": "{name} есть в нескольких списках",
      "prospect_is_client": "Потенциальный клиент {name} уже ваш клиент: {client}",
      "missing_contact": "У {name} нет телефона и e-mail",
      "invalid_email": "{name}: «{value}» — неверный e-mail",
      "invalid_phone": "{name}: «{value}» — неверный номер телефона",
      "missing_birthdate": "У {name} нет даты рождения",
      "broken_reference": "{table}.{field}: {problem}",
      "client_without_policy": "{name} — клиент без действующего полиса",
      "needs_outdated": "Анализу потребностей {name} уже {days} дн.",
      "shared_contact": "У {a} и {b} {basis, select, phone {один номер телефона} email {один адрес e-mail} other {общие контактные данные}}"
    },
    "why": {
      "duplicate_person": "Тот же номер телефона или то же имя и дата рождения.",
      "duplicate_prospect": "Один и тот же номер импортирован дважды.",
      "prospect_is_client": "Не звоните «вслепую» собственным клиентам.",
      "missing_contact": "С этим человеком невозможно связаться.",
      "invalid_email": "Письма не будут доставлены.",
      "invalid_phone": "Звонки и WhatsApp не пройдут.",
      "missing_birthdate": "Нужна для обзоров, поздравлений и расчёта стоимости.",
      "broken_reference": "Запись ссылается на то, чего уже нет.",
      "client_without_policy": "Отметьте как бывшего клиента или добавьте полис.",
      "needs_outdated": "Жизнь меняется — пересмотрите потребности.",
      "shared_contact": "Часто это члены семьи — проверьте, что это разные люди."
    },
    "fix": {
      "merge": "Объединить…",
      "edit": "Изменить",
      "open": "Открыть",
      "review": "Проверить",
      "compare": "Сравнить…"
    },
    "merge_title": "Объединить дубликаты",
    "keep": "Оставить",
    "merge_explain": "Всё, что связано с {drop}, переходит к {keep}; {drop} перемещается в архив, а не удаляется.",
    "merge_confirm": "Объединить",
    "merged": "Записи объединены",
    "fills": "Пустые поля заполнены из дубликата: {list}",
    "merge_safety": "Сначала создаётся защитный снимок; отмена тоже работает.",
    "snapshot_label": "Перед объединением {name}",
    "table": {
      "household_members": "Семья",
      "policies": "Полисы",
      "cases": "Заявки",
      "tasks": "Задачи",
      "notes": "Заметки",
      "reviews": "Обзоры",
      "timeline": "События истории",
      "documents": "Документы",
      "service_cases": "Запросы на обслуживание",
      "consents": "Согласия",
      "legacy_records": "Импортированные записи",
      "comparisons": "Сравнения",
      "needs_analyses": "Анализы потребностей",
      "quotations": "Котировки",
      "opportunities": "Возможности",
      "referrals": "Рекомендации",
      "communications": "Коммуникации",
      "meetings": "Встречи",
      "claims": "Страховые случаи",
      "persons": "Люди",
      "prospects": "Потенциальные клиенты",
      "production_events": "Продажи",
      "renewals": "Продления",
      "commission_entries": "Комиссии",
      "tax_snapshots": "Налоговые расчёты",
      "financial_items": "Доходы, кредиты и цели",
      "life_events": "Жизненные события",
      "campaign_activities": "Активность кампаний",
      "automation_runs": "Запуски автоматизации",
      "extraction_drafts": "Проверки документов",
      "insured_items": "Застрахованные объекты",
      "premium_arrears": "Просроченные взносы",
      "nps_surveys": "Отзывы клиентов",
      "kyc_files": "Файлы KYC/AML",
      "sale_files": "Файлы продаж (IDD)",
      "call_logs": "Звонки потенциальным клиентам",
      "risk_profiles": "Профили риска",
      "family_links": "Семейная карта",
      "client_summaries": "Сводки для клиентов"
    },
    "field": {
      "primaryPhone": "телефон",
      "primaryEmail": "e-mail",
      "birthDate": "дата рождения",
      "occupation": "профессия",
      "employer": "работодатель",
      "address": "адрес",
      "city": "город",
      "maritalStatus": "семейное положение",
      "gender": "пол",
      "householdId": "семья",
      "source": "источник",
      "notes": "примечания",
      "displayName": "имя",
      "firstName": "имя",
      "lastName": "фамилия",
      "phones": "телефоны",
      "emails": "e-mail",
      "stage": "этап",
      "clientSince": "клиент с",
      "referredByPersonId": "по рекомендации",
      "referredByName": "по рекомендации (имя)"
    },
    "compare_title": "Сравнение записей",
    "compare_hint": "Ничего не меняется, пока вы не выберете. При объединении создаётся защитный снимок; решение оставить раздельно запоминается.",
    "shared_explain": "Члены семьи часто пользуются общим телефоном или e-mail. Если это разные люди, оставьте их раздельно.",
    "keep_separate": "Оставить раздельно",
    "kept_separate": "Оставлены раздельно — эта пара больше не будет отмечаться",
    "merge_these": "Объединить…",
    "linked": "Связанные записи",
    "linked_counts": "{policies, plural, one {# полис} few {# полиса} many {# полисов} other {# полиса}} · {tasks, plural, one {# задача} few {# задачи} many {# задач} other {# задачи}} · {documents, plural, one {# документ} few {# документа} many {# документов} other {# документа}}",
    "same_household": "одна семья",
    "conflicts": "Разные значения — приоритет у сохраняемой записи:",
    "conflict_keeps": "остаётся «{keep}» (другое: «{drop}», сохранено в истории)",
    "moves_sensitive": "Также переносятся {consents, plural, one {# запись о согласии} few {# записи о согласии} many {# записей о согласии} other {# записи о согласии}} и {documents, plural, one {# документ} few {# документа} many {# документов} other {# документа}}."
  },
  "compliance": {
    "title": "Комплаенс и GDPR",
    "subtitle": "Согласия, доступ, исправление и удаление · без записанного согласия на маркетинг: {count}",
    "pick": "Выберите человека, чтобы увидеть его согласия и права на данные.",
    "consents": "Согласия",
    "record": "Записать согласие",
    "purpose": "Цель",
    "granted": "Дано",
    "withdrawn": "Отозвано",
    "not_recorded": "Не записано",
    "history": "История",
    "channel_hint": "Выбирайте канал, только если клиент ограничил согласие этим каналом; откуда получено согласие, указывается в поле «Источник».",
    "rights": "Права субъекта данных",
    "export": "Выгрузить все данные (JSON)",
    "exported": "Персональные данные выгружены",
    "rectify": "Исправить данные",
    "erase": "Удалить персональные данные",
    "note": "Удаление анонимизирует человека и удаляет заметки, разговоры и документы; страховые записи сохраняются по требованиям регулятора.",
    "erase_title": "Удаление персональных данных · {name}",
    "erase_explain": "Человек анонимизируется. Полисы, заявки, страховые случаи и согласия сохраняются, но больше его не идентифицируют.",
    "will_delete": "Будет удалено",
    "will_retain": "Будет сохранено (анонимно)",
    "erase_word": "УДАЛИТЬ",
    "type_to_confirm": "Введите {word} для подтверждения",
    "erased": "Персональные данные удалены",
    "snapshot_label": "Перед удалением {name}",
    "snapshot_kept": "Сохранён защитный снимок: {label}",
    "lawful_basis": "Правовое основание",
    "source": "Источник",
    "source_hint": "напр. подписанная форма, телефонный звонок, сайт",
    "scope": "Объём",
    "scope_hint": "напр. рассылки о пенсиях, только WhatsApp",
    "basis": {
      "consent": "Согласие",
      "contract": "Договор",
      "legal_obligation": "Юридическая обязанность",
      "legitimate_interest": "Законный интерес",
      "vital_interest": "Жизненно важный интерес"
    },
    "any_channel": "Любой канал"
  },
  "consent": {
    "purpose": {
      "marketing": "Маркетинг",
      "advice": "Консультации и обслуживание",
      "health_data": "Обработка данных о здоровье",
      "third_party": "Передача страховщикам",
      "newsletter": "Рассылка",
      "client": "Отношения с клиентом",
      "data_processing": "Обработка данных",
      "documents": "Хранение документов",
      "whatsapp": "Сообщения WhatsApp",
      "voice_recording": "Запись встреч для резюме"
    }
  },
  "templates": {
    "title": "Шаблоны сообщений",
    "subtitle": "Единый многоязычный каталог для всех сообщений клиентам — поля подставляются из ваших данных",
    "template": "Шаблон",
    "compose": "Сообщение",
    "compose_template": "Сообщение по шаблону",
    "subject": "Тема",
    "body": "Текст",
    "preview": "Предпросмотр",
    "custom": "Изменён",
    "default": "По умолчанию",
    "saved": "Шаблон сохранён",
    "reset": "Восстановить по умолчанию",
    "missing": "Пока нет значения для: {list}",
    "key": {
      "appointment_confirm": "Подтверждение встречи",
      "appointment_reminder": "Напоминание о встрече",
      "missed_call": "Пропущенный звонок",
      "birthday": "День рождения",
      "nameday": "Именины",
      "review_invite": "Приглашение на обзор",
      "renewal": "Продление",
      "quote_followup": "Уточнение по котировке",
      "decision_followup": "Ожидающее решение",
      "missing_documents": "Недостающие документы",
      "underwriting_update": "Новости андеррайтинга",
      "meeting_followup": "После встречи",
      "referral_thanks": "Благодарность за рекомендацию",
      "claim_update": "Новости по страховому случаю",
      "campaign": "Свободное сообщение",
      "followup_general": "Общее напоминание",
      "premium_reminder": "Напоминание о просроченном взносе",
      "nps_invite": "Вопрос об удовлетворённости (NPS)",
      "google_review": "Просьба об отзыве в Google",
      "review_request": "Благодарность + отзыв в Google"
    },
    "print_letter": "Печать как письмо"
  },
  "decision": {
    "reason": {
      "draft": "Сравнение ещё в черновике",
      "decide_later": "Клиент сказал, что решит позже"
    }
  },
  "ask": {
    "title": "Спросить AVRASTRO",
    "subtitle": "Вопросы обычным языком на греческом или английском — ответы формируются на этом устройстве из ваших записей",
    "ask": "Спросить",
    "placeholder": "напр. У каких клиентов есть дети младше 10 лет?",
    "privacy": "Ответы рассчитываются локально по доступным вам записям. Ничего не отправляется в сервисы ИИ.",
    "empty": "Спрашивайте о клиентах, продлениях, продажах или кампаниях — к каждому ответу прилагаются записи, на которых он основан.",
    "lens": "Спросить AVRASTRO: «{q}»",
    "voice": "Диктовка",
    "voice_note": "Диктовка использует службу распознавания речи браузера; ничего не записывается и не сохраняется",
    "voice_failed": "Диктовка сейчас недоступна",
    "segment_answer": "{segment}: {count, plural, one {# человек} few {# человека} many {# человек} other {# человека}}{incomplete, plural, =0 {} other { · с неполными данными: #}}",
    "renewals": "{count, plural, =0 {Нет продлений} one {# продление} few {# продления} many {# продлений} other {# продления}} с {from} по {to}",
    "production": "Продажи {period}: {total} ({count, plural, one {# событие} few {# события} many {# событий} other {# события}})",
    "draft": "Вот черновик напоминания — проверьте его перед отправкой.",
    "campaign_draft": "С этой аудитории можно начать кампанию: {count, plural, one {# человек} few {# человека} many {# человек} other {# человека}}. Перед любым контактом проверяются согласия и исключения.",
    "start_my_day": "Ваш день готов: приоритеты, звонки и напоминания в одной очереди.",
    "unknown": "Пока не удалось распознать этот вопрос. Попробуйте один из примеров или назовите клиента, период или сегмент.",
    "ambiguous": "Подходит несколько человек: {names}. Уточните, пожалуйста.",
    "which": "Вы имели в виду: {names}?",
    "open_draft": "Открыть черновик",
    "create_campaign": "Создать кампанию",
    "sources": "На основе {count, plural, =0 {0 записей} one {# доступной вам записи} few {# доступных вам записей} many {# доступных вам записей} other {# доступной вам записи}}",
    "example": {
      "review": "У кого просрочен ежегодный обзор?",
      "education": "Родители детей младше 10 лет без образовательной программы",
      "renewals": "Продления в ближайшие 30 дней",
      "life_medical": "Клиенты со страхованием жизни, но без медицинской программы",
      "draft": "Подготовь напоминание по моей последней встрече",
      "campaign": "Запусти кампанию для ипотек без кредитного страхования жизни",
      "summary": "Сводка по Марии",
      "prep": "Подготовь мою встречу с Андреасом",
      "opportunities": "Какие у меня есть возможности?"
    },
    "client_summary": "{name}: действующих полисов — {policies} ({annual} в год), открытых заявок — {cases}, открытых задач — {tasks}. Обзор: {review}. Пробелы в покрытии: {gaps}.",
    "meeting_prep": "Подготовка к встрече с {name} готова: темы для разговора, семья, полисы и открытые вопросы.",
    "opportunities": "Лучшие возможности ({count}) — для каждой указаны причина и следующий шаг.",
    "open_client": "Открыть клиента"
  },
  "audit": {
    "title": "Журнал аудита",
    "note": "Каждое изменение записывается: кто, когда и что. Медицинские документы и документы с ограниченным доступом записываются без содержимого.",
    "synced": "синхронизация",
    "export": "Экспорт CSV",
    "col": {
      "at": "Когда (UTC)",
      "actor": "Кто",
      "action": "Действие",
      "summary": "Кратко",
      "entity": "Запись",
      "changes": "Изменения (было → стало)"
    }
  },
  "auto": {
    "title": "Автоматизация",
    "subtitle": "ЕСЛИ что-то происходит, ТО создаётся задача — никогда не сообщение и никогда не изменение данных клиента",
    "install": "Установить рекомендуемые правила",
    "installed": "Рекомендуемые правила установлены (выключены — проверьте и включите)",
    "new": "Новое правило",
    "edit": "Изменить правило",
    "empty": "Правил пока нет. Установите рекомендуемые или создайте свои.",
    "enabled": "Правило включено",
    "disabled": "Правило выключено",
    "enabled_label": "Включено",
    "history": "Последние запуски",
    "last_run": "последний запуск {date}",
    "make_runner": "Запускать автоматизацию на этом устройстве",
    "runner_here": "Ежедневная автоматизация выполняется на этом устройстве.",
    "runner_other": "Ежедневная автоматизация выполняется на другом устройстве, поэтому задачи не дублируются.",
    "runner_none": "Ни одно устройство не выполняет автоматизацию ежедневно — её можно запускать вручную.",
    "nothing_enabled": "Делать нечего: сегодня ни одно включённое правило не сработало.",
    "preview_title": "Тестовый запуск (ничего не создаётся)",
    "preview_note": "Тестовый запуск показывает, какие именно задачи создал бы реальный запуск.",
    "test": "Тест",
    "run": "Запустить",
    "ran": "{count, plural, =0 {Новых задач нет} one {Создана # задача} few {Создано # задачи} many {Создано # задач} other {Создано # задачи}}",
    "safety": "Автоматизация только создаёт задачи. Каждое совпадение обрабатывается один раз (идемпотентно), один запуск ограничен 200 задачами, а каждое изменение правила создаёт новую версию.",
    "when": "ЕСЛИ {trigger}",
    "then": "ТО задача «{kind}» со сроком через {days, plural, =0 {0 дней} one {# день} few {# дня} many {# дней} other {# дня}}",
    "when_label": "Когда",
    "days": "Дни",
    "due_in": "Срок (дней)",
    "task_kind": "Тип задачи",
    "task_title": "Название задачи",
    "would_create": "создаст {count, plural, =0 {ничего} one {# задачу} few {# задачи} many {# задач} other {# задачи}}{done, plural, =0 {} other { · уже выполнено: #}}",
    "result": {
      "created": "задача создана"
    },
    "trigger": {
      "renewal_due": "до продления {days, plural, =0 {0 дней} one {# день} few {# дня} many {# дней} other {# дня}}",
      "birthday": "у клиента день рождения",
      "quote_pending": "котировка ждёт решения {days, plural, one {# день} few {# дня} many {# дней} other {# дня}}",
      "review_overdue": "ежегодный обзор просрочен",
      "policy_lapsed": "полис прекращается",
      "life_event": "записано жизненное событие",
      "claim_action_due": "страховой случай требует действий"
    }
  },
  "automation": {
    "default": {
      "renewal": "Готовить продления за 30 дней",
      "birthday": "Звонок в день рождения",
      "quote": "Напоминать о котировках через 5 дней"
    },
    "task": {
      "renewal": "Подготовить условия продления",
      "birthday": "Позвонить с поздравлением",
      "quote": "Уточнить по ожидающей котировке"
    }
  },
  "campaigns": {
    "title": "Кампании",
    "subtitle": "От умного сегмента к проверенной аудитории, сообщению и плану действий — каждый контакт под вашим контролем",
    "new": "Новая кампания",
    "empty": "Кампаний пока нет. Начните с библиотеки или с сегмента.",
    "campaign": "Кампания",
    "audience": "Аудитория",
    "contacted": "Контакты",
    "issued": "Выдано",
    "production": "Продажи",
    "channel_label": "Канал",
    "created": "Кампания создана",
    "prepare": "Проверить и зафиксировать аудиторию",
    "prepared": "Аудитория проверена и зафиксирована",
    "launch": "Запустить (создать задачи)",
    "relaunch": "Создать недостающие задачи",
    "launched": "Кампания запущена — задачи в вашей очереди",
    "complete": "Завершить кампанию",
    "completed": "Кампания завершена",
    "audience_preview": "Предпросмотр аудитории",
    "audience_frozen": "Аудитория зафиксирована {date}",
    "eligible": "Подходят",
    "excluded_note": "Исключены: {list}",
    "preview_hint": "Включаются только люди с согласием на этот канал и контактными данными. С исключёнными людьми никогда не связываются.",
    "draft": "Черновик сообщения",
    "activity_saved": "Активность записана",
    "message": "Сообщение",
    "kit": "Набор кампании: сценарий звонка, тезисы, последовательность",
    "call_script": "Сценарий звонка",
    "talking_points": "Тезисы",
    "sequence": "Последовательность",
    "step": "день {day}: {action}",
    "landing": "Текст для страницы",
    "social": "Пост для соцсетей",
    "use_theme": "Использовать",
    "from_segment": "Создать кампанию",
    "never_sends": "AVRASTRO никогда ничего не отправляет сам: он готовит черновики и задачи, а вы решаете, что отправить.",
    "verify_claims": "Перед использованием сверяйте все цифры и утверждения с актуальными материалами страховщика.",
    "attribution": "Полис засчитывается кампании, если он выдан в пределах окна атрибуции после первого контакта (first touch).",
    "conversion": "конверсия {pct}",
    "no_conversion": "конверсии пока нет",
    "tab": {
      "campaigns": "Кампании",
      "library": "Библиотека",
      "segments": "Сегменты",
      "newsletter": "Рассылка",
      "suggestions": "Предложения"
    },
    "status": {
      "draft": "Черновик",
      "ready": "Готова",
      "active": "Активна",
      "completed": "Завершена",
      "archived": "В архиве"
    },
    "kpi": {
      "audience": "Аудитория",
      "contacted": "Контакты",
      "responded": "Ответили",
      "appointments": "Встречи",
      "quotes": "Котировки",
      "applications": "Заявки",
      "issued": "Выдано"
    },
    "channel": {
      "whatsapp": "WhatsApp",
      "email": "E-mail",
      "sms": "SMS",
      "phone": "Звонок"
    },
    "activity": {
      "contacted": "Связались",
      "responded": "Ответил",
      "appointment": "Встреча",
      "quote": "Котировка",
      "application": "Заявка",
      "issued": "Выдан",
      "opted_out": "Отказался от контактов"
    },
    "objective": "Цель",
    "obj": {
      "appointments": "Назначить встречи",
      "reviews": "Ежегодные обзоры",
      "new_business": "Новый бизнес",
      "cross_sell": "Полная защита (кросс-продажи)",
      "reactivation": "Возврат клиентов",
      "referrals": "Рекомендации",
      "retention": "Удержание",
      "information": "Только информирование"
    },
    "obj_hint": {
      "appointments": "Успех = назначенные встречи.",
      "reviews": "Успех = проведённые обзоры.",
      "new_business": "Успех = заявки и взносы по выданным полисам.",
      "cross_sell": "Успех = новое покрытие для существующих клиентов.",
      "reactivation": "Успех = прекратившие клиенты снова активны.",
      "referrals": "Успех = полученные рекомендации.",
      "retention": "Успех = сохранённые продления.",
      "information": "Без цели продаж — держите клиентов в курсе."
    }
  },
  "campaign": {
    "step": {
      "message": "сообщение",
      "call": "звонок",
      "followup": "напоминание"
    },
    "task": {
      "message": "Кампания: отправить подготовленное сообщение",
      "call": "Кампания: позвонить",
      "followup": "Кампания: повторный контакт"
    }
  },
  "audience": {
    "reason": {
      "archived": "В архиве",
      "suppressed": "Не связываться",
      "consent_withdrawn": "Согласие отозвано",
      "no_consent": "Нет согласия на маркетинг",
      "channel_not_consented": "Нет согласия на этот канал",
      "no_contact_detail": "Нет телефона или e-mail"
    }
  },
  "segments": {
    "incomplete": "{count, plural, one {# с неполными данными} few {# с неполными данными} many {# с неполными данными} other {# с неполными данными}}",
    "incomplete_hint": "Эти люди могут сюда относиться, но им мешает недостающая деталь (например, дата рождения). Заполните карточку — и они будут включены.",
    "incomplete_short": "Неполные данные",
    "refreshed": "обновлено {date}",
    "population": "{count, plural, one {Проверен # человек} few {Проверено # человека} many {Проверено # человек} other {Проверено # человека}}",
    "detail": {
      "age": "возраст",
      "amount": "сумма",
      "balance": "остаток",
      "birthDate": "дата рождения",
      "capacity": "остаток лимита",
      "children": "дети",
      "childrenWithoutBirthDate": "дети без даты рождения",
      "currency": "валюта",
      "date": "дата",
      "days": "дни",
      "dueDate": "срок",
      "income": "доход",
      "needsEvaluated": "потребности оценены",
      "policies": "полисы",
      "product": "продукт",
      "state": "состояние",
      "status": "статус",
      "type": "тип",
      "youngest": "младший ребёнок",
      "annual": "Годовой взнос",
      "stage": "Этап",
      "item": "Объект",
      "linkedPolicy": "Связанный полис",
      "vehicles": "Транспортные средства",
      "family": "Члены семьи",
      "employees": "Сотрудники"
    }
  },
  "segment": {
    "parents_children_under_10": "Родители детей младше 10 лет",
    "parents_children_0_12": "Родители детей 0–12 лет",
    "no_medical_recorded": "Нет медицинского страхования",
    "mortgage_no_credit_life": "Ипотека без кредитного страхования жизни",
    "life_no_savings": "Страхование жизни без накопительной программы",
    "over_40_no_retirement": "Старше 40 без пенсионной программы",
    "reviews_overdue": "Просроченные ежегодные обзоры",
    "birthdays_this_month": "Дни рождения в этом месяце",
    "namedays_this_week": "Именины на этой неделе",
    "tax_opportunity": "Неиспользованный налоговый вычет по взносам страхования жизни",
    "lapsed_policies": "Прекращённые полисы",
    "gi_renewals_30": "Продления общего страхования в течение 30 дней",
    "life_no_medical": "Страхование жизни без медицинской программы",
    "parents_no_education": "Родители без образовательной программы",
    "criteria": {
      "parents_children_under_10": "Клиенты, в семье которых есть хотя бы один ребёнок младше 10 лет (нужна дата рождения).",
      "parents_children_0_12": "Клиенты, в семье которых есть хотя бы один ребёнок 0–12 лет.",
      "no_medical_recorded": "Активные клиенты без действующего медицинского полиса.",
      "mortgage_no_credit_life": "Указана ипотека, но нет действующего полиса кредитного страхования жизни.",
      "life_no_savings": "Действующий полис страхования жизни, но нет накопительной или инвестиционной программы.",
      "over_40_no_retirement": "40 лет и старше без действующей пенсионной программы.",
      "reviews_overdue": "Ежегодный обзор просрочен или ещё не проводился.",
      "birthdays_this_month": "День рождения в текущем месяце.",
      "namedays_this_week": "Именины в ближайшие 7 дней.",
      "tax_opportunity": "Сохранённый налоговый расчёт показывает остаток вычета по взносам страхования жизни (только утверждённые или предварительные правила).",
      "lapsed_policies": "Хотя бы один полис прекращён из-за неуплаты.",
      "gi_renewals_30": "Продление общего страхования в ближайшие 30 дней.",
      "life_no_medical": "Действующий полис страхования жизни, но нет действующего медицинского полиса.",
      "parents_no_education": "Есть дети, но нет образовательного полиса или цели на образование.",
      "property_no_earthquake": "Действующий объект недвижимости среди застрахованных объектов без связанного действующего полиса общего страхования. Если связанный полис есть, но в его условиях не упомянуто землетрясение, клиент отмечается как неполный (детали покрытия не записаны). О покрытии у других компаний неизвестно.",
      "family_vehicle_no_life": "Действующее транспортное средство, супруг(а) или дети в семье и нет действующего полиса страхования жизни или кредитного страхования жизни (как страхователь или застрахованный).",
      "mortgage_no_protection": "Действующий объект недвижимости с отметкой об ипотеке и нет действующего полиса кредитного страхования жизни или страхования жизни.",
      "business_no_liability": "Действующий бизнес с сотрудниками без связанного действующего полиса страхования ответственности. Бизнесы без указанного числа сотрудников отмечаются как неполные.",
      "gap_life_cover": "Клиенты без записанного страхования жизни.",
      "gap_income_protection": "Клиенты 18–64 лет без записанной защиты дохода.",
      "gap_beneficiaries": "Клиенты с полисом жизни без названных выгодоприобретателей.",
      "gap_health": "Клиенты без записанного медицинского плана.",
      "gap_retirement": "Клиенты моложе 65 лет без записанных пенсионных накоплений."
    },
    "property_no_earthquake": "Недвижимость: страхование от землетрясения не записано",
    "family_vehicle_no_life": "Семья с автомобилем без страхования жизни",
    "mortgage_no_protection": "Жильё в ипотеке без страхования кредита или жизни",
    "business_no_liability": "Бизнес с сотрудниками без полиса ответственности",
    "gap_life_cover": "Пробел: страхование жизни",
    "gap_income_protection": "Пробел: защита дохода",
    "gap_beneficiaries": "Пробел: выгодоприобретатели",
    "gap_health": "Пробел: медицинское страхование",
    "gap_retirement": "Пробел: пенсия"
  },
  "commission": {
    "title": "Комиссии",
    "generate": "Рассчитать по продажам",
    "generated": "{count, plural, =0 {Новых строк комиссии нет} one {Добавлена # строка комиссии} few {Добавлено # строки комиссии} many {Добавлено # строк комиссии} other {Добавлено # строки комиссии}}",
    "rules": "Правила",
    "rule": "Правило комиссии",
    "rule_new": "Новое правило",
    "rule_hint": "Правило задаёт ожидаемую ставку для страховщика, категории и периода. При расчёте ставка фиксируется в каждой строке.",
    "kind_label": "Вид",
    "rate": "Ставка (%)",
    "any": "любой страховщик",
    "from": "Действует с",
    "to": "Действует до",
    "source": "Источник",
    "source_ph": "напр. агентский договор 2026",
    "totals": "ожидается {expected} · выплачено {paid} · к получению {outstanding}",
    "none": "строк комиссии нет",
    "mark_paid": "Отметить выплаченной",
    "disclaimer": "Ожидаемая комиссия — оценка по вашим собственным правилам; определяющей является выписка страховщика.",
    "kind": {
      "new_business": "Новый бизнес",
      "renewal": "Продление",
      "trail": "Регулярная",
      "bonus": "Бонус",
      "campaign_bonus": "Бонус за кампанию",
      "adjustment": "Корректировка"
    },
    "status": {
      "expected": "Ожидается",
      "pending": "В обработке",
      "paid": "Выплачена",
      "cancelled": "Отменена"
    }
  },
  "custom": {
    "title": "Пользовательские поля",
    "subtitle": "Добавьте сведения, нужные вашей практике, без изменения базы данных",
    "new": "Новое поле",
    "empty": "Пользовательских полей пока нет.",
    "entity": "Относится к",
    "key": "Ключ",
    "key_hint": "строчные латинские буквы, цифры и _ (после использования изменить нельзя)",
    "type_label": "Тип",
    "label_en": "Название (английский)",
    "label_el": "Название (греческий)",
    "options": "Варианты",
    "options_hint": "через запятую",
    "required": "обязательно",
    "values": "{count, plural, =0 {не используется} one {# значение} few {# значения} many {# значений} other {# значения}}",
    "note": "Значения хранятся в каждой записи, входят в резервные копии и выгрузки и не удаляются при отключении поля.",
    "type": {
      "text": "Текст",
      "number": "Число",
      "date": "Дата",
      "choice": "Выбор",
      "bool": "Да / нет"
    }
  },
  "day": {
    "greeting": {
      "morning": "Доброе утро{name, select, none {} other {, {name}}}",
      "afternoon": "Добрый день{name, select, none {} other {, {name}}}",
      "evening": "Добрый вечер{name, select, none {} other {, {name}}}"
    },
    "tab": {
      "morning": "Начало дня",
      "queue": "Очередь работы",
      "evening": "Итоги дня"
    },
    "start": "Начать день",
    "morning_line": "{count, plural, one {Сегодня вы нужны # человеку.} few {Сегодня вы нужны # людям.} many {Сегодня вы нужны # людям.} other {Сегодня вы нужны # человека.}} Начните с первой карточки — остальное подождёт.",
    "all_clear": "Сегодня ничего срочного. Хороший день для обзоров и новых разговоров.",
    "tiles_note": "Каждая плитка открывает соответствующий список. Числа считаются по тем же правилам, что и список внимания.",
    "focus_mode": "Режим фокуса",
    "record": "Записать",
    "recorded": "Результат записан, следующий шаг запланирован",
    "next_action": "Следующий шаг после сегодняшнего контакта",
    "completed": "Сделано сегодня",
    "none_completed": "Сегодня пока ничего не выполнено.",
    "pending": "Ещё открыто",
    "nothing_pending": "На сегодня ничего не осталось. Отличная работа.",
    "move_all": "Перенести всё на следующий рабочий день",
    "move_to": "Перенести на {date}",
    "moved": "{count, plural, one {Перенесена # задача} few {Перенесено # задачи} many {Перенесено # задач} other {Перенесено # задачи}} — исходные даты сохранены",
    "moved_one": "Задача перенесена",
    "first_due": "первоначальный срок {date}",
    "moved_times": "{count, plural, =1 {перенесена один раз} one {перенесена # раз} few {перенесена # раза} many {перенесена # раз} other {перенесена # раза}}",
    "tile": {
      "followups": "Напоминания",
      "birthdays": "Дни рождения",
      "namedays": "Именины",
      "child_birthdays": "Дни рождения детей в этом месяце",
      "renewals": "Продления",
      "reviews": "Обзоры",
      "quotes": "Котировки и решения",
      "lapses": "Прекращения и просрочки",
      "cases": "Заявки",
      "life_events": "Жизненные события"
    }
  },
  "finances": {
    "title": "Доходы, кредиты и цели",
    "add": "Добавить",
    "empty": "Доходы, кредиты или цели пока не записаны.",
    "kind_label": "Вид",
    "type_label": "Тип",
    "label": "Описание",
    "amount": "Сумма",
    "instalment": "Платёж",
    "unknown_hint": "оставьте пустым, если неизвестно — неизвестное никогда не считается нулём",
    "frequency": "Периодичность",
    "gross_net": "Брутто или нетто",
    "gross": "брутто",
    "net": "нетто",
    "unknown": "неизвестно",
    "balance": "Остаток",
    "target": "Целевая сумма",
    "by_date": "К дате",
    "rate": "Ставка (%)",
    "term": "Срок (мес.)",
    "lender": "Кредитор",
    "default_currency": "Валюта по умолчанию",
    "from_document": "из документа",
    "year": "год",
    "kind": {
      "income": "Доход",
      "expense": "Расход",
      "liability": "Кредит",
      "goal": "Цель",
      "asset": "Актив"
    },
    "type": {
      "salary": "Зарплата",
      "self_employment": "Самозанятость",
      "rental": "Доход от аренды",
      "pension": "Пенсия",
      "other": "Другое",
      "living": "Расходы на жизнь",
      "rent": "Аренда",
      "income_tax": "Подоходный налог",
      "education": "Образование",
      "mortgage": "Ипотека",
      "loan": "Кредит",
      "credit_card": "Кредитная карта",
      "retirement": "Пенсия",
      "home": "Жильё",
      "emergency": "Резервный фонд",
      "cash": "Наличные",
      "savings": "Сбережения",
      "investments": "Инвестиции",
      "property": "Недвижимость"
    },
    "freq": {
      "monthly": "в месяц",
      "annual": "в год",
      "one_off": "разово"
    }
  },
  "fneeds": {
    "title": "Потребности семьи (страхование жизни)",
    "income": "Годовой доход для замещения",
    "replacement": "Замещение (%)",
    "years": "Лет поддержки",
    "debts": "Долги к погашению",
    "final": "Расходы на похороны",
    "assets": "Ликвидные активы",
    "inflation": "Инфляция (%)",
    "return": "Доходность (%)",
    "capital": "Необходимый капитал",
    "existing": "Минус имеющееся страхование жизни",
    "gap": "Пробел",
    "c": {
      "income": "Замещение дохода",
      "debts": "Долги",
      "education": "Образование",
      "final": "Расходы на похороны",
      "emergency": "Резервный фонд",
      "assets": "Минус ликвидные активы"
    },
    "not_evaluated": "Ещё не оценено — не хватает: {fields}. Ничего не предполагается.",
    "assumptions": "Только для иллюстрации. Реальная ставка: {real}% в год. Допущения можно изменить, они печатаются на каждом документе.",
    "field": {
      "annualIncome": "годовой доход",
      "years": "лет поддержки",
      "debts": "долги"
    }
  },
  "lifeEvent": {
    "title": "Жизненные события",
    "add": "Записать",
    "new": "Новое жизненное событие",
    "type": "Что произошло?",
    "create_task": "Создать задачу-напоминание",
    "saved": "Жизненное событие записано",
    "empty": "Жизненных событий не записано.",
    "followup_created": "напоминание создано",
    "task": {
      "marriage": "Пересмотреть покрытие после свадьбы",
      "new_child": "Пересмотреть защиту семьи после рождения ребёнка",
      "new_job": "Пересмотреть защиту дохода после смены работы",
      "salary_increase": "Проверить покрытие и накопления после повышения зарплаты",
      "home_purchase": "Страхование жилья и защита ипотеки",
      "mortgage": "Застраховать новую ипотеку",
      "new_loan": "Проверить защиту нового кредита",
      "business_start": "Страхование бизнеса и ключевых лиц",
      "retirement_planning": "Разговор о пенсионном планировании",
      "divorce": "Пересмотреть выгодоприобретателей и покрытие",
      "new_property": "Застраховать новую недвижимость",
      "other": "Отработать жизненное событие"
    }
  },
  "lock": {
    "title": "AVRASTRO заблокирован",
    "subtitle": "Ваши данные на этом устройстве зашифрованы. Введите парольную фразу, чтобы продолжить.",
    "unlock": "Разблокировать",
    "unlocking": "Разблокировка…",
    "recovery_key": "Ключ восстановления",
    "use_recovery": "Использовать ключ восстановления",
    "use_passphrase": "Использовать парольную фразу"
  },
  "meeting_mode": {
    "title": "Режим встречи",
    "open": "Режим встречи",
    "purpose": "Встреча с клиентом (режим встречи)",
    "age": "{age} лет",
    "add_goal": "Добавить цель",
    "not_evaluated": "Ещё не оценено — недостающие данные заполним вместе.",
    "disclaimer": "Это резюме для обсуждения. Оно не является предложением или рекомендацией, пока рекомендация не согласована и не оформлена документально.",
    "notes_ph": "О чём договорились? Что дальше?",
    "summary_title": "Итоги встречи — {name}",
    "print": "Печать итогов",
    "finish": "Завершить встречу",
    "saved": "Встреча записана",
    "autosaved": "Сохраняется автоматически",
    "step": {
      "family": "Семья",
      "income": "Доход",
      "loans": "Кредиты",
      "insurance": "Страхование",
      "goals": "Цели",
      "analysis": "Защита",
      "discussion": "Обсуждение",
      "summary": "Итоги"
    }
  },
  "money": {
    "mixed_currencies": "несколько валют — не суммируются"
  },
  "quickadd": {
    "title": "Быстрое добавление",
    "pick_person": "Для кого?",
    "note": "Заметка",
    "client": "Клиент",
    "lead": "Контакт",
    "policy": "Полис",
    "task": "Задача",
    "appointment": "Встреча",
    "claim": "Страховой случай",
    "upload": "Документ",
    "card": "Визитка"
  },
  "adjustment": {
    "type": {
      "increase": "Повышение",
      "decrease": "Снижение",
      "reversal": "Сторно",
      "renewal": "Продление",
      "correction": "Исправление"
    },
    "source": {
      "renewal": "из продления",
      "extraction": "из документа"
    },
    "mode": {
      "new_instalment": "Новый платёж ({freq})",
      "new_annual": "Новый годовой взнос",
      "delta_instalment": "Изменение на платёж",
      "delta_annual": "Изменение в год"
    }
  },
  "needTag": {
    "life_cover": "Страхование жизни",
    "savings": "Накопления",
    "education": "Образование",
    "child_protection": "Защита детей",
    "retirement": "Пенсия",
    "medical": "Медицина",
    "accident": "Несчастный случай",
    "income_protection": "Защита дохода",
    "critical_illness": "Критические заболевания",
    "mortgage_protection": "Защита ипотеки",
    "property": "Имущество",
    "motor": "Авто",
    "travel": "Путешествия",
    "liability": "Ответственность",
    "business": "Бизнес"
  },
  "production": {
    "title": "Продажи",
    "subtitle": "Каждое изменение взноса засчитывается ровно один раз — новый бизнес, повышения, снижения, продления и сторно",
    "total": "Итого",
    "life": "Жизнь",
    "general": "Общее",
    "events": "Операции",
    "previous": "аналогичный прошлый период",
    "vs_previous": "к прошлому периоду",
    "no_comparison": "без сравнения (в прошлом периоде был ноль)",
    "reconciled": "Сверено",
    "reconciled_hint": "журнал совпадает с текущими годовыми взносами",
    "by_type": "По типу",
    "no_contexts": "нет зачётов за кросс-продажи или кампании",
    "type_filter": "Фильтр по типу",
    "all_types": "Все типы",
    "all_branches": "Все виды страхования",
    "type_col": "Тип",
    "amount": "Годовая сумма",
    "effective": "действует с",
    "single": "единовременный взнос",
    "empty": "За этот период продаж нет.",
    "ledger_empty": "Журнал пуст. Сформируйте его из существующих полисов — ничего не меняется, только добавляются зачёты.",
    "backfill": "Сформировать из существующих полисов",
    "backfilled": "{count, plural, =0 {Добавлять нечего — журнал полон} one {Добавлена # запись} few {Добавлено # записи} many {Добавлено # записей} other {Добавлено # записи}}",
    "definition": "Продажи = годовой взнос, засчитанный в день записи. При повышении засчитывается только разница; аннулирование в пределах окна сторнирует новый бизнес; единовременные взносы показаны отдельно.",
    "type": {
      "new_business": "Новый бизнес",
      "increase": "Повышение",
      "decrease": "Снижение",
      "renewal": "Продление",
      "replacement": "Замена",
      "reactivation": "Восстановление",
      "cancellation": "Аннулирование",
      "reversal": "Сторно"
    },
    "period": {
      "today": "Сегодня",
      "week": "Эта неделя",
      "month": "Этот месяц",
      "quarter": "Этот квартал",
      "year": "Этот год"
    },
    "context": {
      "upsell": "допродажа",
      "cross_sale": "кросс-продажа",
      "campaign": "кампания"
    }
  },
  "protection": {
    "title": "Карта защиты семьи",
    "legend": "Статус определяется только по оценке потребностей — никаких догадок",
    "area_label": "Область",
    "family": "Семья",
    "required": "Требуется",
    "covered": "Покрыто",
    "gap": "Пробел",
    "unknown": "не оценено",
    "basis_label": "Основание",
    "cover_no_amount": "покрытие есть, сумма неизвестна",
    "cover_recorded": "покрытие записано",
    "presence": "есть (без суммы)",
    "evaluate": "Оценить потребности",
    "principle": "Совместная выплата учитывается для семьи один раз. Статус «Защищено» требует завершённого анализа потребностей; недостающие сведения отображаются как «не оценено».",
    "topics": "Стоит обсудить",
    "topics_hint": "Подсказки по записям — темы для разговора, а не рекомендации.",
    "mortgage_alerts": "Защита ипотеки",
    "mortgage_alert": "Ипотека {balance}, привязанное страхование жизни {cover} — возможный пробел {gap}",
    "mortgage_alert_hint": "Остаток на {date} · кредитор {lender}. Перед любой рекомендацией проверьте текущий остаток.",
    "mortgage_line": "остаток {balance} · покрытие {cover}",
    "no_alerts": "Пробелов в защите ипотеки не найдено.",
    "book_title": "Защита по всему портфелю",
    "book_subtitle": "Пробелы по ипотеке и семьи, которым нужна оценка",
    "area": {
      "life": "Жизнь",
      "income": "Доход",
      "medical": "Медицина",
      "critical_illness": "Критические заболевания",
      "accident": "Несчастный случай",
      "mortgage": "Ипотека",
      "loans": "Кредиты",
      "emergency_fund": "Резервный фонд",
      "retirement": "Пенсия",
      "education": "Образование",
      "savings": "Накопления",
      "property": "Имущество",
      "motor": "Авто",
      "business": "Бизнес"
    },
    "status": {
      "protected": "Защищено",
      "partial": "Частично",
      "not_evaluated": "Не оценено",
      "gap": "Пробел",
      "not_needed": "Не нужно"
    },
    "basis": {
      "needs_analysis": "анализ потребностей",
      "liabilities": "записанные кредиты",
      "expenses": "записанные расходы",
      "none": "оценки ещё нет"
    },
    "topic": {
      "child_education": "Образование детей",
      "mortgage_protection": "Защита ипотеки",
      "family_income_replacement": "Замещение дохода семьи",
      "child_medical": "Медицинская страховка детей",
      "family_protection": "Защита семьи",
      "retirement": "Пенсионное планирование",
      "medical": "Медицинское страхование"
    },
    "topic_hint": {
      "child_education": "В семье есть дети, но образовательная программа или цель не записаны.",
      "mortgage_protection": "Записана ипотека без кредитного страхования жизни.",
      "family_income_replacement": "Страхование жизни есть; проверьте, соответствует ли оно потребностям семьи.",
      "child_medical": "Для ребёнка в семье медицинская страховка не записана — стоит вместе проверить, нужна ли она.",
      "family_protection": "Дети в семье, а страхование жизни не записано — повод обсудить, как семья справится, а не рекомендация.",
      "retirement": "35+ лет без записанной пенсионной программы.",
      "medical": "Медицинская программа не записана."
    }
  },
  "renewals": {
    "title": "Продления",
    "subtitle": "Продления общего страхования по срочности — подготовьте условия, затем запишите решение",
    "include_life": "Включить годовщины полисов жизни",
    "due": "Срок",
    "last": "Прошлый взнос",
    "last_hint": "годовая сумма за заканчивающийся период",
    "new": "Взнос при продлении",
    "diff": "Изменение",
    "awaiting": "ожидаются условия",
    "terms": "Условия",
    "change": "Изменение к прошлому взносу: {diff} ({pct})",
    "decide": {
      "renewed": "Продлён",
      "lapsed": "Не продлён",
      "declined": "Клиент отказался"
    },
    "no_auto": "Ничего не продлевается автоматически — продление учитывается, только когда вы его запишете.",
    "note": "Отметка «Продлён» обновляет взнос с даты продления и однократно засчитывает продажу за продление.",
    "empty": "В этом окне продлений нет.",
    "bucket": {
      "all": "Все",
      "expired": "Истекли",
      "today": "Сегодня",
      "d7": "7 дней",
      "d15": "15 дней",
      "d30": "30 дней"
    },
    "decided": {
      "renewed": "Продление записано — взнос обновлён, продажа за продление засчитана",
      "lapsed": "Записано как непродлённый",
      "declined": "Записано: клиент отказался от продления"
    },
    "mode": {
      "queue": "По срочности",
      "general": "Продления общего страхования"
    }
  },
  "retention": {
    "title": "Удержание",
    "subtitle": "Прекращения, просрочки платежей, молчание и пропущенные обзоры — в одном месте",
    "days": "{days, plural, one {# день} few {# дня} many {# дней} other {# дня}}",
    "verified": "подтверждено страховщиком",
    "advisor_note": "ваша заметка, не подтверждено",
    "kind": {
      "lapsed": "Прекращённые полисы",
      "late_payment": "Просроченные платежи",
      "renewal_due": "Предстоящие продления",
      "no_contact": "Давно нет контакта",
      "review_overdue": "Просроченные обзоры"
    }
  },
  "security": {
    "title": "Безопасность",
    "subtitle": "Шифрование на этом устройстве, автоматическая блокировка и журнал аудита",
    "encryption": "Шифрование хранимых данных",
    "on": "Шифрование включено",
    "on_detail": "AES-256-GCM с ключом, защищённым вашей парольной фразой (PBKDF2, {iterations} итераций). Записи, снимки и файлы зашифрованы.",
    "off_intro": "Ваши данные хранятся на этом устройстве без парольной фразы. Любой, у кого есть доступ к этому профилю браузера, может их прочитать.",
    "enable": "Включить шифрование",
    "enable_hint": "Выберите длинную парольную фразу, которую вы запомните. Вы также получите ключ восстановления — храните его в надёжном месте.",
    "encrypting": "Шифрование…",
    "passphrase": "Парольная фраза",
    "passphrase_again": "Повторите парольную фразу",
    "new_passphrase": "Новая парольная фраза",
    "current_or_recovery": "Текущая парольная фраза или ключ восстановления",
    "change": "Сменить парольную фразу",
    "changed": "Парольная фраза изменена",
    "lock_now": "Заблокировать сейчас",
    "autolock": "Автоматически блокировать через",
    "never": "Никогда",
    "minutes": "{count, plural, one {# минуту} few {# минуты} many {# минут} other {# минуты}}",
    "recovery_title": "Ваш ключ восстановления",
    "recovery_intro": "Если вы забудете парольную фразу, этот ключ — единственный способ вернуть доступ. AVRASTRO не может восстановить его за вас. Распечатайте его или сохраните в менеджере паролей.",
    "recovery_ack": "Я надёжно сохранил(а) ключ восстановления",
    "recovery_done": "Готово — заблокировать и открыть заново",
    "fact": {
      "keys": "Ключи никогда не покидают это устройство и не отправляются на сервер.",
      "recovery": "Если потерять и парольную фразу, и ключ восстановления, данные на этом устройстве открыть будет невозможно.",
      "limits": "Шифрование защищает хранимые данные. Пока AVRASTRO разблокирован, их видит любой, кто пользуется этим компьютером, — блокируйте его, когда отходите."
    },
    "memory_note": "Этот сеанс работает только в памяти (хранилище браузера недоступно), поэтому шифровать на диске нечего.",
    "desktop_note": "Настольное приложение хранит данные в локальной базе; полное шифрование базы для настольной версии запланировано. Пока используйте шифрование диска средствами операционной системы.",
    "strength": {
      "0": "Слишком коротко — используйте не менее 10 символов",
      "1": "Допустимо — длиннее лучше",
      "2": "Хорошо",
      "3": "Надёжно"
    }
  },
  "sync": {
    "title": "Синхронизация",
    "subtitle": "Работайте офлайн на любом устройстве; изменения безопасно объединяются, когда вы снова в сети",
    "unavailable": "В этом сеансе синхронизация недоступна.",
    "now": "Синхронизировать",
    "running": "Синхронизация…",
    "status": "Статус",
    "state": {
      "local": "Только это устройство",
      "paired": "Подключено",
      "offline": "Офлайн — изменения сохраняются"
    },
    "last": "последняя синхронизация {when}",
    "never": "синхронизации ещё не было",
    "pending": "Ожидает отправки",
    "pending_hint": "сохранено на этом устройстве, будет отправлено при следующей синхронизации",
    "conflicts": "Конфликты",
    "conflicts_hint": "одно и то же поле изменено на двух устройствах",
    "rejected": "Не принято",
    "rejected_hint": "сервер отклонил эти изменения — они сохранены для проверки",
    "error": "Последняя попытка не удалась: {error}",
    "reauth": "Войти снова",
    "pairing": "Подключение",
    "pair": "Подключиться к серверу синхронизации",
    "pair_intro": "Подключите это устройство к серверу синхронизации вашей практики, чтобы работать на нескольких устройствах и с коллегами. До этого всё остаётся на этом устройстве.",
    "pair_hint": "Адрес сервера, ID рабочего пространства и данные для входа выдаёт ваш администратор.",
    "paired": "Устройство подключено — первая синхронизация запущена",
    "unpair": "Отключить",
    "server": "Сервер",
    "https": "Требуется https:// (http:// только для этого компьютера)",
    "workspace": "Рабочее пространство",
    "workspace_id": "ID рабочего пространства",
    "account": "Учётная запись",
    "password": "Пароль",
    "password_note": "Пароль отправляется только на ваш сервер синхронизации и никогда не хранится на этом устройстве.",
    "device": "Устройство",
    "lease": "Офлайн-доступ до",
    "encryption": "Шифрование на этом устройстве",
    "encrypted": "вкл.",
    "not_encrypted": "выкл. — включить",
    "security_note": "Данные передаются по HTTPS. Сервер проверяет вашу роль и рабочее пространство; удалённые записи хранятся как «надгробия», чтобы они не вернулись по ошибке.",
    "inbox": "Конфликты",
    "no_conflicts": "Конфликтов нет. Изменения в разных полях объединяются автоматически.",
    "review": "Проверить",
    "conflict_hint": "ничего не перезаписывается, пока вы не решите",
    "field": "Поле",
    "local": "Это устройство",
    "cloud": "Другое устройство",
    "critical": "важное",
    "keep": "Оставить",
    "keep_edited": "Оставить изменённую запись",
    "keep_delete": "Оставить удалённой",
    "keep_cloud": "Оставить версию другого устройства",
    "accept_delete": "Принять удаление",
    "apply": "Применить",
    "resolved": "Конфликт разрешён",
    "retry": "Повторить",
    "requeued": "В очереди на следующую синхронизацию",
    "discard": "Отбросить",
    "discarded": "Изменение отброшено",
    "device_data": "Данные на этом устройстве",
    "records": "Записи",
    "files": "Файлы",
    "storage": "Занято места",
    "clear_device": "Удалить данные с этого устройства…",
    "clear_intro": "Удаляется только локальная копия. Данные на сервере синхронизации и других устройствах не затрагиваются.",
    "clear_pending": "{count, plural, one {# изменение ещё не отправлено и будет потеряно} few {# изменения ещё не отправлены и будут потеряны} many {# изменений ещё не отправлены и будут потеряны} other {# изменения ещё не отправлены и будут потеряны}}. Сначала синхронизируйте.",
    "clear_word": "УДАЛИТЬ",
    "clear_type": "Введите {word} для подтверждения",
    "pack_export": "Экспорт пакета синхронизации",
    "pack_exported": "{count, plural, one {Экспортировано # изменение} few {Экспортировано # изменения} many {Экспортировано # изменений} other {Экспортировано # изменения}}",
    "pack_import": "Импорт пакета синхронизации",
    "pack_invalid": "Этот файл не является пакетом синхронизации AVRASTRO.",
    "pack_note": "Нет сервера? Переносите изменения между устройствами файлом (флешка, общая папка). Действуют те же правила объединения и конфликтов.",
    "pack_from": "С устройства",
    "pack_ops": "Изменения",
    "pack_apply": "Применить напрямую",
    "pack_merge": "Объединить",
    "pack_skip": "Уже есть",
    "pack_preview_note": "Перед применением создаётся защитный снимок.",
    "pack_imported": "Применено: {applied}, объединено: {merged}, конфликтов: {conflicts}",
    "pack_mark_delivered": "Отметить как доставленный",
    "pack_delivered": "Пакет отмечен как доставленный",
    "badge": {
      "locked": "Только чтение — войдите для синхронизации",
      "conflict": "{count, plural, one {# конфликт нужно разрешить} few {# конфликта нужно разрешить} many {# конфликтов нужно разрешить} other {# конфликта нужно разрешить}}",
      "running": "Синхронизация…",
      "offline": "Офлайн — изменения сохраняются на этом устройстве",
      "pending": "{count, plural, one {# изменение ожидает отправки} few {# изменения ожидают отправки} many {# изменений ожидают отправки} other {# изменения ожидают отправки}}",
      "ok": "Всё актуально",
      "update": "Нужно обновление, чтобы продолжить синхронизацию"
    },
    "readonly": {
      "lease_expired": "Срок офлайн-доступа истёк. Вы можете всё просматривать, но чтобы вносить изменения, войдите снова.",
      "device_revoked": "Администратор отключил это устройство. Данные здесь доступны только для чтения.",
      "licence_expired": "Подписка закончилась. Вы можете просматривать и выгружать все данные; продлите подписку, чтобы снова вносить изменения.",
      "licence_required": "Для этой копии AVRASTRO нужна учётная запись. Войдите, чтобы вносить изменения, — ваши данные не затронуты."
    },
    "role": {
      "admin": "Администратор",
      "advisor": "Консультант",
      "manager": "Руководитель (только чтение)",
      "assistant": "Ассистент"
    },
    "reason": {
      "deleted_locally": "Удалено здесь, изменено на другом устройстве",
      "deleted_remotely": "Изменено здесь, удалено на другом устройстве",
      "edited_both": "Изменено на обоих устройствах",
      "critical_field": "Важное поле (взнос, статус, согласие…) изменено на обоих устройствах"
    },
    "err": {
      "invalid_credentials": "Неверный e-mail или пароль.",
      "revoked": "Администратор отключил это устройство.",
      "expired": "Сеанс истёк. Войдите снова.",
      "no_token": "Вход не выполнен.",
      "permission": "Ваша роль этого не допускает.",
      "not_found": "Рабочее пространство на этом сервере не найдено.",
      "https_required": "Адрес сервера должен начинаться с https://.",
      "network": "Не удалось связаться с сервером. Проверьте адрес и подключение.",
      "device": "Не удалось зарегистрировать это устройство."
    }
  },
  "taxc": {
    "title": "Налоговый центр",
    "subtitle": "Налоговые правила с версиями и источниками; только иллюстрации — никогда не налоговая консультация",
    "year": "Налоговый год",
    "unavailable": "Нет применимых правил на {year}",
    "source": "Источник: {source} · проверено {date}",
    "approved_by": "утверждено: {who}",
    "rulesets": "Версии правил",
    "rules_note": "Правила никогда не додумываются: для года без утверждённых или предварительных правил результат не показывается. Прежние расчёты сохраняют версию правил, по которой сделаны.",
    "built_in": "встроенные",
    "approve": "Утвердить",
    "approved": "Правила утверждены",
    "ruleset_new": "Новая версия правил",
    "ruleset_hint": "Вводите правила точно в том виде, в каком их опубликовал налоговый орган, и укажите источник. Черновые правила для расчётов не используются.",
    "ruleset_id": "ID набора правил",
    "ruleset_saved": "Версия правил сохранена",
    "source_label": "Официальный источник",
    "source_ph": "напр. циркуляр Налогового департамента, URL",
    "verified": "Проверено",
    "status_label": "Статус",
    "bands": "Ступени подоходного налога",
    "band_add": "Добавить ступень",
    "up_to": "до (пусто = без ограничения)",
    "params": "Параметры",
    "pick_person": "Выберите человека для расчёта.",
    "gross": "Годовой доход брутто",
    "si": "Социальное страхование",
    "medical": "Взносы GESY / медицинские взносы",
    "provident": "Накопительный фонд",
    "pension": "Пенсионный фонд",
    "children": "Дети",
    "life_policies": "{count, plural, =0 {Полисы страхования жизни не учтены} one {Учтён # полис страхования жизни} few {Учтено # полиса страхования жизни} many {Учтено # полисов страхования жизни} other {Учтено # полиса страхования жизни}}",
    "opportunity": "Вычет по взносам страхования жизни",
    "o": {
      "gross": "Доход брутто",
      "limit": "Лимит вычета",
      "eligible": "Уже использовано",
      "remaining": "Остаток вычета"
    },
    "illustration": "Иллюстрация: использование остатка вычета может снизить налог примерно на {saving} (предельная ставка {rate}).",
    "disclaimer": "Иллюстрация по указанным правилам; не налоговая консультация. Уточните у бухгалтера клиента.",
    "save_snapshot": "Сохранить расчёт",
    "snapshot_saved": "Расчёт сохранён вместе с версией правил",
    "snapshots": "Сохранённые расчёты",
    "rules_changed": "по новым правилам: {amount}",
    "status": {
      "approved": "Утверждены",
      "provisional": "Предварительные",
      "draft": "Черновик",
      "retired": "Выведены из употребления"
    },
    "reason": {
      "no_rules_for_year": "На этот год налоговых правил нет. Добавьте их из официального источника — правила прошлого года вместо них не используются.",
      "not_approved": "Правила на этот год ещё в черновике. Утвердите их, чтобы использовать.",
      "no_engine": "Налоговые расчёты для этой страны пока недоступны.",
      "expired": "Правила на этот год выведены из употребления.",
      "income_unknown": "Укажите доход брутто — он никогда не предполагается."
    },
    "savings_title": "Возможности налоговой экономии в вашем портфеле",
    "savings_sub": "Последний расчётный лист или налоговый расчёт по каждому клиенту, у которого остался лимит на вычитаемые взносы.",
    "savings_empty": "Пока нет — проанализируйте расчётный лист клиента, чтобы найти возможность.",
    "savings_col_client": "Клиент",
    "savings_col_room": "Лимит / год",
    "savings_col_saving": "Экономия налога",
    "savings_col_from": "Источник",
    "from_payslip": "расчётный лист",
    "from_calculator": "расчёт",
    "follow_up": "Задача",
    "follow_up_open": "задача открыта",
    "follow_up_made": "Задача создана",
    "own_folder": "Для ваших собственных налогов как консультанта (лицензия, страхование ответственности, соцстрахование, справки):"
  },
  "vault": {
    "title": "Документы",
    "subtitle": "Каждый документ с владельцем, категорией и версиями — читается локально, проверяется вами",
    "upload": "Загрузить документ",
    "choose_file": "Выбрать файл",
    "scan": "Сфотографировать",
    "category": "Категория",
    "all_categories": "Все категории",
    "restricted": "Ограниченный доступ (медицинские или конфиденциальные)",
    "version_of": "Новая версия документа",
    "new_document": "— новый документ —",
    "store": "Сохранить",
    "stored": "Документ сохранён",
    "upload_note": "Файлы до 20 МБ хранятся на этом устройстве (и на сервере синхронизации, если он подключён). Текст читается локально; ничего не отправляется в сервисы ИИ.",
    "too_large": "Файл больше {mb} МБ.",
    "duplicate": "Точно такой же файл уже сохранён как «{title}». Если это обновление, выберите его в поле «Новая версия документа».",
    "file_missing": "Файл недоступен на этом устройстве.",
    "open": "Открыть",
    "download": "Скачать",
    "versions": "{count, plural, one {# версия} few {# версии} many {# версий} other {# версии}}",
    "drafts": "{count, plural, one {# документ ожидает проверки} few {# документа ожидают проверки} many {# документов ожидают проверки} other {# документа ожидают проверки}}",
    "nothing_found": "Подходящих документов нет.",
    "footer": "Открытие или скачивание документа записывается в журнал аудита.",
    "tab_note": "Сохранённые файлы, версии и прочитанные из них значения",
    "review": "Проверить извлечённые значения",
    "review_intro": "Примите, исправьте или отклоните каждое значение. Ничего не записывается в карточку, пока вы не примените.",
    "field": "Поле",
    "extracted": "Из документа",
    "existing": "Сейчас в AVRASTRO",
    "destination": "Куда",
    "page": "стр. {page}",
    "confidence": "Уверенность",
    "alternatives": "Другие найденные значения: {list}",
    "not_found": "не найдено",
    "correct": "Правильное значение",
    "accept": "Принять",
    "rejectf": "Отклонить",
    "add_manual": "Добавить значение вручную:",
    "add": "Добавить",
    "target_policy": "Полис",
    "apply": "Применить принятые значения",
    "applied": "Значения применены со ссылкой на документ",
    "reject_all": "Отклонить все",
    "rejected": "Проверка закрыта — ничего не изменено",
    "never_auto": "Значения из документов никогда не применяются автоматически. Взнос, прочитанный из документа, записывается как исправление, а не как продажа.",
    "stage": {
      "idle": "Сохранить",
      "reading": "Чтение…",
      "hashing": "Проверка…",
      "storing": "Сохранение…",
      "extracting": "Чтение текста…",
      "done": "Готово",
      "error": "Ошибка"
    },
    "show": {
      "all": "Все",
      "files": "С файлом"
    },
    "doctype": {
      "payslip": "Расчётный лист",
      "income_statement": "Справка о доходах",
      "tax_certificate": "Налоговая справка",
      "tax_assessment": "Налоговое уведомление",
      "loan_statement": "Выписка по кредиту",
      "mortgage_statement": "Выписка по ипотеке",
      "policy_schedule": "Спецификация полиса",
      "quotation": "Котировка",
      "bank_document": "Банковский документ",
      "pension_statement": "Выписка пенсионного фонда",
      "other": "Другой документ"
    },
    "method": {
      "pdf_text": "Текстовый слой PDF",
      "text": "Текстовый файл",
      "manual": "Введено вручную",
      "ocr_unavailable": "Текст прочитать не удалось"
    },
    "error": {
      "pdf_encrypted": "PDF защищён паролем.",
      "no_text_layer": "PDF — это скан без текстового слоя; введите значения вручную.",
      "ocr_not_configured": "Фото сохраняются, но не распознаются: сервис OCR не подключён. Введите значения вручную.",
      "read_failed": "Не удалось прочитать файл."
    },
    "decision": {
      "pending": "на проверку",
      "accepted": "принято",
      "rejected": "отклонено"
    },
    "fkey": {
      "name": "Имя",
      "employer": "Работодатель",
      "period": "Период",
      "gross_monthly": "Зарплата брутто в месяц",
      "net_monthly": "Зарплата нетто в месяц",
      "gross_annual": "Годовой доход брутто",
      "net_annual": "Годовой доход нетто",
      "tax_amount": "Налог",
      "loan_amount": "Сумма кредита",
      "loan_balance": "Непогашенный остаток",
      "loan_instalment": "Платёж",
      "loan_rate": "Процентная ставка",
      "loan_term_months": "Срок (мес.)",
      "lender": "Кредитор",
      "policy_number": "Номер полиса",
      "insurer": "Страховщик",
      "policy_premium": "Взнос",
      "premium_frequency": "Периодичность оплаты",
      "sum_assured": "Страховая сумма",
      "policy_expiry": "Дата окончания"
    },
    "dest": {
      "identity_check": "только проверка личности",
      "persons_employer": "человек · работодатель",
      "info": "только для сведения",
      "financial_items_income": "доход",
      "financial_items_expense": "расходы",
      "financial_items_liability": "кредиты",
      "policies": "полис"
    }
  },
  "onboard": {
    "welcome": "Добро пожаловать в AVRASTRO",
    "welcome_sub": "Ваше рабочее пространство консультанта — приватное, на этом устройстве, готово за минуту.",
    "setup": "Настроить мою практику",
    "setup_sub": "Рынок, ваш профиль, логотип и цели — около двух минут, любой шаг необязателен.",
    "import_sub": "Перенесите клиентов, полисы и задачи из прежней VÉRO CRM.",
    "demo_sub": "Сначала осмотритесь с вымышленными клиентами. Потом их можно удалить.",
    "account": "Войти или создать учётную запись",
    "account_sub": "Синхронизируйте устройства, создавайте резервные копии в облаке и работайте командой.",
    "account_sub_server": "Для синхронизации, облачного резервного копирования и команд — понадобится адрес сервера вашего провайдера.",
    "private": "Всё остаётся на этом устройстве, пока вы не решите подключить учётную запись.",
    "progress": "Ход настройки",
    "step": {
      "market": "Рынок",
      "profile": "Профиль",
      "brand": "Бренд",
      "goals": "Цели",
      "done": "Готово"
    },
    "market_title": "Где вы работаете?",
    "market_sub": "Рынок определяет валюту, поля лицензии, именины и списки документов. Язык задаётся отдельно — вы выбрали его на первом экране.",
    "market_note": "Рынок можно изменить в любое время в настройках.",
    "currency": "Валюта",
    "time_zone": "Часовой пояс",
    "profile_title": "Как вас видят клиенты",
    "profile_sub": "Используется в предложениях, обзорах, письмах и сообщениях. Ничего не придумывается — пустые поля просто не попадают в документы.",
    "profile_note": "Больше деталей (фото, подпись, регуляторный текст) — в разделе «Система → Фирменный стиль».",
    "brand_title": "Ваш логотип на каждом документе",
    "brand_sub": "Документы выходят с двойным брендингом: на первом месте логотип вашего агентства, AVRASTRO — ненавязчиво. PNG, JPG, WebP или SVG — размер и поля подгоняются автоматически.",
    "no_logo": "Логотипа пока нет",
    "goals_title": "Цели и напоминания",
    "goals_sub": "Цели задают шкалы темпа в бизнес-центре; напоминания создают задачи — AVRASTRO никогда ничего не отправляет сам.",
    "goal_premium": "Цель по новым годовым взносам ({currency})",
    "goal_clients": "Новые клиенты в этом году",
    "goal_meetings": "Встречи в этом году",
    "reminders": "Готовить ежедневные напоминания на этом устройстве (повторные контакты, продления, дни рождения, обзоры)",
    "reminders_note": "Устанавливает стандартную автоматизацию; каждую можно проверить или выключить в разделе «Система → Автоматизация».",
    "done_title": "Всё готово",
    "done_sub": "Начните с экрана «Сейчас»: он подскажет, кому нужно внимание и что делать дальше.",
    "logo_ready": "Логотип готов для документов",
    "reminders_on": "Ежедневные напоминания на этом устройстве",
    "start_tour": "Показать, что где (1 минута)",
    "go_today": "Перейти к «Сейчас»",
    "skip": "Пропустить",
    "signed_in_as": "Вы вошли как {name} · {workspace}. Ваш профиль на avrastro.com заполняет настройку — меняйте что угодно."
  },
  "tour": {
    "title": "Экскурсия",
    "show": "Показать экскурсию",
    "step": "{n} из {total}",
    "skip": "Пропустить экскурсию",
    "finish": "Готово",
    "today": {
      "title": "Сейчас",
      "body": "Кому вы нужны сейчас: приоритеты, напоминания, продления и дни рождения — с причиной и следующим лучшим действием."
    },
    "people": {
      "title": "Люди",
      "body": "Все клиенты, семьи и полисы с полной картиной 360°, документами и обзорами."
    },
    "growth": {
      "title": "Рост",
      "body": "Потенциальные клиенты, воронка, рекомендации и кампании — откуда приходит новый бизнес."
    },
    "cases": {
      "title": "Заявки",
      "body": "Заявки от предложения до выдачи полиса — со списками документов и статусом андеррайтинга."
    },
    "lens": {
      "title": "Лупа",
      "body": "Нажмите Ctrl/⌘ K в любом месте, чтобы найти кого угодно или сделать что угодно, просто набрав текст."
    },
    "flow": {
      "title": "Flow",
      "body": "Проходите свой день по одному пункту, не переключаясь между экранами."
    },
    "system": {
      "title": "Система",
      "body": "Данные и резервные копии, фирменный стиль, учётная запись и настройки. Ваши данные принадлежат вам — выгружайте их в любой момент."
    }
  },
  "outlook": {
    "title": "Календарь Outlook",
    "intro": "Подключите календарь Outlook (Microsoft 365): встречи из CRM появятся в Outlook и на телефоне, а всё, что вы запланировали в Outlook, закроет те же слоты для онлайн-записи на сайте.",
    "connect": "Подключить Outlook",
    "check": "Проверить подключение",
    "opened": "Завершите вход на открывшейся странице Microsoft, затем нажмите «Проверить подключение».",
    "account": "Учётная запись",
    "last": "Последняя синхронизация",
    "events": "Встреч в Outlook: {n}",
    "sync": "Синхронизировать",
    "synced": "Синхронизировано: встреч в Outlook — {n}.",
    "err": "Синхронизация не завершилась ({e}).",
    "reconnect": "Microsoft просит подключиться заново (например, изменился пароль или был отозван доступ). Нажмите «Подключить Outlook».",
    "disconnect": "Отключить",
    "disconnect_confirm": "Отключить Outlook? Встречи, уже находящиеся в Outlook, там останутся.",
    "note": "Outlook — это копия: изменения вносятся в CRM и попадают в Outlook в течение нескольких минут. Вход выполняется на странице самой Microsoft; ваш пароль никогда не проходит через AVRASTRO.",
    "mail": {
      "title": "Письма клиентов в их истории",
      "intro": "По желанию: письма между вашим Outlook и клиентом CRM (по e-mail клиента) появляются в истории этого клиента — тема, дата, направление и ссылка для открытия в Outlook. Другие письма никогда не сохраняются. Microsoft попросит разрешить «Чтение почты».",
      "connect": "Показывать письма клиентов",
      "on": "Включено — последняя проверка {when}. Проверка каждые 10 минут, пока есть подключение.",
      "sync": "Проверить сейчас",
      "synced": "Проверено: новых писем от клиентов — {n}.",
      "off": "Остановить",
      "off_confirm": "Прекратить чтение почты Outlook? Письма, уже попавшие в историю клиентов, останутся; календарь останется подключённым.",
      "note": "Текст письма не сохраняется, если вы не отметите «сохранять текст писем» в истории клиента (только для этого клиента). Два человека с одним адресом не сопоставляются.",
      "keep_text": "Сохранять текст писем Outlook этого клиента (начиная с этого момента)",
      "sent": "Отправлено · Outlook",
      "received": "Получено · Outlook",
      "open": "Открыть в Outlook",
      "in_untitled": "Письмо от клиента (без темы)",
      "out_untitled": "Письмо клиенту (без темы)"
    }
  },
  "account": {
    "signin_email": "E-mail для входа",
    "change_email": "Изменить e-mail",
    "email_current": "Текущий e-mail",
    "email_new": "Новый e-mail",
    "email_send_code": "Отправить код",
    "email_code_sent": "Мы отправили 6-значный код на {email}. Введите его здесь (действует 15 минут).",
    "email_code": "Код из письма",
    "email_confirm": "Подтвердить",
    "email_changed": "Теперь вы входите с {email}.",
    "email_change_note": "Пароль, данные, рабочие пространства и устройства остаются прежними. На старый адрес придёт уведомление об изменении.",
    "title": "Учётная запись и подписка",
    "subtitle_out": "По желанию: учётная запись добавляет синхронизацию между устройствами, зашифрованное облачное резервное копирование и командную работу. AVRASTRO полностью работает и без неё.",
    "subtitle_in": "Ваш профиль, подписка, безопасность, устройства и облачные резервные копии.",
    "unavailable": "В этой сборке учётные записи недоступны.",
    "tab": {
      "signin": "Вход",
      "register": "Регистрация",
      "reset": "Забыли пароль"
    },
    "server": "Сервер",
    "server_hint": "Адрес службы учётных записей AVRASTRO (https).",
    "change_server": "изменить",
    "session_ended": "Вы вышли из системы на этом устройстве. Ваши данные на месте — войдите снова, чтобы продолжить синхронизацию.",
    "why_title": "Что даёт учётная запись",
    "why": {
      "sync": "Синхронизация между компьютером, планшетом и телефоном — конфликты показываются вам и никогда не перезаписываются молча.",
      "backup": "Облачные резервные копии, зашифрованные на вашем устройстве вашим собственным паролем.",
      "team": "Для агентств: места, роли, приглашения и журнал активности.",
      "devices": "Просмотр устройств и выход на них; двухэтапный вход по желанию.",
      "local": "Данные клиентов остаются в зашифрованном хранилище на каждом устройстве. Без учётной записи ничего его не покидает."
    },
    "privacy_note": "Синхронизированные записи защищены при передаче и хранении на сервере; облачные резервные копии зашифрованы сквозным шифрованием.",
    "email_label": "E-mail",
    "password": "Пароль",
    "password_repeat": "Повторите пароль",
    "current_password": "Текущий пароль",
    "new_password": "Новый пароль",
    "pw_rule": "Не менее 10 символов; хорошо подойдёт короткая фраза.",
    "pw_ok": "Достаточно надёжный",
    "pw_mismatch": "Пароли не совпадают",
    "password_note": "Пароль никогда не хранится на этом устройстве — только сеанс, который можно отозвать.",
    "sign_in": "Войти",
    "sign_out": "Выйти",
    "working": "Подождите…",
    "mfa_code": "Код из приложения-аутентификатора",
    "mfa_code_hint": "6-значный код из приложения-аутентификатора или один из кодов восстановления.",
    "choose_workspace": "Ваш e-mail относится к нескольким рабочим пространствам. Выберите одно:",
    "switch_sync": "Это устройство синхронизируется с {server}. При входе синхронизация переключится на вашу учётную запись AVRASTRO. Продолжить?",
    "signed_in": "Вход выполнен · {workspace}",
    "signed_out": "Вы вышли. Всё на этом устройстве сохранилось.",
    "created": "Учётная запись создана · {workspace}",
    "create": "Создать учётную запись",
    "trial_note": "Бесплатный пробный период {days} дн. Для начала платёжные данные не нужны.",
    "code_needed": "В этой службе требуется код активации или приглашения.",
    "invite_only": "Новые учётные записи в этой службе — только по приглашению.",
    "reg": {
      "you": "Вы",
      "practice": "Ваша практика",
      "prefs": "Предпочтения"
    },
    "first_name": "Имя",
    "last_name": "Фамилия",
    "mobile": "Мобильный",
    "branch": "Филиал",
    "office_phone": "Телефон офиса",
    "code": "Код активации или приглашения",
    "code_hint": "Необязательно. От вашего агентства или от AVRASTRO.",
    "accept_terms": "Я принимаю Условия обслуживания *",
    "accept_privacy": "Я прочитал(а) Уведомление о конфиденциальности и согласен(на) на обработку данных моей учётной записи (GDPR) *",
    "accept_marketing": "Присылать мне иногда новости о продукте (необязательно)",
    "reg_note": "Поля лицензии зависят от выбранного рынка. При создании учётной записи данные ваших клиентов никуда не отправляются.",
    "send_reset": "Отправить код сброса",
    "reset_sent": "Если для этого адреса есть учётная запись, код сброса уже отправлен (действует один час). Введите его вместе с новым паролем.",
    "reset_code": "Код сброса",
    "set_password": "Задать новый пароль",
    "reset_done": "Пароль изменён. Выполнен выход на всех устройствах — войдите с новым паролем.",
    "email_verified": "подтверждён",
    "email_unverified": "не подтверждён",
    "verify_resend": "Отправить письмо для подтверждения",
    "verify_sent": "Письмо для подтверждения отправлено",
    "verified": "E-mail подтверждён",
    "checked": "последняя проверка {when}",
    "billing_success": "Спасибо — ваша подписка активируется.",
    "subscription": "Подписка",
    "plan": "Тариф",
    "status": "Статус",
    "cancels": "завершится в конце периода",
    "trial_end": "Пробный период до",
    "period_end": "Оплачено до",
    "limits": "Лимиты",
    "limits_value": "Мест: {seats} · устройств на каждого: {devices}",
    "licence": "Лицензия на этом устройстве",
    "valid_until": "до {date}",
    "unmanaged": "Это рабочее пространство без подписки (собственный сервер синхронизации). Ограничения не действуют.",
    "redeem": "Активировать код",
    "code_applied": "Код применён",
    "manage_billing": "Счета и оплата",
    "price_unset": "Цена по запросу",
    "free": "Бесплатно",
    "current_plan": "Текущий тариф",
    "choose_plan": "Выбрать",
    "billing_off": "Онлайн-оплата в этой службе не настроена; чтобы сменить тариф, обратитесь к провайдеру.",
    "renew": "Продлить",
    "readonly_safe": "Ничего не удалено — вы по-прежнему можете всё просматривать и выгружать.",
    "profile": "Профиль",
    "profile_note": "Профиль также заполняет реквизиты ваших документов там, где они ещё пусты. Логотипы, фото и подпись — в разделе «Фирменный стиль».",
    "edit_branding": "Оформление документов",
    "security": "Безопасность",
    "change_password": "Сменить пароль",
    "change_password_note": "На других устройствах будет выполнен выход.",
    "password_changed": "Пароль изменён",
    "mfa": "Двухэтапный вход",
    "mfa_on": "вкл.",
    "mfa_off": "Двухэтапный вход выключен",
    "mfa_enable": "Включить двухэтапный вход",
    "mfa_disable": "Выключить",
    "mfa_steps": "Добавьте этот ключ в приложение-аутентификатор (например, Google Authenticator, Microsoft Authenticator, 1Password), затем введите показанный 6-значный код.",
    "mfa_open_app": "Открыть в приложении-аутентификаторе на этом устройстве",
    "mfa_confirm": "Подтвердить и включить",
    "mfa_recovery": "Двухэтапный вход включён. Сохраните эти коды восстановления в надёжном месте — каждый действует один раз, если вы потеряете телефон. Они показываются только сейчас.",
    "mfa_save_codes": "Сохранить коды",
    "mfa_code_or_recovery": "Код аутентификатора или восстановления",
    "device_lock": "Блокировка и шифрование устройства",
    "security_note": "Пароли хранятся на сервере в виде хешей (scrypt); сеансы можно отзывать для каждого устройства.",
    "devices": "Устройства",
    "device_unnamed": "Устройство",
    "this_device": "это устройство",
    "signed_out_device": "выход выполнен",
    "last_seen": "последний раз {when}",
    "revoke": "Выйти",
    "revoke_confirm": "Выйти на «{device}»? Данные на нём останутся доступны только для чтения, пока там снова не выполнят вход.",
    "device_revoked": "Выход на устройстве выполнен",
    "devices_note": "Потеряли устройство? Выполните выход на нём здесь и смените пароль.",
    "cloud_backup": "Облачная резервная копия (сквозное шифрование)",
    "cloud_backup_desc": "Полная резервная копия шифруется на этом устройстве паролем копии перед загрузкой. Сервер не может её прочитать.",
    "cloud_backup_note": "Без пароля копии никто — включая AVRASTRO — не сможет её восстановить. Храните его надёжно. Сохраняются 30 последних копий.",
    "backup_password": "Пароль резервной копии",
    "backup_password_hint": "Не менее 10 символов; может отличаться от пароля для входа.",
    "backup_now": "Зашифровать и сохранить сейчас",
    "backup_done": "Зашифрованная копия загружена",
    "backup_restore": "Восстановить…",
    "backup_restore_next": "Введите пароль копии и нажмите «Анализировать»: перед любыми изменениями вы увидите предпросмотр.",
    "backup_delete_confirm": "Удалить эту облачную копию? Данные на этом устройстве не затрагиваются.",
    "backup_role": "Облачные копии доступны администраторам и консультантам.",
    "backup_plan": "Облачное резервное копирование не входит в ваш тариф.",
    "backup_stale": "Последней облачной копии больше недели.",
    "backup_none": "Облачных копий пока нет.",
    "privacy": "Конфиденциальность (GDPR)",
    "privacy_desc": "Скачайте данные, которые служба хранит о вашей учётной записи, выгрузите клиентскую базу или удалите учётную запись.",
    "export": "Скачать данные моей учётной записи",
    "export_clients": "Выгрузить данные клиентов",
    "delete": "Удалить учётную запись",
    "delete_intro": "Учётная запись в службе будет удалена. Если вы последний участник рабочего пространства, его копия на сервере (синхронизированные записи и облачные копии) тоже будет удалена. Данные на этом устройстве не затрагиваются. Агентствам: сначала передайте роль администратора.",
    "delete_type": "Введите DELETE для подтверждения",
    "deleted": "Учётная запись удалена. Данные на этом устройстве сохранены.",
    "badge": {
      "trial": "Пробный · {days} дн.",
      "active": "Подписка",
      "grace": "Продлить · {days} дн.",
      "expired": "Только чтение",
      "invalid": "Проверка лицензии",
      "none": "Войти"
    },
    "readonly": {
      "licence_expired": "Подписка закончилась — AVRASTRO на этом устройстве работает только в режиме чтения.",
      "licence_required": "Войдите в учётную запись AVRASTRO, чтобы вносить изменения."
    },
    "sub_status": {
      "trialing": "Пробный период",
      "active": "Активна",
      "past_due": "Ожидается оплата",
      "canceled": "Отменена",
      "expired": "Истекла"
    },
    "licence_state": {
      "none": "Не требуется",
      "trialing": "Пробный период",
      "active": "Действует",
      "grace": "Льготный период — скоро продлите",
      "expired": "Истекла (только чтение)",
      "invalid": "Не удалось проверить"
    },
    "interval": {
      "month": "месяц",
      "year": "год",
      "trial": "пробный",
      "custom": "индивидуально"
    },
    "feature": {
      "sync": "Синхронизация",
      "cloud_backup": "Облачные копии",
      "campaigns": "Кампании",
      "tax_center": "Налоговый центр",
      "team": "Команда",
      "branding_agency": "Брендинг агентства",
      "sso": "Единый вход (SSO)",
      "audit_export": "Выгрузка аудита",
      "api": "API",
      "website_inbox": "Входящие с сайта",
      "client_portal": "Портал клиента",
      "ai_drafts": "Черновики ИИ",
      "automations": "Автоматизация",
      "analytics": "Аналитика",
      "group_plans": "Групповые программы"
    },
    "err": {
      "email_same": "Вы уже используете этот e-mail.",
      "code_expired": "Срок действия кода истёк или он слишком много раз введён неверно. Запросите новый код.",
      "generic": "Что-то пошло не так ({code}). Попробуйте снова.",
      "network": "Служба учётных записей недоступна. Проверьте подключение — AVRASTRO продолжает работать офлайн.",
      "https_required": "Используйте защищённый адрес https://.",
      "no_server": "Сначала укажите адрес сервера.",
      "key_mismatch": "Лицензионный ключ сервера не совпадает с ключом, которому доверяет приложение. Вход не выполнен — ради вашей безопасности.",
      "invalid_credentials": "Неверный e-mail или пароль.",
      "mfa_required": "Введите код из приложения-аутентификатора.",
      "mfa_invalid": "Неверный код. Проверьте время на телефоне и попробуйте снова.",
      "rate_limited": "Слишком много попыток. Подождите несколько минут.",
      "email_taken": "Для этого e-mail уже есть учётная запись — войдите.",
      "email_invalid": "Проверьте адрес e-mail.",
      "name_required": "Имя и фамилия обязательны.",
      "password_too_short": "Используйте не менее 10 символов.",
      "password_too_common": "Этот пароль слишком распространён.",
      "password_contains_email": "Не используйте в пароле имя из вашего e-mail.",
      "consent_required": "Примите Условия и Уведомление о конфиденциальности.",
      "code_invalid": "Этот код недействителен или уже использован.",
      "code_required": "Требуется код активации или приглашения.",
      "registration_closed": "Новые учётные записи — только по приглашению.",
      "invitation_other_email": "Это приглашение отправлено на другой адрес e-mail.",
      "seat_limit": "Все места по тарифу заняты.",
      "device_limit": "Достигнут лимит устройств по тарифу. Выполните выход на старом устройстве в разделе «Учётная запись → Устройства» (с другого устройства) или обратитесь к администратору.",
      "licence_expired": "Подписка закончилась — продлите её, чтобы вносить изменения.",
      "plan_feature": "Ваш тариф этого не включает.",
      "token_invalid": "Код недействителен или истёк. Запросите новый.",
      "revoked": "Ваш сеанс завершён. Войдите снова.",
      "expired": "Срок сеанса истёк. Войдите снова.",
      "no_token": "Пожалуйста, войдите.",
      "signed_out": "Пожалуйста, войдите.",
      "permission": "Ваша роль этого не допускает.",
      "not_found": "Не найдено — возможно, удалено.",
      "plaintext_refused": "Загружать можно только зашифрованные резервные копии.",
      "too_large": "Слишком большой объём для службы.",
      "billing_not_configured": "Онлайн-оплата в этой службе не настроена.",
      "plan_not_on_sale": "Этот тариф пока нельзя купить онлайн.",
      "no_billing_customer": "Платёжного аккаунта пока нет.",
      "transfer_ownership": "Сначала назначьте администратором другого участника.",
      "cancel_subscription_first": "Сначала отмените текущую подписку («Счета и оплата»).",
      "confirm_required": "Введите DELETE для подтверждения.",
      "last_admin": "В рабочем пространстве должен быть хотя бы один администратор.",
      "already_member": "Вы уже участник этого рабочего пространства.",
      "mfa_already_enabled": "Двухэтапный вход уже включён.",
      "mfa_not_pending": "Начните настройку заново.",
      "mfa_not_enabled": "Двухэтапный вход выключен.",
      "licence_expiry": "Укажите корректную дату окончания лицензии.",
      "server_error": "В службе возникла проблема. Попробуйте позже.",
      "website_session_ended": "Ваш сеанс на avrastro.com завершён. Продолжите через avrastro.com, чтобы снова синхронизироваться, — данные на этом устройстве в безопасности.",
      "workspace_mismatch": "На этом устройстве хранятся данные другого рабочего пространства ({workspace}). Они никогда не загружаются в другую учётную запись. Используйте другой профиль браузера или компьютер либо сначала выгрузите и очистите это устройство («Данные и безопасность»).",
      "website_web_only": "Вход через сайт с этого экрана работает в веб-приложении. В настольном приложении используйте показанный здесь код.",
      "already_linked": "Это рабочее пространство уже связано с учётной записью avrastro.com.",
      "storage_limit": "Хранилище резервных копий по вашему тарифу заполнено. Удалите старые облачные копии ниже или добавьте место в Advisor Hub.",
      "push_endpoint": "Служба уведомлений этого браузера не поддерживается.",
      "push_key": "Браузер передал неполный ключ уведомлений. Попробуйте снова.",
      "push_limit": "Достигнут лимит в 10 устройств с уведомлениями. Сначала отключите одно из них.",
      "push_not_configured": "На этом сервере уведомления недоступны.",
      "passkey_unknown": "Этот passkey не зарегистрирован ни для одной учётной записи AVRASTRO (возможно, он удалён).",
      "passkey_challenge": "Срок запроса passkey истёк. Попробуйте снова.",
      "passkey_expired": "Срок запроса passkey истёк. Попробуйте снова.",
      "passkey_signature": "Не удалось проверить passkey.",
      "passkey_sign_count": "Похоже, этот passkey скопирован на другое устройство, поэтому он отклонён. Войдите с паролем и добавьте его заново.",
      "passkey_origin": "Этот passkey относится к другому сайту.",
      "passkey_rp_id": "Этот passkey относится к другому сайту.",
      "passkey_user_verification": "Устройство не подтвердило, что это вы (Face ID, отпечаток пальца или PIN устройства).",
      "passkey_exists": "Этот passkey уже добавлен.",
      "passkey_limit": "Достигнут лимит в 20 passkey. Сначала удалите один.",
      "passkeys_not_configured": "На этом сервере passkey недоступны."
    },
    "licence_offline": "проверена на этом устройстве, работает офлайн",
    "website": {
      "title": "Одна учётная запись с {site}",
      "sub_web": "Войдите один раз на {site} — CRM откроется с той же учётной записью. Второй пароль не нужен.",
      "sub_desktop": "Продолжите на {site} в браузере и подтвердите показанный здесь код. В это приложение пароль не вводится.",
      "continue": "Продолжить с {site}",
      "code_intro": "В браузере откроется {site}. Войдите там, затем введите этот код, когда его попросят:",
      "open": "Открыть {site}",
      "waiting": "Ожидание подтверждения… Код действует 10 минут. Не открылось? Перейдите на",
      "manage_plan": "Тариф и оплата на {site}",
      "manage_plan_note": "Повышение тарифа, дополнения, счета и отмена управляются в Advisor Hub.",
      "link_title": "Используйте и учётную запись {site}",
      "link_sub": "Привяжите это рабочее пространство к своей учётной записи консультанта на {site}: открывайте CRM из Advisor Hub и управляйте там тарифом. Делается один раз; ваш пароль продолжит работать.",
      "link": "Связать с {site}",
      "already_linked": "Это рабочее пространство уже связано с учётной записью {site}."
    },
    "store_note": "Всё, что входит в подписку вашего рабочего пространства, появится здесь автоматически после входа.",
    "invite_code": "Код приглашения",
    "read_legal": "Ознакомьтесь:"
  },
  "team": {
    "subtitle": "Места, роли, приглашения и активность вашего агентства.",
    "sign_in_first": "Чтобы управлять командой, войдите в учётную запись.",
    "admin_only": "Команду видят только администраторы и руководители.",
    "seats": "Занято мест",
    "seats_hint": "Активные участники по тарифу",
    "invitations": "Открытые приглашения",
    "invitations_hint": "Ещё не использованные коды",
    "members": "Участники",
    "member": "Участник",
    "role": "Роль",
    "active": "Активен",
    "disabled": "Отключён",
    "disable": "Отключить",
    "enable": "Включить",
    "disable_confirm": "Отключить {name}? На всех его устройствах будет выполнен выход; общие записи останутся.",
    "roles_note": "Администратор: всё, включая команду и оплату. Консультант: свой портфель. Руководитель: обзор только для чтения. Ассистент: без конфиденциальных документов.",
    "invite": "Пригласить коллегу",
    "invite_email": "E-mail",
    "invite_email_hint": "Необязательно: оставьте пустым, чтобы получить код и передать его самостоятельно.",
    "valid_days": "Действует (дней)",
    "invite_create": "Создать приглашение",
    "code_once": "Код приглашения (показывается один раз):",
    "code_mailed": "Также отправлен на {email}.",
    "open_invitation": "Открытое приглашение",
    "until": "до {date}",
    "revoke": "Отозвать",
    "activity": "Активность",
    "no_activity": "Активности пока нет.",
    "action": {
      "sign_in": "вошёл в систему",
      "account_created": "создал учётную запись",
      "account_joined": "присоединился к команде",
      "account_deleted": "удалил свою учётную запись",
      "profile_updated": "обновил профиль",
      "password_changed": "сменил пароль",
      "password_reset": "сбросил пароль",
      "mfa_enabled": "включил двухэтапный вход",
      "mfa_disabled": "выключил двухэтапный вход",
      "device_revoked": "выполнил выход на устройстве",
      "code_redeemed": "активировал код",
      "invitation_created": "создал приглашение",
      "invitation_revoked": "отозвал приглашение",
      "member_updated": "изменил участника",
      "backup_uploaded": "создал облачную копию",
      "backup_downloaded": "скачал облачную копию",
      "backup_deleted": "удалил облачную копию",
      "push_refused": "синхронизация отклонена (подписка)",
      "push_denied": "изменение отклонено (права)",
      "file_upload": "загрузил файл документа",
      "file_download": "открыл файл документа",
      "file_denied": "получил отказ в доступе к файлу документа"
    },
    "activity_export": "Экспорт активности (CSV)",
    "activity_export_locked": "Выгрузка журнала активности для комплаенса входит в тарифы Team и Enterprise.",
    "activity_export_unavailable": "Выгрузка журнала активности не входит в подписку этого рабочего пространства."
  },
  "branding": {
    "title": "Фирменный стиль",
    "subtitle": "Ваш логотип, реквизиты и подпись на каждом предложении, обзоре, письме и отчёте — по умолчанию вместе с брендом AVRASTRO.",
    "open": "Логотипы, фото и подпись",
    "incomplete": "Добавьте имя, телефон или e-mail и номер лицензии, чтобы в документах были полные реквизиты.",
    "save": "Сохранить фирменный стиль",
    "saved": "Фирменный стиль сохранён",
    "sec": {
      "identity": "Консультант",
      "licence": "Лицензия",
      "contact": "Контакты",
      "logos": "Агентство и логотипы",
      "signature": "Подпись",
      "documents": "В документах"
    },
    "advisor_name": "Имя консультанта",
    "job_title": "Должность",
    "job_title_ph": "напр. старший страховой консультант",
    "photo": "Фото",
    "country": "Рынок",
    "licence_number": "Номер лицензии",
    "licence_authority": "Орган лицензирования",
    "authority_hint": "Предложено для рынка — уточните у вашего регулятора.",
    "licence_expiry": "Окончание лицензии",
    "licence_short": "Лицензия",
    "registration": "Регистрационный номер компании",
    "regulatory": "Регуляторное заявление",
    "regulatory_hint": "Показывается в нижнем колонтитуле документов для клиентов, напр. «Зарегистрированный страховой посредник, лицензия …».",
    "field": {
      "licenceNumber": "Номер лицензии",
      "licenceAuthority": "Орган лицензирования",
      "licenceExpiry": "Окончание лицензии"
    },
    "agency_name": "Агентство / компания",
    "agency_logo": "Логотип агентства",
    "advisor_logo": "Ваш собственный логотип (необязательно)",
    "advisor_logo_hint": "Показывается рядом с логотипом агентства, если отличается.",
    "agency_admin_only": "Профиль агентства может изменить только администратор.",
    "logo_hint": "PNG, JPG, WebP или SVG до 10 МБ. Размер, поля и пропорции подгоняются автоматически — подойдут широкие, квадратные и высокие логотипы.",
    "upload": "Загрузить",
    "replace": "Заменить",
    "remove": "Убрать",
    "upload_logo": "Загрузить логотип",
    "replace_logo": "Заменить логотип",
    "remove_logo": "Убрать логотип",
    "processing": "Подготовка…",
    "empty": {
      "logo": "Нет логотипа",
      "photo": "Нет фото",
      "signature": "Нет подписи"
    },
    "image_error": {
      "too_large": "Изображение больше 10 МБ.",
      "unsupported": "Используйте PNG, JPG, WebP, SVG или GIF.",
      "unreadable": "Не удалось прочитать изображение.",
      "too_big_after": "Изображение слишком детализировано для хранения; попробуйте более простую или уменьшенную версию."
    },
    "signature": "Изображение подписи (не электронная подпись)",
    "signature_hint": "Загрузите скан (белый фон станет прозрачным) или нарисуйте подпись.",
    "draw": "Нарисовать",
    "draw_title": "Нарисуйте подпись",
    "draw_hint": "Мышью, стилусом или пальцем.",
    "clear": "Очистить",
    "use_signature": "Использовать подпись",
    "sign_off": "Завершение писем",
    "sign_off_hint": "Используется в конце сообщений и писем.",
    "mode": "Режим брендинга",
    "mode_opt": {
      "co": "Совместный",
      "advisor": "Сначала мой бренд",
      "vero": "Только AVRASTRO"
    },
    "mode_hint": {
      "co": "Ваши логотипы на первом месте; логотип AVRASTRO — рядом с заголовком документа и в нижнем колонтитуле.",
      "advisor": "В шапке только ваши логотипы; «Подготовлено в AVRASTRO» мелко в нижнем колонтитуле.",
      "vero": "В шапке логотип AVRASTRO вместо вашего (ваше имя и реквизиты остаются)."
    },
    "show_photo": "Показывать моё фото",
    "show_signature": "Подписывать предложения и письма",
    "show_regulatory": "Показывать регуляторное заявление",
    "accent": "Акцентный цвет",
    "preview": "Предпросмотр",
    "preview_note": "Настоящий шаблон документа в формате A4 — именно так он печатается и выглядит в PDF.",
    "powered": "Подготовлено в AVRASTRO",
    "prepared_with": "Подготовлено в",
    "sample": {
      "proposal": "Предложение",
      "review": "Ежегодный обзор",
      "letter": "Письмо",
      "proposal_title": "Предложение по защите",
      "review_title": "Ежегодный обзор",
      "letter_title": "Письмо",
      "client": "Г-жа Мария Пример<br>ул. Примерная, 1, 1000 Город",
      "letter_body": "Уважаемая госпожа Пример!<br><br>Благодарю за встречу. Как договаривались, прилагаю сводку по вашему страхованию и следующие шаги.",
      "situation": "Семья из четырёх человек; один доход; ипотека до 2041 года. Приоритет: защита дохода и страхование жизни под ипотеку.",
      "next": "Следующий обзор через 12 месяцев."
    },
    "signature_note": "Изображение вашей собственноручной подписи; печатается только в документах, где вы отметили «С моей подписью». Это не электронная и не квалифицированная электронная подпись — для документов, которые клиент подписывает электронно, используйте Электронную подпись. Видеть, вставлять, заменять и удалять его можете только вы.",
    "signature_alt": "Изображение подписи",
    "delete_signature": "Удалить подпись",
    "signature_replace_confirm": "Заменить изображение вашей подписи новым?",
    "signature_delete_confirm": "Удалить изображение вашей подписи? Оно будет удалено из вашего профиля на всех синхронизированных устройствах и больше не сможет вставляться в документы.",
    "signature_saved": "Изображение подписи сохранено",
    "signature_replaced": "Изображение подписи заменено",
    "signature_deleted": "Изображение подписи удалено"
  },
  "radar": {
    "title": "Радар возможностей",
    "subtitle": "Возможностей в вашем портфеле: {count} — для каждой указаны причина и следующий шаг.",
    "book": "портфель {amount}",
    "empty": "Сейчас предложить нечего.",
    "more": "Показать ещё {count}",
    "note": "Только подсказки: каждое действие открывает обычную форму; ничего не отправляется и не создаётся само. Люди из списка «не связываться» исключены.",
    "kind": {
      "coverage_gap": "Пробелы в покрытии",
      "life_event": "Жизненные события",
      "renewal_window": "Поводы при продлении",
      "review_due": "Предстоящие обзоры",
      "decision_open": "Открытые решения",
      "lapsed": "Возврат клиентов",
      "dormant": "Давно без контакта",
      "referral_ask": "Попросить рекомендации",
      "family_uncovered": "Семья без покрытия",
      "tax_saving": "Налоговая экономия",
      "premium_overdue": "Просроченные взносы",
      "cross_sell": "Жизнь ↔ общее страхование"
    },
    "why": {
      "coverage_gap": "Нужно покрытие «{areas}», которого нет.",
      "life_event": "{event} {date} — обычно стоит пересмотреть защиту.",
      "renewal_window": "{product} продлевается через {days} дн. — естественный повод всё пересмотреть.",
      "review_overdue": "Ежегодный обзор просрочен на {days} дн.",
      "review_never": "Есть полисы, но обзора ещё не было.",
      "decision_open": "«{title}» ждёт решения уже {days} дн.",
      "lapsed": "{product} прекращён в течение последнего года — стоит позвонить и предложить восстановление.",
      "dormant": "Нет контакта уже {days} дн.",
      "referral_ask": "Крепкие отношения (состояние {score}), а рекомендацию не просили больше года.",
      "referral_after_review": "Недавно прошёл обзор и доволен — хороший момент попросить рекомендацию.",
      "family_uncovered": "У {name} из той же семьи нет собственного покрытия.",
      "tax_saving": "Ещё можно вычесть около €{capacity} взносов в год ({year}) — примерно на €{saving} меньше налога.",
      "premium_overdue": "{product}: взнос ещё не получен ({days} дн.) — звонок сохранит покрытие.",
      "premium_lapse_risk": "{product}: взнос просрочен на {days} дн. — риск прекращения.",
      "cs_property_no_earthquake": "{item}: в CRM нет связанного полиса страхования жилья — может быть полезен вопрос о страховании от землетрясения.",
      "cs_family_vehicle_no_life": "Семья с автомобилем ({item}) без записанного страхования жизни — возможно, стоит поговорить о защите семьи.",
      "cs_mortgage_no_protection": "По объекту {item} есть кредит, но страхование кредита или жизни не записано — короткая проверка может помочь.",
      "cs_business_no_liability": "У {item} есть сотрудники, но полис ответственности не привязан — может быть полезен вопрос об ответственности работодателя."
    },
    "action": {
      "call": "Позвонить",
      "followup": "Напомнить",
      "appointment": "Назначить встречу",
      "proposal": "Потребности и предложение",
      "campaign": "Кампания",
      "message": "Черновик сообщения"
    }
  },
  "growth_a": {
    "title": "Аналитика роста",
    "subtitle": "{from} – {to}: откуда приходит новый бизнес и как он конвертируется.",
    "period": {
      "month": "Этот месяц",
      "quarter": "Квартал",
      "year": "Этот год",
      "last12": "Последние 12 месяцев"
    },
    "new_contacts": "Новые контакты",
    "new_clients": "Новые клиенты",
    "conversion": "Конверсия",
    "conversion_hint": "новые контакты, ставшие клиентами",
    "issue_rate": "Доля выдачи",
    "issue_rate_hint": "выдано ÷ (выдано + отклонено/отозвано)",
    "avg_case": "Средний размер заявки",
    "avg_case_hint": "взнос по выданным заявкам",
    "avg_policy": "Средний новый полис",
    "avg_policy_hint": "годовой взнос",
    "days_to_issue": "Дней до выдачи",
    "pipeline": "Объём воронки",
    "pipeline_hint": "открытые возможности, ожидаемый взнос",
    "weighted": "Взвешенная воронка",
    "weighted_hint": "по этапам: 10 · 25 · 50 · 75 %",
    "commission": "Комиссия",
    "commission_paid": "выплачено {amount}",
    "sources": "Источники новых контактов",
    "source_tip": "{contacts} контактов · {clients} клиентов · конверсия {conversion}",
    "sources_note": "Полоса: годовой взнос клиентов из источника (контакты, если клиентов пока нет). Процент: конверсия.",
    "no_contacts": "За этот период новых контактов нет.",
    "cases": "Заявки",
    "started": "Начато",
    "issued": "Выдано",
    "declined": "Отклонено / отозвано",
    "open_cases": "Открыто сейчас",
    "open_opps": "Открытые возможности",
    "new_policies": "Новые полисы",
    "referrals": "Рекомендации",
    "ref_given": "Получено",
    "ref_converted": "Стали контактами",
    "ref_business": "Бизнес по рекомендациям",
    "definitions": "Рассчитано по вашим записям за период; ничего не выборочно и не оценочно. Бизнес = действующий годовой взнос на сегодня.",
    "source": {
      "referral": "Рекомендация",
      "website": "Сайт",
      "unknown": "Не указан",
      "campaign": "Кампания",
      "social": "Соцсети",
      "event": "Мероприятие",
      "cold_call": "Холодные звонки",
      "walk_in": "Визит в офис",
      "legacy": "Импорт",
      "friends_family": "Друзья и семья",
      "professional_network": "Профессиональные связи",
      "portfolio_transfer": "Передача портфеля",
      "met_in_person": "Личное знакомство"
    }
  },
  "req": {
    "details": "Подробности",
    "status": "Статус",
    "waiting_on": "Ожидается от",
    "requested_at": "Запрошен",
    "received_at": "Получен",
    "expires_at": "Действует до",
    "expires_hint": "напр. удостоверение личности или медицинское заключение",
    "document": "Связанный документ",
    "label": "Описание",
    "complete": "Все обязательные документы получены",
    "status_opt": {
      "required": "Требуется",
      "requested": "Запрошен",
      "received": "Получен",
      "waived": "Не нужен",
      "expired": "Истёк"
    },
    "waiting_opt": {
      "client": "Клиент",
      "insurer": "Страховщик",
      "advisor": "Я"
    },
    "state": {
      "missing": "Нет",
      "requested": "Запрошен",
      "waiting_client": "Ждём клиента",
      "waiting_insurer": "Ждём страховщика",
      "received": "Получен",
      "waived": "Не нужен",
      "expired": "Истёк"
    },
    "sum": {
      "received": "получено: {count}",
      "missing": "нет: {count}",
      "waiting_client": "ждём клиента: {count}",
      "waiting_insurer": "ждём страховщика: {count}",
      "expired": "истекло: {count}"
    }
  },
  "checklist": {
    "title": "Список документов",
    "manage": "Списки документов",
    "new": "Новый список",
    "intro": "Списки по страховщику и/или категории продукта. При создании заявки предлагается самый конкретный: страховщик + категория › страховщик › категория.",
    "name": "Название",
    "insurer_hint": "Оставьте пустым для любого страховщика",
    "category_hint": "Оставьте пустым для любого продукта",
    "any": "Любой страховщик и продукт",
    "items": "Пунктов: {count}",
    "add_item": "Добавить пункт",
    "mandatory": "Обязателен для завершения",
    "mandatory_short": "Обязательно",
    "optional": "необязательно",
    "active": "Активен",
    "inactive": "неактивен",
    "choose": "Добавить список…",
    "apply": "Добавить",
    "applied": "Список добавлен (только недостающие пункты)",
    "fits": "подходит",
    "none_yet": "Списков страховщиков пока нет.",
    "suggested": "Предлагается: {name}",
    "auto_named": "Автоматически: {name}",
    "auto_market": "Автоматически (по умолчанию для рынка)",
    "market_default": "По умолчанию для рынка"
  },
  "referral": {
    "task_title": "Связаться с рекомендованным"
  },
  "web": {
    "refresh": "Обновить",
    "loading": "Загрузка…",
    "connect": "Подключить учётную запись",
    "see_plans": "Тарифы",
    "reason": {
      "signed_out": "Подключите учётную запись avrastro.com, чтобы получать то, что клиенты отправляют вам через сайт.",
      "offline": "Вы офлайн. Этой странице нужен интернет; всё уже принятое находится в вашей CRM и работает офлайн.",
      "plan": "Ваш текущий тариф этого не включает. Повысьте тариф в Advisor Hub."
    },
    "err": {
      "plan_feature": "Ваш текущий тариф этого не включает.",
      "licence_expired": "Подписка закончилась — рабочее пространство только для чтения. Продлите её в Advisor Hub.",
      "portal_not_allowed": "Этот клиент не разрешил (или больше не разрешает) публикации на своём портале.",
      "title_required": "Добавьте заголовок.",
      "not_found": "Больше недоступно.",
      "ai_not_configured": "Черновики ИИ на этом сервере не настроены.",
      "ai_allowance_used": "Лимит черновиков ИИ на этот месяц исчерпан. Докупите в Advisor Hub или дождитесь следующего месяца.",
      "ai_unavailable": "Сервис ИИ не ответил. Попробуйте снова.",
      "ai_empty": "Сервис ИИ ничего не вернул. Попробуйте снова.",
      "input_required": "Напишите заметки, по которым составить черновик.",
      "network": "Нет связи со службой AVRASTRO. Попробуйте снова.",
      "permission": "Ваша роль этого не допускает.",
      "website_unreachable": "avrastro.com не ответил. Попробуйте чуть позже; ничего не изменилось.",
      "website_error": "avrastro.com не смог завершить операцию. Попробуйте снова или подтвердите встречу в Advisor Hub.",
      "website_not_linked": "Ваша учётная запись avrastro.com не подключена к этой CRM.",
      "booking_state": "Эта встреча уже изменена на avrastro.com (подтверждена, отклонена или отменена). Обновите список.",
      "action": "Недопустимое действие."
    },
    "inbox": {
      "title": "Входящие с сайта",
      "subtitle": "Доступы к данным, запросы на встречу и сообщения с avrastro.com. Ничего не попадает в CRM, пока вы не примете.",
      "tab": {
        "open": "На проверку",
        "all": "Все"
      },
      "empty": "Проверять нечего. Новые доступы, записи и сообщения с avrastro.com появятся здесь.",
      "empty_all": "Записей пока нет.",
      "kind": {
        "share": "Отчёты, к которым дан доступ",
        "booking": "Запрос на встречу",
        "lead": "Сообщение"
      },
      "status": {
        "accepted": "Принято",
        "declined": "Отклонено",
        "archived": "В архиве",
        "revoked": "Отозвано клиентом",
        "expired": "Срок доступа истёк"
      },
      "mode": {
        "office": "в офисе",
        "online": "онлайн",
        "phone": "по телефону",
        "cafe": "в кафе",
        "client_place": "у клиента",
        "video": "видеозвонок"
      },
      "booking": {
        "requested": "запрошена",
        "confirmed": "подтверждена",
        "declined": "отклонена",
        "cancelled": "отменена",
        "cancelled_by_client": "отменена клиентом",
        "completed": "проведена"
      },
      "received": "получено {when}",
      "share_line": "{n, plural, one {# отчёт} few {# отчёта} many {# отчётов} other {# отчёта}}, доступ до {until}",
      "portal_allowed": "портал клиента разрешён",
      "show_results": "Показать полученные результаты",
      "matches": "Совпадает с {name} в вашей CRM.",
      "accept_link": "Принять в карточку {name}",
      "accept_new": "Принять как нового потенциального клиента",
      "accept_lead": "Принять как новый контакт",
      "other_person": "Другой человек…",
      "existing_person": "Связать с существующим человеком",
      "link": "Связать",
      "decline": "Отклонить",
      "decline_confirm": "Отклонить эту запись? AVRASTRO не уведомляет отправителя; в CRM ничего не добавляется.",
      "declined": "Отклонено.",
      "accepted": "{name} теперь в вашей CRM.",
      "open_person": "Открыть в CRM",
      "booking_changed": "Клиент изменил эту встречу на avrastro.com.",
      "cancel_appointment": "Отменить в ежедневнике",
      "cancelled_on_site": "Отменено на avrastro.com",
      "appointment_cancelled": "Встреча отменена в вашем ежедневнике.",
      "withdrawal_revoked": "Отозвано клиентом на avrastro.com",
      "withdrawal_expired": "Срок доступа на avrastro.com истёк",
      "withdrawals": "{n, plural, one {# отзыв записан} few {# отзыва записаны} many {# отзывов записаны} other {# отзыва записаны}} в историю согласий.",
      "note_share": "Получено через avrastro.com: {purpose}",
      "task_share": "Проверить данные от {name}",
      "task_booking": "Запрос на встречу через avrastro.com{topic}",
      "via_site": "через {site}",
      "note_lead": "Сообщение с avrastro.com{topic}",
      "task_lead": "Ответить: {name}",
      "scope": "Доступ avrastro.com {ref}: отчётов — {n}; профиль: {fields}; портал клиента: {portal}; до {until}",
      "privacy": "Полученные данные хранятся в службе AVRASTRO, только пока клиент это разрешает. Принятые записи становятся записями CRM под вашим контролем. Обновлено",
      "task_callback": "Перезвонить: {name}{topic}",
      "callback": "Просьба перезвонить",
      "best_time": {
        "morning": "утро",
        "midday": "полдень",
        "afternoon": "вторая половина дня"
      },
      "shared_policies": "Полисы из папки клиента",
      "policy_renews": "Продление",
      "policy_sum": "Страховая сумма",
      "policy_premium": "Взнос",
      "opinion_file": "Котировка для второго мнения",
      "opinion_open": "Открыть файл (avrastro.com)",
      "opinion_closed": "файл больше недоступен",
      "opinion_until": "доступен до {date}"
    },
    "portal": {
      "title": "Портал клиента",
      "subtitle": "То, что вы публикуете на личной странице клиента на avrastro.com. Только для клиентов, которые это разрешили; что они видят, решаете вы.",
      "empty": "Пока ни один клиент не разрешил публикации на портале. Клиент разрешает это, когда делится с вами отчётами на avrastro.com.",
      "allowed_until": "Разрешено до {date}",
      "publish": "Опубликовать",
      "publish_to": "Опубликовать для {name}",
      "withdraw": "Снять",
      "withdraw_confirm": "Снять эту публикацию? Клиент больше не будет её видеть.",
      "withdrawn": "Снято",
      "read": "Прочитано {date}",
      "unread": "Ещё не прочитано",
      "published": "Опубликовано на портале клиента.",
      "kind": {
        "summary": "Сводка по страхованию",
        "review": "Итоги обзора",
        "document_request": "Нужны документы",
        "appointment": "Встреча",
        "note": "Заметка"
      },
      "kind_label": "Тип",
      "title_label": "Заголовок",
      "body_label": "Сообщение",
      "body_hint": "Пишется для клиента. Внутренние заметки никогда не публикуются.",
      "sections": "Строки (название · значение)",
      "prefill": "Заполнить из полисов клиента",
      "prefill_title": "Ваше текущее страхование",
      "add_line": "Добавить строку",
      "line_label": "Название",
      "line_value": "Значение",
      "year": "год",
      "renews": "продление {date}",
      "note": "Опубликовано на портале клиента: {title}",
      "publish_note": "Клиент видит это на своей личной странице avrastro.com и не получает никаких других данных из вашей CRM. Публикацию можно снять в любой момент.",
      "privacy": "Публикации портала хранятся в службе AVRASTRO в зашифрованном виде и показываются только вошедшему клиенту и только пока он вам это разрешает."
    },
    "drafts": {
      "title": "Черновики ИИ",
      "subtitle": "Черновики сообщений, сводок, заметок о встречах и повесток обзоров — вы всё проверяете и редактируете перед использованием.",
      "kind": {
        "message": "Сообщение клиенту",
        "summary": "Сводка по клиенту",
        "meeting": "Заметки о встрече → действия",
        "review": "Повестка ежегодного обзора"
      },
      "kind_label": "Что составить",
      "input": "Ваши заметки",
      "input_hint": "Только факты. Без номеров документов и сведений о здоровье, если это не необходимо.",
      "run": "Составить",
      "working": "Составляется…",
      "usage": "Использовано черновиков в этом месяце: {used} из {allowance}",
      "not_configured": "Черновики ИИ на этом сервере ещё не настроены (владелец добавляет API-ключ).",
      "privacy": "Ваши заметки отправляются провайдеру ИИ только для составления этого черновика; AVRASTRO не хранит ни их, ни черновик на сервере.",
      "result": "Черновик",
      "empty": "Черновик появится здесь.",
      "review": "Проверьте каждый факт, сумму и обещание перед отправкой — ИИ может ошибаться. Ничего не отправляется автоматически.",
      "copy": "Копировать",
      "copied": "Скопировано.",
      "save_note": "Сохранить как заметку"
    },
    "booking": {
      "who_title": "Встреча подтверждена на avrastro.com",
      "confirm_title": "Подтвердить встречу",
      "question": "Это существующий клиент или новый человек? Выберите, чтобы встреча попала в ваш ежедневник, а его карточка открылась для подготовки.",
      "confirm_question": "Это существующий клиент или новый человек? После выбора встреча подтверждается на avrastro.com, клиент получает полное подтверждение, а встреча попадает в ваш ежедневник.",
      "found_email": "Найдено в вашей CRM: {name} (тот же e-mail).",
      "found_phone": "Найдено в вашей CRM: {name} (тот же телефон).",
      "not_found": "В вашей CRM нет никого с таким e-mail или телефоном.",
      "is_match": "Да, это {name}",
      "existing": "Существующий клиент — выбрать из списка",
      "new_prospect": "Новый человек — потенциальный клиент",
      "later": "Позже",
      "note": "Остаётся во «Входящих с сайта», пока вы не выберете.",
      "confirm_note": "Клиент получит письмо с датой, временем, адресом, картой, списком того, что взять с собой, и вашими контактами.",
      "done": "Встреча в вашем ежедневнике.",
      "done_confirmed": "Подтверждено; клиент уведомлён, встреча в вашем ежедневнике.",
      "task_confirmed": "Встреча (avrastro.com){topic}",
      "confirm": "Подтвердить встречу",
      "decline": "Отклонить запрос",
      "decline_confirm": "Отклонить этот запрос? Клиент получит письмо, что это время недоступно, и сможет выбрать другое.",
      "declined": "Отклонено; клиент уведомлён.",
      "confirmed_hint": "Подтверждено на avrastro.com — свяжите с клиентом, чтобы добавить в ежедневник."
    }
  },
  "groups": {
    "title": "Групповые программы",
    "subtitle": "Программы работодателей — групповое медицинское страхование, страхование жизни, пенсионное и от несчастных случаев — со списком участников.",
    "new": "Новая групповая программа",
    "empty": "Групповых программ пока нет. Добавьте программу работодателя, чтобы хранить список участников, взнос и продление в одном месте.",
    "not_found": "Этой групповой программы больше нет.",
    "scheme": "Программа",
    "category": "Категория",
    "members": "Участники",
    "annual": "Годовой взнос",
    "renewal": "Продление",
    "in_days": "через {days} дн.",
    "overdue": "просрочено",
    "cat": {
      "life": "Групповое страхование жизни",
      "medical": "Групповое медицинское",
      "pension": "Пенсионный / накопительный фонд",
      "accident": "Групповое от несчастных случаев",
      "mixed": "Смешанная",
      "other": "Другое"
    },
    "status": {
      "quote": "Котировка",
      "active": "Действует",
      "renewing": "Продлевается",
      "ended": "Завершена"
    },
    "filter": {
      "active": "Активные",
      "pending": "Вступают",
      "left": "Вышли",
      "all": "Все"
    },
    "field": {
      "displayName": "Имя",
      "firstName": "Имя",
      "lastName": "Фамилия",
      "birthDate": "Дата рождения",
      "email": "E-mail",
      "phone": "Телефон",
      "employeeNo": "Табельный №",
      "class": "Категория",
      "joinDate": "Вступил",
      "leaveDate": "Вышел",
      "dependants": "Иждивенцы"
    },
    "export": "Экспорт списка",
    "import": "Импорт списка участников",
    "add_member": "Добавить участника",
    "active": "Активные участники",
    "pending": "Вступают",
    "dependants": "Иждивенцы",
    "avg_age": "Средний возраст",
    "split": "Работодатель платит {employer} ({share}%), участники — {members}.",
    "changes_soon": "Ближайшие 30 дней: вступают — {joining}, выходят — {leaving}.",
    "missing_birth": "{n, plural, one {У # участника} few {У # участников} many {У # участников} other {У # участника}} нет даты рождения — страховщикам она обычно нужна.",
    "classes": "Категории",
    "class_line": "{n, plural, one {# участник} few {# участника} many {# участников} other {# участника}}",
    "no_members": "Участников пока нет.",
    "contact": "Контактное лицо",
    "renewal_task_create": "Создать напоминание о продлении",
    "renewal_task": "Продление групповой программы: {name}",
    "renewal_task_done": "Напоминание о продлении создано.",
    "not_clients": "Ещё не индивидуальные клиенты ({n})",
    "not_clients_note": "Каждый участник — возможный повод для консультации (личное покрытие, семья, накопления). Им ничего не отправляется.",
    "all_clients": "Все активные участники уже клиенты.",
    "make_prospect": "Добавить как потенциального клиента",
    "prospect_created": "{name} добавлен(а) как потенциальный клиент.",
    "left_on": "вышел {date}",
    "mark_left": "Отметить выход",
    "left": "Записан выход — история сохранена.",
    "employer": "Работодатель",
    "scheme_name": "Название программы",
    "carrier": "Страховщик",
    "policy_number": "№ полиса",
    "start": "Дата начала",
    "premium_model": "Взнос",
    "per_member": "На участника в год",
    "total": "Всего в год",
    "premium_per_member": "€ на участника / год",
    "total_premium": "Всего € / год",
    "employer_share": "Доля работодателя",
    "vat": "№ НДС / TIC работодателя",
    "add_class": "Добавить категорию",
    "class_name": "Категория (напр. руководство)",
    "benefits": "Покрытие (напр. План A, весь мир)",
    "individual": "Индивидуальная карточка клиента",
    "individual_hint": "Свяжите участника с его собственной карточкой в CRM (необязательно).",
    "import_title": "Импорт списка — {name}",
    "import_intro": "Используйте файл от работодателя или страховщика (CSV или Excel) либо вставьте строки. Перед сохранением вы увидите результат по каждой строке.",
    "import_file": "Выбрать файл",
    "import_paste": "…или вставьте строки сюда (со строкой заголовков)",
    "import_unreadable": "Не удалось прочитать файл. Сохраните его как CSV или .xlsx и попробуйте снова.",
    "import_leavers": "Участники, которых нет в этом файле, вышли",
    "import_summary": "{add} новых · {update} обновлено · {skip} пропущено",
    "import_new_classes": "новые категории: {names}",
    "import_leaving": "выходят: {n}",
    "import_apply": "Импортировать новых: {add}, обновить: {update}",
    "import_done": "Список импортирован: новых — {add}, обновлено — {update}.",
    "import_again": "Выбрать другой файл",
    "import_action": {
      "add": "Новый",
      "update": "Обновить",
      "skip": "Пропущен"
    },
    "problem": {
      "name_missing": "нет имени",
      "birthDate_invalid": "нечитаемая дата рождения",
      "joinDate_invalid": "нечитаемая дата вступления",
      "leaveDate_invalid": "нечитаемая дата выхода",
      "dependants_invalid": "число иждивенцев не является числом",
      "duplicate_in_file": "повторяющаяся строка в файле"
    },
    "locked": "Групповые программы входят в тарифы Professional и Team. Существующие программы остаются доступными для просмотра и выгрузки."
  },
  "save": {
    "short_saved": "Сохранено",
    "short_volatile": "Не сохраняется",
    "short_error": "Ошибка сохранения",
    "short_offline": "Офлайн",
    "auto": "Каждое изменение сохраняется на этом устройстве по ходу работы.",
    "saved_at": "Сохранено на этом устройстве {time}",
    "volatile": "Не сохраняется: этот браузер не разрешил локальное хранилище, поэтому после закрытия ничего не останется. Используйте Chrome или Edge в обычном (не приватном) окне.",
    "error": "Последнее изменение не удалось сохранить на этом устройстве. Экспортируйте резервную копию и проверьте свободное место.",
    "offline": "Нет интернета: всё на этом устройстве продолжает работать; онлайн-функции ждут подключения.",
    "backup_never": "На этом устройстве ещё не создавалась резервная копия.",
    "backup_due": "Последняя резервная копия — {days} дн. назад."
  },
  "protect": {
    "title": "Где хранятся ваши данные и как они защищены",
    "personal_edition": "Персональная офлайн-версия",
    "volatile": "Не сохраняется — работа только в памяти. Ничего не закрывайте, пока не экспортируете резервную копию, и откройте AVRASTRO в Chrome или Edge в обычном окне.",
    "native": "Сохраняется по ходу работы в собственном файле базы данных приложения на этом компьютере.",
    "browser": "Сохраняется по ходу работы в хранилище этого браузера на этом компьютере. Другой браузер или компьютер этих данных не видит — переносите их файлом резервной копии.",
    "persisted": "Браузер хранит данные постоянно (не удаляет их для освобождения места).",
    "not_persisted": "Браузер может удалить данные, если диск сильно заполнится, — храните резервные копии.",
    "encrypted": "Зашифровано на этом устройстве вашей парольной фразой (AES-256-GCM). AVRASTRO запрашивает её при каждом запуске.",
    "not_encrypted": "Не зашифровано средствами AVRASTRO: открыть данные может любой, кто пользуется этой учётной записью компьютера. Используйте шифрование диска и парольную фразу.",
    "turn_on": "Включить шифрование",
    "snapshots": "Автоматические копии для восстановления: одна каждые 12 часов, если что-то изменилось; на этом устройстве хранятся 7 последних.",
    "last_auto": "Последняя: {time}.",
    "backup_never": "На этом устройстве ещё не создавалась резервная копия.",
    "backup_age": "Последняя резервная копия: {days} дн. назад.",
    "backup_why": "Файл резервной копии — ваша копия вне браузера. Сохраняйте её еженедельно на флешку или в облачную папку.",
    "online": "В сети.",
    "offline": "Офлайн.",
    "network_needed": "Без интернета здесь всё работает; подключение нужно только для входа, синхронизации, входящих с сайта, портала клиента и черновиков ИИ."
  },
  "register": {
    "title": "Список клиентов",
    "subtitle": "Все клиенты с датой начала отношений и источником. Распечатайте, выгрузите или дополните недостающее.",
    "who": "Кто",
    "who_clients": "Клиенты",
    "who_with_former": "Клиенты и бывшие клиенты",
    "who_all": "Все, включая потенциальных клиентов",
    "source_all": "Все источники",
    "from": "Клиент с: от",
    "to": "до",
    "sort": "Порядок",
    "sort_name": "Имя",
    "sort_since": "Клиент с",
    "sort_source": "Источник",
    "group": "Группировать по источнику",
    "contact": "Телефон и e-mail",
    "portfolio": "Полисы и взносы",
    "count": "{count, plural, one {# клиент} few {# клиента} many {# клиентов} other {# клиента}}",
    "by_source": "По источникам",
    "by_year": "Новые клиенты по годам",
    "col_no": "№",
    "col_name": "Клиент",
    "col_phone": "Телефон",
    "col_email": "E-mail",
    "col_since": "Клиент с",
    "col_source": "Источник",
    "col_referred": "По рекомендации",
    "col_policies": "Действующие полисы",
    "col_premium": "Годовой взнос",
    "col_year": "Год",
    "col_clients": "Клиенты",
    "col_share": "Доля",
    "col_stage": "Этап",
    "print": "Печать",
    "csv": "Экспорт CSV (Excel)",
    "fill": "Заполнить источник и дату",
    "fill_done": "Готово",
    "missing": "без источника: {source} · без даты «клиент с»: {since}",
    "note_first_policy": "¹ дата первого полиса — дата «клиент с» не указана",
    "note_added": "² дата добавления клиента в AVRASTRO — дата «клиент с» не указана",
    "empty": "Под эти фильтры клиентов нет.",
    "saved": "Сохранено",
    "filters": "Фильтры: {list}",
    "total": "Итого",
    "exported": "Список клиентов выгружен",
    "basis": "Основание даты"
  },
  "payslip": {
    "title": "Расчётный лист → налог",
    "open": "Расчётный лист → налог",
    "intro": "Загрузите один или несколько расчётных листов (PDF). Они читаются на этом компьютере — ничего никуда не отправляется. Перед сохранением вы проверяете каждую сумму.",
    "choose": "Выбрать PDF расчётных листов",
    "stored": "Расчётные листы, уже имеющиеся в документах клиента",
    "read": "Прочитать расчётные листы",
    "reading": "Чтение…",
    "add_more": "Добавить расчётные листы",
    "manual": "Ввести вручную",
    "person_first": "Сначала выберите клиента.",
    "period": "Период",
    "employer": "Работодатель",
    "unknown_period": "период не найден",
    "k": {
      "gross": "Начислено (брутто)",
      "basic": "Оклад",
      "allowances": "Надбавки и доплаты",
      "thirteenth": "13-я зарплата",
      "si": "Социальное страхование",
      "ghs": "GESY (ΓεΣΥ)",
      "provident": "Накопительный фонд",
      "pension": "Пенсионный фонд",
      "medical": "Медицинский фонд",
      "union": "Профсоюз / профессиональная организация",
      "tax": "Удержанный подоходный налог",
      "otherDeductions": "Прочие удержания",
      "deductionsTotal": "Всего удержаний",
      "net": "К выплате (нетто)"
    },
    "from_line": "Из строки: «{line}»",
    "derived": "рассчитано по строкам начислений",
    "not_found": "не найдено",
    "alternatives": "Также найдено: {list}",
    "check_ok": "Сходится: брутто − удержания = нетто.",
    "check_diff": "Расхождение на {amount}. Проверьте суммы.",
    "check_unknown": "Сумма к выплате не найдена — проверьте суммы.",
    "warn": {
      "no_text": "Этот PDF — скан (изображение): в нём нет текста для чтения. Введите суммы из расчётного листа вручную.",
      "no_gross": "Сумма брутто не найдена.",
      "no_si": "Социальное страхование не найдено.",
      "no_period": "Расчётный период не найден.",
      "net_mismatch": "Брутто − удержания не равно сумме к выплате.",
      "unidentified_deductions": "Некоторые удержания в итоге не распознаны; они учтены как «прочие удержания»."
    },
    "error": {
      "not_pdf": "Это не файл PDF.",
      "password": "PDF защищён паролем. Откройте его, сохраните копию без пароля и попробуйте снова.",
      "damaged": "Не удалось прочитать PDF."
    },
    "year_settings": "Год",
    "salaries": "Зарплат в год",
    "salaries_hint": "Выберите 13, если клиент получает 13-ю зарплату.",
    "tax_year": "Налоговый год",
    "children": "Дети",
    "household_income": "Доход семьи (необязательно)",
    "life_policies": "Учитываемые полисы страхования жизни",
    "no_life": "В AVRASTRO нет действующего полиса страхования жизни.",
    "result": "Результат",
    "annual_gross": "Годовой доход брутто",
    "contributions": "Вычитаемые взносы сейчас",
    "cap": "Лимит (1/5 дохода)",
    "capacity": "Остаток для вычитаемых взносов",
    "per_month": "≈ {amount} в месяц",
    "tax_estimate": "Ориентировочный подоходный налог {year}",
    "effective": "эффективная ставка {rate}",
    "withheld": "Удержано по расчётным листам (в год)",
    "withheld_diff_over": "Удерживается примерно на {amount} больше расчётного — после подачи декларации возможен возврат.",
    "withheld_diff_under": "Удерживается примерно на {amount} меньше расчётного — после подачи декларации возможна доплата.",
    "withheld_ok": "Удержания соответствуют расчёту.",
    "saving": "Полное использование лимита (≈ {monthly}/мес. вычитаемых взносов) сэкономит около {saving} налога в год при предельной ставке {rate}.",
    "no_capacity": "Вычитаемые взносы уже достигают лимита — дополнительной налоговой экономии от взносов не будет.",
    "unavailable": "Нет налоговых правил на {year}: {reason}",
    "save": "Сохранить у клиента",
    "saved": "Анализ расчётного листа сохранён",
    "follow_up": "Создать напоминание для предложения по налоговой экономии",
    "follow_up_title": "Предложение по налоговой экономии: до {amount}/год вычитаемых взносов",
    "print": "Печать",
    "share": "Отправить клиенту",
    "store_note": "Расчётные листы сохраняются в документах клиента с ограниченным доступом (ассистенты их не видят).",
    "doc_title": "Расчётный лист {period}",
    "print_title": "Анализ расчётного листа и налога",
    "disclaimer": "Оценка для консультации на основе расчётных листов и указанных налоговых правил — не налоговая консультация. Окончательный налог определяется по налоговой декларации.",
    "months_used": "{count, plural, one {# расчётный лист} few {# расчётных листа} many {# расчётных листов} other {# расчётного листа}}",
    "annual_basis": "типичный месяц × {n}",
    "col_file": "Расчётный лист",
    "payslips": "Расчётные листы",
    "ask_client": "Запросить расчётные листы у клиента",
    "change": {
      "salary_increase": "Зарплата выросла на {pct}% с прошлого расчётного листа ({from} → {to}). При сохранении записываются жизненное событие «повышение зарплаты» и пересмотр покрытия.",
      "new_job": "С прошлого расчётного листа сменился работодатель. При сохранении записываются жизненное событие «новая работа» и пересмотр покрытия."
    }
  },
  "share": {
    "open": "Отправить клиенту",
    "title": "Отправить: {name}",
    "what": "Что отправить",
    "message": "Сообщение",
    "to": "Кому:",
    "preview": "Предпросмотр",
    "chars": "символов",
    "privacy": "Содержит личные и финансовые данные — проверьте получателя перед отправкой.",
    "nothing": "отправлять пока нечего",
    "how": "AVRASTRO открывает ваше приложение с готовым сообщением; отправляете вы сами. Каждая отправка отмечается в истории клиента.",
    "copied": "Скопировано — вставьте в любое приложение.",
    "ics": "Файл календаря",
    "subject": "Информация для {name}",
    "log_subject": "Отправлено через {channel}",
    "intro_default": "Здравствуйте, {name}! Как мы обсуждали, направляю информацию о вашем страховании:",
    "item": {
      "summary": "Краткая сводка",
      "policies": "Полисы и взносы",
      "protection": "Обзор защиты",
      "tax": "Налоговый результат (расчётный лист)",
      "documents": "Документы, которые ещё нужны",
      "appointment": "Следующая встреча",
      "renewals": "Предстоящие продления",
      "request": "Запросить документы"
    },
    "s": {
      "summary": "Сводка",
      "policies": "Ваши полисы",
      "protection": "Ваша защита",
      "tax": "Оценка налога {year}",
      "documents": "Пожалуйста, пришлите мне",
      "appointment": "Наша следующая встреча",
      "renewals": "Скоро продление",
      "request": "Для подготовки вашего дела, пожалуйста, пришлите мне"
    },
    "ch": {
      "whatsapp": "WhatsApp",
      "viber": "Viber",
      "email": "E-mail",
      "sms": "SMS",
      "system": "Поделиться…",
      "copy": "Копировать текст",
      "pdf": "PDF / печать"
    },
    "summary_line": "{count, plural, =0 {Нет действующих полисов} one {# действующий полис} few {# действующих полиса} many {# действующих полисов} other {# действующего полиса}} · всего {total} в год",
    "no": "№",
    "year": "год",
    "renews": "продление",
    "tax_income": "Годовой доход брутто: {amount}",
    "tax_estimate": "Ориентировочный подоходный налог: {amount}",
    "tax_capacity": "Вы ещё можете использовать {amount} в год (≈ {monthly}/мес.) вычитаемых взносов — примерно на {saving} меньше налога в год.",
    "tax_full": "Ваши вычитаемые взносы уже достигают годового лимита.",
    "tax_note": "Это оценка, а не налоговая консультация; окончательный налог определяется по вашей налоговой декларации.",
    "req": {
      "payslips": "Последние 3 расчётных листа (PDF или фото)",
      "tax_return": "Последняя налоговая декларация / уведомление",
      "id": "Копия удостоверения личности или паспорта",
      "policy_schedules": "Спецификации уже имеющихся полисов",
      "medical": "Свежее медицинское заключение, если его запросит страховщик",
      "vehicle": "Регистрационный документ автомобиля и водительские права",
      "property": "Документ о праве собственности или оценка недвижимости и данные кредита",
      "loan": "Кредитный или ипотечный договор (сумма, срок, банк)",
      "bank": "IBAN для прямого дебетования взносов"
    },
    "intro_request": "Здравствуйте, {name}! Чтобы проверить, сколько налога вы могли бы сэкономить, пришлите, пожалуйста, следующее. Подойдёт фото или PDF прямо сюда."
  },
  "gate": {
    "title": "Вход в AVRASTRO CRM",
    "sub": "CRM для страховых консультантов: клиенты, полисы, продления и задачи — одинаково на компьютере, планшете и телефоне.",
    "fact": {
      "sync": "Одна учётная запись синхронизирует все ваши устройства.",
      "backup": "Зашифрованные облачные копии с паролем, который знаете только вы.",
      "team": "Агентства с ролями, приглашениями и журналом активности."
    },
    "legal": "Правовая информация",
    "terms_page": "Условия использования",
    "privacy_page": "Конфиденциальность",
    "reset_title": "Новый пароль",
    "session_ended": "Ваш сеанс завершён. Войдите снова; ваши данные в безопасности.",
    "unavailable": "Служба учётных записей сейчас недоступна. Обновите страницу чуть позже.",
    "no_account": "Нет учётной записи?",
    "have_account": "Уже есть учётная запись?",
    "show": "Показать",
    "hide": "Скрыть",
    "show_password": "Показать пароль",
    "hide_password": "Скрыть пароль",
    "optional": "(необязательно)",
    "forgot": "Забыли пароль?",
    "or": "или",
    "reg_closed_title": "Регистрация скоро откроется",
    "reg_closed_body": "Пока новую учётную запись можно создать только по приглашению агентства, которое уже пользуется AVRASTRO CRM. Если у вас есть код приглашения, введите его ниже.",
    "reg_code_title": "Нужен код",
    "reg_code_body": "Новые учётные записи создаются по коду активации от AVRASTRO или по приглашению вашего агентства.",
    "invite_code": "Код приглашения",
    "code_label": "Код активации или приглашения",
    "code_set": "Код: {code}",
    "change": "Изменить",
    "have_code": "У меня есть код активации или приглашения",
    "accept": "Я принимаю {terms} и ознакомился(-ась) с {privacy}.",
    "terms_link": "Условия использования",
    "privacy_link": "Политикой конфиденциальности",
    "reg_after": "Мы отправим вам письмо для подтверждения адреса. Остальные данные о практике можно добавить в разделе «Учётная запись» в любое время.",
    "reset_intro": "Введите e-mail вашей учётной записи. Мы отправим код сброса, действующий один час.",
    "reset_from_link": "Выберите новый пароль. На всех устройствах будет выполнен выход, затем войдите с новым паролем.",
    "back_signin": "Назад ко входу",
    "reset_done": "Пароль изменён. Войдите с новым паролем.",
    "preparing": "Готовим ваше рабочее пространство…",
    "err": {
      "network": "Не удалось связаться с AVRASTRO. Проверьте подключение к интернету и попробуйте снова.",
      "registration_closed": "Регистрация пока закрыта. Нужен действующий код приглашения.",
      "workspace_mismatch": "В этом браузере хранятся данные другого рабочего пространства ({workspace}); они никогда не загружаются в другую учётную запись. Войдите в ту учётную запись или используйте другой профиль браузера."
    }
  },
  "insured": {
    "new": "Добавить объект",
    "empty": "Застрахованных объектов пока нет. Добавьте автомобили, жильё или бизнес клиента, чтобы хранить стоимость, водителей и сроки в одном месте.",
    "note": "Стоимость указана со слов клиента. Проверка стоимости восстановления только ориентировочная — это не консультация и не оценка.",
    "filter": {
      "active": "Активные",
      "all": "Все (включая проданные / архивные)"
    },
    "kind": {
      "vehicle": "Транспортное средство",
      "property": "Недвижимость",
      "business": "Бизнес",
      "other": "Другое"
    },
    "status": {
      "active": "Активен",
      "sold": "Продан",
      "archived": "В архиве"
    },
    "field": {
      "kind": "Тип",
      "label": "Название",
      "regNo": "Рег. номер",
      "make": "Марка",
      "model": "Модель",
      "make_model": "Марка / модель",
      "year": "Год",
      "value": "Стоимость",
      "drivers": "Водители",
      "ncdYears": "Лет без убытков",
      "motDue": "Техосмотр (MOT) до",
      "roadTaxDue": "Дорожный налог до",
      "address": "Адрес",
      "areaSqm": "Площадь (м²)",
      "yearBuilt": "Год постройки",
      "rebuildValue": "Стоимость восстановления",
      "contentsValue": "Стоимость имущества",
      "mortgaged": "В ипотеке",
      "activity": "Вид деятельности",
      "employees": "Сотрудники",
      "policies": "Связанные полисы"
    },
    "label_hint": "Необязательно — иначе используется рег. номер, адрес или вид деятельности.",
    "ncd_hint": "Лет без страховых случаев (скидка за безубыточность)",
    "drivers_hint": "Имена через запятую",
    "task_note": "Напоминание создаётся за 14 дней до техосмотра (MOT) и срока дорожного налога.",
    "mark_sold": "Отметить как проданный",
    "archive": "В архив",
    "reactivate": "Снова сделать активным",
    "done": {
      "sold": "Отмечен как проданный — сохранён в истории",
      "archived": "Перемещён в архив — сохранён в истории"
    },
    "due": {
      "mot": "Техосмотр (MOT)",
      "road_tax": "Дорожный налог"
    },
    "due_line": "{what}: {label} — {date} (через {days} дн.)",
    "task": {
      "mot": "Техосмотр (MOT): {label}",
      "road_tax": "Дорожный налог: {label}"
    },
    "hint": {
      "missing": "Ориентировочно: для этой недвижимости не указана стоимость восстановления.",
      "missing_with_estimate": "Ориентировочно: стоимость восстановления не указана. При {cost} за м² площадь даёт около {estimate}.",
      "below": "Ориентировочно: площадь × {cost} за м² ≈ {estimate}, что выше указанной стоимости восстановления ({rebuild}). Стоит уточнить у клиента и страховщика."
    }
  },
  "gi_renewals": {
    "intro": "Продления общего страхования в виде воронки. Напоминания создаются за {days} дн. до окончания (настройки).",
    "create_tasks": "Создать напоминания ({count})",
    "tasks_done": "{count, plural, one {Создано # напоминание о продлении} few {Создано # напоминания о продлении} many {Создано # напоминаний о продлении} other {Создано # напоминания о продлении}}",
    "task_title": "Продление через {days} дн.: {product}",
    "empty": "В ближайшие недели продлений общего страхования нет.",
    "note": "Общее страхование = полисы вида «общее» или категорий авто, жильё, путешествия, ответственность, бизнес. Ничего не продлевается автоматически.",
    "lost_note": "Записан как непродлённый; полис и его история сохранены.",
    "in_days": "через {days} дн. · {date}",
    "expired": "истёк {date}",
    "stage_label": "Этап",
    "stage": {
      "new": "К началу",
      "requested_quotes": "Условия запрошены",
      "compared": "Сравнено",
      "sent_to_client": "Отправлено клиенту",
      "approved": "Одобрено",
      "renewed": "Продлён",
      "lost": "Потеряно"
    },
    "moved": {
      "requested_quotes": "Записано: условия запрошены",
      "compared": "Записано: условия сравнены",
      "sent_to_client": "Записано: отправлено клиенту",
      "approved": "Записано: одобрено клиентом",
      "renewed": "Продление записано — взнос обновлён, продажа за продление засчитана",
      "lost": "Записано как потерянное"
    }
  },
  "premiums": {
    "title": "Просроченные взносы",
    "panel_title": "Просроченные взносы (открытые)",
    "record": "Записать просроченный взнос",
    "form_intro": "Взнос, который страховщик не смог получить (неудачное списание, неоплаченный платёж). Создаётся напоминание; клиенту ничего не отправляется.",
    "amount": "Сумма",
    "due_date": "Дата платежа",
    "note_ph": "напр. банк вернул списание",
    "none": "По этому полису просроченных взносов не записано.",
    "none_open": "Открытых просроченных взносов нет.",
    "note": "Запись, открытая дольше {days} дн., отмечается на полисе как «риск прекращения» (меняется в настройках). Напоминания открываются как черновики — ничего не отправляется само.",
    "risk_hint": "Показывается, если просроченный взнос открыт дольше {days} дн.",
    "lapse_risk": "Риск прекращения",
    "overdue_chip": "Взнос просрочен",
    "open_days": "{count, plural, one {открыт # день} few {открыт # дня} many {открыт # дней} other {открыт # дня}}",
    "reminder": "Черновик напоминания",
    "mark_paid": "Оплачен",
    "mark_lapsed": "Прекращён",
    "recorded": "Просроченный взнос записан — добавлено напоминание",
    "paid_done": "Отмечен как оплаченный — сохранён в истории",
    "lapsed_done": "Отмечен как прекращённый — сохранён в истории",
    "task_title": "Просроченный взнос: {product} ({number})",
    "status": {
      "open": "Открыт",
      "paid": "Оплачен",
      "lapsed": "Прекращён"
    },
    "source": {
      "manual": "Введено вами",
      "import": "Список страховщика"
    },
    "import": "Импорт списка страховщика",
    "import_title": "Импорт списка просрочек страховщика",
    "import_intro": "Выберите файл CSV или Excel, присланный страховщиком (или вставьте его). Вы указываете, какой столбец — номер полиса, сумма и дата платежа. Строки сопоставляются только по точному номеру полиса; всё остальное показывается как несопоставленное, без догадок.",
    "import_file": "Выбрать файл",
    "import_paste": "…или вставьте строки сюда (со строкой заголовков)",
    "import_unreadable": "Не удалось прочитать файл. Сохраните его как CSV или .xlsx и попробуйте снова.",
    "import_summary": "{matched} сопоставлено · {unmatched} не сопоставлено · {duplicates} уже записано",
    "import_apply": "Записать {count, plural, one {# запись} few {# записи} many {# записей} other {# записи}}",
    "import_done": "{count, plural, one {Записан # просроченный взнос} few {Записано # просроченных взноса} many {Записано # просроченных взносов} other {Записано # просроченного взноса}}, к каждому — напоминание",
    "import_again": "Выбрать другой файл",
    "map_all": "Выберите три столбца: номер полиса, сумма и дата платежа.",
    "field": {
      "policyNumber": "Номер полиса",
      "amount": "Сумма",
      "dueDate": "Дата платежа"
    },
    "duplicate": "Уже записан",
    "new_item": "Новый",
    "unmatched": "Несопоставленные строки",
    "unmatched_note": "Несопоставленные строки не записываются. Проверьте номер полиса в CRM (или добавьте полис) и импортируйте снова.",
    "reason": {
      "no_number": "Нет номера полиса",
      "no_policy": "Нет полиса с таким номером",
      "ambiguous": "Этот номер у нескольких полисов",
      "amount": "Сумма не читается",
      "date": "Дата не читается",
      "future": "Дата платежа в будущем"
    }
  },
  "schedule": {
    "title": "Новый полис из PDF спецификации",
    "intro": "Выберите спецификацию полиса от страховщика. Она читается на этом устройстве; проверьте и исправьте каждое значение — ничего не сохраняется, пока вы не нажмёте «Сохранить». Номера документов и банковские реквизиты никогда не считываются.",
    "choose": "Выбрать PDF",
    "reading": "Чтение…",
    "from_line": "Из: «{line}» (стр. {page})",
    "not_found": "В спецификации не найдено — введите, если знаете",
    "alternatives": "также найдено: {list}",
    "premium_is": "Указанный выше взнос — это",
    "basis": {
      "instalment": "платёж по периодичности",
      "annual": "годовая сумма"
    },
    "keep_pdf": "Сохранить PDF в документах клиента со ссылкой на полис",
    "duplicate_warn": "Полис с таким номером уже существует ({product}). Отметьте, чтобы всё равно сохранить ещё один.",
    "note": "Значения из документа — лишь подсказки: приоритет у спецификации и записей страховщика.",
    "save": "Сохранить полис",
    "saved": "Полис сохранён по спецификации",
    "doc_title": "Спецификация полиса {number}",
    "vault_hint": "Похоже на спецификацию полиса — создайте по ней полис, сначала проверив значения.",
    "k": {
      "insurer": "Страховщик",
      "policyNumber": "Номер полиса",
      "insuredName": "Застрахованное лицо",
      "product": "Продукт / вид",
      "startDate": "Дата начала",
      "endDate": "Дата окончания",
      "renewalDate": "Дата продления",
      "premium": "Взнос",
      "frequency": "Периодичность оплаты",
      "sumInsured": "Страховая сумма"
    },
    "warn": {
      "no_text": "Текст не найден (сканированное изображение). Введите значения вручную.",
      "no_number": "Номер полиса не найден — проверьте спецификацию.",
      "no_premium": "Взнос не найден — введите его (он нужен для сохранения).",
      "dates": "Дата окончания раньше даты начала — проверьте обе.",
      "insurer_from_heading": "Страховщик взят из заголовка страницы — подтвердите его.",
      "holder_as_insured": "Нет пометки «застрахованный»: показано имя страхователя — измените, если застрахован другой человек."
    }
  },
  "recon": {
    "title": "Сверка выписки по комиссиям",
    "open": "Сверить выписку",
    "intro": "Загрузите выписку страховщика по комиссиям (CSV или Excel, либо вставьте её) и выберите столбцы. Она сравнивается с комиссией, которую CRM ожидает по вашим продажам; ничего не меняется, пока вы не примете строку.",
    "file": "Выбрать файл выписки",
    "paste": "…или вставьте строки сюда (со строкой заголовков)",
    "unreadable": "Не удалось прочитать файл. Сохраните его как CSV или .xlsx и попробуйте снова.",
    "map_all": "Выберите три столбца: номер полиса, сумма и период.",
    "again": "Другая выписка",
    "ref": "Номер выписки",
    "ref_hint": "Сохраняется с каждой принятой строкой, напр. «Eurolife 09/2026»",
    "insurer": "Страховщик (необязательно)",
    "insurer_hint": "Как недостающие показываются только полисы этого страховщика",
    "field": {
      "policyNumber": "Номер полиса",
      "amount": "Сумма комиссии",
      "period": "Период"
    },
    "status": {
      "matched": "Совпадает",
      "different": "Другая сумма",
      "missing": "Нет в выписке (ожидалось, не выплачено)",
      "unexpected": "Неожиданные (выплачено, не ожидалось)"
    },
    "reason": {
      "no_policy": "нет полиса с таким номером",
      "ambiguous": "этот номер у нескольких полисов",
      "no_entry": "нет ожидаемой комиссии за этот период"
    },
    "problem": {
      "no_number": "Нет номера полиса",
      "amount": "Сумма не читается",
      "period": "Период не читается"
    },
    "invalid": "Строки, которые не удалось прочитать",
    "col": {
      "expected": "Ожидается",
      "paid": "Выплачено",
      "difference": "Разница"
    },
    "summary": "Периоды {periods}: ожидается {expected} · по выписке {paid} · разница {difference}",
    "accept": "Принять строку",
    "accept_n": "Принять {count, plural, one {# строку} few {# строки} many {# строк} other {# строки}}",
    "accepted": "принята",
    "accepted_done": "{count, plural, one {Записана # строка выписки} few {Записано # строки выписки} many {Записано # строк выписки} other {Записано # строки выписки}}",
    "paid_date": "Дата выплаты",
    "export": "Экспорт CSV",
    "print": "Печать",
    "note": "При принятии сумма из выписки записывается как выплаченная в ожидаемой строке (ожидаемая сумма сохраняется, поэтому разница остаётся видна); строка без ожидаемой комиссии записывается как выплаченная корректировка. Недостающие строки остаются открытыми."
  },
  "morning": {
    "title": "Утреннее письмо «Мой день»",
    "intro": "Каждый рабочий день платформа присылает вам день одним взглядом: встречи, звонки и напоминания на сегодня или просроченные, продления в ближайшие 30 дней, дни рождения и открытые просрочки взносов — со ссылкой на лист дня.",
    "enabled": "Присылать утреннее письмо по рабочим дням",
    "time": "Время",
    "time_hint": "Время Кипра (по умолчанию 07:30)",
    "to": "Отправлять на",
    "to_hint": "Пусто = e-mail вашей учётной записи ({email})",
    "to_invalid": "Похоже, адрес e-mail неверный — ничего не изменено.",
    "lang": "Язык письма",
    "skip_holidays": "Не отправлять в государственные праздники Кипра",
    "next": "Следующее письмо: {date} в {time}",
    "no_next": "В ближайшие две недели нет рабочих дней.",
    "off": "Выключено — ничего не отправляется.",
    "privacy": "В письме только количества, имена и время — без фамилий, телефонов, сумм, полисов, сведений о здоровье и финансах. Лист дня открывается в приложении после входа. Платформа составляет письмо по данным, которые синхронизируют ваши устройства; если устройство не синхронизировалось со вчерашнего дня, будет показана вчерашняя картина.",
    "need_account": "Утреннее письмо отправляет платформа AVRASTRO: войдите в учётную запись («Система → Учётная запись») и не отключайте синхронизацию.",
    "test": "Отправить тестовое письмо сейчас",
    "test_sent": "Тестовое письмо отправлено на {to}",
    "test_failed": "Не удалось отправить тестовое письмо ({code}). Убедитесь, что это устройство синхронизировало настройку."
  },
  "nps": {
    "title": "Отзывы клиентов",
    "subtitle": "Один вопрос, 0–10. Готовится здесь, отправляете вы.",
    "ask": "Попросить отзыв",
    "need_account": "Страницу опроса обслуживает платформа AVRASTRO: сначала войдите в учётную запись («Система → Учётная запись»).",
    "prepared": "Опрос подготовлен — проверьте сообщение и отправьте его сами",
    "prepared_chip": "Отзыв запрошен",
    "answered_chip": "Оценка {score}/10",
    "resend": "Сообщение",
    "withdraw": "Отозвать",
    "withdrawn": "Опрос отозван — ссылка больше не работает",
    "empty": "Отзывов пока не запрашивали. После встречи или закрытого страхового случая «Попросить отзыв» подготовит короткое сообщение со ссылкой.",
    "status": {
      "prepared": "Запрошен — ждём ответа",
      "answered": "Получен ответ",
      "withdrawn": "Отозван"
    },
    "trigger": {
      "meeting": "после встречи",
      "claim": "после страхового случая",
      "manual": "по вашей инициативе"
    },
    "category": {
      "promoter": "Промоутер (9–10)",
      "passive": "Нейтрал (7–8)",
      "detractor": "Критик (0–6)"
    },
    "review": "Попросить отзыв в Google",
    "review_again": "Отзыв в Google (повторно)",
    "review_no_link": "Укажите ссылку на отзывы Google в настройках",
    "callback": "Задача перезвонить",
    "callback_title": "Перезвонить — оценка {score}/10",
    "chart_title": "Отзывы клиентов (NPS)",
    "score_12m": "NPS за последние 12 месяцев",
    "answers": "Ответы",
    "response_rate": "ответили {pct}%",
    "no_answers": "нет ответов",
    "chart_alt": "NPS по месяцам: {list}",
    "chart_note": "NPS = % оценок 9–10 минус % оценок 0–6. Столбцы выше средней линии — положительные; месяцы без ответов показаны как —.",
    "review_url": "Ссылка на отзывы Google",
    "review_url_hint": "Из профиля компании в Google → «Попросить отзывы». Используется как «Оставить отзыв» в шаблонах сообщений (review.link) и в черновике после оценки 9 или 10.",
    "review_url_invalid": "Ссылка должна начинаться с https:// — ничего не изменено."
  },
  "card": {
    "title": "Новый контакт с визитки",
    "photo": "Сфотографируйте или выберите фото визитки",
    "photo_alt": "Визитка",
    "reading": "Чтение визитки…",
    "read_device": "Прочитано на этом устройстве — проверьте каждое поле.",
    "read_platform": "Прочитано службой распознавания текста — проверьте каждое поле.",
    "read_failed": "Не удалось прочитать визитку. Вставьте или введите её текст ниже.",
    "no_ocr": "Этот браузер не умеет читать текст с фото. Вставьте или введите текст визитки ниже (на телефоне: долгое нажатие на фото → «Копировать текст»).",
    "too_large": "Фото больше 5 МБ — выберите поменьше.",
    "text": "Текст визитки",
    "text_hint": "Лучше всего по одному элементу в строке.",
    "read": "Заполнить поля",
    "review": "Проверьте перед сохранением",
    "empty": "Сфотографируйте визитку или вставьте её текст: поля появятся здесь для проверки.",
    "rest": "Не использовано: {lines}",
    "source_note": "Сохраняется как новый контакт с источником «Личное знакомство». Телефон офиса, сайт и адрес попадают в примечания.",
    "privacy": "Ничего не сохраняется, пока вы не нажмёте «Сохранить». Фото остаётся на этом устройстве; только если на вашей платформе включена служба распознавания текста, оно отправляется туда для чтения и не хранится.",
    "note_from": "С визитки ({date})",
    "field": {
      "firstName": "Имя",
      "lastName": "Фамилия",
      "mobile": "Мобильный",
      "phone": "Телефон офиса",
      "email": "E-mail",
      "company": "Компания",
      "jobTitle": "Должность",
      "website": "Сайт",
      "address": "Адрес"
    }
  },
  "kyc": {
    "title": "Файл KYC / AML",
    "subtitle": "Контрольный список «знай своего клиента» для страхования жизни",
    "saved": "Файл KYC сохранён",
    "task_title": "Пересмотр KYC/AML: {name}",
    "status": {
      "complete": "Заполнен",
      "incomplete": "Неполный",
      "none": "Не начат"
    },
    "missing": "Не хватает: {list}",
    "miss": {
      "id_document": "удостоверения личности в хранилище",
      "id_expired": "удостоверение личности просрочено",
      "beneficiaries": "выгодоприобретателей",
      "pep": "ответа о PEP",
      "source_of_funds": "источника средств",
      "checked": "даты проверки",
      "next_review": "даты следующего пересмотра",
      "review_overdue": "дата пересмотра прошла"
    },
    "review_on": "Следующий пересмотр: {date} (через {days} дн.)",
    "review_overdue": "Пересмотр был назначен на {date} ({days} дн. назад)",
    "amlr_before": "Регламент ЕС о противодействии отмыванию денег (ЕС) 2024/1624 применяется с {date} (через {days} дн.). До этого действуют кипрский закон о ПОД и формы страховщика.",
    "amlr_after": "Регламент ЕС о противодействии отмыванию денег (ЕС) 2024/1624 применяется с {date}.",
    "id_document": "Удостоверение личности (в хранилище)",
    "id_document_hint": "Загрузите удостоверение личности или паспорт в хранилище (категория «Удостоверение личности») и выберите его здесь. Его номер остаётся только в документе.",
    "id_none": "— нет в деле —",
    "upload_id": "Загрузить в хранилище",
    "id_expiry": "Документ действует до",
    "risk": "Риск",
    "risk_level": {
      "low": "Низкий",
      "standard": "Стандартный",
      "high": "Высокий"
    },
    "pep": "Политически значимое лицо (или близкий родственник / партнёр)?",
    "pep_hint": "Публичная должность сейчас или в последние 12 месяцев либо близкий родственник или партнёр такого лица.",
    "pep_answer": {
      "no": "Нет",
      "yes": "Да",
      "unknown": "Ещё не спрашивали"
    },
    "pep_note": "Какая должность / связь",
    "funds": "Источник средств",
    "fund": {
      "salary": "Зарплата",
      "business": "Доход от бизнеса",
      "savings": "Сбережения",
      "inheritance": "Наследство",
      "property_sale": "Продажа недвижимости",
      "investments": "Инвестиции",
      "pension": "Пенсия",
      "gift": "Дарение",
      "other": "Другое"
    },
    "funds_note": "Подробности (необязательно)",
    "beneficiaries": "Выгодоприобретатели",
    "ben_name": "Имя",
    "ben_relationship": "Кем приходится",
    "ben_add": "Добавить выгодоприобретателя",
    "checked_at": "Проверено",
    "next_review": "Следующий пересмотр",
    "next_review_hint": "Пусто = от даты проверки: высокий риск — 1 год, стандартный — 3 года, низкий — 5 лет.",
    "no_id_numbers": "Похоже, в поле указан номер удостоверения, паспорта, налоговый или банковский номер. Удалите его — такие номера хранятся только в документе в хранилище.",
    "privacy": "Храните только то, что требует контрольный список. Номера документов здесь никогда не вводятся; сам документ находится в зашифрованном хранилище, а доступ к документам с ограниченным доступом записывается в журнал."
  },
  "creport": {
    "title": "Страховые случаи и изменения от клиентов",
    "subtitle": "Сообщения ваших клиентов через портал на сайте",
    "empty": "Сообщений пока нет. Клиенты, разрешившие портал, могут сообщить о страховом случае или запросить изменение со своей страницы на сайте.",
    "unavailable": "Не удалось загрузить сообщения (офлайн или сайт не связан).",
    "new": "Новые",
    "accept": "Принять в CRM",
    "accepted": "Сообщение принято — создан страховой случай / запрос с напоминанием на сегодня",
    "decline": "Отклонить",
    "declined": "Отклонено — клиент видит, что вы с ним свяжетесь",
    "declined_chip": "Отклонено",
    "matched": "Сопоставлено по e-mail или телефону: {name}",
    "event_date": "Дата события",
    "policy_ref": "Указанный номер полиса",
    "files": "{count, plural, one {# файл} few {# файла} many {# файлов} other {# файла}}",
    "file_failed": "Не удалось сохранить файл {name} — откройте сообщение позже ещё раз.",
    "docs_asked": "Клиенту было показано",
    "task_title": "Сообщение клиента: {title}",
    "insurer_note": "Официальное заявление о страховом случае или изменении подаётся страховщику так, как он требует (на его форме, через его портал или по e-mail, с оригиналами документов, в сроки по полису). Клиенту сообщается то же самое.",
    "kind": {
      "car_accident": "ДТП",
      "home_damage": "Ущерб жилью",
      "hospital": "Госпитализация",
      "death": "Смерть родственника",
      "theft": "Кража",
      "change": "Запрос на изменение"
    },
    "stage": {
      "sent": "Отправлено",
      "received": "Получено",
      "documents_needed": "Нужны документы",
      "in_progress": "В работе",
      "with_insurer": "У страховщика",
      "approved": "Одобрено",
      "paid": "Выплачено",
      "declined": "Отклонено страховщиком",
      "closed": "Закрыто"
    },
    "doc": {
      "accident_form": "Извещение о ДТП",
      "photos_damage": "Фото повреждений",
      "photos_scene": "Фото места происшествия",
      "driving_licence": "Водительские права",
      "police_report": "Полицейский протокол",
      "repair_estimate": "Смета ремонта",
      "other_party": "Данные другой стороны",
      "description": "Описание",
      "invoices": "Счета / квитанции",
      "police_report_if_any": "Полицейский протокол (если есть)",
      "discharge_summary": "Выписка из больницы",
      "hospital_invoices": "Счета больницы",
      "medical_reports": "Медицинские заключения",
      "claim_form_insurer": "Форма заявления страховщика",
      "death_certificate": "Свидетельство о смерти",
      "policy_document": "Полис",
      "beneficiary_id": "Удостоверение личности выгодоприобретателя",
      "medical_cause": "Медицинская справка о причине смерти",
      "bank_details_beneficiary": "Банковские реквизиты выгодоприобретателя",
      "list_of_items": "Список похищенного",
      "proof_of_ownership": "Подтверждение права собственности",
      "request_details": "Что нужно изменить",
      "supporting_document": "Подтверждающий документ"
    }
  },
  "passkey": {
    "title": "Passkey (Face ID, Touch ID, отпечаток пальца)",
    "intro": "Входите по лицу или отпечатку пальца вместо пароля. Биометрия остаётся на вашем устройстве; AVRASTRO проверяет только подпись. Passkey также считается вторым этапом входа.",
    "add": "Добавить passkey на этом устройстве",
    "added": "Passkey добавлен. В следующий раз выберите «Войти с passkey».",
    "removed": "Passkey удалён.",
    "remove": "Удалить",
    "remove_confirm": "Удалить passkey «{name}»? Тогда на этом устройстве снова нужно будет входить с паролем.",
    "unnamed": "Passkey",
    "created": "добавлен {date}",
    "last_used": "последнее использование {date}",
    "none": "Passkey пока нет.",
    "unsupported": "Чтобы добавить passkey, откройте AVRASTRO в браузере (app.avrastro.com) на телефоне или компьютере.",
    "sign_in": "Войти с passkey",
    "cancelled": "Passkey не использован (отменено или недоступно на этом устройстве)."
  },
  "push": {
    "help": {
      "retry": "Всё ещё ничего: «Выключить» для устройства, обновить страницу, снова «Включить» и «Отправить тест». История показывает, было ли уведомление отправлено.",
      "closed": "При закрытом браузере: Chrome / Edge показывают их, пока браузер работает в фоне; на телефоне они приходят и при закрытом приложении.",
      "private": "Приватное окно или заблокированные данные сайтов: там уведомления не работают.",
      "ios": "iPhone / iPad: только из значка AVRASTRO на экране «Домой» (Safari → Поделиться → На экран «Домой»), iOS 16.4 или новее.",
      "focus": "Режим «Не беспокоить» / «Фокусирование» скрывает уведомления — проверьте его.",
      "os": "Система: Mac → Системные настройки → Уведомления → (ваш браузер) → Разрешить. Windows → Параметры → Система → Уведомления → (ваш браузер) вкл.",
      "allow": "Браузер: значок замка рядом с адресом → Уведомления → Разрешить. Затем обновите страницу.",
      "title": "Уведомления не приходят? Пошаговая проверка"
    },
    "status": {
      "queued": "ожидает (тихие часы)",
      "failed": "не доставлено",
      "sent": "отправлено"
    },
    "history_empty": "Уведомления ещё не отправлялись.",
    "history": "История уведомлений",
    "time_zone": "Время устройства: {tz}",
    "quiet_hint": "В тихие часы ничего не показывается; то, что пришло с сайта, появится сразу после их окончания.",
    "quiet_to": "до",
    "quiet_from": "с",
    "quiet": "Тихие часы",
    "failing": "неудачных доставок: {n}",
    "error": {
      "unsupported": "Этот браузер не поддерживает уведомления. Используйте Chrome, Edge, Firefox или Safari.",
      "subscribe_timeout": "Служба уведомлений браузера не ответила. Проверьте соединение и попробуйте ещё раз чуть позже.",
      "subscribe_failed": "Служба уведомлений браузера (Google, Apple, Mozilla или Microsoft) не приняла регистрацию. Проверьте соединение и что браузеру разрешены уведомления в системе, затем попробуйте снова.",
      "sw_timeout": "Фоновая служба AVRASTRO не запустилась вовремя. Обновите страницу (один раз) и снова нажмите «Включить».",
      "sw_failed": "Браузер не позволил AVRASTRO установить фоновую службу (service worker), нужную для уведомлений. В приватном окне или при заблокированных данных сайтов это запрещено — откройте app.avrastro.com в обычном окне.",
      "dismissed": "Окно разрешения закрыто без ответа. Нажмите «Включить» ещё раз и выберите «Разрешить».",
      "denied": "Браузер не разрешил уведомления для AVRASTRO. Разрешите их через значок замка рядом с адресом (Настройки сайта → Уведомления → Разрешить) и попробуйте снова."
    },
    "not_configured_here": "Сервер AVRASTRO, к которому вы подключены, не отправляет уведомления (не настроен). На app.avrastro.com они работают.",
    "state": {
      "desktop": "Приложение для компьютера",
      "server": "Недоступны на этом сервере",
      "blocked": "Здесь недоступны",
      "off": "Не включены на этом устройстве",
      "on": "Включены на этом устройстве"
    },
    "turning_on": "Включение…",
    "on_no_test": "Уведомления включены, но тестовое ещё не доставлено. Нажмите «Отправить тест» чуть позже.",
    "title": "Уведомления на этом устройстве",
    "intro": "Уведомление на телефоне или компьютере, когда с сайта приходит запись или сообщение, и перед вашими встречами. Выключено, пока вы не включите здесь; у каждого устройства свои настройки.",
    "on": "Включить уведомления на этом устройстве",
    "on_done": "Уведомления включены. На это устройство отправлено тестовое уведомление.",
    "off": "Выключить",
    "off_confirm": "Отключить уведомления на «{device}»?",
    "device": "Устройство",
    "denied": "Браузер не разрешил уведомления. Разрешите их в настройках сайта в браузере и попробуйте снова.",
    "test": "Отправить тест",
    "test_sent": "Тестовое уведомление отправлено.",
    "test_failed": "Не удалось доставить тестовое уведомление. Выключите и снова включите уведомления на том устройстве.",
    "last_ok": "последняя доставка {when}",
    "minutes_before": "Напоминать",
    "minutes": "за {n} мин",
    "pref": {
      "renewals": "Продления полисов",
      "tasks": "Задачи / follow-up на день",
      "bookings": "Записи с сайта",
      "messages": "Сообщения с сайта",
      "appointments": "Перед встречами",
      "details": "Показывать подробности на экране блокировки"
    },
    "support": {
      "insecure": "Для уведомлений нужно защищённое соединение (https). Откройте AVRASTRO по адресу https://app.avrastro.com.",
      "desktop_app": "Приложение для компьютера не получает веб-уведомления (Web Push). Пока оно открыто, оно показывает собственные системные уведомления — включите их в Настройках. Чтобы получать уведомления, когда оно закрыто, включите их на app.avrastro.com в браузере или на телефоне.",
      "unsupported": "Это приложение или браузер не может получать уведомления. Используйте AVRASTRO в Chrome, Edge, Firefox или Safari на app.avrastro.com.",
      "ios_home_screen": "На iPhone и iPad: откройте app.avrastro.com в Safari, «Поделиться» → «На экран „Домой“», откройте AVRASTRO с экрана «Домой» и включите уведомления здесь.",
      "denied": "Уведомления AVRASTRO заблокированы в этом браузере. Разрешите их в настройках сайта и перезагрузите страницу."
    },
    "note": "По умолчанию на экране блокировки видно только «Новый запрос на встречу» или «Встреча через 30 минут» — без имён клиентов. Уведомление передаётся в зашифрованном виде через push-службу вашего браузера (Apple, Google, Mozilla или Microsoft)."
  },
  "esign": {
    "send": "Отправить на подпись",
    "send_title": "Отправить на подпись — {name}",
    "kind_label": "Документ",
    "kind": {
      "needs": "Заявление о потребностях",
      "consent": "Согласие GDPR",
      "proposal": "Сводка предложения",
      "other": "Другой документ"
    },
    "lang": "Язык документа",
    "title_label": "Название",
    "extra_text": "Дополнительный текст (необязательно)",
    "extra_hint": "Печатается в конце документа, перед подписью.",
    "email": "E-mail клиента",
    "email_hint": "Сюда отправляются ссылка и 6-значный код подтверждения.",
    "days": "Ссылка действует",
    "days_n": "{n, plural, one {# день} few {# дня} many {# дней} other {# дня}}",
    "legal": "Простая электронная подпись (eIDAS, Регламент (ЕС) 910/2014, ст. 3(10)): клиент читает PDF, подтверждает кодом, отправленным на его e-mail, и подписывает пальцем или мышью; добавляется страница аудита (время, хеш IP, браузер, канал кода, SHA-256 документа). Если страховщик требует собственную форму или подпись, приоритет у них.",
    "sent_title": "Отправлено на подпись",
    "sent_emailed": "Ссылка отправлена на {email}. Вы также можете отправить её сами (например, в WhatsApp):",
    "sent_link": "Отправьте клиенту эту ссылку:",
    "list_title": "Электронные подписи",
    "none": "На подпись пока ничего не отправлялось.",
    "status": {
      "sent": "отправлено",
      "opened": "открыто",
      "signed": "подписано",
      "cancelled": "отменено",
      "expired": "истекло"
    },
    "sent_on": "отправлено {date}",
    "signed_on": "подписано {date}",
    "until": "действует до {date}",
    "collect": "Добавить в документы",
    "cancel": "Отменить",
    "collected": "{n, plural, =1 {Подписанный документ добавлен} one {# подписанный документ добавлен} few {# подписанных документа добавлены} many {# подписанных документов добавлены} other {# подписанного документа добавлены}} в документы клиента.",
    "err": {
      "esign_no_channel": "Добавьте e-mail клиента: на него отправляется код подтверждения.",
      "esign_missing": "Нужны название и имя клиента.",
      "esign_empty": "В документе нет содержимого.",
      "esign_not_configured": "Электронные подписи на этом сервере недоступны.",
      "email_invalid": "Похоже, адрес e-mail неверный."
    },
    "doc": {
      "client": "Клиент",
      "name": "Имя и фамилия",
      "needs": "Заявление о потребностях",
      "no_needs": "Анализ потребностей пока не записан.",
      "analysis_date": "Анализ потребностей",
      "consent": "Согласие на обработку персональных данных (GDPR)",
      "proposal": "Сводка предложения",
      "no_quotes": "Котировки пока не записаны."
    },
    "needs": {
      "declaration": "Подтверждаю, что приведённые выше сведения о моём положении и потребностях, насколько мне известно, точны и полны и были обсуждены с моим консультантом."
    },
    "proposal": {
      "declaration": "Подтверждаю, что получил(а) и понял(а) эту сводку предложения. Она не является договором страхования: действуют документы, условия и решение о принятии на страхование самого страховщика."
    },
    "consent": {
      "controller": "Контролёр: мой страховой консультант, указанный в начале этого документа, который ведёт дело клиента в AVRASTRO CRM.",
      "purposes": "Цели: консультирование и посредничество в страховании, подготовка котировок и заявок, обслуживание и пересмотр моих полисов и поддержание связи по ним.",
      "data": "Данные: идентификационные и контактные данные, сведения о семье и финансах, которые я предоставляю, и — только когда это необходимо для заявки — сведения о здоровье, на обработку которых я даю явное согласие (GDPR, ст. 9(2)(a)).",
      "recipients": "Получатели: страховщики, в которые я решу обратиться, и поставщики услуг, которыми консультант пользуется для CRM, на основании договора и законодательства ЕС о защите данных.",
      "retention": "Срок хранения: пока я являюсь клиентом, а после — только столько, сколько требует закон.",
      "rights": "Мои права: доступ, исправление, удаление, ограничение, переносимость и возражение, а также жалоба Уполномоченному по защите персональных данных (Кипр).",
      "withdraw": "Я могу в любое время отозвать это согласие, сообщив своему консультанту; это не влияет на уже выполненную обработку.",
      "declaration": "Я ознакомился(-ась) с изложенным выше и даю своё согласие."
    }
  },
  "vcall": {
    "location": "AVRASTRO Video",
    "mode": "Встреча",
    "mode_physical": "Лично",
    "mode_video": "Видеозвонок",
    "create_room": "Создать комнату AVRASTRO Video (защищённая ссылка для этой встречи, с залом ожидания)",
    "addon_needed": "AVRASTRO Video — дополнение, не активное в вашей подписке. Можно вставить свою ссылку на видео в поле «Место».",
    "own_link": "Вставьте свою ссылку на видео (Zoom, Teams, Meet…) в поле «Место».",
    "guest_link": "Ссылка для клиента",
    "link_note": "Открывается за 15 минут до начала ({from}); клиент ждёт, пока вы его не впустите. Без записи.",
    "key_link": "Ключ шифрования (конфиденциальный звонок)",
    "key_note": "Ссылка клиента не содержит ключ — как и письмо, календарь или сайт. Отправьте эту ссылку-ключ отдельно (SMS, телефон), никогда в том же сообщении.",
    "open_panel": "Видеозвонок",
    "panel_title": "Видеозвонок",
    "guest_waiting": "{name} в зале ожидания",
    "privacy_note": "Звонок идёт в отдельном окне. Ничего из CRM не показывается, если вы сами не выберете «Общий вид» или не покажете окно.",
    "open_call": "Открыть окно звонка",
    "open_here": "Открыть в этой панели",
    "call_frame": "Видеозвонок",
    "lobby": "Зал ожидания",
    "lobby_empty": "Никто не ждёт.",
    "admit": "Впустить",
    "deny": "Отклонить",
    "in_call": "В звонке: {names}",
    "lock": "Закрыть комнату",
    "unlock": "Открыть комнату",
    "end_all": "Завершить для всех",
    "revoke": "Новая ссылка (старая перестанет работать)",
    "shared_title": "Общий вид",
    "shared_note": "Клиент видит только эту безопасную сводку шага встречи — без комиссий, личных заметок и других клиентов.",
    "shared_step": "Шаг встречи",
    "shared_preview": "Что видит клиент",
    "share_on": "Показать клиенту",
    "share_off": "Скрыть",
    "shared_on": "Клиент теперь видит Общий вид.",
    "shared_off": "Общий вид скрыт.",
    "chat_title": "Ссылки в чате звонка",
    "chat_esign_btn": "Отправить на подпись",
    "chat_esign": "Документ на подпись",
    "chat_portal_btn": "Ссылка на портал клиента",
    "chat_portal": "Ваши документы на портале клиента",
    "chat_posted": "Ссылка отправлена в чат звонка.",
    "notes_title": "Заметки и следующие шаги",
    "notes_ph": "Заметки этой встречи (личные, клиенту не показываются)",
    "notes_private": "Сохраняются во встрече этого клиента, связанной с записью.",
    "follow_ph": "Следующий шаг",
    "follow_by": "Кто",
    "by_advisor": "Я",
    "by_client": "Клиент",
    "follow_add": "Добавить следующий шаг",
    "notes_save": "Сохранить заметки",
    "meeting_finish": "Завершить встречу",
    "meeting_purpose": "Видеоконсультация",
    "notes_saved": "Заметки сохранены во встрече.",
    "meeting_saved": "Встреча сохранена; следующие шаги в календаре.",
    "usage": "В этом месяце: {minutes} из {limit} минут участников (честное использование)",
    "usage_warn": "больше 80% — без доплаты",
    "no_recording": "AVRASTRO Video не записывает, не расшифровывает и не резюмирует звонки.",
    "ics_note": "Видеозвонок AVRASTRO — открывается в браузере:",
    "call_notes": "Заметки из окна звонка",
    "call_notes_saved": "Сохранены во встрече этого клиента (клиент никогда не видит заметки).",
    "elsewhere_h": "Откройте звонок в Safari или Chrome",
    "elsewhere_p": "Это окно не может использовать камеру и микрофон (например, браузер, встроенный в другое приложение). Скопируйте ссылку организатора и откройте её в Safari или Chrome.",
    "elsewhere_open": "Открыть в браузере",
    "elsewhere_once": "Ссылка организатора действует один раз, 2 минуты. Если она истекла, снова нажмите «Открыть окно звонка».",
    "feedback_title": "Оценка клиента",
    "feedback_stars": "{n} из 5 звёзд",
    "status": {
      "scheduled": "запланирован",
      "open": "открыт",
      "expired": "ссылка истекла",
      "ended": "завершён",
      "cancelled": "отменён"
    },
    "err": {
      "generic": "Видеосервис ответил: {code}",
      "video_not_entitled": "AVRASTRO Video не входит в вашу подписку (дополнение).",
      "video_not_configured": "AVRASTRO Video ещё не настроен на этом сервере.",
      "video_too_early": "Звонок открывается за час до встречи.",
      "video_not_open": "Звонок не открыт (завершён или истёк).",
      "video_room_full": "В звонке нет мест (не более 4 человек).",
      "video_guest_state": "Этот человек больше не ждёт.",
      "video_link_origin": "Можно отправлять только ссылки на подпись и портал клиента.",
      "network": "Нет связи с платформой AVRASTRO.",
      "rate_limited": "Слишком много попыток — подождите минуту."
    },
    "alert_waiting_title": "{names} ждёт вас в видеозвонке",
    "alert_soon_title": "Видеозвонок через {minutes} мин.",
    "alert_join": "Войти сейчас",
    "alert_waiting_tab": "Вас ждут",
    "alert_enable_notifications": "Уведомлять и в другой вкладке: включить",
    "popup_blocked": "Браузер заблокировал новое окно — нажмите «Открыть окно звонка» на панели."
  },
  "newsletter": {
    "audience": "Аудитория: подписчики рассылки",
    "audience_name": "Подписчики рассылки",
    "need_account": "Войдите в учётную запись AVRASTRO («Система → Учётная запись»), чтобы видеть подписчиков и отправлять рассылку.",
    "unavailable": "Подписчики сейчас недоступны ({code}).",
    "active": "Подтверждённые подписчики",
    "langs": "Язык",
    "list": {
      "monthly": "Ежемесячная рассылка",
      "alerts": "Уведомления об изменениях"
    },
    "privacy_note": "Только люди, подтвердившие подписку на avrastro.com (двойное подтверждение). Адреса хранятся на платформе в зашифрованном виде; здесь видны только количества. В каждом письме есть ссылка для отписки в один клик.",
    "new": {
      "monthly": "Новая ежемесячная рассылка",
      "alerts": "Новое уведомление об изменении"
    },
    "new_title": {
      "monthly": "Ежемесячная рассылка",
      "alerts": "Уведомление об изменении"
    },
    "body_start_el": "Γεια σας {name},\n\n",
    "body_start_en": "Hello {name},\n\n",
    "drafts": "Черновики уведомлений ждут одобрения",
    "drafts_hint": "Подготовлены, потому что на avrastro.com обновился гид. Они никогда не отправляются автоматически: откройте, проверьте и отправьте или отклоните.",
    "open_draft": "Открыть для проверки",
    "dismiss": "Отклонить",
    "dismissed": "Черновик отклонён.",
    "empty": "Рассылок пока нет. Начните с кнопок выше.",
    "language": "Язык текста",
    "body": "Текст",
    "body_hint": "{name} заменяется именем подписчика (или опускается). Каждый подписчик получает письмо на выбранном им языке.",
    "footer_note": "Каждое письмо автоматически заканчивается фразой «AVRASTRO не является страховой компанией» и персональной ссылкой для отписки.",
    "problem": {
      "subject_el": "нет темы на греческом",
      "subject_en": "нет темы на английском",
      "body_el": "текст на греческом слишком короткий",
      "body_en": "текст на английском слишком короткий",
      "asks_for_data": "в тексте запрашиваются персональные данные — уберите это"
    },
    "send_test": "Отправить тест себе",
    "send_list": "Отправить подписчикам",
    "test_first": "Сначала отправьте тест себе.",
    "confirm_send": "Отправить сейчас подписчикам ({n})? Это действие нельзя отменить.",
    "test_sent": "Тест отправлен на {to}.",
    "sent": "Отправлено подписчикам: {n} (с ошибкой: {failed}).",
    "send_failed": "Отправка не удалась ({code}).",
    "history": "Отправки",
    "test": "тест",
    "sent_line": "отправлено {n} · с ошибкой {failed}"
  },
  "whatsapp": {
    "title": "WhatsApp Business",
    "intro": "Напоминания о встречах, поздравления с днём рождения и уведомления о продлении с вашего номера WhatsApp Business по шаблонам, одобренным Meta. Только клиентам, давшим согласие на WhatsApp, и только когда вы нажимаете «Отправить в WhatsApp» или включаете соответствующую автоматизацию.",
    "need_account": "Войдите в учётную запись AVRASTRO, чтобы подключить номер WhatsApp.",
    "admin_only": "Подключить номер WhatsApp может только администратор офиса.",
    "connected": "Подключено: {number} ({name}).",
    "webhook": "Вебхук Meta (callback URL): {url} · verify token: {token} · поле: messages",
    "disconnect": "Отключить номер",
    "phone_id": "Phone number ID",
    "phone_id_hint": "Meta → WhatsApp → API setup",
    "app_secret": "App secret",
    "app_secret_hint": "Приложение Meta → Settings → Basic",
    "token": "Постоянный access token",
    "token_hint": "Токен системного пользователя с правом whatsapp_business_messaging; отправляется на платформу один раз и хранится там в зашифрованном виде, в CRM не сохраняется.",
    "connect": "Подключить номер",
    "connected_ok": "Номер WhatsApp подключён.",
    "connect_failed": "Не подключено ({code}). Проверьте токен, Phone number ID и App secret.",
    "enabled": "Использовать WhatsApp Business для клиентов с согласием на WhatsApp",
    "lang": "Язык",
    "auto": "Отправлять автоматически",
    "bad_name": "Название шаблона состоит только из строчных латинских букв, цифр и _ (как в Meta).",
    "reminder_hours": "Автоматическое напоминание: за сколько часов до встречи",
    "renewal_days": "Автоматическое уведомление о продлении: за сколько дней до продления",
    "privacy": "Из CRM уходят только параметры шаблона (имя, дата, время, название продукта) — никогда суммы, номера полисов или сведения о здоровье. Автоматические сообщения отправляются с 09:00 до 20:00, один раз на клиента и повод. Meta взимает плату за каждый диалог.",
    "send": "Отправить в WhatsApp",
    "send_title": "Отправить в WhatsApp",
    "what": "Сообщение",
    "which_appointment": "Встреча",
    "preview": "Шаблон {template} с параметрами: {params}",
    "send_note": "Отправляется с вашего номера WhatsApp Business по одобренному шаблону; доставка отображается в истории клиента.",
    "sent": "Отправлено в WhatsApp.",
    "send_failed": "WhatsApp не принял сообщение — см. историю клиента.",
    "send_error": "Не отправлено ({code}).",
    "use": {
      "appointment_reminder": "Напоминание о встрече",
      "birthday": "Поздравление с днём рождения",
      "renewal_notice": "Уведомление о продлении"
    },
    "params": {
      "appointment_reminder": "Одобренный шаблон с параметрами: (1) имя, (2) дата, (3) время",
      "birthday": "Одобренный шаблон с параметром: (1) имя",
      "renewal_notice": "Одобренный шаблон с параметрами: (1) имя, (2) продукт, (3) дата продления"
    },
    "block": {
      "off": "WhatsApp Business выключен (настройки).",
      "no_template": "Для этого сообщения не задан одобренный шаблон (настройки).",
      "no_consent": "Для этого клиента не записано согласие на WhatsApp («Комплаенс» → согласие «WhatsApp»).",
      "consent_withdrawn": "Клиент отозвал согласие на WhatsApp.",
      "no_number": "У этого клиента нет мобильного номера.",
      "archived": "Клиент в архиве.",
      "do_not_contact": "Клиент просил с ним не связываться.",
      "not_found": "Выберите предстоящую встречу с указанным временем."
    },
    "consent_record": "Клиент согласен на сообщения в WhatsApp — записать согласие",
    "not_synced": "(Платформа проверяет синхронизированные данные — если вы только что это изменили, дождитесь синхронизации и попробуйте снова.)"
  },
  "voice": {
    "open": "Итоги встречи по записи голоса",
    "title": "Итоги встречи по записи голоса",
    "intro": "Запишите встречу в приложении — вы получите черновик итогов и предлагаемые задачи для проверки и правки. Ничего не сохраняется, пока вы не нажмёте «Сохранить». Аудио один раз отправляется на расшифровку и сразу удаляется; в CRM оно никогда не хранится.",
    "consent_missing": "В карточке клиента нет согласия на запись встреч. Спросите клиента; если он согласен, запишите согласие здесь.",
    "consent_withdrawn": "Клиент отозвал согласие на запись встреч. Не записывайте.",
    "consent_record": "Клиент согласен — записать согласие",
    "consent_note": "Согласие на запись встреч для письменных итогов (аудио удаляется после расшифровки).",
    "consent_on_file": "Согласие на запись есть ({date}).",
    "confirm_now": "Я спросил(а) клиента сейчас, и он согласен на эту запись.",
    "record_intro": "Положите устройство между собой и клиентом. До {max} минут.",
    "start": "Начать запись",
    "stop": "Остановить и подвести итоги",
    "recording": "Идёт запись",
    "privacy": "Аудио один раз передаётся в службу расшифровки через платформу AVRASTRO и сразу удаляется. Сведения о здоровье и другие чувствительные данные отмечаются и исключаются, если вы их не оставите.",
    "mic_denied": "Микрофон недоступен — разрешите его в браузере и попробуйте снова.",
    "working": "Расшифровка и подготовка итогов… это занимает до минуты.",
    "failed": "Итоги не получены ({code}). Ничего не сохранено.",
    "review_intro": "Проверьте и отредактируйте. Сохраняются только отмеченные строки и задачи.",
    "meeting": "Сохранить во встречу",
    "new_meeting": "Новая встреча (сегодня)",
    "summary": "Итоги",
    "decisions": "Решения",
    "tasks": "Предлагаемые задачи",
    "keep": "Оставить",
    "in_days": "через (дней)",
    "sensitive": "Чувствительные данные: {kinds}",
    "sensitive_hint": "Исключаются, если вы не отметите. Оставляйте только то, что нужно для страхования.",
    "kind": {
      "health": "здоровье",
      "beliefs": "убеждения",
      "origin": "происхождение",
      "sexual": "личная жизнь",
      "criminal": "судимость",
      "identifier": "номер документа / счёта"
    },
    "review_note": "Черновик подготовлен ИИ и может содержать ошибки; после сохранения ответственность за него ваша.",
    "save": "Сохранить",
    "discard": "Отбросить",
    "saved": "Итоги встречи сохранены.",
    "timeline": "Итоги встречи (по записи голоса)",
    "off": "Итоги встреч по записи голоса для этого офиса не включены (платформе нужна служба расшифровки — см. шаги для владельца). Ничего не записано.",
    "need_account": "Войдите в учётную запись AVRASTRO, чтобы пользоваться итогами встреч.",
    "dictation_open": "Голосовые заметки после встречи",
    "mode": "Что вы записываете",
    "mode_meeting": "Встречу (с согласия)",
    "mode_dictation": "Свои заметки",
    "dictation_intro": "После встречи расскажите своими словами, что обсуждалось. Ваш голос превращается в заметки, задачи и черновик анализа потребностей — всё проверяется вами перед сохранением. Работает, когда на платформе настроена служба расшифровки (TRANSCRIBE).",
    "dictation_confirm": "Я записываю только свой голос, не клиента.",
    "needs": "Потребности для черновика анализа",
    "needs_note": "Отмеченные станут черновиком (не итоговым) анализа потребностей, который вы дополните."
  },
  "help": {
    "title": "Справочный центр",
    "subtitle": "Инструкции для каждого экрана, сочетания клавиш и новости.",
    "panel_title": "Справка по этому экрану",
    "open": "Справка",
    "this_screen": "Справка по этому экрану",
    "open_centre": "Справочный центр",
    "search": "Поиск в справке…",
    "no_results": "По запросу «{q}» ничего не найдено.",
    "no_context": "Для этого экрана пока нет статьи. Вот основное:",
    "topics": "Разделы справки",
    "welcome_title": "Чем мы можем помочь?",
    "welcome_sub": "Начните с одной из статей или найдите нужное по слову.",
    "press_question": "Совет: нажмите «?» на любом экране, чтобы открыть справку по нему.",
    "lesson_link": "Урок: {title}",
    "keys": "Клавиши",
    "action": "Действие",
    "where": "Где",
    "version": "Версия {v}",
    "tab": {
      "articles": "Статьи",
      "shortcuts": "Сочетания клавиш",
      "new": "Что нового",
      "ask": "Спросите AVRASTRO · Справка"
    },
    "group": {
      "start": "Начало работы",
      "clients": "Клиенты и встречи",
      "sales": "Продажи и комплаенс",
      "service": "Обслуживание и продления",
      "growth": "Рост и продажи",
      "safety": "Данные и безопасность",
      "settings": "Настройки"
    }
  },
  "lessons": {
    "title": "Уроки",
    "subtitle": "{count, plural, one {# короткий урок} few {# коротких урока} many {# коротких уроков} other {# короткого урока}} с шагами, видео и тестом — в удобном для вас темпе.",
    "progress": "Пройдено уроков: {done} из {total}",
    "continue": "Продолжить: {title}",
    "start": "Начать: {title}",
    "minutes": "{n} мин",
    "level": {
      "basic": "Основы",
      "daily": "Ежедневная работа",
      "advanced": "Продвинутый"
    },
    "done": "Пройден",
    "quiz_score": "Тест {correct}/{of}",
    "video_soon": "Видео скоро появится",
    "video_soon_sub": "А пока следуйте шагам ниже — они такие же, как в видео.",
    "watch_in": "Смотреть: {lang}",
    "lang": {
      "el": "на греческом",
      "en": "на английском",
      "ru": "на русском"
    },
    "of": "Урок {n} из {total}",
    "all": "Все уроки",
    "goal": "Чему вы научитесь",
    "steps": "Шаги",
    "practice": "Попробуйте: {screen}",
    "mark_done": "Отметить как пройденный",
    "mark_undone": "Снять отметку",
    "marked_done": "Урок пройден",
    "marked_undone": "Отметка о прохождении снята",
    "read_more": "Читайте также",
    "nav": "Навигация по урокам",
    "prev": "Предыдущий",
    "next": "Следующий",
    "quiz": "Короткий тест",
    "right": "Верно!",
    "wrong": "Не совсем.",
    "check": "Проверить ответы",
    "retry": "Ещё раз"
  },
  "setup": {
    "step": {
      "profile": {
        "title": "Профиль и регистрация в ICCS",
        "sub": "Ваш регистрационный номер, статус и классы, по которым вы зарегистрированы."
      },
      "office": {
        "title": "Офис и доступность",
        "sub": "Где и когда вы встречаетесь с клиентами."
      },
      "clients": {
        "title": "Импорт клиентов",
        "sub": "Перенесите клиентов из Excel/CSV или из старой VÉRO."
      },
      "connect": {
        "title": "Календарь и почта",
        "sub": "Ваши встречи в Outlook и переписка с клиентами в их истории."
      },
      "bookings": {
        "title": "Запись на avrastro.com",
        "sub": "Клиенты записываются онлайн, вы подтверждаете."
      },
      "modules": {
        "title": "Какие инструменты показывать",
        "sub": "Скройте ненужное — данные не меняются."
      },
      "safety": {
        "title": "Резервные копии и безопасность",
        "sub": "Копия вне устройства, шифрование и безопасный вход."
      }
    },
    "title": "Настройка AVRASTRO",
    "subtitle": "Семь коротких шагов; любой можно пропустить и вернуться к нему позже.",
    "help": "Как это работает",
    "steps_label": "Шаги настройки",
    "progress": "Готово на {percent}%",
    "progress_aria": "Настройка выполнена на {percent}%",
    "step_of": "Шаг {n} из {total}",
    "card_title": "Подготовим вашу практику к работе",
    "card_sub": "Выполнено {done} из {total}{skipped, plural, =0 {} other { · пропущено: #}}",
    "start": "Начать настройку",
    "continue": "Продолжить настройку",
    "snooze": "Скрыть на неделю",
    "snoozed": "Список вернётся через неделю — или откройте мастер настройки в любой момент.",
    "back": "Назад",
    "skip": "Пропустить пока",
    "unskip": "Вернуться к шагу",
    "mark_done": "Готово",
    "save_next": "Сохранить и продолжить",
    "next": "Далее",
    "cancel": "Отмена",
    "saved": "Сохранено",
    "choose": "— выберите —",
    "status": {
      "done": "Готово",
      "skipped": "Пропущено",
      "todo": "Осталось"
    },
    "finish": {
      "title": "Стартовый список",
      "sub": "Выполнено {done} из {total}. Остальные шаги остаются на экране «Сейчас», пока вы их не выполните или не пропустите.",
      "done_title": "Всё готово!",
      "done_sub": "Настройка завершена. Уроки шаг за шагом покажут повседневную работу."
    },
    "to_today": "Перейти к «Сейчас»",
    "reg_no": "Регистрационный номер ICCS",
    "reg_no_hint": "Как в реестре посредников Службы надзора за страховыми компаниями (ICCS); указывается в документах для клиентов.",
    "capacity": "Статус",
    "capacity_hint": "Статус, в котором вы зарегистрированы.",
    "capacity_opt": {
      "tied_agent": "Аффилированный (эксклюзивный) страховой агент",
      "agent": "Страховой агент (нескольких страховщиков)",
      "broker": "Страховой брокер",
      "advisor_rep": "Страховой консультант посредника",
      "ancillary": "Вспомогательный страховой посредник"
    },
    "lines": "Классы страхования",
    "line": {
      "life": "Страхование жизни",
      "general": "Общее страхование",
      "life_sub": "Жизнь, здоровье, накопления, пенсия — с файлом KYC/AML и налоговым центром.",
      "general_sub": "Авто, жильё, путешествия, бизнес — с застрахованными объектами и стадиями продления."
    },
    "insurers": "Страховщики, с которыми вы работаете",
    "insurers_hint": "Через запятую.",
    "profile_note": "Эти данные указываются в предложениях, письмах и профиле; их можно изменить в настройках. AVRASTRO не является страховщиком.",
    "https_hint": "Ссылка, начинающаяся с https://",
    "office_phone": "Телефон офиса",
    "days": "Рабочие дни",
    "from": "С",
    "to": "До",
    "meeting_minutes": "Обычная длительность встречи",
    "minutes": "{n} мин",
    "modes": "Где вы встречаетесь с клиентами",
    "mode": {
      "office": "В офисе",
      "online": "Онлайн",
      "phone": "По телефону",
      "client_place": "У клиента",
      "cafe": "В кафе"
    },
    "office_note": "Длительность станет значением по умолчанию для новых встреч; часы записи на avrastro.com задаются в Advisor Hub.",
    "clients_now": "{count, plural, =0 {В AVRASTRO пока нет клиентов.} one {В AVRASTRO # клиент или потенциальный клиент.} few {В AVRASTRO # клиента и потенциальных клиента.} many {В AVRASTRO # клиентов и потенциальных клиентов.} other {В AVRASTRO # клиента и потенциальных клиента.}}",
    "clients_demo": "(Это демонстрационные данные — добавьте своих клиентов.)",
    "clients_excel": "Из Excel или CSV",
    "clients_excel_sub": "Список клиентов с проверкой дубликатов до сохранения.",
    "clients_vero": "Из старой VÉRO CRM",
    "clients_vero_sub": "Резервная копия (.json/.ICRM) с полисами, задачами и документами.",
    "clients_one_sub": "По одному, с предупреждением о повторяющемся телефоне или e-mail.",
    "clients_card_sub": "Фото визитки через быстрое добавление («+»).",
    "connect_done": "Outlook подключён.",
    "connect_ready": "Outlook можно подключить в разделе «Учётная запись».",
    "connect_sign_in": "Для подключения календаря и почты нужна учётная запись AVRASTRO. Без неё каждая встреча открывается как файл .ics в вашем календаре.",
    "connect_outlook_sub": "Встречи CRM в Outlook и на телефоне; ваше занятое время закрывает слоты записи.",
    "connect_mail": "Переписка с клиентами",
    "connect_mail_sub": "Письма с клиентами CRM появляются в их истории (по желанию).",
    "connect_ics": "Без подключения (.ics)",
    "connect_ics_sub": "Из ежедневника каждая встреча открывается в календаре телефона.",
    "connect_note": "AVRASTRO никогда не отправляет сообщения сам — он открывает черновики в ваших приложениях.",
    "bookings_1": "На avrastro.com → Advisor Hub → «Доступность» укажите дни и часы.",
    "bookings_2": "Кнопка «Предпросмотр» показывает вашу страницу записи; скопируйте её адрес сюда.",
    "bookings_3": "Каждый запрос приходит во входящие сайта и попадает в ежедневник только после вашего подтверждения.",
    "open_availability": "Открыть «Доступность» на avrastro.com",
    "booking_url": "Ваша ссылка для записи",
    "copy": "Копировать",
    "copied": "Скопировано",
    "copy_failed": "Не удалось скопировать — выделите ссылку и скопируйте вручную.",
    "bookings_note": "Добавьте ссылку в подпись письма, в соцсети или на свой сайт.",
    "modules_both": "Вы зарегистрированы по страхованию жизни и общему страхованию: показаны все инструменты.",
    "modules_life": "Только страхование жизни: инструменты общего страхования (объекты, стадии продления) скрыты.",
    "modules_general": "Только общее страхование: инструменты страхования жизни (KYC/AML, защита, налоговый центр) скрыты.",
    "change_lines": "Изменить классы",
    "modules_note": "Скрытие меняет только видимость: данные сохраняются, а скрытый экран открывается через Лупу.",
    "safety_no_backup": "На этом устройстве ещё не создавалась резервная копия.",
    "safety_backup_age": "{days, plural, =0 {Последняя копия: сегодня.} one {Последняя копия: # день назад.} few {Последняя копия: # дня назад.} many {Последняя копия: # дней назад.} other {Последняя копия: # дня назад.}}",
    "safety_encrypted": "Данные на этом устройстве зашифрованы.",
    "safety_not_encrypted": "Данные не зашифрованы средствами AVRASTRO.",
    "safety_account": "Включите двухэтапный вход или passkey для своей учётной записи.",
    "practice_title": "Классы, регистрация и инструменты",
    "hidden_tools": "Скрытые инструменты",
    "none_hidden": "Нет",
    "choose_tools": "Выбрать инструменты"
  },
  "cimport": {
    "field": {
      "displayName": "Имя и фамилия",
      "firstName": "Имя",
      "lastName": "Фамилия",
      "phone": "Телефон",
      "email": "E-mail",
      "birthDate": "Дата рождения",
      "address": "Адрес",
      "city": "Город",
      "occupation": "Профессия",
      "clientSince": "Клиент с",
      "notes": "Примечания"
    },
    "title": "Импорт клиентов из Excel или CSV",
    "intro": "Выберите файл .xlsx или .csv либо вставьте строки вместе с заголовками. Проверьте сопоставление столбцов и предпросмотр — ничего не сохраняется, пока вы не нажмёте «Импортировать».",
    "choose": "Выбрать файл",
    "paste": "…или вставьте строки сюда (вместе со строкой заголовков)",
    "unreadable": "Не удалось прочитать файл. Сохраните его как .xlsx или CSV и попробуйте снова.",
    "header_row": "Первая строка — заголовки",
    "column": "Столбец {n}",
    "ignore": "— не импортировать —",
    "kind": {
      "new": "Новый",
      "existing": "Уже есть",
      "repeat": "Повтор в файле",
      "invalid": "Без имени"
    },
    "col": {
      "status": "Статус",
      "notes": "Замечания"
    },
    "add_anyway": "Всё равно добавить: {name}",
    "match": {
      "phone": "Тот же телефон, что у: {name}",
      "email": "Тот же e-mail, что у: {name}",
      "name": "То же имя, что у: {name}"
    },
    "problem": {
      "birth_date": "дата рождения не учтена",
      "client_since": "«клиент с» не учтено",
      "email": "неверный e-mail"
    },
    "more_rows": "…и ещё строк: {count}.",
    "as": "Импортировать как",
    "stage": {
      "client": "Клиенты",
      "prospect": "Потенциальные клиенты"
    },
    "safety": "Существующие записи не меняются. Весь импорт можно отменить через Ctrl+Z.",
    "run": "{count, plural, =0 {Импортировать} one {Импортировать # запись} few {Импортировать # записи} many {Импортировать # записей} other {Импортировать # записи}}",
    "done": "{count, plural, one {Импортирована # запись} few {Импортировано # записи} many {Импортировано # записей} other {Импортировано # записи}}",
    "card_title": "Импорт клиентов (Excel/CSV)",
    "card_sub": "Список клиентов из другой программы или таблицы с проверкой дубликатов.",
    "open": "Импортировать клиентов"
  },
  "salefile": {
    "check": {
      "identity_disclosed": "Данные и регистрационный номер посредника",
      "advice_disclosed": "Предоставляется ли консультация",
      "complaints_info": "Жалобы и внесудебное урегулирование",
      "capacity_disclosed": "Статус и представляемые страховщики",
      "remuneration_disclosed": "Характер вознаграждения",
      "demands_needs": "Требования и потребности",
      "recommendation": "Персональная рекомендация",
      "product_info": "Информационный документ о продукте",
      "kid": "Документ с ключевой информацией (KID)",
      "costs_disclosed": "Расходы и сборы",
      "suitability": "Оценка пригодности",
      "suitability_report": "Заключение о пригодности",
      "kyc": "Файл KYC/AML заполнен",
      "privacy_notice": "Уведомление о персональных данных (GDPR)",
      "durable_medium": "На бумаге или долговечном носителе",
      "signed": "Подписанное заявление"
    },
    "check_hint": {
      "identity_disclosed": "Имя, адрес, регистрация в ICCS и как её проверить (IDD, ст. 18).",
      "advice_disclosed": "Клиенту сообщено, даёте ли вы рекомендации по продуктам (IDD, ст. 18).",
      "complaints_info": "Порядок подачи жалоб и Финансовый омбудсмен (IDD, ст. 18).",
      "capacity_disclosed": "Действуете ли вы от имени клиента или страховщика(-ов), и каких (IDD, ст. 19).",
      "remuneration_disclosed": "Плата от клиента, комиссия, иное или их сочетание (IDD, ст. 19).",
      "demands_needs": "Записаны в поле выше; продукт им соответствует (IDD, ст. 20).",
      "recommendation": "Почему продукт лучше всего отвечает потребностям (IDD, ст. 20).",
      "product_info": "IPID для общего страхования (IDD, ст. 20(5)) или преддоговорная информация страховщика по страхованию жизни.",
      "kid": "Для инвестиционных страховых продуктов (регламент PRIIPs).",
      "costs_disclosed": "Все расходы и связанные с ними сборы (IDD, ст. 29).",
      "suitability": "Знания и опыт, финансовое положение и способность нести убытки, цели и терпимость к риску (IDD, ст. 30).",
      "suitability_report": "Передаётся клиенту до заключения договора (IDD, ст. 30).",
      "kyc": "Из вкладки KYC/AML клиента.",
      "privacy_notice": "Уведомление об обработке и, при необходимости, согласие.",
      "durable_medium": "Информация передана на бумаге или долговечном носителе, у клиента есть копия (IDD, ст. 23).",
      "signed": "Клиент подписал заявление на страхование."
    },
    "title": "Файлы продаж (IDD)",
    "subtitle": "Требования и потребности, рекомендация и раскрытие информации — один файл на каждую продажу.",
    "how": "Что нужно",
    "new": "Новый файл продажи",
    "stat": {
      "without": "Полисы за 12 месяцев без файла",
      "open": "Файлы в работе",
      "complete": "Заполненные файлы"
    },
    "without_title": "Полисы без файла",
    "without_sub": "Действующие полисы, начавшиеся за последние 12 месяцев.",
    "open_file": "Открыть файл",
    "without_empty": "У каждого недавнего полиса есть файл продажи.",
    "open_title": "В работе",
    "open_sub": "Чего не хватает в каждом файле.",
    "progress": "Заполнено на {percent}%",
    "missing": "Не хватает: {list}",
    "open_empty": "Нет незаполненных файлов.",
    "done_title": "Заполненные файлы",
    "hide": "Скрыть",
    "view": "Открыть",
    "done_empty": "Пока нет заполненных файлов.",
    "disclaimer": "Подсказка для вашего архива согласно Директиве (ЕС) 2016/97 (IDD) и закону Кипра 38(I)/2016 с поправками — не юридическая консультация. Приоритет имеют правила вашего страховщика и указания Службы надзора за страховыми компаниями (ICCS). Файлы не удаляются.",
    "edit_title": "Файл продажи — {name}",
    "save": "Сохранить файл",
    "saved": "Файл продажи сохранён",
    "complete": "Файл заполнен полностью",
    "client": "Клиент",
    "policy": "Полис",
    "no_policy": "— полиса пока нет —",
    "sale_date": "Дата продажи",
    "product": "Продукт",
    "insurer": "Страховщик",
    "line_label": "Тип продажи",
    "line": {
      "life": "Жизнь",
      "general": "Общее страхование",
      "ibip": "Инвестиционный (IBIP)"
    },
    "line_hint": {
      "life": "Жизнь, здоровье, защита дохода — с файлом KYC/AML.",
      "general": "Авто, жильё, путешествия, бизнес — с документом IPID.",
      "ibip": "Накопительные/инвестиционные (например, unit-linked): также оценка пригодности, расходы и KID."
    },
    "advice_label": "Рекомендация",
    "advice": {
      "advised": "С рекомендацией",
      "non_advised": "Без рекомендации"
    },
    "channel_label": "Способ",
    "channel": {
      "face_to_face": "Лично",
      "distance": "Дистанционно"
    },
    "needs": "Анализ потребностей",
    "demands": "Требования и потребности клиента",
    "demands_hint": "Что клиент запросил и что ему нужно, вашими словами (хотя бы одно предложение).",
    "recommendation": "Рекомендация",
    "recommendation_hint": "Почему предложенный продукт лучше всего отвечает этим потребностям.",
    "checklist": "Что и когда было передано клиенту",
    "open_kyc": "Открыть KYC/AML",
    "auto_ok": "Заполнено",
    "auto_todo": "Заполните поле",
    "given_on": "Дата: {item}",
    "today": "Сегодня",
    "document_for": "Документ: {item}",
    "no_document": "— без документа —",
    "notes": "Примечания"
  },
  "nba": {
    "kind": {
      "settle_arrears": "Сначала просроченный взнос",
      "call_detractor": "Позвоните до любого предложения",
      "resolve_service": "Сначала закройте открытый вопрос",
      "request_terms": "Запросите условия продления",
      "send_terms": "Отправьте сравнение клиенту",
      "follow_up_terms": "Позвоните за решением",
      "confirm_renewal": "Отметьте продление",
      "explain_increase": "Объясните повышение",
      "check_sum_insured": "Проверьте восстановительную стоимость",
      "renew_kyc": "Обновите файл KYC",
      "review_cover": "Назначьте обзор",
      "confirm_contact": "Позвоните клиенту",
      "prepare_renewal": "Подготовьте продление"
    },
    "why": {
      "settle_arrears": "Не оплачено {amount} уже {days} дн. — покрытие под угрозой до продления.",
      "call_detractor": "Клиент оценил обслуживание на {score}/10 в этом году — сначала выслушайте его.",
      "resolve_service": "{count, plural, one {Открыт # страховой случай или запрос} few {Открыто # случая или запроса} many {Открыто # случаев или запросов} other {Открыто # случая или запроса}} — разговор о продлении сейчас неуместен.",
      "request_terms": "Работа ещё не начата — запросите условия у страховщиков.",
      "send_terms": "Условия сравнены — отправьте их клиенту.",
      "follow_up_terms": "Условия отправлены {days} дн. назад, ответа нет.",
      "confirm_renewal": "Клиент одобрил — отметьте «Продлён», чтобы обновить взнос.",
      "explain_increase": "Новый взнос выше на {pct}% — объясните причину или предложите альтернативы.",
      "check_sum_insured": "Для «{item}» стоимость не указана или выглядит заниженной — ориентировочная проверка недострахования.",
      "renew_kyc": "Файл KYC/AML неполный или подлежит пересмотру — обновите его на встрече в годовщину полиса.",
      "review_cover": "За последние 12 месяцев обзора не было — годовщина полиса — хороший повод.",
      "confirm_contact": "За последние 6 месяцев контактов не зафиксировано.",
      "prepare_renewal": "Всё в порядке — подготовьте краткую информацию для клиента."
    },
    "also": {
      "settle_arrears": "просрочка",
      "call_detractor": "низкая оценка",
      "resolve_service": "открытый вопрос",
      "request_terms": "условия",
      "send_terms": "отправка условий",
      "follow_up_terms": "ожидание ответа",
      "confirm_renewal": "одобрено",
      "explain_increase": "рост взноса",
      "check_sum_insured": "возможное недострахование",
      "renew_kyc": "KYC",
      "review_cover": "обзор",
      "confirm_contact": "нет контакта",
      "prepare_renewal": "продление"
    },
    "title": "Следующее лучшее действие",
    "subtitle": "Для каждого продления в ближайшие 60 дней — шаг, который стоит сделать сейчас.",
    "in_days": "через {days} дн. · {date}",
    "expired": "истёк {days} дн. назад · {date}",
    "task_title": "{action}: {product}",
    "task_done": "Задача добавлена в ежедневник на сегодня",
    "task_exists": "В ежедневнике",
    "create_task": "Создать задачу",
    "empty": "В ближайшие 60 дней продлений нет.",
    "more": "Показать ещё {count}"
  },
  "call": {
    "outcome": {
      "no_answer": "Не ответил",
      "busy": "Занято",
      "wrong_number": "Неверный номер",
      "not_interested": "Не заинтересован",
      "callback": "Перезвонить позже",
      "interested": "Заинтересован",
      "meeting": "Встреча назначена",
      "do_not_call": "Больше не звонить"
    }
  },
  "calls": {
    "title": "Звонки потенциальным клиентам",
    "subtitle": "Списки номеров, быстрый экран звонков и ваши результаты: кто ответил, кому перезвонить, где назначена встреча.",
    "how": "Как это работает",
    "new_list": "Новый список звонков",
    "edit_list": "Настройки списка",
    "goal_today": "Звонков сегодня",
    "goal_week": "Встреч на этой неделе",
    "streak": "{count, plural, one {# день подряд} few {# дня подряд} many {# дней подряд} other {# дня подряд}}",
    "best": "рекорд {count}",
    "goals_edit": "Цели",
    "goal_dials": "Звонков в день",
    "goal_meetings": "Встреч в неделю",
    "max_attempts": "Максимум попыток на номер",
    "max_attempts_hint": "После стольких звонков без ответа номер больше не попадает в очередь.",
    "no_lists": "Списков пока нет. Создайте список, вставьте номера или импортируйте файл Excel/CSV.",
    "numbers": "Номера",
    "to_call": "Позвонить сегодня",
    "dials": "Звонки",
    "meetings": "Встречи",
    "dnc_short": "Не звонить",
    "start": "Начать звонки",
    "import": "Импорт номеров",
    "open_list": "Список",
    "overdue_title": "{count, plural, one {# обратный звонок ждёт} few {# обратных звонка ждут} many {# обратных звонков ждут} other {# обратного звонка ждут}}",
    "overdue_sub": "Вы обещали перезвонить, и срок уже прошёл.",
    "call_now": "Позвонить",
    "privacy_title": "Конфиденциальность:",
    "privacy_note": "Для каждого списка укажите правовое основание (согласие или законный интерес) и источник номеров. Тот, кто попросил больше не звонить, отмечается «Больше не звонить» и больше нигде не предлагается для звонка.",
    "privacy_settings": "Настройки",
    "settings_title": "Звонки потенциальным клиентам",
    "legal_title": "Проверьте действующие правила:",
    "legal_note": "Правила нежелательных рекламных звонков и хранения данных меняются. AVRASTRO не решает, что разрешено: прежде чем звонить по списку, проверьте правила, действующие на Кипре сегодня (например, разъяснения Офиса Уполномоченного по защите персональных данных), и инструкции вашей компании. Фиксируйте источник каждого списка и выполняйте любую просьбу больше не звонить.",
    "list_name": "Название списка",
    "list_name_hint": "например, «Список А, октябрь»",
    "lawful_basis": "Правовое основание",
    "lawful_basis_hint": "На каком основании вы храните эти номера и звоните по ним.",
    "basis": {
      "consent": "Согласие",
      "legitimate_interest": "Законный интерес",
      "existing_relationship": "Существующие отношения",
      "unknown": "Неизвестно"
    },
    "basis_missing": "основание не указано",
    "consent_source": "Источник номеров / согласия",
    "consent_source_hint": "например, «Анкета посетителей выставки 2026»",
    "scripts": "Вступительные фразы A / B",
    "scripts_hint": "Попробуйте два варианта начала разговора; «Мой прогресс» покажет, какой приносит больше встреч.",
    "variant": "Вариант {v}",
    "script_title": "Короткое название",
    "script_opening": "С чего вы начинаете разговор",
    "script_notes": "Заметки: вопросы, ответы на возражения",
    "save_and_import": "Сохранить и импортировать номера",
    "import_dnc": "{count, plural, one {# номер отмечен «Больше не звонить» и не будет добавлен} few {# номера отмечены «Больше не звонить» и не будут добавлены} many {# номеров отмечены «Больше не звонить» и не будут добавлены} other {# номера отмечены «Больше не звонить» и не будут добавлены}}",
    "legend_dnc": "Больше не звонить",
    "session": "Звонки",
    "made_session": "{count, plural, one {# звонок} few {# звонка} many {# звонков} other {# звонка}}",
    "booked_session": "{count, plural, one {# встреча} few {# встречи} many {# встреч} other {# встречи}}",
    "today_of": "Сегодня {n} / {goal}",
    "left": "Осталось {count}",
    "variant_mode": "Вступительная фраза",
    "alternate": "A/B по очереди",
    "end_session": "Завершить",
    "done_title": "На сегодня звонить больше некому",
    "done_sub": "За эту сессию: звонков — {made}, встреч — {booked}.",
    "reason": {
      "callback_due": "Пора перезвонить",
      "followup_due": "Продолжение — заинтересован",
      "new": "Новый номер",
      "retry": "Повторная попытка"
    },
    "attempts": "{count, plural, one {# попытка} few {# попытки} many {# попыток} other {# попытки}}",
    "timer_start": "Запустить таймер",
    "timer_stop": "Конец разговора",
    "notes": "Заметки",
    "history": "{count, plural, one {# предыдущий звонок} few {# предыдущих звонка} many {# предыдущих звонков} other {# предыдущего звонка}}",
    "held_on": "Основание: {basis} · Источник: {source}",
    "opening_line": "Вступительная фраза {v}",
    "no_script": "Для этого варианта ещё нет вступительной фразы.",
    "add_script": "Добавить",
    "outcome": "Результат",
    "when_meeting": "Когда встреча?",
    "when_callback": "Когда перезвонить?",
    "today": "Сегодня",
    "tomorrow": "Завтра",
    "date": "Дата",
    "time": "Время",
    "where": "Где",
    "duration": "Длительность",
    "minutes": "{count, plural, one {# минута} few {# минуты} many {# минут} other {# минуты}}",
    "book_meeting": "Назначить встречу",
    "save_callback": "Сохранить обратный звонок",
    "keys_hint": "Клавиши 1–8 — быстрый результат · Esc — выход",
    "skip": "Пропустить",
    "saved": "{name}: сохранено",
    "saved_callback": "{name}: обратный звонок добавлен в задачи",
    "saved_meeting": "{name}: встреча добавлена в календарь",
    "task_callback": "Перезвонить: {name}",
    "task_followup": "Продолжить: {name} (заинтересован)",
    "task_meeting": "Встреча с {name} (после звонка)",
    "dnc_title": "«Больше не звонить»: {name}",
    "dnc_body": "Номер больше не будет предлагаться для звонка ни в одном списке, не будет добавлен повторно при импорте и исключается из кампаний по телефону. Открытые обратные звонки отменяются.",
    "dnc_yes": "Больше не звонить",
    "dnc_on": "Больше не звонить",
    "dnc_mark": "Отметить «Больше не звонить»",
    "dnc_clear": "Снять отметку «Больше не звонить»",
    "dnc_on_done": "Отмечено «Больше не звонить»",
    "dnc_off_done": "Отметка «Больше не звонить» снята"
  },
  "callstats": {
    "title": "Мой прогресс",
    "subtitle": "Сколько звонков вы делаете, сколько людей отвечает и как часто вы назначаете встречу — по дням, неделям, месяцам, спискам и вступительным фразам.",
    "pdf": "PDF",
    "list": "Список",
    "all_lists": "Все списки",
    "variant": "Вступительная фраза",
    "all_variants": "Все фразы",
    "period": {
      "week": "Неделя",
      "30d": "30 дней",
      "month": "Месяц",
      "90d": "90 дней",
      "year": "Год"
    },
    "per": {
      "day": "по дням",
      "week": "по неделям",
      "month": "по месяцам"
    },
    "kpi": {
      "dials": "Звонки",
      "connect": "Ответили",
      "conversations": "Разговоры",
      "meetings": "Встречи",
      "meeting_rate": "Встреча на звонок",
      "meeting_per_conv": "Встреча на разговор",
      "held_noshow": "Состоялись / неявка",
      "show_rate": "Пришли на встречу",
      "sales": "Продажи",
      "dials_per_meeting": "Звонков на встречу",
      "avg_duration": "Средняя длительность",
      "sales_premium": "Годовой взнос по продажам"
    },
    "insights": "Что показывают ваши данные",
    "insights_note": "Рассчитывается только по вашим звонкам; если данных мало, выводы не делаются.",
    "tone": {
      "good": "Хорошо",
      "watch": "Внимание",
      "info": "Информация"
    },
    "insight": {
      "best_window": "Больше всего встреч вы назначаете в {window}: {rate}% звонков против {overall}% в целом.",
      "best_weekday": "Ваш лучший день — {weekday}: {rate}% встреч на звонок против {overall}% в целом.",
      "variant_ratio": "Фраза {win} приносит в {ratio} раза больше встреч, чем {lose} ({winRate}% против {loseRate}%).",
      "variant_only": "Встречи принесла только фраза {win} ({meetings}), фраза {lose} — пока ни одной.",
      "variant_even": "Обе фразы дают похожий результат (A {a}%, B {b}%).",
      "variant_more_data": "Для сравнения A/B нужно не меньше {need} звонков на каждую фразу (сейчас A {a}, B {b}).",
      "callbacks_overdue": "Многие «перезвонить позже» так и не выполнены — просрочено {count}.",
      "connect_low_window": "Отвечают только на {rate}% звонков; в {window} — на {best}%.",
      "connect_low": "Отвечают только на {rate}% звонков; попробуйте другое время или дни.",
      "no_shows": "{noShow} из {total} встреч не состоялись (неявка); напоминание накануне может помочь.",
      "meetings_unconfirmed": "{count} встреч прошли, но не отмечено, состоялись ли они.",
      "trend_up": "На этой неделе встреча назначается в {now}% звонков против {before}% за четыре предыдущие недели.",
      "trend_down": "На этой неделе доля встреч снизилась до {now}% с {before}% за четыре предыдущие недели.",
      "dials_per_meeting": "В среднем на одну встречу нужно {dials} звонков.",
      "streak": "Вы выполняете дневную цель {days} дн. подряд.",
      "sales": "Звонки привели к {sales} продажам после {meetings} состоявшихся встреч.",
      "no_data": "За этот период звонков пока нет."
    },
    "funnel": "От звонка до продажи",
    "step": {
      "dials": "Звонки",
      "reached": "Ответили",
      "conversations": "Разговоры",
      "meetings": "Назначено встреч",
      "held": "Состоялось встреч",
      "sales": "Продажи"
    },
    "trend": "Динамика {per}",
    "rate_trend": "Встречи на звонок (%)",
    "reached": "Ответили",
    "empty": "За этот период звонков нет.",
    "best_hours": "Лучшее время (встречи на звонок)",
    "best_days": "Лучшие дни (встречи на звонок)",
    "bar_tip": "{rate} встреч на звонок · {meetings} встреч из {dials} звонков · ответили {connect}",
    "dials_n": "{count, plural, one {# звонок} few {# звонка} many {# звонков} other {# звонка}}",
    "bars_note": "Бледные столбцы — меньше 15 звонков, выводы делать рано.",
    "ab": "Вступительная фраза A / B",
    "by_list": "По спискам",
    "no_list": "Без списка",
    "meetings_title": "Встречи после звонков",
    "meetings_sub": "Отмечайте, состоялась ли встреча или клиент не пришёл, — так считается доля явки.",
    "booked_on": "Назначена {date}",
    "state": {
      "held": "Состоялась",
      "no_show": "Неявка",
      "unconfirmed": "Уточнить",
      "upcoming": "Предстоит",
      "cancelled": "Отменена"
    },
    "mark_held": "Состоялась",
    "mark_noshow": "Неявка",
    "no_meetings": "За этот период встреч ещё не назначено.",
    "definitions": "Ответили: кто-то взял трубку. Разговор: перезвонить, заинтересован или встреча, либо любой разговор от 60 секунд. Продажа: полис этого человека, начавшийся после первого звонка.",
    "csv": {
      "day": "День",
      "hour": "Час",
      "name": "Имя",
      "phone": "Телефон",
      "seconds": "Секунды",
      "when": "Перезвон / встреча"
    }
  },
  "gaps": {
    "title": "Карта пробелов в защите",
    "subtitle": "У каких клиентов нет записанной защиты в каждой области — для информирования, а не давления.",
    "how": "Как это считается",
    "empty": "Клиентов пока нет.",
    "area": {
      "life_cover": "Страхование жизни",
      "income_protection": "Защита дохода",
      "beneficiaries": "Названные выгодоприобретатели",
      "health": "Медицинское страхование",
      "retirement": "Накопления на пенсию",
      "mortgage": "Защита ипотеки",
      "education": "Образование детей"
    },
    "short": {
      "life_cover": "Жизнь",
      "income_protection": "Доход",
      "beneficiaries": "Выгодопр.",
      "health": "Здоровье",
      "retirement": "Пенсия",
      "mortgage": "Ипотека",
      "education": "Учёба"
    },
    "cell": {
      "ok": "записано",
      "gap": "ничего не записано",
      "na": "не применимо"
    },
    "list_all": "{count, plural, one {# клиент хотя бы с одним пробелом} few {# клиента хотя бы с одним пробелом} many {# клиентов хотя бы с одним пробелом} other {# клиента хотя бы с одним пробелом}}",
    "list_area": "{area}: {count, plural, one {# клиент без записи} few {# клиента без записи} many {# клиентов без записи} other {# клиента без записи}}",
    "recorded_only": "Учитывается только то, что записано в AVRASTRO, — защита в других местах неизвестна.",
    "campaign": "Информационная кампания",
    "client": "Клиент",
    "legend": "✓ записано · ○ ничего не записано · – не применимо",
    "none": "Здесь пробелов нет.",
    "disclaimer": "Карта помогает организовать информирование; это не рекомендация. Любое решение клиента принимается после анализа потребностей.",
    "campaign_title": "Информирование: {area}",
    "wording_title": "Как мы пишем:",
    "wording_rules": "мы информируем и приглашаем проверить — без страха, без спешки, без продуктов и цен. Клиент может просто не отвечать.",
    "language": "Язык сообщения",
    "channel": "Канал",
    "ch": {
      "email": "E-mail",
      "whatsapp": "WhatsApp",
      "sms": "SMS",
      "phone": "Телефон",
      "letter": "Письмо"
    },
    "subject": "Тема",
    "message": "Сообщение",
    "message_hint": "Имя клиента и ваше имя подставляются для каждого клиента.",
    "campaign_create": "Создать кампанию",
    "campaign_note": "Кампания создаётся как черновик: аудитория фиксируется только из клиентов, давших согласие на канал, и ни одно сообщение не отправляется автоматически.",
    "msg": {
      "life_cover": {
        "subject": "Короткий вопрос о вашей семье",
        "body": "Здравствуйте, {first}!\n\nВ вашем деле не записано страхование жизни. Возможно, у вас есть защита в другом месте — тогда я просто это отмечу. Если хотите, за 20 минут мы можем вместе посмотреть, что понадобится вашей семье, если ваш доход пропадёт.\n\nЕсли вам это неинтересно, ничего делать не нужно.\n\n{advisor}"
      },
      "income_protection": {
        "subject": "Что будет с вашим доходом, если вы не сможете работать?",
        "body": "Здравствуйте, {first}!\n\nМногие не знают, что будет, если болезнь или несчастный случай не позволят работать несколько месяцев. В вашем деле не записана защита дохода. Если хотите, я объясню варианты на короткой встрече.\n\nЕсли вам это неинтересно, ничего делать не нужно.\n\n{advisor}"
      },
      "beneficiaries": {
        "subject": "Актуальны ли ваши выгодоприобретатели?",
        "body": "Здравствуйте, {first}!\n\nВ одном из ваших полисов страхования жизни не указаны выгодоприобретатели. Эту простую проверку стоит делать, особенно после изменений в семье. Если хотите, посмотрим вместе за несколько минут.\n\n{advisor}"
      },
      "health": {
        "subject": "Медицинская страховка — короткая проверка",
        "body": "Здравствуйте, {first}!\n\nВ вашем деле не записан медицинский план. Если у вас есть защита в другом месте (например, от работодателя), я хотел бы это отметить; если нет, могу рассказать, какие есть варианты и как они работают.\n\nЕсли вам это неинтересно, ничего делать не нужно.\n\n{advisor}"
      },
      "retirement": {
        "subject": "Ваша пенсия — картина за несколько минут",
        "body": "Здравствуйте, {first}!\n\nВ вашем деле не записаны накопления на пенсию. Если хотите, вместе посмотрим, сколько может понадобиться и что уже есть, — без каких-либо обязательств.\n\n{advisor}"
      }
    }
  },
  "auditpack": {
    "title": "Пакет для проверки",
    "subtitle": "В один клик для проверки ICCS или страховщика: файлы продаж, раскрытия информации, KYC, профили риска и согласия за период.",
    "pdf": "PDF",
    "zip": "ZIP с документами",
    "zipping": "Готовится…",
    "zip_done": "Пакет (ZIP) сохранён · файлов: {count}",
    "period": "Период",
    "preset": {
      "quarter": "Прошлый квартал",
      "year": "Этот год",
      "12m": "12 месяцев"
    },
    "from": "С",
    "to": "По",
    "files": "Файлы продаж",
    "complete": "Полные",
    "open": "С пробелами",
    "clients": "Клиенты",
    "kyc_incomplete": "KYC неполные",
    "without_file": "Полисы без файла",
    "files_title": "{count, plural, one {# файл продажи} few {# файла продаж} many {# файлов продаж} other {# файла продаж}}",
    "chip_complete": "Полный",
    "missing_title": "Чего не хватает",
    "nothing_missing": "В файлах за этот период ничего не упущено.",
    "contents": "ZIP содержит пакет в виде страницы (откройте и распечатайте в PDF), таблицы CSV и связанные документы из хранилища.",
    "empty": "За этот период файлов продаж нет.",
    "disclaimer": "Вспомогательный инструмент для вашего архива, не юридическая консультация; приоритет имеют запросы ICCS или страховщика. Ваши данные не изменяются.",
    "doc_title": "Пакет документов по продажам",
    "index": "Содержание",
    "col": {
      "date": "Дата",
      "client": "Клиент",
      "product": "Продукт",
      "kind": "Вид",
      "status": "Статус",
      "item": "Пункт",
      "given": "Предоставлено",
      "document": "Документ",
      "purpose": "Цель",
      "granted": "Дано",
      "basis": "Правовое основание"
    },
    "kyc_title": "Знай своего клиента (KYC)",
    "kyc": {
      "none": "Нет",
      "incomplete": "Неполный",
      "complete": "Полный"
    },
    "kyc_checked": "Проверено",
    "kyc_next": "Следующий пересмотр",
    "kyc_beneficiaries": "Выгодоприобретатели",
    "kyc_funds": "Источник средств",
    "kyc_none": "Файла KYC нет.",
    "risk_none": "Профиль риска не привязан.",
    "consents": "Согласия",
    "documents": "Документы",
    "readme": "AVRASTRO — пакет документов по продажам\nПериод: {from} – {to}\nФайлов продаж: {files}\npack.html: откройте в браузере и распечатайте в PDF\n*.csv: таблицы (файлы продаж, раскрытия, KYC, согласия, документы)\ndocuments/: документы из хранилища, связанные с файлами"
  },
  "family": {
    "title": "Семейная карта",
    "subtitle": "Супруг(а), дети, родители, бабушки и дедушки, крёстные — и кто за кого платит.",
    "add": "Добавить родственника",
    "edit": "Родственник",
    "empty": "Родственников пока нет.",
    "rel": {
      "spouse": "Супруг(а)",
      "partner": "Партнёр",
      "child": "Ребёнок",
      "parent": "Родитель",
      "grandparent": "Дедушка / бабушка",
      "grandchild": "Внук / внучка",
      "sibling": "Брат / сестра",
      "godparent": "Крёстный / крёстная",
      "godchild": "Крестник / крестница",
      "other": "Другое"
    },
    "client": "клиент",
    "baptism_on": "Крещение {date}",
    "policies": "{count, plural, one {# полис} few {# полиса} many {# полисов} other {# полиса}}",
    "client_pays": "Платит клиент",
    "pays_for_client": "Платит за клиента",
    "delete_confirm": "Удалить «{name}» из семейной карты?",
    "relation": "Родство",
    "who": "Кто",
    "who_name": "Только имя",
    "who_book": "Человек из базы",
    "person": "Человек",
    "name": "Имя",
    "birth": "Дата рождения",
    "baptism": "Дата крещения",
    "baptism_hint": "Для напоминания о годовщине.",
    "pays": "Кто платит",
    "pays_none": "—",
    "pays_pays_for": "Клиент платит за него",
    "pays_paid_by": "Он платит за клиента",
    "notes": "Заметка",
    "privacy": "Записывайте только то, что нужно для обслуживания семьи; без номеров документов и данных о здоровье."
  },
  "radar34": {
    "title": "Радар жизненных событий",
    "subtitle": "{count, plural, one {# событие в ближайшие 60 дней} few {# события в ближайшие 60 дней} many {# событий в ближайшие 60 дней} other {# события в ближайшие 60 дней}}",
    "item": {
      "milestone_birthday": "Исполняется {age}",
      "loan_ends": "Заканчивается кредит «{label}»",
      "policy_matures": "Истекает полис «{label}»",
      "turns18": "{name} исполняется 18",
      "baptism": "Годовщина крещения: {name} ({years})",
      "transparency_day": "День прозрачности: {years, plural, one {# год} few {# года} many {# лет} other {# года}} сотрудничества — годовая сводка",
      "risk_review": "Профиль «{level}» больше не соответствует сроку до цели"
    },
    "today": "сегодня",
    "in_days": "{count, plural, one {через # день} few {через # дня} many {через # дней} other {через # дня}} · {date}",
    "task": "Задача",
    "task_done": "Задача есть",
    "more": "ещё {count}",
    "less": "Меньше"
  },
  "summary": {
    "meeting_open": "Персональная сводка встречи",
    "transparency_open": "Сводка прозрачности",
    "meeting_studio": "Персональная сводка · {name}",
    "transparency_title": "Годовая сводка прозрачности · {name}",
    "meeting": "Встреча",
    "no_meeting": "Без встречи",
    "language": "Язык клиента",
    "language_hint": "Сводка составляется на языке, который читает клиент.",
    "remember_lang": "Запомнить",
    "lang_saved": "Язык клиента сохранён",
    "title_label": "Заголовок",
    "intro": "Вступление",
    "closing": "Заключение",
    "keep": "Включить в сводку",
    "sensitive": "Чувствительное",
    "sensitive_hint": "Похоже на данные о здоровье или другие чувствительные сведения — не включается, пока вы не отметите.",
    "add_line": "Строка",
    "add_step": "Следующий шаг",
    "preview": "Что увидит клиент",
    "meeting_note": "До клиента доходит только отмеченное; ваши внутренние заметки никогда не показываются. Сценарий (JSON) позже можно превратить в короткое видео с озвучкой.",
    "save_draft": "Сохранить",
    "saved": "Сводка сохранена",
    "print": "PDF",
    "portal": "В портал клиента",
    "film": "Сценарий видео",
    "film_done": "Сценарий видео (JSON) сохранён",
    "published": "Опубликовано в портале клиента",
    "portal_signed_out": "Войдите в аккаунт AVRASTRO, чтобы публиковать в портале.",
    "portal_no_link": "Клиент не связан с аккаунтом на avrastro.com; распечатайте PDF или отправьте его.",
    "portal_no_grant": "Клиент не разрешил публикации в своём портале.",
    "portal_failed": "Публикация не завершена; попробуйте ещё раз.",
    "earlier": "{count, plural, one {# предыдущая сводка} few {# предыдущие сводки} many {# предыдущих сводок} other {# предыдущей сводки}}",
    "status": {
      "draft": "черновик",
      "final": "итоговая",
      "shared": "отправлена"
    },
    "shared_on": "в портале {date}",
    "meeting_title": "Наша встреча {date}",
    "meeting_intro": "Уважаемый(ая) {name}, благодарю вас за уделённое время. Ниже кратко изложено, что мы обсудили, о чём договорились и каковы следующие шаги.",
    "meeting_closing": "Если у вас возникнут вопросы, я всегда к вашим услугам.\n{advisor}",
    "discussed": "Что мы обсудили",
    "agreed": "О чём договорились",
    "next_steps": "Следующие шаги",
    "step": "Шаг",
    "who": "Кто",
    "when": "Срок",
    "who_advisor": "Ваш консультант",
    "who_client": "Вы",
    "thanks": "Благодарю вас за доверие.",
    "film_cta": "Я на связи по любому вопросу",
    "not_advice": "Эта сводка носит информационный характер и не заменяет условия ваших полисов.",
    "tr": {
      "title": "Годовая сводка прозрачности {year}",
      "intro": "Уважаемый(ая) {name}, как и каждый год, направляю вам ясную картину: все ваши полисы, что вы платите, кто выгодоприобретатели и что изменилось с {from} по {to}.",
      "closing": "Если что-то изменилось — новый член семьи, смена работы, новый кредит, — сообщите мне, и мы посмотрим вместе.\n{advisor}",
      "note": "Суммы годовые, как они записаны; приоритет имеют условия и документы вашего страховщика.",
      "policies": "Ваши полисы",
      "policy": "Полис",
      "insurer": "Страховщик",
      "premium": "Взнос",
      "year": "год",
      "renewal": "Продление",
      "insured": "Застрахованный",
      "beneficiaries": "Выгодоприобретатели",
      "no_beneficiary": "Не указаны",
      "totals": "Итого годовых взносов",
      "total_line": "Итого: {amount} в год",
      "changes": "Что изменилось",
      "no_changes": "За период изменений нет.",
      "change": {
        "new": "{date}: новый полис «{label}»",
        "ended": "{date}: «{label}» — {status}",
        "premium": "{date}: «{label}» — взнос с {before} на {after}",
        "claim": "{date}: страховой случай «{label}»"
      },
      "status": {
        "lapsed": "прекращён из-за неоплаты",
        "cancelled": "отменён",
        "matured": "истёк срок",
        "other": "изменение"
      },
      "to_check": "Проверить вместе",
      "check_beneficiaries": "{count, plural, one {В # полисе жизни не указаны выгодоприобретатели.} few {В # полисах жизни не указаны выгодоприобретатели.} many {В # полисах жизни не указаны выгодоприобретатели.} other {В # полиса жизни не указаны выгодоприобретатели.}}",
      "advisor_note": "Заметка консультанта",
      "advisor_note_hint": "Необязательно; по одной строке на пункт.",
      "from": "Период с"
    }
  },
  "askhelp": {
    "title": "Спросите AVRASTRO · Справка",
    "subtitle": "Вопросы о том, как работает AVRASTRO, — ответы по справке, урокам и разделу «Что нового».",
    "launcher": "Спросите AVRASTRO о приложении",
    "ai_badge": "ИИ",
    "disclosure": "Ответы пишет система искусственного интеллекта (ИИ) только по справке AVRASTRO, и в них возможны ошибки; верным считается текст статьи, на которую они ссылаются.",
    "warning": "Не вставляйте данные клиентов (имена, телефоны, e-mail, номера удостоверений, IBAN, сведения о здоровье). Спрашивайте об экране или действии. Отправляется только вопрос — никогда не данные CRM.",
    "label": "Ваш вопрос об AVRASTRO",
    "placeholder": "например: Как импортировать клиентов из Excel?",
    "ask": "Спросить",
    "thinking": "Ищу в справке…",
    "will_remove": "Перед отправкой будет удалено данных: {count} (e-mail, телефоны, номера): «{q}»",
    "removed": "Перед отправкой удалено данных: {count}.",
    "you": "Вы",
    "from_help": "Из справки:",
    "open_screen": "Открыть: {label}",
    "kind_article": "Статья",
    "kind_lesson": "Урок",
    "kind_new": "Что нового",
    "search_title": "Из поиска по справке",
    "off_not_signed": "Чтобы получать ответы ИИ, войдите в аккаунт AVRASTRO. А пока — что нашлось в справке:",
    "off_not_configured": "Сервис ИИ не настроен. Вот что нашлось в справке:",
    "off_disabled": "Помощник отключён для этого рабочего пространства (Настройки). Вот что нашлось в справке:",
    "off_failed": "Помощник не ответил. Вот что нашлось в справке:",
    "off_rate": "Слишком много вопросов за короткое время — попробуйте позже. Вот что нашлось в справке:",
    "no_results": "В справке ничего не найдено по запросу «{q}». Попробуйте другое слово или откройте уроки.",
    "data_hint": "Для вопросов о ваших данных (например, «у каких клиентов продление?») есть «Спросить AVRASTRO» — он отвечает на этом устройстве.",
    "data_go": "Спросить AVRASTRO",
    "ex1": "Как импортировать клиентов из Excel?",
    "ex2": "Как сделать резервную копию?",
    "ex3": "Что такое файл продажи по IDD?",
    "clear": "Очистить",
    "shortcut": "Ctrl+J или ⌘J",
    "settings_title": "«Спросите AVRASTRO» — справка с ИИ",
    "settings_intro": "Ответы ИИ на вопросы о работе с AVRASTRO — только по справке, урокам и разделу «Что нового». Отправляется только вопрос: e-mail, телефоны, номера удостоверений и IBAN удаляются ещё на устройстве; данные клиентов не отправляются никогда.",
    "settings_enabled": "Включено для этого рабочего пространства",
    "settings_ai_on": "Сервис ИИ доступен.",
    "settings_ai_off": "Сервис ИИ недоступен; вместо него показывается поиск по справке.",
    "settings_need_account": "Нужен вход в аккаунт AVRASTRO.",
    "off_health": "Пожалуйста, не указывайте здесь сведения о здоровье — ни свои, ни клиентов. Вопрос не отправлен. Спросите в общем виде об экране или действии, например: «как зарегистрировать страховой случай?»."
  },
  "desktop": {
    "update": {
      "data_path": "Ваши данные: {path}",
      "check": "Проверить обновления",
      "current": "Установленная версия: {version}",
      "intro": "AVRASTRO проверяет наличие новой подписанной версии при запуске и при восстановлении соединения и спрашивает вас перед установкой.",
      "card_title": "Обновления приложения",
      "not_configured": "Автоматические обновления в этой сборке не активны. В следующей сборке они появятся; до тех пор устанавливайте новые версии вручную.",
      "none": "У вас последняя версия.",
      "err_check": "Проверка обновлений не удалась (нет сети или сервер недоступен). Будет повторена автоматически.",
      "err_generic": "Обновление не завершилось (например, прервалось соединение). Установленная версия и ваши данные не изменились. Попробуйте снова.",
      "err_busy": "Обновление уже устанавливается.",
      "err_signature": "Обновление отклонено: подпись недействительна. Ничего не изменилось. Сообщите в поддержку AVRASTRO.",
      "snapshot_label": "Перед обновлением до {version}",
      "downloading": "Загрузка и проверка подписи…",
      "saving": "Создание резервной копии данных…",
      "later": "Позже",
      "retry": "Повторить",
      "install": "Установить и перезапустить",
      "safe": "Ваши данные остаются на компьютере как есть: обновление заменяет только приложение. Перед установкой также создаётся резервная копия. Приложение закроется и откроется снова.",
      "notes": "Что нового",
      "available": "Доступна версия {version} (у вас {current}).",
      "title": "Новая версия AVRASTRO"
    },
    "notify": {
      "renewals": "Полисы к продлению в ближайшие 30 дней: {n}",
      "overdue": "просрочено: {n}",
      "due": "Задачи / follow-up на сегодня: {n}",
      "digest_title": "Сегодня в AVRASTRO",
      "appt_body": "В {time} · {title}",
      "appt_title": "Встреча через {min} мин",
      "test_failed": "Уведомление не удалось показать. Проверьте системные настройки уведомлений для AVRASTRO OS.",
      "test_sent": "Тестовое уведомление показано. Если вы его не видите, проверьте системные настройки уведомлений и режим «Не беспокоить».",
      "test_body": "Этот компьютер будет показывать уведомления AVRASTRO, пока приложение открыто.",
      "test_title": "Уведомления работают",
      "unavailable": "Системные уведомления недоступны в этой версии приложения. Установите последнюю.",
      "denied": "Система не разрешает уведомления для AVRASTRO. Mac: Системные настройки → Уведомления → AVRASTRO OS → Разрешить. Windows: Параметры → Система → Уведомления → AVRASTRO OS.",
      "limits": "Работают, пока AVRASTRO открыт (в том числе свёрнут). При закрытом приложении на этот компьютер ничего не приходит — для этого включите уведомления на app.avrastro.com (браузер или телефон).",
      "on_state": "Включены",
      "turn_on": "Включить уведомления на этом компьютере",
      "intro": "Системные уведомления (Mac: Центр уведомлений · Windows: уведомления) о встречах, задачах / follow-up на день и продлениях — по данным этого компьютера.",
      "title": "Уведомления на этом компьютере"
    }
  },
  "policy_delete": {
    "action": "Удалить",
    "title": "Удаление ошибочно внесённого полиса",
    "restore_title": "Восстановление удалённого полиса",
    "word": "УДАЛИТЬ",
    "steps": "Шаги",
    "step_password": "Пароль",
    "step_code": "Код приложения",
    "step_confirm": "Подтверждение",
    "checking": "Проверяем, можно ли безопасно удалить…",
    "unavailable_title": "Удаление здесь недоступно",
    "unavailable_offline": "У этого рабочего пространства нет учётной записи AVRASTRO, поэтому удаление нельзя подтвердить и защитить на сервере. Войдите в учётную запись, чтобы удалять полисы. Вместо этого можно отметить полис как аннулированный — внесён по ошибке.",
    "unavailable_nosync": "Удаление защищает сервер через облачную синхронизацию, которая на этом устройстве не включена. Включите синхронизацию или отметьте полис как аннулированный — внесён по ошибке.",
    "mfa_title": "Сначала настройте приложение-аутентификатор",
    "mfa_body": "Для удаления полиса нужны ваш пароль и код из приложения-аутентификатора (двухэтапный вход). Включите двухэтапный вход для учётной записи и вернитесь.",
    "mfa_setup": "Настроить двухэтапный вход",
    "locked_until": "Попробуйте снова после {time}.",
    "retry": "Повторить",
    "intro": "В целях безопасности подтвердите, что это вы. Полис убирается из списков, отчётов и статистики; он сохраняется в архиве и может быть восстановлен в течение {days} дней.",
    "restore_intro": "Для восстановления удалённого полиса нужно то же подтверждение: пароль и код приложения-аутентификатора.",
    "password": "Ваш пароль AVRASTRO",
    "password_hint": "Пароль, с которым вы входите в AVRASTRO. Входите через avrastro.com без пароля? Используйте ключ доступа или задайте пароль через «Забыли пароль».",
    "use_passkey": "Использовать ключ доступа",
    "passkey_ok": "Ключ доступа подтверждён.",
    "code_intro": "Введите новый код из приложения-аутентификатора (не тот, которым вы только что вошли).",
    "code": "Код из приложения-аутентификатора",
    "code_hint": "6 цифр. Коды восстановления здесь не принимаются.",
    "verify": "Проверить",
    "verified": "Личность подтверждена. Завершите в течение {seconds} с.",
    "identity": "Удаляемый полис",
    "product": "Продукт",
    "number": "Номер полиса",
    "issue": "Дата выпуска",
    "premium": "Годовая премия",
    "reason": "Причина",
    "reason_hint": "Обязательно — например, «внесён дважды», «не тот клиент».",
    "type_word": "Введите {word} для подтверждения",
    "soft_note": "Ничего не стирается: полис и всё связанное с ним сохраняются скрытыми и могут быть восстановлены в течение {days} дней.",
    "restore_reason": "Примечание (необязательно)",
    "confirm": "Удалить полис",
    "restore": "Восстановить",
    "done": "Полис удалён.",
    "done_pending": "Полис удалён на этом устройстве; сервер подтвердит удаление, когда вы будете в сети.",
    "restored": "Полис восстановлен.",
    "restore_until": "Его можно восстановить до {date}.",
    "retained": "Срок восстановления истёк; полис остаётся скрытым и хранится в архиве.",
    "deleted_on": "Удалён {date}",
    "list_title": "{count, plural, one {# удалённый полис} few {# удалённых полиса} many {# удалённых полисов} other {# удалённого полиса}}",
    "view": "Открыть",
    "linked_none": "С этим полисом не связаны другие записи.",
    "linked_hidden": "Скрываются вместе с ним (сохраняются, вернутся при восстановлении):",
    "linked_kept": "Остаются видимыми как история:",
    "error_alt": "Вместо этого отметьте его как аннулированный — внесён по ошибке. Он остаётся видимым с историей и больше не считается действующим.",
    "mark_error": "Отметить: внесён по ошибке",
    "marked_error": "Отмечен как аннулированный — внесён по ошибке.",
    "entered_in_error": "Внесён по ошибке",
    "table": {
      "policy_adjustments": "Изменения премии",
      "tasks": "Задачи и напоминания",
      "documents": "Документы",
      "service_cases": "Обращения",
      "claims": "Страховые случаи",
      "production_events": "Записи продаж",
      "renewals": "Продления",
      "commission_entries": "Записи комиссий",
      "premium_arrears": "Просроченные премии",
      "cases": "Заявки",
      "sale_files": "Файлы продажи"
    },
    "err": {
      "generic": "Не удалось выполнить ({code}).",
      "invalid_credentials": "Неверный пароль.",
      "reauth_invalid": "Не удалось подтвердить ключ доступа.",
      "passkey_cancelled": "Запрос ключа доступа отменён.",
      "mfa_invalid": "Код приложения неверен или устарел.",
      "mfa_reused": "Этот код уже использован. Дождитесь следующего кода в приложении.",
      "mfa_enrolment_required": "Сначала настройте двухэтапный вход (приложение-аутентификатор).",
      "stepup_locked": "Слишком много неудачных попыток. В целях безопасности удаление заблокировано на 15 минут.",
      "rate_limited": "Слишком много попыток. Подождите несколько минут.",
      "policy_not_synced": "Этот полис ещё не попал на сервер. Дождитесь синхронизации и повторите.",
      "policy_already_deleted": "Этот полис уже удалён.",
      "policy_not_deleted": "Этот полис не удалён.",
      "restore_window_passed": "Срок восстановления истёк.",
      "permission": "Ваша роль не позволяет удалять полисы.",
      "network": "Нет связи с сервером. Для удаления нужно подключение.",
      "stepup_required": "Сервер отклонил изменение: нет подтверждения. Ничего не удалено.",
      "stepup_invalid": "Сервер отклонил изменение: недействительное подтверждение. Ничего не изменено.",
      "stepup_expired": "Подтверждение истекло (5 минут). Ничего не изменено — начните заново.",
      "stepup_used": "Это подтверждение уже использовано. Ничего не изменено — начните заново.",
      "stepup_mismatch": "Подтверждение относилось к другому полису, устройству или учётной записи. Ничего не изменено.",
      "stepup_unavailable": "Этот сервер синхронизации не может защитить удаление. Ничего не изменено.",
      "stepup_window": "Срок восстановления истёк. Ничего не изменено.",
      "policy_delete_fields": "Сервер отклонил удаление (проверьте часы устройства). Ничего не изменено.",
      "policy_hard_delete": "Полисы никогда не стираются; используйте «Удалить» в карточке полиса.",
      "policy_deleted_changed": "Удалённый полис нельзя изменить.",
      "refused": "Сервер отклонил изменение. Ничего не изменено."
    }
  },
  "sign_optin": {
    "label": "С моей подписью",
    "none": "Добавьте изображение подписи в разделе «Брендинг», чтобы подписывать документы."
  },
  "rights": {
    "title": "{feature}: не входит в ваш текущий тариф",
    "body": "Ваши записи остаются здесь, только для чтения — ничего не скрыто и не удалено. Ничего не включается и не оплачивается без вас.",
    "lapsed_title": "{feature}: срок подписки истёк",
    "lapsed_body": "Всё остаётся видимым, только для чтения. Продлите подписку в разделе «Учётная запись», чтобы снова вносить изменения.",
    "in_plans": "Входит в тарифы: {plans}",
    "in_addons": "Дополнение: {addons}",
    "store": "Не входит в вашу текущую подписку."
  },
  "notes": {
    "included": "Входит в ваш тариф",
    "upgrade": "Доступно при переходе: {plans}",
    "not_in_plan": "Не входит в текущую подписку",
    "kind": {
      "security": "Безопасность",
      "fix": "Исправление"
    },
    "intro": "Исправления безопасности, совместимости и ошибок получают все. Новые платные модули отмечены: входят в ваш тариф или доступны при переходе — они никогда не включаются и не оплачиваются сами.",
    "intro_store": "Исправления безопасности, совместимости и ошибок получают все. То, что не входит в вашу подписку, отмечено — ничего не включается само.",
    "in_update": "В этом обновлении",
    "upgrade_hint": "Обновление бесплатно и сохраняет ваши данные. Модули, отмеченные как расширение, остаются выключенными, пока вы не выберете тариф, который их включает.",
    "upgrade_hint_store": "Обновление бесплатно и сохраняет ваши данные. То, что не входит в вашу подписку, остаётся выключенным.",
    "binary_vs_rights": "Обновления (безопасность, совместимость, исправления) — для всех, независимо от тарифа; они никогда не меняют то, что вы платите."
  },
  "maint": {
    "phase": {
      "upcoming": "Плановое техническое обслуживание",
      "ongoing": "Идёт техническое обслуживание",
      "restored": "Работа восстановлена"
    },
    "window": "Когда: {window}",
    "your_zone": "ваше время ({zone})",
    "services": "Затронуто: {services}",
    "service": {
      "sync": "Синхронизация устройств",
      "web_app": "Веб-приложение",
      "desktop_app": "Приложение для компьютера",
      "account": "Вход и учётная запись",
      "billing": "Оплата",
      "website": "avrastro.com",
      "client_portal": "Портал клиента",
      "backups": "Резервные копии в облаке",
      "ai": "Функции ИИ",
      "notifications": "Уведомления",
      "updates": "Обновления приложения"
    },
    "sync_warning": "Можно продолжать работу: изменения, сделанные без связи, сохраняются на этом устройстве и отправляются, когда работа восстановится.",
    "restored_body": "Всё снова работает. Изменения, сохранённые на этом устройстве, сейчас отправляются.",
    "dismiss": "Скрыть"
  },
  "sync_update": {
    "title": "Обновите AVRASTRO, чтобы продолжить синхронизацию.",
    "body": "Сервер больше не принимает эту версию, поэтому синхронизация приостановлена, чтобы защитить ваши данные. Ничего не потеряно: изменения на этом устройстве сохраняются и будут отправлены после обновления.",
    "body_version": "Сервер больше не принимает эту версию, поэтому синхронизация приостановлена, чтобы защитить ваши данные. Нужна версия {version} или новее. Ничего не потеряно: изменения на этом устройстве сохраняются и будут отправлены после обновления."
  },
  "recs": {
    "intro": "До трёх идей кампаний из вашей собственной базы: существующие сегменты, согласия, история контактов, календарь и заметки о рынке, сохранённые вами с источником. У каждой указано, почему она предложена.",
    "never_sends": "Ничего не отправляется и никто не получает контакт автоматически. Одобрение создаёт кампанию с аудиторией, проверенной на согласие; запускаете её и отправляете каждое сообщение вы сами.",
    "none": "Сейчас предложений нет: для каждой темы либо нет людей с согласием, либо она уже идёт, проводилась в последние 90 дней или отложена вами.",
    "why": "Почему предлагается",
    "audience": "Аудитория",
    "eligible": "С согласием на этот канал",
    "in_segment": "В сегменте",
    "recent": "Контакт по кампании за последние 30 дней",
    "no_eligible_channel": "Ни у кого в этом сегменте нет согласия на этот канал. Выберите другой канал.",
    "audience_note": "При одобрении те же правила согласия фиксируют ту же аудиторию (согласие, отзыв, канал, «не связываться», контактные данные).",
    "goal_title": "Цель по контактам",
    "goal": "Всего контактов: {total} · около {perDay} в день · первое касание в течение рабочих дней: {days}.",
    "schedule": "Предлагаемый график",
    "schedule_note": "С {start} по {end}. Даты становятся задачами только после запуска кампании.",
    "kpis": "Как будет измеряться",
    "kpi": {
      "contacts": "Контакты",
      "positive": "Положительные ответы (цель)",
      "meetings": "Встречи (цель)",
      "conversion": "Конверсия в полис (цель)"
    },
    "kpi_measured": "измеряется по первым контактам",
    "kpi_basis_own": "Цели — по вашим прошлым кампаниям (записано контактов: {sample}).",
    "kpi_basis_none": "Пока без целевых цифр: в ваших прошлых кампаниях записано контактов: {sample}, нужно не меньше {min}. Ничего не предполагается.",
    "market": "Сохранённые вами заметки о рынке",
    "draft": "Черновик сообщения (можно менять)",
    "title_field": "Название кампании",
    "message": "Сообщение",
    "approve_check": "Одобряю: создать кампанию и зафиксировать её аудиторию с согласием (человек: {count}). Ничего не отправляется.",
    "approve": "Одобрить и создать кампанию",
    "dismiss": "Не сейчас (30 дней)",
    "approved": "Кампания создана — аудитория проверена и зафиксирована. Запустите её, когда будете готовы.",
    "dismissed": "Отложено на 30 дней.",
    "inputs_title": "Что используют предложения — и что никогда не используют",
    "inputs_used": "Используется",
    "inputs_not_used": "Никогда не используется",
    "input": {
      "segments": "Существующие умные сегменты центра кампаний (включая сегменты пробелов в защите), и только те, что указаны в теме библиотеки.",
      "consent": "Согласие на маркетинг и его отзыв, канал согласия, список «не связываться», «не звонить» и наличие телефона или e-mail.",
      "history": "История контактов: контакты, ответы, встречи и отказы по кампаниям, открытые задачи кампаний, идущие или недавние кампании.",
      "season": "Календарь (например, конец налогового года или начало учебного года) — только даты.",
      "market": "Заметки о рынке, сохранённые вами с источником и датой. AVRASTRO никогда не пишет и не выдумывает новости рынка.",
      "own_rates": "Результаты ваших прошлых кампаний — только для целевых KPI и только при достаточной истории."
    },
    "not_used": {
      "health": "Состояние здоровья, медицинские ответы и всё о здоровье человека.",
      "smoker": "Курит ли человек.",
      "claims": "Страховые случаи.",
      "medical_documents": "Медицинские документы и медицинские требования заявок.",
      "notes": "Заметки и любой свободный текст.",
      "finances": "Доходы, сбережения или налоговые данные сверх того, что уже использует существующий сегмент."
    },
    "health_note": "Единственные сегменты, связанные со здоровьем, — существующие, которые ищут отсутствие медицинского полиса («нет записанного медицинского покрытия», «пробел: здоровье»); они никогда не смотрят на состояние здоровья.",
    "market_title": "Заметки о рынке (с источником)",
    "market_hint": "Добавьте новость, о которой вы прочитали, с источником, датой и темами, к которым она относится. Она цитируется в предложениях в вашей формулировке 180 дней.",
    "note_add": "Добавить заметку о рынке",
    "note_title": "О чём",
    "note_source": "Источник (обязательно)",
    "note_url": "Ссылка (необязательно)",
    "note_date": "Дата публикации",
    "note_summary": "Краткое содержание (необязательно)",
    "note_themes": "Связанные темы кампаний",
    "note_save": "Сохранить заметку",
    "note_saved": "Заметка о рынке сохранена.",
    "season": {
      "tax_year_end": "Конец налогового года",
      "school_year": "Новый учебный год",
      "new_year": "Начало года",
      "summer_travel": "Летние поездки",
      "spring_home": "Весенняя проверка дома"
    },
    "reason": {
      "segment": "Человек в сегменте «{segment}»: {members} (из проверенных: {population}).",
      "consent": "С учётом правил согласия на этот канал можно связаться с: {eligible}; исключены: {excluded}.",
      "cool_off": "С некоторыми из них ({count}) уже связывались по кампании за последние {days} дней — учтите это перед повторным контактом.",
      "last_run": "Последний раз тема проводилась {date} (дней назад: {days}).",
      "never_run": "Вы ещё не проводили эту тему.",
      "season_tax_year_end": "Календарь: {month} — близко к концу налогового года.",
      "season_school_year": "Календарь: в месяце «{month}» семьи готовятся к учебному году.",
      "season_new_year": "Календарь: {month} — начало года, обычное время для ежегодных обзоров.",
      "season_summer_travel": "Календарь: {month} — сезон летних поездок.",
      "season_spring_home": "Календарь: {month} — обычное время для проверки дома.",
      "market": "Ваша заметка: «{title}» — {source}, {date}.",
      "incomplete": "Ещё могут подойти (данные неполные, не включены): {count}."
    }
  },
  "dayreport": {
    "title": "Итоги дня",
    "subtitle": "Заполняется по записям CRM за день. Добавляйте свои итоги только для работы вне CRM.",
    "day": "День",
    "recorded": "Записано",
    "self": "Моя запись",
    "self_short": "мои",
    "total": "Учитывается",
    "metric": {
      "callsAttempted": "Звонков сделано",
      "callsCompleted": "Звонков с разговором",
      "peopleApproached": "Людей охвачено",
      "contactsCompleted": "Состоявшихся контактов",
      "positiveReplies": "Положительных ответов",
      "rejections": "Отказов",
      "meetingsBooked": "Назначено встреч",
      "followupsCompleted": "Выполнено напоминаний"
    },
    "def": {
      "callsAttempted": "Каждый записанный звонок и выполненные задачи-звонки для людей без записанного звонка в этот день.",
      "callsCompleted": "Звонки, где удалось поговорить (результат кроме «не ответил», «занято», «неверный номер»).",
      "peopleApproached": "Разные люди или потенциальные клиенты, с которыми вы связались: звонки, сообщения, контакты кампаний, напоминания с результатом.",
      "contactsCompleted": "Разные люди, с которыми был разговор, ответ или запись на встречу.",
      "positiveReplies": "Люди, чей последний контакт за день был положительным.",
      "rejections": "Люди, чей последний контакт за день был отказом.",
      "meetingsBooked": "Разные люди, для которых сегодня назначена встреча в повестке.",
      "followupsCompleted": "Задачи-напоминания, выполненные сегодня (включая шаги кампаний)."
    },
    "below_recorded": "меньше записанного — учитывается записанное",
    "extra": "+{n} из моей записи",
    "self_hint": "Ваша запись — это ваш итог за день. Учитывается большее из двух чисел, а не сумма, поэтому звонок, записанный позже, не считается дважды.",
    "goals": "Цели",
    "goals_self": "Выполнено целей",
    "of": "из",
    "rates": "Показатели",
    "rate_def": {
      "goal_completion": "выполнено целей ÷ целей",
      "response": "положительные ответы ÷ охваченные люди",
      "appointment_conversion": "назначенные встречи ÷ состоявшиеся контакты"
    },
    "campaigns": "Результаты кампаний",
    "campaign_line": "контакты {contacted} · ответы {responded} · встречи {appointment} · отказы {opted_out} · задачи {tasks}",
    "rating": "Как прошёл день для вас? (1–5)",
    "rating_hint": "Ваша собственная оценка — показывается рядом с цифрами и не смешивается с ними.",
    "notes": "Заметки",
    "feedback": "Обратная связь",
    "fb_show": "Показать",
    "fb_hide": "Скрыть",
    "fb_own": "Своими словами (необязательно)",
    "fb_own_hint": "Что получилось, что попробовать завтра…",
    "save": "Сохранить отчёт",
    "saved": "Итоги дня сохранены.",
    "saved_at": "Сохранено {when}",
    "x_of_y": "{x} из {y} ({pct})",
    "no_denominator": "— (пока не с чем сравнить)",
    "fb": {
      "quiet_day": "Сегодня активность не записана. Если это был день в офисе или отдыха — это нормально.",
      "goals_all": "Все цели достигнуты ({met} из {total}).",
      "goals_most": "Достигнуто целей: {met} из {total}.",
      "goals_some": "Достигнуто целей: {met} из {total}. Цели на завтра можно подстроить под то, что помещается в день.",
      "goals_none": "Сегодня ни одна из целей ({total}) не достигнута. Возможно, завтра лучше подойдут меньшие или более скромные цели.",
      "small_day": "Охвачено людей: {count} — слишком мало, чтобы делать выводы по показателю.",
      "response_good": "Положительно ответили {pos} из {appr}.",
      "response_zero": "Сегодня нет положительных ответов (охвачено: {appr}). Стоит попробовать другое время или другую вступительную фразу.",
      "meetings": "Встреч назначено сегодня: {count}.",
      "followups": "Выполнено напоминаний: {count}.",
      "pending": "Открытых задач на сегодня или раньше: {count} — их можно перенести ниже.",
      "low_rating": "Вы оценили день на {rating} из 5. При желании отметьте, что было трудно, — это будет видно рядом с цифрами за месяц.",
      "high_rating": "Вы оценили день на {rating} из 5."
    },
    "relationship": "Кофе / знакомства / рекомендации: проведено {done} · ещё запланировано {planned}",
    "relationship_hint": "Считаются отдельно: не добавляются ко встречам и к показателям."
  },
  "monthly": {
    "title": "Результаты за месяц",
    "subtitle": "По месяцам, по записям CRM и вашим итогам дня. Совпадение — не причина.",
    "month": "Месяц",
    "print": "Печать / PDF",
    "partial": "месяц ещё идёт",
    "activity_line": "активность в {active} из {working} рабочих дней · сохранено отчётов: {reports}",
    "split": "записано {recorded} · моё {self}",
    "goals": "Целей выполнено / поставлено",
    "campaigns": "Идущие кампании",
    "rates": "Показатели месяца",
    "small_sample": "малая выборка (меньше {min}) — осторожно с выводами",
    "rates_note": "Для каждого показателя указаны числитель и знаменатель. Выполнение целей = выполненные цели ÷ цели; отклик = положительные ответы ÷ охваченные люди; конверсия во встречи = назначенные встречи ÷ состоявшиеся контакты; активность = дни с активностью ÷ рабочие дни.",
    "interpretation": "Что показывают цифры",
    "priorities": "Реалистичные приоритеты на следующий месяц",
    "no_cause": "Эти строки описывают, что происходило в одно время; они не показывают, что одно стало следствием другого.",
    "trend": "Активность по месяцам (n = охвачено людей)",
    "rate_trend": "Показатели по месяцам, % (n = охвачено людей)",
    "chart_note": "Месяц с малым n может сильно меняться случайно.",
    "empty": "За эти месяцы ещё ничего не записано. Здесь появятся звонки, задачи, встречи, результаты кампаний и итоги дня.",
    "table": "По месяцам",
    "definitions": "Записанные показатели пересчитываются по CRM за каждый день, поэтому всегда совпадают с активностью. Ваши записи учитываются только там, где они больше записанного за этот день.",
    "active_days": "Активные дни",
    "working_days": "Рабочие дни",
    "reports": "Итоги дня",
    "avg_rating": "Средняя самооценка",
    "rate": {
      "goal_completion": "Выполнение целей",
      "response": "Отклик",
      "appointment_conversion": "Конверсия во встречи",
      "call_connect": "Звонки с разговором",
      "activity": "Уровень активности"
    },
    "line": {
      "no_data": "За месяц «{month}» ничего не записано.",
      "activity": "Активность в {active} из {working} рабочих дней.",
      "activity_partial": "Пока в этом месяце: активность в {active} из {working} рабочих дней.",
      "rate_small": "{rate}: {num} из {den} ({pct}) — меньше {min}, слишком малая выборка, чтобы судить об изменении.",
      "rate_now": "{rate}: {num} из {den} ({pct}); в предыдущем месяце слишком мало данных для сравнения.",
      "rate_up": "{rate} был выше: {num} из {den} ({pct}) против {pnum} из {pden} ({ppct}) месяцем ранее (+{diff}).",
      "rate_down": "{rate} был ниже: {num} из {den} ({pct}) против {pnum} из {pden} ({ppct}) месяцем ранее (−{diff}).",
      "rate_same": "{rate} почти не изменился: {num} из {den} ({pct}) против {pnum} из {pden} ({ppct}).",
      "per_day_up": "{metric}: {now} в рабочий день против {prev} месяцем ранее (всего {total} против {ptotal}).",
      "per_day_down": "{metric}: {now} в рабочий день против {prev} месяцем ранее (всего {total} против {ptotal}).",
      "coincided": "Более высокий показатель «{rate}» совпал по времени с идущими кампаниями ({count}: {campaigns}). Совпадение по времени не показывает, что результат дала кампания.",
      "limits": "Учитывается только записанное в CRM; незаписанная работа не видна (сохранено отчётов: {reports}).",
      "limits_self": "Включает ваши записи за дни: {days} (показаны отдельно от записанного); сохранено отчётов: {reports}."
    },
    "prio": {
      "fewer_goals": "Ставьте около {perDay} целей в день — столько, сколько в среднем удалось ({num} из {den} в этом месяце).",
      "activity_days": "Запланируйте время для контактов в {days} из {working} рабочих дней следующего месяца (в этом месяце: {active} из {was}).",
      "response": "Попробуйте другую вступительную фразу или время — положительно ответили {num} из {den} ({pct}). «Мой прогресс» показывает ваши лучшие часы.",
      "conversion": "В каждом положительном разговоре предлагайте два конкретных времени встречи — встречей закончились {num} из {den} состоявшихся контактов ({pct}).",
      "overdue": "Начните месяц с просроченных задач и напоминаний ({count}).",
      "calls_target": "Реалистичная цель по звонкам: около {perDay} в рабочий день (ваше среднее за последние активные месяцы ({months}) — {avg}).",
      "keep": "Сохраняйте тот же ритм — заметных недостатков в этом месяце нет."
    },
    "relationship": "Кофе / знакомства",
    "relationship_hint": "кофе {coffee} · рекомендации {referral} — не встречи"
  },
  "catalog": {
    "title": "Страховщики и продукты",
    "hint": "Ваш собственный список: каждая страховая компания, с которой вы работаете → её категории продуктов → каждая конкретная программа. Новые полисы выбираются отсюда.",
    "show_inactive": "Показывать отключённые",
    "import": "Импорт из моих полисов",
    "import_nothing": "Нечего импортировать — все страховщики и продукты ваших полисов уже здесь.",
    "empty": "Страховщиков пока нет. Добавьте компании, с которыми вы работаете, или импортируйте их из своих полисов.",
    "counts": "{categories, plural, one {# категория} few {# категории} many {# категорий} other {# категории}} · {plans, plural, one {# программа} few {# программы} many {# программ} other {# программы}}",
    "insurer_name": "Название страховой компании",
    "add_insurer": "Добавить страховщика",
    "note": "Отключение скрывает запись для новых полисов; полисы, где она уже указана, сохраняют её. Удалить запись можно, только пока её не использует ни один полис.",
    "saved": "Каталог сохранён",
    "collapse": "Свернуть",
    "expand": "Развернуть",
    "inactive": "отключено",
    "kind": {
      "insurer": "Страховщик",
      "category": "Категория продукта",
      "plan": "Конкретная программа"
    },
    "policies": "{count, plural, =0 {нет полисов} one {# полис} few {# полиса} many {# полисов} other {# полиса}}",
    "up": "Переместить {name} выше",
    "down": "Переместить {name} ниже",
    "deactivate": "Отключить",
    "reactivate": "Включить снова",
    "remove": "Удалить {name}",
    "remove_hint": "Удалить навсегда (ничто не использует)",
    "deactivated": "{name}: отключено",
    "reactivated": "{name}: включено снова",
    "removed": "{name}: удалено",
    "category_name": "Новая категория (напр. Life Protection)",
    "category_name_for": "Новая категория — {insurer}",
    "maps_to": "Тип полиса",
    "add_category": "Добавить категорию",
    "plan_name": "Новая программа (напр. Life Plan 1)",
    "plan_name_for": "Новая программа в категории {category}",
    "add_plan": "Добавить программу",
    "edit_title": "Изменить: {kind}",
    "insurer_code": "Код (необязательно)",
    "plan_code": "Код программы (необязательно)",
    "branch_inherit": "Как у категории",
    "active_from": "Продаётся с",
    "active_to": "Продаётся до",
    "update_policies": "Также обновить название в {count, plural, one {# существующем полисе} few {# существующих полисах} many {# существующих полисах} other {# существующих полисах}}",
    "update_policies_category": "Также обновить тип в {count, plural, one {# существующем полисе} few {# существующих полисах} many {# существующих полисах} other {# существующих полисах}}",
    "history_kept": "{count, plural, one {Существующий полис сохраняет} few {# существующих полиса сохраняют} many {# существующих полисов сохраняют} other {# существующих полиса сохраняют}} название, с которым был внесён (связь с этой записью остаётся).",
    "import_title": "Импорт страховщиков и продуктов из того, что у вас уже есть",
    "import_confirm": "Импортировать",
    "import_intro": "Из вашего профиля и существующих полисов: новых страховщиков — {insurers}, новых категорий — {categories}, новых программ — {plans}. Ничего не придумывается: только названия, которые уже есть в ваших данных.",
    "already": "уже в каталоге",
    "new": "новое",
    "from_practice": "из вашего профиля",
    "import_link": "Связать существующие полисы ({count}) с этими записями (их текст не меняется)",
    "import_note": "Одинаковые названия в разном написании (регистр, ударения) объединяются. Полисы без страховщика не учитываются. Страховщики, указанные в шаге профиля выше, учитываются после сохранения этого шага.",
    "imported": "Импортировано: страховщиков — {insurers}, программ — {plans}",
    "choose": "Выберите…",
    "other": "Другое / нет в моём каталоге",
    "other_note": "Нет в вашем каталоге: введите ниже. Отметьте «добавить в мой каталог», чтобы в следующий раз он был в списке.",
    "add_from_policy": "Добавить «{insurer}» и этот продукт в мой каталог"
  },
  "studio": {
    "title": "AI-студия",
    "subtitle": "Посты, реклама, сторис и рилс для ваших кампаний — каждое слово в вашем стиле, каждое утверждение из одобренных фактов, ничего без вашего одобрения.",
    "balance": "{total} из {allowance} кредитов",
    "balance_hint": "1 кредит ≈ €0,01 затрат поставщика. Месячный лимит обновляется 1-го числа.",
    "signed_out": "Войдите в учётную запись AVRASTRO, чтобы пользоваться студией (нужна платформа).",
    "not_configured_title": "Студия ещё не включена",
    "not_configured_body": "Поставщики изображений и голоса ещё не подключены к этой платформе.",
    "not_entitled_title": "AVRASTRO Studio — это дополнение",
    "not_entitled_body": "Ваша подписка не включает студию. Она доступна как дополнение «AVRASTRO Studio» или как отдельный план.",
    "fonts_missing": "Не удалось загрузить фирменные шрифты; в предпросмотре используются шрифты компьютера.",
    "never_posts": "Студия никогда ничего не публикует и не отправляет сама. Отмеченные изображения созданы ИИ; факты о продуктах — только из вашего реестра утверждений.",
    "tab": {
      "create": "Создать",
      "library": "Библиотека",
      "reels": "Рилс",
      "claims": "Реестр утверждений",
      "credits": "Кредиты"
    },
    "brief": "1. Что вы хотите?",
    "brief_text": "Опишите своими словами",
    "brief_hint": "Например: «тёплый пост для родителей о планировании учёбы детей». Никаких имён клиентов и данных о здоровье.",
    "topic": "Тема",
    "audience": "Аудитория (группа, не человек)",
    "audience_hint": "В ИИ передаётся только тема — никогда чьи-либо данные.",
    "tone": "Тон",
    "language": "Язык",
    "cite_facts": "Одобренные факты, которые можно упомянуть",
    "cite_hint": "Цифры, выгоды и покрытие — только из отмеченных фактов; остальное блокируется.",
    "page": "стр.",
    "until": "действует до {date}",
    "write_copy": "Написать тексты ({credits} кредит)",
    "removed": "{count, plural, one {Удалён # личный элемент} few {Удалено # личных элемента} many {Удалено # личных элементов} other {Удалено # личного элемента}} перед ИИ",
    "ideas": "Идеи кампании",
    "template": "2. Шаблон",
    "picture": "3. Изображение",
    "variants": "{count, plural, one {# вариант} few {# варианта} many {# вариантов} other {# варианта}}",
    "tier_standard": "Стандарт",
    "tier_premium": "Премиум",
    "make_images": "Создать изображения ({credits} кредитов)",
    "own_photo": "Своё фото",
    "own_photo_licence": "собственное фото, права заявлены пользователем",
    "own_clip_licence": "собственное видео, права заявлены пользователем",
    "own_music_licence": "собственная музыка, лицензия заявлена пользователем",
    "no_picture": "Без изображения",
    "working": "Обработка…",
    "picture_note": "ИИ создаёт только изображение; каждое слово ставит шаблон вашими шрифтами. Без сходства с реальными людьми, без текста на картинке.",
    "edit": "Редактировать",
    "field": {
      "headline": "Заголовок",
      "subline": "Подзаголовок",
      "body": "Текст",
      "cta": "Призыв к действию",
      "caption": "Текст поста",
      "hashtags": "Хештеги",
      "script": "Озвучка",
      "ideas": "Идеи",
      "footer": "Сноска",
      "labels": "Метки",
      "claims": "Указанные факты",
      "title": "Название"
    },
    "contact": "Ваша контактная строка",
    "show_logo": "Мой логотип",
    "show_mark": "Знак AVRASTRO",
    "ai_label": "Метка «{label}»",
    "marketing_label": "Метка «Рекламная информация» (всегда)",
    "font_template": "Шрифт шаблона",
    "colour_primary": "Основной цвет",
    "colour_accent": "Акцентный цвет",
    "formats": "Размеры",
    "format_1x1": "Квадрат 1:1",
    "format_4x5": "Лента 4:5",
    "format_9x16": "Сторис / рилс 9:16",
    "format_16x9": "Широкий 16:9",
    "format_banner": "Баннер",
    "save_draft": "Сохранить черновик",
    "save_changes": "Сохранить изменения",
    "saved": "Сохранено",
    "saved_reset": "Сохранено — изменение требует нового одобрения",
    "approval_note": "Ничего нельзя экспортировать, прикрепить к кампании или опубликовать до вашего одобрения. Любое изменение требует нового одобрения.",
    "checks_ok": "Проверки пройдены",
    "checks_blocked": "Исправьте до проверки",
    "issue": {
      "number_without_claim": "{field}: «{quote}» — цифра без одобренного факта",
      "risk_phrase": "{field}: «{quote}» — обещание, которое нельзя давать",
      "medical_without_claim": "{field}: медицинское покрытие без одобренного факта",
      "coverage_without_claim": "{field}: что покрывает продукт — без одобренного факта",
      "claim_expired": "Указанный факт истёк или отозван",
      "claim_unknown": "Указанного факта нет в реестре",
      "footer_missing": "Нет пометки «Общая информация, а не рекомендация.»",
      "not_insurer_missing": "Нет пометки «AVRASTRO не является страховой компанией.»",
      "marketing_label_missing": "Нет рекламной метки",
      "ai_label_missing": "Изображению ИИ нужна метка ИИ",
      "personal_data": "{field}: «{quote}» — личные контактные данные",
      "insurer_name": "{field}: «{quote}» — название страховщика (бренды страховщиков выключены)",
      "text_too_long": "{field}: слишком длинно для одного из размеров"
    },
    "review_title": "ИИ-проверка:",
    "review_pass": "проблем не найдено",
    "review_flags": "{count, plural, one {# пункт для проверки} few {# пункта для проверки} many {# пунктов для проверки} other {# пункта для проверки}}",
    "review_advisory": "Только рекомендация: решаете и одобряете вы.",
    "for_campaign": "Для кампании «{title}»",
    "status_draft": "Черновик",
    "status_in_review": "На проверке",
    "status_approved": "Одобрено",
    "status_archived": "В архиве",
    "approved_by": "Одобрено: {who}, {date}",
    "superseded": "содержимое изменилось",
    "submit": "На одобрение",
    "approve": "Одобрить",
    "reject": "Запросить изменения",
    "archive": "В архив",
    "restore": "Восстановить",
    "done_submit": "Отправлено на одобрение",
    "done_approve": "Одобрено",
    "done_reject": "Возвращено в черновик",
    "done_archive": "Перемещено в архив",
    "done_restore": "Восстановлено",
    "waiting_approval": "Ожидает одобрения консультанта.",
    "use": "Использовать",
    "needs_approval": "Сначала одобрите: затем экспорт, кампания или публикация вами.",
    "choose_campaign": "Выберите кампанию…",
    "attach": "Прикрепить",
    "attached": "Прикреплено к кампании",
    "detach": "Убрать",
    "open_campaign": "Открыть кампанию",
    "copy_caption": "Копировать текст поста",
    "caption_copied": "Текст скопирован — опубликуйте его со своего аккаунта",
    "handoff_note": "Публикуете вы: скачайте файлы и опубликуйте их со своих аккаунтов. Сообщения клиентам — через Campaign Center с их согласием.",
    "provenance": "Происхождение",
    "prov_ai": "Содержит материалы ИИ (с меткой и в экспортированных файлах).",
    "prov_no_ai": "Без материалов, созданных ИИ.",
    "prov_kind_copy": "Тексты",
    "prov_kind_review": "Проверка",
    "prov_kind_image": "Изображение",
    "prov_kind_video": "Кадры ИИ",
    "prov_kind_voice": "Озвучка",
    "prov_kind_transcribe": "Расшифровка",
    "prov_kind_music": "Музыка",
    "c2pa_note": "Файлы содержат метку IPTC «создано ИИ». Подпись C2PA пока не ставится (нужен сертификат); происхождение хранится здесь.",
    "history": "История",
    "hist_create": "создано",
    "hist_for_campaign": "для кампании",
    "hist_edit": "изменено",
    "hist_edit_reset": "изменено — одобрение сброшено",
    "hist_submit": "на одобрение",
    "hist_approve": "одобрено",
    "hist_reject": "запрошены изменения",
    "hist_archive": "в архиве",
    "hist_restore": "восстановлено",
    "hist_attach": "прикреплено к кампании",
    "hist_detach": "убрано из кампании",
    "hist_export": "экспортировано",
    "hist_export_review": "экспорт — снова на одобрение",
    "export_review": "Файл отправлен на одобрение: он будет передан для публикации только после проверки советником или администратором.",
    "export_to_review": "Файл на одобрение (именно он будет передан для публикации)",
    "export_open": "Открыть файл",
    "all": "Все",
    "library_empty": "Пока нет материалов.",
    "creative": "Материал",
    "campaign": "Кампания",
    "updated": "Обновлено",
    "kind_image": "Изображение",
    "kind_video": "Рилс",
    "kind_story": "Сторис",
    "kind_carousel": "Карусель",
    "kind_copy": "Текст",
    "kind_presentation": "Презентация",
    "claims_title": "Реестр утверждений",
    "claims_intro": "Одобренные вами факты о продуктах — каждый из исходного документа со страницей и сроком действия. Цифры, выгоды, исключения и медицинское покрытие — только отсюда.",
    "claims_empty": "Одобренных фактов пока нет. Без них студия пишет только общие, информационные тексты.",
    "retired": "отозван",
    "retire": "Отозвать",
    "approved_on": "одобрено {date}",
    "claim_new": "Новый одобренный факт",
    "claim_plan": "План из каталога (необязательно)",
    "claim_product": "Продукт",
    "claim_statement": "Факт — как в источнике",
    "claim_statement_hint": "Например: «Покрытие стационара до €100 000 в год.» Без данных клиентов.",
    "claim_source": "Исходный документ (брошюра, описание продукта)",
    "claim_source_name": "Название документа",
    "claim_valid_until": "Действует до",
    "claim_add": "Одобрить и добавить",
    "claim_added": "Факт добавлен",
    "claim_need_file": "Сначала приложите исходный документ",
    "claim_note": "Вы подтверждаете факт для продукта до указанной даты. Факты не удаляются, а отзываются.",
    "claim_field_topic": "тема",
    "claim_field_product": "продукт",
    "claim_field_statement": "факт",
    "claim_field_source": "источник",
    "claim_field_source_document": "исходный документ",
    "claim_field_page": "страница",
    "claim_field_valid_until": "срок действия",
    "claim_field_valid_from": "дата начала",
    "claim_field_personal_data": "без личных данных",
    "credits_left": "Осталось кредитов",
    "credits_allowance": "В этом месяце",
    "credits_topup": "Пополнения",
    "credits_rules": "Жёсткие лимиты на сервере: нет баланса — нет генерации. Неудачная генерация возвращается автоматически. Неиспользованные месячные кредиты сгорают; пополнения остаются.",
    "action_col": "Действие",
    "credits_col": "Кредиты",
    "ledger": "Движение кредитов",
    "ledger_empty": "Пока нет движений.",
    "led_allowance": "месячный лимит",
    "led_expire": "сгорели",
    "led_topup": "пополнение",
    "led_charge": "списано",
    "led_refund": "возврат",
    "led_adjust": "корректировка",
    "action": {
      "copy": "Тексты (пост, подписи, сценарий)",
      "image_standard": "Изображение, стандарт",
      "image_premium": "Изображение, премиум",
      "voice_30s": "Озвучка за 30 с",
      "transcribe_10min": "Расшифровка за 10 мин",
      "reel_render": "Сборка рилс",
      "music_ai": "Музыка ИИ",
      "broll_fast": "Кадр ИИ (быстрый)",
      "broll_premium": "Кадр ИИ (премиум)"
    },
    "confirm_title": "Использовать кредиты?",
    "confirm_body": "«{action}» использует около {credits} кредитов. При сбое поставщика они вернутся автоматически.",
    "confirm_ok": "Использовать {credits} кредитов",
    "topic_life": "Защита жизни",
    "topic_medical": "Медицинская страховка",
    "topic_child_savings": "Накопления для детей",
    "topic_education": "Образование",
    "topic_retirement": "Пенсия",
    "topic_personal_accident": "Несчастные случаи",
    "topic_income_protection": "Защита дохода",
    "topic_loan_protection": "Защита кредита",
    "topic_generic": "Общее",
    "aud_general": "Широкая аудитория",
    "aud_parents_young_children": "Родители маленьких детей",
    "aud_new_parents": "Молодые родители",
    "aud_young_couples": "Молодые пары",
    "aud_young_professionals": "Молодые специалисты",
    "aud_homeowners_mortgage": "Владельцы жилья с ипотекой",
    "aud_self_employed": "Самозанятые",
    "aud_business_owners": "Владельцы бизнеса",
    "aud_pre_retirees": "40–60 лет, думают о пенсии",
    "aud_retirees": "Пенсионеры",
    "aud_drivers_families": "Семьи за рулём",
    "aud_homeowners": "Владельцы жилья",
    "tone_warm": "Тёплый",
    "tone_professional": "Деловой",
    "tone_energetic": "Энергичный",
    "tone_calm": "Спокойный",
    "reels_off": "Рилс пока недоступны на этой платформе (сборка видео выключена).",
    "reel_clips": "Ваши видео",
    "reel_upload": "Загрузить видео",
    "ai_footage": "кадры ИИ",
    "words": "{count, plural, one {# слово} few {# слова} many {# слов} other {# слова}}",
    "transcribe": "Расшифровать ({credits} кр.)",
    "broll": "Кадр ИИ (премиум)",
    "broll_note": "Только иллюстративные кадры на несколько секунд; никогда реалистичные люди как клиенты. С меткой ИИ.",
    "broll_placeholder": "Например: волны на тихом пляже на закате",
    "broll_make": "Создать кадр ({credits} кредитов)",
    "broll_clip": "Кадр ИИ",
    "reel_length": "Длина: около {seconds} с",
    "reel_plan": "Выбрать лучшие моменты",
    "reel_heuristic": "Выбор автоматический и неидеальный (чёткие целые фразы по порядку съёмки): проверьте и уберите лишнее.",
    "reel_total": "Длина рилс {seconds} с",
    "reel_title": "Название",
    "reel_default_title": "Рилс",
    "voiceover": "Озвучка (необязательно)",
    "voiceover_hint": "Проверяется как любой текст: без цифр без факта, без обещаний.",
    "make_voice": "Создать озвучку ({credits} кредитов)",
    "music": "Музыка",
    "music_hint": "Собственная музыка AVRASTRO (без сэмплов и лицензий) или ваш лицензированный трек.",
    "music_none": "Без музыки",
    "music_calm": "Спокойная",
    "music_warm": "Тёплая",
    "music_bright": "Яркая",
    "music_own": "Мой трек",
    "music_upload": "Загрузить свой лицензированный трек",
    "transition": "Между клипами",
    "transition_cut": "Склейка",
    "transition_fade": "Растворение",
    "vertical": "Вертикальное 9:16",
    "horizontal": "Горизонтальное 16:9",
    "captions": "{count, plural, one {# субтитр} few {# субтитра} many {# субтитров} other {# субтитра}}",
    "reel_render": "Собрать рилс ({credits} кредитов)",
    "rendering": "Собирается на платформе — около минуты на 30 с.",
    "reel_note": "Субтитры, титры и финальная карточка ставятся AVRASTRO вашими шрифтами; каждый рилс заканчивается пометкой «Общая информация, а не рекомендация.»",
    "creatives": "Материалы",
    "create_for_campaign": "Создать в AI-студии",
    "no_creatives": "Материалы ещё не прикреплены.",
    "choose_approved": "Выберите одобренный материал…",
    "only_approved": "Прикрепляются только одобренные материалы; изменение после одобрения требует нового одобрения.",
    "err": {
      "generic": "Студия не смогла это сделать ({code}).",
      "network": "Нет связи с платформой.",
      "plan_feature": "Студия не входит в вашу подписку.",
      "studio_not_configured": "Студия не включена на этой платформе.",
      "studio_credits_exhausted": "Недостаточно кредитов в этом месяце.",
      "studio_daily_cap": "Достигнут дневной лимит; попробуйте завтра.",
      "studio_confirm_required": "Сначала подтвердите кредиты.",
      "studio_provider_failed": "Поставщик не ответил; кредиты возвращены.",
      "studio_not_approved": "Использовать можно только одобренный материал.",
      "studio_checks_failed": "Проверки нашли, что исправить (см. список).",
      "studio_sensitive": "В описании есть данные о здоровье (заболевание, диагноз, лекарства или операция) — ваши или другого человека, например клиента. Они никогда не передаются ИИ. Опишите тему в общих словах (например, «страхование от тяжёлых заболеваний»), без людей.",
      "studio_audience": "Аудитория должна быть из списка.",
      "studio_type": "Этот тип файла не принимается.",
      "too_large": "Файл слишком большой.",
      "studio_storage_full": "Хранилище студии заполнено.",
      "licence_expired": "Подписка истекла: существующие материалы остаются видимыми.",
      "permission": "Ваша роль не позволяет это действие.",
      "studio_approver_role": "Одобряет только консультант или администратор.",
      "studio_hash_mismatch": "Материал изменился; обновите.",
      "studio_status": "Материал уже в другом состоянии; обновите.",
      "studio_claim": "Для факта нужно: {fields}.",
      "studio_claim_unknown": "Указанного факта нет в реестре.",
      "studio_job_failed": "Сборка не удалась; кредиты возвращены.",
      "studio_job_timeout": "Сборка идёт слишком долго; проверьте библиотеку позже.",
      "campaign_not_found": "Этой кампании нет в рабочем пространстве.",
      "studio_reel_length": "Рилс — не более 60 секунд."
    }
  },
  "phonecal": {
    "title": "Календарь телефона",
    "intro": "Ваши встречи и план в календаре iPhone или Android, привязанные к вашей учётной записи AVRASTRO. Каждая категория — отдельный календарь, чтобы задать ей свой цвет на телефоне.",
    "need_account": "Войдите в учётную запись AVRASTRO (с синхронизацией): календарь формирует платформа из синхронизированных данных.",
    "account": "Учётная запись",
    "workspace": "Рабочее пространство",
    "last_fetch": "Последнее чтение телефоном",
    "never": "пока нет",
    "detail": "Что показывают события",
    "detail_initials": "Только тип и инициалы клиента (напр. «Встреча · М.Г.») — рекомендуется",
    "detail_full": "Ваш заголовок, имя клиента и место",
    "detail_note": "Никогда заметки, телефоны, данные о здоровье или полисах. С полными данными заголовок виден так, как вы его написали, — не пишите в заголовках чувствительные сведения.",
    "create": "Создать ссылки календаря",
    "created": "Ссылки готовы",
    "saved": "Сохранено — телефон покажет при следующем обновлении",
    "subscribe": "Подписаться (iPhone)",
    "all_or_each": "Выберите либо «Всё», либо отдельные (цвет на категорию) — не оба, иначе каждое событие будет видно дважды.",
    "what": {
      "all": "Всё в одном календаре",
      "appointments": "Встречи CRM",
      "plan": "Ваш план: кофе / рекомендация, подготовка, обучение, команда, офис, дорога",
      "calls": "Звонки и follow-up",
      "personal": "Перерывы и личное время"
    },
    "qr_alt": "QR-код для календаря {name}",
    "qr_hint": "Отсканируйте камерой iPhone для подписки. На Android используйте https-ссылку в Google Календаре (на компьютере).",
    "qr_for": "QR для",
    "regenerate": "Новая ссылка",
    "regenerate_confirm": "Текущие ссылки сразу перестанут работать; календари на телефоне нужно будет добавить заново. Продолжить?",
    "regenerated": "Новые ссылки — старые больше не работают",
    "revoke": "Отключить",
    "revoke_confirm": "Ссылки сразу перестанут работать; на телефоне календари останутся пустыми или покажут ошибку — удалите их там. Продолжить?",
    "revoked": "Календарь телефона отключён",
    "err": "Не выполнено ({code})",
    "iphone": {
      "1": "На iPhone откройте эту страницу и нажмите «Подписаться (iPhone)» — или отсканируйте QR камерой.",
      "2": "Или вручную: Настройки → Календарь → Учётные записи → Добавить → Другое → Подписной календарь, и вставьте ссылку.",
      "3": "Нажмите «Далее», при желании задайте имя и выберите цвет — по одному на календарь.",
      "4": "В «Автообновление» выберите «Каждый час» (или как удобно).",
      "5": "Повторите для каждой нужной категории (или только «Всё»)."
    },
    "android": {
      "1": "Google Календарь добавляет календари по ссылке только на компьютере: откройте calendar.google.com с Google-аккаунтом телефона.",
      "2": "Слева: «Другие календари» → «+» → «Добавить по URL».",
      "3": "Вставьте https-ссылку (кнопка «Копировать») и нажмите «Добавить календарь».",
      "4": "В настройках календаря выберите цвет; на телефоне: Google Календарь → Настройки → календарь → «Синхронизация» включена.",
      "5": "Google обновляет такие календари раз в несколько часов (до суток) — изменение видно не сразу."
    },
    "note_colour": "Цвет: iPhone и Google задают цвет календарю целиком, а не событию — поэтому каждая категория — отдельный календарь.",
    "note_refresh": "Обновление: телефон запрашивает сам (iPhone обычно раз в 15 минут — час, Google раз в несколько часов); не мгновенно.",
    "note_readonly": "Только чтение: изменения вносятся в CRM, а не на телефоне.",
    "note_sync": "Видно то, что синхронизировано с платформой (синхронизация включена), от 30 дней назад до 6 месяцев вперёд.",
    "note_privacy": "Ссылка секретная: любой, у кого она есть, видит календарь. Не делитесь ею; «Новая ссылка» или «Отключить» сразу её останавливают. Данные остаются на платформе AVRASTRO; телефон хранит копию.",
    "note_future": "Двусторонняя синхронизация с Google / Outlook (изменения с телефона обратно в CRM) требует собственных OAuth-приложений у Google / Microsoft — возможность на будущее."
  },
  "taxf": {
    "title": "Моя налоговая папка",
    "subtitle": "Ваши собственные документы и квитанции как самозанятого консультанта по налоговым годам — готовые для вашего бухгалтера.",
    "year": "Налоговый год",
    "private": "Личная папка: её видите только вы. Руководитель, ассистенты и другие участники команды её не видят, если вы не поделитесь ею.",
    "shared_by": "Папка коллеги, которой с вами поделились, — только чтение.",
    "shared_list": "Доступны вам",
    "not_client": "Это о вашем собственном бизнесе, а не о клиентах. Для налогового планирования клиентов:",
    "open_taxc": "Налоговый центр",
    "start": "Открыть папку {year}",
    "start_hint": "Одна папка на год: собирайте здесь квитанции и справки весь год, а в конце отправьте бухгалтеру один аккуратный ZIP.",
    "created": "Папка {year} открыта; в ежедневник добавлено напоминание.",
    "add": "Добавить документ",
    "add_manual": "Без файла",
    "choose": "Выбрать файлы",
    "camera": "Сфотографировать",
    "drop": "Перетащите сюда PDF или фото (JPG, PNG, HEIC) — или выберите файлы.",
    "drop_active": "Отпустите, чтобы добавить файлы",
    "unsupported": "«{name}» — не PDF, JPG, PNG или HEIC.",
    "too_large": "«{name}» больше {mb} МБ.",
    "reading": "Чтение документа…",
    "queue": "Документ {n} из {total}",
    "stored": "Документ сохранён в папке.",
    "saved": "Сохранено.",
    "deleted": "Удалено из папки.",
    "overview": "По категориям",
    "all_categories": "Все категории",
    "count": "{count, plural, one {# документ} few {# документа} many {# документов} other {# документа}}",
    "missing_n": "не хватает: {count}",
    "other_currencies": "и в других валютах: {list}",
    "total": "Итого в EUR",
    "files_n": "{count, plural, one {# файл} few {# файла} many {# файлов} other {# файла}}",
    "items": "Документы и квитанции",
    "search": "Поиск (издатель, заметка, сумма, дата)",
    "empty": "В этом году пока нет документов.",
    "no_match": "Нет подходящих документов.",
    "checklist": "Что я жду — чек-лист",
    "checklist_empty": "Добавьте то, что приходит регулярно (например, соцстрахование каждый месяц), чтобы видеть, чего не хватает.",
    "still_missing": "Ещё не хватает",
    "nothing_missing": "Ничего из ожидаемого не отсутствует.",
    "show_done": "Показать и полученные",
    "upload_for": "Загрузить",
    "waive": "Не нужно",
    "unwaive": "Вернуть",
    "notes": "Заметки для бухгалтера",
    "notes_ph": "например: «Машина используется ~70% для работы», «Март оплачен в апреле».",
    "accountant": "Мой бухгалтер",
    "accountant_name": "Имя",
    "accountant_email": "E-mail",
    "export_zip": "ZIP для бухгалтера",
    "exporting": "Создание ZIP…",
    "exported": "ZIP создан (файлов: {files}).",
    "export_missing_files": "Файлов нет на этом устройстве и в ZIP: {count} (см. index.csv).",
    "mail_draft": "Черновик письма бухгалтеру",
    "mail_title": "Черновик сообщения бухгалтеру",
    "mail_note": "Ничего не отправляется автоматически. Откройте его в почтовой программе, приложите ZIP и отправьте сами.",
    "mail_open": "Открыть в почте",
    "mail_copy": "Скопировать текст",
    "mail_copied": "Текст скопирован.",
    "mark_sent": "Я отправил(а) бухгалтеру",
    "sent_on": "Отправлено бухгалтеру {date}",
    "share": "Поделиться",
    "share_title": "Поделиться папкой {year}",
    "share_hint": "Только участники команды с этими e-mail смогут читать папку (но не изменять). Удалите e-mail, чтобы закрыть доступ.",
    "share_emails": "E-mail участников (по одному в строке)",
    "shared_with": "Доступ у: {list}",
    "quick": "Быстрое добавление",
    "quick_title": "Регулярные документы года",
    "quick_hint": "Создаёт ожидаемые позиции в чек-листе — по одной на месяц, квартал или год. Повторное добавление их не дублирует.",
    "quick_category": "Что вы ждёте",
    "quick_subject": "Компания / организация (необязательно)",
    "quick_subject_ph": "например, «Тестовая страховая (вымышленная)»",
    "quick_add": "Добавить в чек-лист",
    "quick_added": "{count, plural, one {В чек-лист добавлена # позиция} few {В чек-лист добавлены # позиции} many {В чек-лист добавлено # позиций} other {В чек-лист добавлено # позиции}}.",
    "quick_none": "Все уже есть — ничего не добавлено.",
    "freq": {
      "monthly": "Каждый месяц (12)",
      "quarterly": "Каждый квартал (4)",
      "annual": "Раз в год"
    },
    "cert": "Годовая справка о страховых взносах",
    "cert_title": "Справка о взносах — по одной на каждый ваш полис",
    "cert_hint": "Если вы также клиент в своей CRM, выберите себя, чтобы найти ваши полисы жизни, пенсии и здоровья. Иначе введите их вручную.",
    "cert_me": "Я как клиент (необязательно)",
    "cert_manual": "Полисы вручную (по одному в строке)",
    "cert_manual_ph": "например, «Жизнь — Тестовая страховая (вымышленная) — 12345»",
    "cert_none": "У этого человека не найдено полисов жизни, пенсии или здоровья.",
    "categories": "Категории",
    "categories_title": "Категории {year}",
    "categories_hint": "Переименуйте или скройте категории и добавьте свои. Они действуют для этого года; новый год берёт их из предыдущего.",
    "cat_hidden": "Скрыта",
    "cat_custom": "Моя категория",
    "cat_new": "Новая категория",
    "cat_group": "Группа",
    "form_new": "Новый документ",
    "form_edit": "Документ папки",
    "prefilled": "Некоторые поля заполнены из текста документа. Проверьте их и исправьте при необходимости — они сохраняются только после нажатия «Сохранить».",
    "from_doc": "из документа",
    "no_text": "В документе нет текста для чтения (например, фото или скан) — заполните поля.",
    "field": {
      "date": "Дата",
      "amount": "Сумма",
      "currency": "Валюта",
      "issuer": "Издатель / поставщик",
      "category": "Категория",
      "subcategory": "Подкатегория",
      "declare": "Декларировать?",
      "status": "Статус",
      "notes": "Заметка для бухгалтера",
      "files": "Файлы",
      "expected": "Отвечает на ожидаемый документ",
      "period": "Период"
    },
    "none": "— нет —",
    "declare_hint": "Ваша отметка для бухгалтера — AVRASTRO не решает, что вычитается.",
    "declare": {
      "yes": "Да",
      "no": "Нет",
      "ask": "Спросить бухгалтера"
    },
    "status": {
      "missing": "Отсутствует",
      "received": "Получен",
      "checked": "Проверен",
      "waived": "Не нужен"
    },
    "mark_checked": "Отметить как проверенный",
    "add_file": "Добавить файл",
    "open_file": "Открыть",
    "detach": "Убрать файл",
    "detach_confirm": "Убрать файл из папки?",
    "delete": "Удалить документ",
    "delete_confirm": "Удалить этот документ и его файлы из папки? Сразу после этого можно отменить.",
    "file_missing": "Файла нет на этом устройстве.",
    "read_only": "Только чтение",
    "reminder": "Напоминание в ежедневнике: {date}",
    "reminder_title": "Подготовьте налоговую папку {year}",
    "reminder_add": "Напомнить в марте",
    "hints": "Полезная информация (Кипр)",
    "hint_mark": "требует подтверждения вашим бухгалтером",
    "hints_disclaimer": "Организация документов — не налоговая консультация. AVRASTRO не рассчитывает налог и не решает, что вычитается; информация из открытых источников (проверено 29.10.2026) и может измениться.",
    "sources": "Источники",
    "cat_hints": "О категории",
    "help_card": "Соберите свои налоговые документы за год в личной папке и отправьте их бухгалтеру одним ZIP.",
    "business_card": "Моя налоговая папка {year}",
    "business_card_sub": "документов: {items} · не хватает: {missing}",
    "open": "Открыть",
    "group": {
      "income": "Доходы",
      "contributions": "Взносы",
      "insurance": "Страховые взносы",
      "business": "Деловые расходы",
      "personal": "Личные вычеты",
      "other": "Прочее"
    },
    "cat": {
      "commissions": "Доходы — выписки по комиссиям",
      "social_insurance": "Социальное страхование (самозанятый)",
      "gesy": "Взносы GESY",
      "provident_pension": "Пенсионные и сберегательные фонды",
      "life_insurance": "Взносы по страхованию жизни и справка",
      "medical_insurance": "Медицинское страхование",
      "home_insurance": "Страхование жилья (стихийные бедствия)",
      "professional_indemnity": "Страхование профессиональной ответственности",
      "licence_fees": "Лицензия, реестр и профессиональные организации",
      "cpd_training": "Повышение квалификации (CPD) и обучение",
      "office_rent_utilities": "Аренда офиса и коммунальные услуги",
      "car_fuel": "Автомобиль и топливо",
      "phone_internet": "Телефон и интернет",
      "equipment": "Оборудование",
      "software_subscriptions": "Программы и подписки (и CRM)",
      "marketing": "Маркетинг",
      "travel": "Поездки",
      "accounting_legal": "Бухгалтерские и юридические услуги",
      "bank_charges": "Банковские сборы",
      "housing": "Аренда или проценты по ипотеке основного жилья",
      "green_ev": "Энергомодернизация / электромобиль",
      "donations": "Пожертвования",
      "other": "Прочее"
    },
    "sub": {
      "premium": "Квитанция о взносе",
      "annual_certificate": "Годовая справка о взносах",
      "supervisor": "Надзорный орган",
      "professional_body": "Профессиональная ассоциация",
      "registration": "Регистрация / продление",
      "rent": "Аренда",
      "electricity": "Электричество",
      "water": "Вода",
      "cleaning": "Уборка",
      "common_charges": "Общие расходы",
      "other": "Другое",
      "fuel": "Топливо",
      "service": "Обслуживание",
      "insurance": "Страховка",
      "road_tax": "Дорожный налог",
      "parking": "Парковка",
      "mortgage_interest": "Проценты по ипотеке"
    },
    "hint": {
      "deadline_2025": "Декларация за 2025 год (T.D.1): через TAXISnet, срок 31.10.2026 (Указ 260/2026); без процентов и сборов при подаче и оплате до 30.11.2026 (решение Комиссара от 19.10.2026).",
      "deadline_2026": "С 2026 налогового года: декларация через Tax For All до 31.07.2027; подавать обязан каждый налоговый резидент 25–70 лет независимо от дохода.",
      "accounts_deadline": "У тех, кто ведёт аудированную/проверенную отчётность, другой срок; например, объявление от 26.03.2026: продление с 31.03 до 30.04.2026.",
      "audit_threshold_2026": "С 2026 года порог обязательной аудированной отчётности для физических лиц повышается до €120 000 (с €70 000).",
      "threshold_2025": "За 2025 год: необлагаемый минимум €19 500.",
      "threshold_2026": "За 2026 год: необлагаемый минимум €22 000 (было €19 500) и новые ставки 20% / 25% / 30% / 35%.",
      "family_2026": "Новые личные вычеты с 2026 года с лимитами семейного дохода (€100 000 без детей или с 1–2, €150 000 с 3–4, €200 000 с 5+, €40 000 для одиноких): дети (€1 000 / €1 250 / €1 500), аренда или проценты по ипотеке (до €2 000), энергомодернизация/электромобиль (до €1 000). Условие: своевременная декларация.",
      "one_fifth": "Соцстрахование, GESY, пенсионные фонды, медицинские схемы и взносы по страхованию жизни вычитаются вместе в пределах 1/5 дохода — правило действует и в 2025, и с 2026 года.",
      "self_employed_rates": "Самозанятые (2025): соцстрахование 16,6% страхуемого дохода; GESY 4%.",
      "life_7pct": "Взносы по страхованию жизни: учитываются до 7% страховой суммы. Сохраните годовую справку страховщика о взносах.",
      "incapacity_2026": "С 01.01.2026 также вычитаются взносы за страхование постоянной или временной, полной или частичной нетрудоспособности (тот же лимит 7%).",
      "home_insurance_2026": "С 01.01.2026: взносы по страхованию жилья от стихийных бедствий (пожар, землетрясение, наводнение) до €500 в год, для любого жилья на Кипре, без критериев дохода.",
      "housing_2026": "С 2026 года: аренда или проценты по ипотеке основного жилья на Кипре до €2 000 на каждого супруга/партнёра; аренда должна оплачиваться безналично (перевод, карта), госсубсидии вычитаются.",
      "green_2026": "С 2026 года: энергомодернизация основного жилья, солнечные панели/батареи, новый электромобиль или зарядная станция до €1 000 в год на супруга/партнёра; остаток переносится до 4 лет.",
      "subscriptions": "Взносы в профсоюзы и профессиональные организации: вычитаются (таблица 2025); в руководстве 2026 года не упоминаются.",
      "donations": "Пожертвования одобренным благотворительным организациям: вычитаются при наличии квитанций (таблица 2025).",
      "business_use": "Ваш бухгалтер решает, что относится к вашей деятельности и в какой доле (например, автомобиль или телефон с личным использованием). Укажите деловое использование в заметке."
    },
    "export": {
      "title": "Налоговая папка {year} — сводка",
      "generated": "Создано: {at}",
      "disclaimer": "Организация документов — не налоговая консультация",
      "disclaimer_more": "Документы собраны консультантом в AVRASTRO. Столбец «Декларировать?» — его собственная отметка; окончательное решение принимает бухгалтер. Налог не рассчитывался.",
      "totals": "Итоги по категориям",
      "category": "Категория",
      "count": "Кол-во",
      "total_eur": "Итого (EUR)",
      "to_declare": "Декларировать",
      "missing_n": "Нет",
      "all": "Всего",
      "no_conversion": "Суммы в других валютах показаны отдельно — конвертация не выполнялась.",
      "documents": "Список документов",
      "date": "Дата",
      "issuer": "Издатель",
      "amount": "Сумма",
      "declare": "Декларировать?",
      "status": "Статус",
      "files": "Файлы",
      "notes": "Заметка",
      "no_file": "без файла",
      "none": "Нет документов.",
      "missing": "Чего ещё не хватает",
      "nothing_missing": "Ничего из ожидаемого не отсутствует.",
      "advisor_notes": "Заметки консультанта",
      "footer": "Содержимое ZIP: папка на каждую категорию, файлы с именем ГГГГ-ММ-ДД_категория_издатель_сумма, index.csv (UTF-8) и эта сводка.",
      "no": "№",
      "subcategory": "Подкатегория",
      "currency": "Валюта",
      "period": "Период"
    },
    "mail": {
      "subject": "Налоговая папка {year} — {name}",
      "greeting": "Здравствуйте, {name},",
      "intro": "направляю документы за {year} налоговый год для моей декларации.",
      "attached": "Во вложении: {file} (папка на каждую категорию, index.csv и сводка SYNOPSI.html).",
      "counts": "Содержит документов: {items} (файлов: {files}), итого в EUR {total}.",
      "missing": "Ещё не хватает ({n}):",
      "nothing_missing": "Ничего из ожидаемого не отсутствует.",
      "notes": "Заметки:",
      "closing": "Спасибо,"
    },
    "upcoming": "Предстоит",
    "show_all": "Все категории"
  }
}
